(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  /* 404 section driver — handles the optional reveal animation and
     the search form's button-not-submit click handler. Both behaviors
     are no-ops when their respective settings are off (no data-reveal
     elements, no search form). */
  (function() {
    function initSection(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

      /* ── Search submit ────────────────────────────────────
         The search button is type="button" (not "submit") to keep
         it visually disconnected from the theme's global Buttons
         hover effects (which target button[type="submit"]:hover via
         css-variables.liquid). Click triggers form.requestSubmit()
         so HTML5 validation still runs. Enter inside the input still
         submits via HTML's implicit-submission rule (single text
         input, no submit button → Enter submits). */
      if (section.dataset.showSearch === 'true') {
        var searchBtn = section.querySelector('.err404__search-submit');
        if (searchBtn) {
          searchBtn.addEventListener('click', function() {
            var form = searchBtn.closest('form');
            if (!form) return;
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }
          });
        }
      }

      if (section.dataset.revealEnabled !== 'true') return;

      var items = section.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) {
        items.forEach(function(el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var delay = Array.prototype.indexOf.call(items, entry.target) * 100;
            setTimeout(function() { entry.target.classList.add('is-visible'); }, delay);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px', threshold: 0.05 });
      items.forEach(function(el) { io.observe(el); });
    }

    function init(root) {
      (root || document).querySelectorAll('.err404').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /* Single bundled script handles both ticker and slides modes.
     Reads display mode + speed/interval from data-* attributes on the
     bar element so this block contains no Liquid interpolation and can
     be cached. Re-init on shopify:section:load so the theme editor
     reloads (after merchant saves) wire up the new mode immediately. */
  (function() {
    /* Marquee (ticker) mode is now pure CSS — see the keyframes and
       __set rules in the stylesheet block above. No JS measurement,
       no cloning, no per-instance keyframe regeneration. Only the
       slides mode needs JS to advance the active slide on an
       interval. */

    function initSlides(bar) {
      var container = bar.querySelector('.announcement-bar__slides');
      if (!container) return;
      var slides = Array.prototype.slice.call(container.querySelectorAll('.announcement-bar__slide'));
      if (slides.length <= 1) return;
      var interval = parseInt(container.dataset.slideInterval, 10) || 4000;
      var sectionId = bar.dataset.sectionId;
      var current = 0;

      function next() {
        var leaving = slides[current];
        current = (current + 1) % slides.length;
        var entering = slides[current];

        leaving.classList.add('is-leaving');
        leaving.classList.remove('is-active');

        setTimeout(function() {
          leaving.classList.remove('is-leaving');
        }, 400);

        entering.classList.add('is-active');
      }

      (window.cspManagedInterval || setInterval)(next, interval, sectionId);
    }

    function initBar(bar) {
      if (!bar || bar.dataset.cspInit === 'true') return;
      bar.dataset.cspInit = 'true';
      var mode = bar.dataset.displayMode;
      if (mode === 'slides') initSlides(bar);
      /* mode === 'ticker' (marquee) needs no JS — handled entirely
         by the CSS keyframe in the stylesheet block above. */
    }

    function init(root) {
      var bar = (root || document).querySelector('#announcement-bar');
      if (bar) initBar(bar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init: when the merchant saves a setting change,
       Shopify replaces the section's DOM and fires this event. The new
       DOM has a fresh #announcement-bar without our data-csp-init flag,
       so initBar runs cleanly on it. */
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  /* Multi-instance article section driver. Handles:
       • Scroll-triggered reveal animations (when enabled)
       • Copy-link share button
       • Auto-scroll to comments after a form submit/error
     All per-instance config is read from data-* attributes on the
     section root or on the buttons themselves. No Liquid here. */
  (function() {
    function initSection(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

      var revealEnabled = section.dataset.revealEnabled === 'true';

      /* ── Reveal ───────────────────────────────────────── */
      if (revealEnabled) {
        var items = section.querySelectorAll('[data-reveal]');
        if (items.length) {
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function(entries) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-visible');
                  io.unobserve(entry.target);
                }
              });
            }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
            items.forEach(function(el) { io.observe(el); });
          } else {
            items.forEach(function(el) { el.classList.add('is-visible'); });
          }
        }
      }

      /* ── Copy link ────────────────────────────────────── */
      var copyBtn = section.querySelector('[data-copy-link]');
      if (copyBtn) {
        var defaultLabel = copyBtn.textContent.trim();
        var copiedLabel = copyBtn.getAttribute('data-copied-label') || 'Copied';
        copyBtn.addEventListener('click', function() {
          var url = copyBtn.getAttribute('data-url');
          var done = function() {
            copyBtn.textContent = copiedLabel;
            setTimeout(function() { copyBtn.textContent = defaultLabel; }, 2000);
          };
          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url).then(done).catch(function() {
              window.prompt('Copy this link:', url);
            });
          } else {
            var ta = document.createElement('textarea');
            ta.value = url;
            ta.style.position = 'fixed';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); done(); }
            catch (e) { window.prompt('Copy this link:', url); }
            document.body.removeChild(ta);
          }
        });
      }

      /* ── Auto-scroll to comments after form submit ──── */
      if (section.dataset.formJustPosted === 'true') {
        var commentsAnchor = section.querySelector('#comments') || document.getElementById('comments');
        if (commentsAnchor) {
          setTimeout(function() {
            commentsAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      }
    }

    function init(root) {
      (root || document).querySelectorAll('.article-x').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"] && !Shopify.designMode) return;
  try {
    
  /* Multi-instance blog section driver. Each .blog-x is identified
     by its data-section-id; the AJAX helpers look up the matching
     section in fetched HTML by that same id so multiple blog
     sections on a page (rare but possible) don't fight over the
     same results container. */
  (function() {
    function initSection(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

      var sectionId = section.dataset.sectionId;
      var revealEnabled = section.dataset.revealEnabled === 'true';
      var revealObserver = null;

      function initReveal() {
        if (!revealEnabled) return;
        var items = section.querySelectorAll('[data-reveal]:not(.is-visible)');
        if (!items.length) return;

        if (!('IntersectionObserver' in window)) {
          items.forEach(function(el) { el.classList.add('is-visible'); });
          return;
        }

        if (!revealObserver) {
          revealObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                var delay = parseInt(entry.target.getAttribute('data-reveal-delay'), 10) || 0;
                setTimeout(function() { entry.target.classList.add('is-visible'); }, delay);
                revealObserver.unobserve(entry.target);
              }
            });
          }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        }

        items.forEach(function(el) { revealObserver.observe(el); });
      }

      initReveal();

      /* ── AJAX navigation for tags + pagination ─────────── */
      var resultsWrap = section.querySelector('[data-blog-results]');
      if (!resultsWrap) return;

      var cache = {};
      var requestId = 0;

      function updateActiveTag(url) {
        var taggedMatch = url.match(/\/tagged\/([^\/?#]+)/);
        var activeSlug = taggedMatch ? decodeURIComponent(taggedMatch[1]) : null;
        var tags = section.querySelectorAll('.blog-x__tag');
        Array.prototype.forEach.call(tags, function(tag) {
          var href = tag.getAttribute('href') || '';
          var hrefMatch = href.match(/\/tagged\/([^\/?#]+)/);
          var hrefSlug = hrefMatch ? decodeURIComponent(hrefMatch[1]) : null;
          if ((hrefSlug && hrefSlug === activeSlug) || (!hrefSlug && !activeSlug)) {
            tag.classList.add('is-active');
          } else {
            tag.classList.remove('is-active');
          }
        });
      }

      function applyHtml(html, url, mode) {
        var doc;
        try { doc = new DOMParser().parseFromString(html, 'text/html'); }
        catch (e) { window.location.href = url; return; }

        var newSection = doc.querySelector('[data-section-id="' + sectionId + '"]');
        if (!newSection) { window.location.href = url; return; }
        var newResults = newSection.querySelector('[data-blog-results]');
        if (!newResults) { window.location.href = url; return; }

        if (mode === 'append') {
          var newGrid = newResults.querySelector('.blog-x__grid');
          var existingGrid = resultsWrap.querySelector('.blog-x__grid');
          if (newGrid && existingGrid) {
            var newCards = Array.prototype.slice.call(newGrid.children);
            newCards.forEach(function(card) { existingGrid.appendChild(card); });
          }
          var oldWrap = resultsWrap.querySelector('.blog-x__load-more-wrap');
          var newWrap = newResults.querySelector('.blog-x__load-more-wrap');
          if (oldWrap) {
            if (newWrap) oldWrap.parentNode.replaceChild(newWrap, oldWrap);
            else oldWrap.parentNode.removeChild(oldWrap);
          }
        } else {
          resultsWrap.innerHTML = newResults.innerHTML;
        }

        resultsWrap.classList.remove('is-loading');
        try { history.pushState({ blogUrl: url }, '', url); } catch (e) {}
        initReveal();
      }

      function fetchAndApply(url, mode) {
        var myId = ++requestId;

        if (cache[url]) {
          applyHtml(cache[url], url, mode);
          return;
        }

        resultsWrap.classList.add('is-loading');

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function(res) {
            if (!res.ok) throw new Error('Fetch failed');
            return res.text();
          })
          .then(function(html) {
            cache[url] = html;
            if (myId !== requestId) return; /* stale response, ignore */
            applyHtml(html, url, mode);
          })
          .catch(function() {
            window.location.href = url;
          });
      }

      section.addEventListener('click', function(e) {
        var link = e.target.closest('.blog-x__tag, .blog-x__page-link, .blog-x__load-more');
        if (!link) return;
        if (!link.href) return;
        if (link.classList.contains('is-current')) { e.preventDefault(); return; }
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;

        e.preventDefault();

        /* No-op if already at this exact URL */
        if (link.href === window.location.href) return;

        var isLoadMore = link.classList.contains('blog-x__load-more');
        var mode = isLoadMore ? 'append' : 'replace';

        if (link.classList.contains('blog-x__tag')) {
          updateActiveTag(link.href);
        }

        fetchAndApply(link.href, mode);
      });

      window.addEventListener('popstate', function() {
        updateActiveTag(window.location.href);
        fetchAndApply(window.location.href, 'replace');
      });
    }

    function init(root) {
      (root || document).querySelectorAll('.blog-x').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Cart section bundled script.
     Reads shop currency + promo button label from data-* attributes on
     the .cart-page root so this block contains no Liquid interpolation
     and can be cached as a static asset. Multi-instance safe via the
     per-section initSection() + data-csp-init guard. Re-inits on
     shopify:section:load so theme-editor saves wire up cleanly. */
  (function() {
    function initSection(rootEl) {
      if (!rootEl || rootEl.dataset.cspInit === 'true') return;
      rootEl.dataset.cspInit = 'true';

      var shopCurrency = rootEl.dataset.shopCurrency || 'USD';
      var promoApplyText = rootEl.dataset.promoApplyText || 'Apply';

      /* ────────────────────────────────────────────────────────────
         Line-item form: qty controls, remove buttons, AJAX cart updates,
         promo codes, accordion, mobile bottom padding sync.
         ──────────────────────────────────────────────────────────── */
      (function() {
        var form = document.getElementById('cart-page-form');
        if (!form) return;
        function fmt(cents) {
          return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: shopCurrency });
        }
        function updateItem(key, qty) {
    // Loading state: dim the items area
    var itemsEl = form.querySelector('.cart-page__items');
    if (itemsEl) itemsEl.style.opacity = '0.4';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) {
      if (!r.ok) return fetch('/cart.js').then(function(r2) { return r2.json(); });
      return r.json();
    })
    .then(function(cart) {
      if (itemsEl) itemsEl.style.opacity = '';

      // Sync all price displays
      var subtotalEl = document.getElementById('cart-page-subtotal');
      if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);
      var subtotalDesktopEl = document.getElementById('cart-page-subtotal-desktop');
      if (subtotalDesktopEl) subtotalDesktopEl.textContent = fmt(cart.total_price);
      var totalEl = document.getElementById('cart-page-total');
      if (totalEl) totalEl.textContent = fmt(cart.total_price);

      // Sync the shipping rewards bar (if present)
      if (window.cartPageShippingBar) window.cartPageShippingBar.update(cart);

      var countEl = document.querySelector('.header__cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? '' : 'none';
      }
      var updatedItem = cart.items.find(function(i) { return i.key === key; });
      if (updatedItem) {
        var input = form.querySelector('.cart-page__qty-input[data-key="' + key + '"]');
        if (input) input.value = updatedItem.quantity;
      }
      if (qty === 0) {
        var row = form.querySelector('[data-key="' + key + '"]');
        if (row) {
          row.style.transition = 'opacity 0.2s';
          row.style.opacity = '0';
          setTimeout(function() {
            row.remove();
            if (cart.item_count === 0) location.reload();
          }, 200);
        }
      }
    })
    .catch(function() {
      if (itemsEl) itemsEl.style.opacity = '';
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var subtotalEl = document.getElementById('cart-page-subtotal');
        if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);
        var subtotalDesktopEl = document.getElementById('cart-page-subtotal-desktop');
        if (subtotalDesktopEl) subtotalDesktopEl.textContent = fmt(cart.total_price);
        var totalEl = document.getElementById('cart-page-total');
        if (totalEl) totalEl.textContent = fmt(cart.total_price);
        if (window.cartPageShippingBar) window.cartPageShippingBar.update(cart);
      });
    });
  }
  form.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action]');
    if (btn) {
      e.preventDefault();
      var item = btn.closest('[data-key]');
      var key = item.dataset.key;
      var input = item.querySelector('.cart-page__qty-input');
      var current = parseInt(input.value) || 0;
      if (btn.dataset.action === 'minus') { input.value = Math.max(0, current - 1); updateItem(key, parseInt(input.value)); }
      else { input.value = current + 1; updateItem(key, current + 1); }
      return;
    }
    var removeBtn = e.target.closest('.cart-page__remove');
    if (removeBtn) { e.preventDefault(); updateItem(removeBtn.dataset.key, 0); }
  });
  form.addEventListener('change', function(e) {
    if (!e.target.classList.contains('cart-page__qty-input')) return;
    var input = e.target;
    var item = input.closest('[data-key]');
    if (item) updateItem(item.dataset.key, Math.max(0, parseInt(input.value) || 0));
  });


  // Promotional code input — shared logic for mobile + desktop instances
  function initPromoInput(inputId, applyId, resultId, messageId) {
    var promoInput = document.getElementById(inputId);
    var promoApply = document.getElementById(applyId);
    var promoResult = document.getElementById(resultId);
    var promoMessage = document.getElementById(messageId);
    if (!promoInput || !promoApply) return;

    promoInput.addEventListener('input', function() {
      promoResult.style.display = 'none';
      promoApply.classList.toggle('is-visible', promoInput.value.trim().length > 0);
    });

    promoApply.addEventListener('click', function() {
      var code = promoInput.value.trim();
      if (!code) return;
      promoApply.textContent = '…';
      promoApply.disabled = true;

      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET', redirect: 'follow', credentials: 'same-origin'
      })
      .then(function() {
        return fetch('/cart.js', { credentials: 'same-origin' });
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        promoApply.textContent = promoApplyText;
        promoApply.disabled = false;

        var apps = cart.cart_level_discount_applications || [];
        var match = apps.find(function(d) {
          return d.title && d.title.toUpperCase() === code.toUpperCase();
        });

        if (match) {
          var savings = match.total_allocated_amount;
          var savingsText = savings > 0
            ? ' — saves ' + (savings / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
            : '';
          promoMessage.textContent = '✓ "' + code + '" applied' + savingsText;
          promoMessage.style.opacity = '1';
          promoMessage.style.color = '';
          promoResult.style.display = 'flex';
          // Sync both subtotal elements
          ['cart-page-subtotal', 'cart-page-subtotal-desktop'].forEach(function(id) {
            var el = document.getElementById(id);
            if (el) el.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          });
          var totalEl = document.getElementById('cart-page-total');
          if (totalEl) totalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        } else {
          promoMessage.textContent = '✕ Invalid or expired code';
          promoMessage.style.opacity = '1';
          promoMessage.style.color = '#ff0000';
          promoResult.style.display = 'flex';
        }
      })
      .catch(function() {
        promoApply.textContent = promoApplyText;
        promoApply.disabled = false;
        promoMessage.textContent = '✕ Could not apply code';
        promoMessage.style.opacity = '1';
        promoMessage.style.color = '#ff0000';
        promoResult.style.display = 'flex';
      });
    });

    promoInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); promoApply.click(); }
    });
  }
  // Mobile promo input
  initPromoInput('cp-promo-input', 'cp-promo-apply', 'cp-promo-result', 'cp-promo-message');
  // Desktop promo input
  initPromoInput('cp-promo-input-desktop', 'cp-promo-apply-desktop', 'cp-promo-result-desktop', 'cp-promo-message-desktop');

  // Accordion
  document.querySelectorAll('.cart-page__accordion-trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.cart-page__accordion-trigger').forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
      });
      this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  // Update bottom padding on mobile to account for fixed summary panel height
  function updateBottomPadding() {
    var summary = document.querySelector('.cart-page__summary');
    if (!summary) return;
    // Always clear the mobile-details padding — the body padding below
    // already covers "scroll past the fixed panel" for everything in
    // the page, so the extra (h + 24) we used to apply on mobile-details
    // was just creating empty space between the promo input and the
    // next section.
    var detailsEl = document.querySelector('.cart-page__mobile-details');
    if (detailsEl) detailsEl.style.paddingBottom = '';
    if (window.innerWidth >= 1200) {
      document.body.style.paddingBottom = '';
      return;
    }
    var h = summary.offsetHeight;
    // Pad body so the footer (and everything below the cart) can scroll past the panel
    document.body.style.paddingBottom = h + 'px';
  }
  updateBottomPadding();
  window.addEventListener('resize', updateBottomPadding);
})();

// Sync wishlist icon states once wishlist drawer is ready.
// Bundled section scripts load deferred, so DOMContentLoaded may already
// have fired by the time we run — handle both timing paths.
(function syncWishlistWhenReady() {
  function doSync() {
    if (window.wishlistDrawer) {
      window.wishlistDrawer.sync();
    } else {
      document.addEventListener('wishlist:ready', function () {
        window.wishlistDrawer.sync();
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doSync);
  } else {
    doSync();
  }
})();

/* ────────────────────────────────────────────────────────────────
   Shipping rewards bar — cart page version
   ────────────────────────────────────────────────────────────────
   Self-contained IIFE that lives outside the form-gated one above
   (which early-returns when the cart is empty). This one runs
   regardless of empty/items state so the bar can show in the empty
   state when ship_show_when_empty is true.

   Exposes window.cartPageShippingBar.update(cart) so the form-gated
   IIFE's updateItem handler can call it after every AJAX cart change
   without us having to introduce a new event protocol. Mirrors the
   cart-drawer bar's algorithm exactly — only DOM IDs and class
   names differ (cart-drawer-* / cart-page-*).
   ──────────────────────────────────────────────────────────────── */
(function() {
  'use strict';
  var shipEl     = document.getElementById('cart-page-ship');
  if (!shipEl) return;
  var shipFillEl = document.getElementById('cart-page-ship-fill');
  var shipMsgEl  = document.getElementById('cart-page-ship-message');
  if (!shipFillEl || !shipMsgEl) return;

  var shipPrevTier = -2;

  function fmt(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: shopCurrency });
  }

  function fillTemplate(tpl, vars) {
    return (tpl || '')
      .replace(/\[amount\]/g,      '<strong>' + (vars.amount || '') + '</strong>')
      .replace(/\[reward\]/g,      '<strong>' + (vars.reward || '') + '</strong>')
      .replace(/\[next_reward\]/g, '<strong>' + (vars.nextReward || '') + '</strong>');
  }

  function updateShippingBar(currentCents, isEmpty) {
    var showWhenEmpty = shipEl.dataset.showWhenEmpty === 'true';
    if (isEmpty && !showWhenEmpty) {
      shipEl.classList.add('is-hidden');
      return;
    }
    shipEl.classList.remove('is-hidden');

    var tc = parseInt(shipEl.dataset.tiersN, 10) || 0;
    var tiers = [];
    for (var i = 1; i <= tc; i++) {
      var c = parseInt(shipEl.dataset['tier' + i + 'Cents'], 10) || 0;
      var r = shipEl.dataset['tier' + i + 'Reward'] || '';
      if (c > 0) tiers.push({ cents: c, reward: r });
    }
    if (!tiers.length) { shipEl.classList.add('is-hidden'); return; }

    var maxCents = parseInt(shipEl.dataset.maxCents, 10) || tiers[tiers.length - 1].cents;

    var reachedIdx = -1;
    for (var j = 0; j < tiers.length; j++) {
      if (currentCents >= tiers[j].cents) reachedIdx = j;
      else break;
    }

    var pct = maxCents > 0 ? Math.min(100, (currentCents / maxCents) * 100) : 0;
    shipFillEl.style.width = pct + '%';

    var allUnlocked = reachedIdx === tiers.length - 1;
    shipEl.classList.toggle('is-complete', allUnlocked);

    var msg;
    if (allUnlocked) {
      msg = fillTemplate(shipEl.dataset.msgAllUnlocked, { reward: tiers[tiers.length - 1].reward });
    } else if (reachedIdx >= 0) {
      var nextTier = tiers[reachedIdx + 1];
      msg = fillTemplate(shipEl.dataset.msgTierUnlocked, {
        reward:     tiers[reachedIdx].reward,
        amount:     fmt(nextTier.cents - currentCents),
        nextReward: nextTier.reward
      });
    } else {
      var firstTier = tiers[0];
      msg = fillTemplate(shipEl.dataset.msgProgress, {
        reward: firstTier.reward,
        amount: fmt(firstTier.cents - currentCents)
      });
    }
    shipMsgEl.innerHTML = msg;

    var celebrate = shipEl.dataset.celebrate === 'true';
    if (celebrate && shipPrevTier !== -2 && reachedIdx > shipPrevTier) {
      shipEl.classList.remove('is-celebrating');
      void shipEl.offsetWidth;
      shipEl.classList.add('is-celebrating');
      setTimeout(function() { shipEl.classList.remove('is-celebrating'); }, 800);
    }
    shipPrevTier = reachedIdx;

    var giftWrap = document.getElementById('cart-page-ship-gift');
    if (giftWrap) {
      var giftCents = parseInt(shipEl.dataset.giftCents, 10) || 0;
      giftWrap.classList.toggle('is-unlocked', giftCents > 0 && currentCents >= giftCents);
    }
  }

  /* Initial render from the server-rendered cart total. */
  var initCents = parseInt(shipEl.dataset.currentCents, 10) || 0;
  var initEmpty = shipEl.dataset.initialEmpty === 'true';
  updateShippingBar(initCents, initEmpty);

  /* Public API for the form IIFE's updateItem handler to call after
     each AJAX cart change. Pass the full cart object (Shopify's
     /cart.js shape) — we read total_price + item_count off it. */
  window.cartPageShippingBar = {
    update: function(cart) {
      if (!cart) return;
      updateShippingBar(cart.total_price, cart.item_count === 0);
    }
  };

  /* Gift preview popover — same click-to-toggle behavior as the
     cart-drawer version. Single click handler for both touch and
     desktop; close on outside click or Escape. */
  var giftBtnEl     = document.getElementById('cart-page-ship-gift-btn');
  var giftPopoverEl = document.getElementById('cart-page-ship-gift-popover');
  if (giftBtnEl && giftPopoverEl) {
    function closeGiftPopover() {
      giftPopoverEl.classList.remove('is-open');
      giftBtnEl.setAttribute('aria-expanded', 'false');
      giftPopoverEl.setAttribute('aria-hidden', 'true');
    }
    function openGiftPopover() {
      giftPopoverEl.classList.add('is-open');
      giftBtnEl.setAttribute('aria-expanded', 'true');
      giftPopoverEl.setAttribute('aria-hidden', 'false');
    }
    giftBtnEl.addEventListener('click', function(e) {
      e.stopPropagation();
      if (giftPopoverEl.classList.contains('is-open')) closeGiftPopover();
      else openGiftPopover();
    });
    document.addEventListener('click', function(e) {
      if (!giftPopoverEl.classList.contains('is-open')) return;
      if (e.target.closest('#cart-page-ship-gift-popover')) return;
      if (e.target.closest('#cart-page-ship-gift-btn')) return;
      closeGiftPopover();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && giftPopoverEl.classList.contains('is-open')) {
        closeGiftPopover();
        giftBtnEl.focus();
      }
    });
  }
})();

/* ────────────────────────────────────────────────────────────────
   Cross-sells — cart page
   ────────────────────────────────────────────────────────────────
   Self-contained IIFE handling the carousel, scroll nav arrows, and
   single-variant quick-add. Multi-variant products open the variant
   sheet (defined in its own IIFE below).
   ──────────────────────────────────────────────────────────────── */
(function() {
  'use strict';

  // Money formatter — same shape as the form-IIFE's fmt
  function fmt(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: shopCurrency });
  }

  /* Per-instance setup. Single inline cross-sells block in this layout;
     loop kept defensively so future placements don't break. */
  document.querySelectorAll('.cart-page__crosssells').forEach(function(crosssellEl) {
    var scrollerEl = crosssellEl.querySelector('.cart-page__crosssells-scroller');
    var navEl      = crosssellEl.querySelector('.cart-page__crosssells-nav');
    if (!scrollerEl) return;

    /* Hide if cart is empty AND merchant has show-when-empty off.
       The cart-page renders an empty state separately so cross-sells
       only need to react when transitioning empty → has-items. */
    function syncEmptyVisibility(isEmpty) {
      var showWhenEmpty = crosssellEl.dataset.showWhenEmpty === 'true';
      crosssellEl.classList.toggle('is-hidden', isEmpty && !showWhenEmpty);
    }
    syncEmptyVisibility(crosssellEl.dataset.initialEmpty === 'true');

    /* Broken-image safety net — listen for img error events on the
       scroller (capture phase since `error` doesn't bubble). When a
       product's featured_image asset 404s at runtime, hide the entire
       card so the carousel doesn't show empty slots. */
    scrollerEl.addEventListener('error', function(e) {
      if (e.target && e.target.tagName === 'IMG') {
        var card = e.target.closest('.cart-page__crosssells-card');
        if (card) card.style.display = 'none';
      }
    }, true);

    /* Quick-add click handler. Single-variant adds inline via
       /cart/add.js + reloads cart. Multi-variant opens the variant
       sheet for inline selection (no PDP redirect). */
    scrollerEl.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.dataset.multiVariant === 'true') {
        // Open the variant sheet — handler is set up by the IIFE below
        if (typeof openCpVariantSheet === 'function') {
          openCpVariantSheet(btn.dataset.productHandle, btn);
        } else {
          // Defensive fallback: variant sheet IIFE didn't initialize
          // (cross-sells disabled, etc) — navigate to PDP instead so
          // the user isn't stuck on a non-functional button.
          var url = btn.dataset.productUrl;
          if (url) window.location.href = url;
        }
        return;
      }
      var vid = btn.dataset.variantId;
      if (!vid) return;
      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
        .then(function(res) {
          btn.classList.remove('is-loading');
          if (!res.ok) return;
          btn.classList.add('is-added');
          setTimeout(function() { btn.classList.remove('is-added'); }, 600);
          /* Reload the page to reflect the new cart state. cart.liquid
             is server-rendered for items, so reload is the cleanest
             path — no partial-update plumbing needed. The shopper sees
             a brief is-added flash before the reload completes. */
          setTimeout(function() { window.location.reload(); }, 350);
        })
        .catch(function() { btn.classList.remove('is-loading'); });
    });

    /* Scroll nav arrows — same algorithm as cart-drawer. */
    if (navEl) {
      var navPrev = navEl.querySelector('[data-cp-cs-nav="prev"]');
      var navNext = navEl.querySelector('[data-cp-cs-nav="next"]');

      function updateNav() {
        var sc = scrollerEl;
        var hasOverflow = sc.scrollWidth - sc.clientWidth > 1;
        navEl.classList.toggle('is-overflow', hasOverflow);
        if (!hasOverflow) return;
        navPrev.disabled = sc.scrollLeft <= 0;
        navNext.disabled = sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 1;
      }

      function scrollByOneCard(direction) {
        var cs = getComputedStyle(crosssellEl);
        var widthVar = window.matchMedia('(max-width: 749px)').matches
          ? cs.getPropertyValue('--cs-card-width-mobile').trim()
          : cs.getPropertyValue('--cs-card-width').trim();
        var cardWidth = parseInt(widthVar, 10) || 140;
        scrollerEl.scrollBy({ left: direction * (cardWidth + 10), behavior: 'smooth' });
      }

      if (navPrev) navPrev.addEventListener('click', function() { scrollByOneCard(-1); });
      if (navNext) navNext.addEventListener('click', function() { scrollByOneCard(1); });
      scrollerEl.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
      requestAnimationFrame(updateNav);
    }
  });
})();

/* ────────────────────────────────────────────────────────────────
   Variant sheet — cart page
   ────────────────────────────────────────────────────────────────
   Self-contained IIFE handling the slide-up modal for picking
   variants. Full port of cart-drawer's vsXxx code with cp-prefix and
   cart-page namespace. Exposes window.openCpVariantSheet so the
   cross-sells IIFE can trigger it across boundaries.

   Money formatter shape matches the cross-sells IIFE: cents → pretty
   currency string using the shop currency setting.
   ──────────────────────────────────────────────────────────────── */
(function() {
  'use strict';
  var vsEl = document.getElementById('cart-page-variant-sheet');
  if (!vsEl) return;

  var vsBackdrop = document.getElementById('cart-page-variant-sheet-backdrop');
  var vsClose    = document.getElementById('cart-page-variant-sheet-close');
  var vsImage    = document.getElementById('cart-page-variant-sheet-image');
  var vsTitle    = document.getElementById('cart-page-variant-sheet-title');
  var vsOptions  = document.getElementById('cart-page-variant-sheet-options');
  var vsAtc      = document.getElementById('cart-page-variant-sheet-atc');
  var vsDetails  = document.getElementById('cart-page-variant-sheet-details');

  /* Image runtime error fallback — hides the entire image area when
     the image asset 404s or fails to load. Without this, a broken
     <img> shows a giant gray placeholder with the title overlay text
     floating inside, which looks broken. The error event doesn't
     bubble, so capture phase isn't needed for this single element. */
  if (vsImage) {
    vsImage.addEventListener('error', function() {
      var wrap = vsImage.parentElement;
      if (wrap) wrap.style.display = 'none';
    });
    vsImage.addEventListener('load', function() {
      var wrap = vsImage.parentElement;
      if (wrap) wrap.style.display = '';
    });
  }

  function fmt(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: shopCurrency });
  }

  var vsCurrentProduct = null;
  var vsCurrentVariants = [];
  var vsSelectedOptions = {};
  var vsSourceBtn = null;
  /* Tracks the most-recently-clicked option (idx, val) so the image
     swap can fall back to "any variant with this option" when the
     exact combo doesn't have a featured_image. */
  var vsLastChange = null;
  var vsProductCache = {};

  /* Swatch map — parsed from data-swatches built by Liquid. Same
     shape as cart-drawer's: lowercased-no-space value names mapped
     to {type, val}. */
  var vsSwatchMap = {};
  (vsEl.dataset.swatches || '').split('||').forEach(function(entry) {
    if (!entry) return;
    var parts = entry.split(':');
    var key  = parts[0];
    var type = parts[1];
    var val  = parts.slice(2).join(':');
    vsSwatchMap[key] = { type: type, val: val };
  });

  function vsGetSwatchStyle(val) {
    var key = val.toLowerCase().replace(/\s/g, '');
    var s = vsSwatchMap[key];
    if (!s || s.type === 'none') return null;
    if (s.type === 'image') return { backgroundImage: 'url(' + s.val + ')', backgroundSize: 'cover' };
    return { backgroundColor: s.val };
  }

  function vsCloseSheet() {
    vsEl.classList.remove('is-open');
    vsEl.setAttribute('aria-hidden', 'true');
    vsCurrentProduct = null;
    // Restore body scroll
    document.body.style.removeProperty('overflow');
  }

  function vsOpen() {
    vsEl.classList.add('is-open');
    vsEl.setAttribute('aria-hidden', 'false');
    var scrollEl = vsEl.querySelector('.cart-page__variant-sheet-scroll');
    if (scrollEl) scrollEl.scrollTop = 0;
    /* Lock body scroll while sheet is open — without this, scrolling
       inside the sheet on mobile bleeds into scrolling the cart-page
       behind it once the sheet content scroll bottoms out. Cart-drawer
       didn't need this because the drawer container already controlled
       scroll; cart.liquid's sheet floats on the page so we manage it. */
    document.body.style.overflow = 'hidden';
  }

  function vsFindSelectedVariant() {
    if (!vsCurrentProduct) return null;
    return vsCurrentVariants.find(function(v) {
      return Object.keys(vsSelectedOptions).every(function(k) {
        var idx = parseInt(k.slice(1), 10) - 1;
        return v.options[idx] === vsSelectedOptions[k];
      });
    }) || null;
  }

  function vsUpdateAtc() {
    var v = vsFindSelectedVariant();
    vsAtc.classList.remove('is-added');

    /* Image swap with fallback strategy:
         1. If exact combo variant exists AND has a featured_image, use that
         2. Otherwise, find any variant matching the user's most-recent
            selection that has a featured_image (handles "Red+M not
            available, but Red+L is — still show Red photo") */
    var imgSrc = null;
    if (v && v.featured_image && v.featured_image.src) {
      imgSrc = v.featured_image.src;
    } else if (vsLastChange) {
      var fallbackVariant = vsCurrentVariants.find(function(cv) {
        return cv.options[vsLastChange.idx] === vsLastChange.val &&
               cv.featured_image && cv.featured_image.src;
      });
      if (fallbackVariant) imgSrc = fallbackVariant.featured_image.src;
    }
    if (imgSrc) vsImage.src = imgSrc;

    // Update details link href to pre-select the chosen variant on PDP
    var baseUrl = vsDetails.dataset.baseUrl || '#';
    vsDetails.href = (v && baseUrl)
      ? baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + v.id
      : baseUrl;

    if (!v) {
      vsAtc.disabled = true;
      vsAtc.textContent = 'Unavailable';
      return;
    }
    if (!v.available) {
      vsAtc.disabled = true;
      vsAtc.textContent = 'Sold out';
      return;
    }
    vsAtc.disabled = false;
    vsAtc.textContent = 'Add to cart — ' + fmt(v.price);
    vsAtc.dataset.variantId = v.id;
  }

  function vsRefreshOptionStates() {
    vsOptions.querySelectorAll('.cp-vs-option-btn, .cp-vs-color-btn').forEach(function(b) {
      var pos = parseInt(b.dataset.pos, 10);
      var val = b.dataset.value;
      var testKey = 'o' + pos;

      // is-unavailable: no variant exists with this value + current other selections
      var test = Object.assign({}, vsSelectedOptions);
      test[testKey] = val;
      var ok = vsCurrentVariants.some(function(v) {
        return v.options.every(function(o, i) { return test['o' + (i + 1)] === o; });
      });
      b.classList.toggle('is-unavailable', !ok);

      // is-sold-out: combo exists but no available stock
      var otherSelections = Object.assign({}, vsSelectedOptions);
      delete otherSelections[testKey];
      var soldOut = !vsCurrentVariants.some(function(v) {
        return v.available && v.options[pos - 1] === val &&
          Object.keys(otherSelections).every(function(k) {
            var idx = parseInt(k.slice(1), 10) - 1;
            return otherSelections[k] === v.options[idx];
          });
      });
      b.classList.toggle('is-sold-out', soldOut);
    });
  }

  function vsRenderOptions(product) {
    vsCurrentProduct = product;
    vsCurrentVariants = product.variants || [];
    vsSelectedOptions = {};
    vsLastChange = null;

    var first = vsCurrentVariants.find(function(v) { return v.available; }) || vsCurrentVariants[0];
    if (!first) {
      vsOptions.innerHTML = '';
      vsAtc.disabled = true;
      vsAtc.textContent = 'Unavailable';
      return;
    }
    (product.options || []).forEach(function(name, i) {
      vsSelectedOptions['o' + (i + 1)] = first.options[i];
    });

    vsOptions.innerHTML = '';
    if (vsCurrentVariants.length === 1 && vsCurrentVariants[0].title === 'Default Title') {
      vsUpdateAtc();
      return;
    }

    (product.options || []).forEach(function(optRaw, idx) {
      var optName = typeof optRaw === 'object' ? optRaw.name : optRaw;
      var pos = idx + 1;

      var vals = [];
      vsCurrentVariants.forEach(function(v) {
        if (vals.indexOf(v.options[idx]) === -1) vals.push(v.options[idx]);
      });

      var isColor = vals.some(function(v) { return !!vsGetSwatchStyle(v); });

      var wrap = document.createElement('div');
      wrap.className = 'cp-vs-option';

      var label = document.createElement('p');
      label.className = 'cp-vs-option__label';
      var selSpan = document.createElement('span');
      selSpan.className = 'cp-vs-option__selected';
      selSpan.textContent = vsSelectedOptions['o' + pos];
      label.textContent = optName + ': ';
      label.appendChild(selSpan);

      var btns = document.createElement('div');
      btns.className = isColor ? 'cp-vs-option__btns cp-vs-option__btns--colors' : 'cp-vs-option__btns';

      vals.forEach(function(val) {
        var swatch = isColor ? vsGetSwatchStyle(val) : null;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.pos = pos;
        btn.dataset.value = val;

        if (swatch) {
          btn.className = 'cp-vs-color-btn';
          var dot = document.createElement('span');
          dot.className = 'cp-vs-color-dot';
          Object.assign(dot.style, swatch);
          var name = document.createElement('span');
          name.className = 'cp-vs-color-name';
          name.textContent = val.toUpperCase();
          btn.appendChild(dot);
          btn.appendChild(name);
        } else {
          btn.className = 'cp-vs-option-btn';
          btn.textContent = val;
        }

        if (vsSelectedOptions['o' + pos] === val) btn.classList.add('is-selected');

        btn.addEventListener('click', function() {
          vsSelectedOptions['o' + pos] = val;
          vsLastChange = { idx: pos - 1, val: val };
          selSpan.textContent = val;
          btns.querySelectorAll('.cp-vs-option-btn, .cp-vs-color-btn').forEach(function(b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          vsRefreshOptionStates();
          vsUpdateAtc();
        });

        btns.appendChild(btn);
      });

      wrap.appendChild(label);
      wrap.appendChild(btns);
      vsOptions.appendChild(wrap);
    });

    vsRefreshOptionStates();
    vsUpdateAtc();
  }

  /* Public entry point — exposed on window so the cross-sells IIFE
     can call it. Fetches product data (cached by handle), populates
     the sheet, slides it up. */
  window.openCpVariantSheet = function(handle, sourceBtn) {
    vsSourceBtn = sourceBtn;
    if (sourceBtn) sourceBtn.classList.add('is-loading');

    function populate(p) {
      if (sourceBtn) sourceBtn.classList.remove('is-loading');
      vsTitle.textContent = p.title;
      var imgUrl = p.featured_image || (p.images && p.images[0]) || '';
      if (typeof imgUrl !== 'string') imgUrl = imgUrl.src || '';
      /* Resize via Shopify's modern ?width=N query parameter rather
         than the old _600x.jpg filename suffix. The suffix approach
         worked on legacy Shopify CDN paths but fails on newer ones —
         particularly common on test/duplicated products — producing
         404 URLs that fire our error listener and hide the image
         wrap. The query param works for any product image URL on the
         Shopify CDN, matching what Liquid's image_url filter produces. */
      if (imgUrl && imgUrl.indexOf('cdn.shopify.com') !== -1) {
        var sep = imgUrl.indexOf('?') === -1 ? '?' : '&';
        imgUrl = imgUrl + sep + 'width=600';
      }
      /* Hide the entire image area (wrap + title overlay) when the
         product has no images. Otherwise the gray placeholder takes
         up ~50vh and the title overlay floats inside it, which makes
         the sheet look broken. The product title still shows via the
         options block's label area when the image is missing. */
      var imgWrap = vsImage.parentElement;
      if (imgUrl) {
        if (imgWrap) imgWrap.style.display = '';
        vsImage.src = imgUrl;
        vsImage.alt = p.title;
      } else {
        if (imgWrap) imgWrap.style.display = 'none';
        vsImage.removeAttribute('src');
        vsImage.alt = '';
      }
      vsDetails.dataset.baseUrl = p.url || '';
      vsRenderOptions(p);
      vsOpen();
    }

    if (vsProductCache[handle]) {
      populate(vsProductCache[handle]);
      return;
    }
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p) {
          if (sourceBtn) sourceBtn.classList.remove('is-loading');
          return;
        }
        vsProductCache[handle] = p;
        populate(p);
      })
      .catch(function() { if (sourceBtn) sourceBtn.classList.remove('is-loading'); });
  };

  /* ATC click — adds the resolved variant, flashes green, then reloads
     the page so the cart items grid updates. Same reload pattern as
     the single-variant cross-sell quick-add. */
  vsAtc.addEventListener('click', function() {
    var vid = vsAtc.dataset.variantId;
    if (!vid || vsAtc.disabled) return;
    vsAtc.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
      .then(function(res) {
        vsAtc.classList.remove('is-loading');
        if (!res.ok) return;
        vsAtc.classList.add('is-added');
        vsAtc.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        // Brief confirmation pause, then close + reload
        setTimeout(function() {
          vsCloseSheet();
          window.location.reload();
        }, 600);
      })
      .catch(function() { vsAtc.classList.remove('is-loading'); });
  });

  // Close handlers — backdrop click, X button, Escape key
  vsBackdrop.addEventListener('click', vsCloseSheet);
  vsClose.addEventListener('click', vsCloseSheet);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && vsEl.classList.contains('is-open')) vsCloseSheet();
  });
})();

    } // ← end initSection

    function init(root) {
      (root || document).querySelectorAll('.cart-page').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init: when the merchant saves a setting change,
       Shopify replaces the section's DOM and fires this event. The new
       DOM has a fresh .cart-page without our data-csp-init flag, so
       initSection runs cleanly on it. */
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-index"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSection(section) {
      if (!section) return;
      if (section.dataset.cidxInit === 'true') return;
      section.dataset.cidxInit = 'true';

      /* Master preview toggle — when off the merchant has chosen a
         fully bare-list look. No previews are rendered server-side
         either, so there's literally nothing for JS to wire. Skip
         all setup including the global mousemove listener. */
      var ENABLE_PREVIEW = section.dataset.enablePreview === 'true';
      if (!ENABLE_PREVIEW) return;

      /* Touch detection — same predicate as the CSS media query.
         On touch devices we skip wiring entirely; CSS already hides
         the preview UI and the row's <a> tag handles tap-navigate. */
      var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
      if (isTouch) return;

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Stack canvas dimensions used for clamping against viewport
         edges. Read from data attributes so JS stays in sync with
         merchant changes in the customizer. */
      var STACK_SIZE = parseInt(section.dataset.thumbSize, 10) || 240;
      var EDGE_MARGIN = 24;

      /* Cycling toggle and speed control. Speed (1-10) maps to a
         cursor-travel threshold (px) — at speed 10 each ~10px of
         movement advances the cycle, at speed 1 each ~100px does.
         Higher speed = more frantic filtering. */
      var ENABLE_CYCLING = section.dataset.enableCycling === 'true';
      var rawDist = parseInt(section.dataset.cycleDistance, 10);
      if (isNaN(rawDist)) rawDist = 50;
      var CYCLE_DISTANCE = Math.max(rawDist, 10);

      /* Cursor + interpolated state for the preview's smooth
         follow animation. */
      var mouseX = 0, mouseY = 0;
      var posX = 0, posY = 0;
      var activePreview = null;
      var rafId = null;

      /* Cycling state — per-row data is captured in row event
         handlers, but the "active" cycle state lives at section
         scope so the global mousemove handler can read it. */
      var lastCycleX = 0, lastCycleY = 0;
      var travelAccumulator = 0;
      var cycleState = 0;
      var activeRow = null;
      var activeThumbs = null;
      var activeSrcs = null;

      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      /* Apply the current cycle state to the visible thumbnails.
         Each card slot i shows product (state + i) mod totalProducts.
         Wraps around indefinitely so sweeping the mouse keeps
         cycling through the collection. */
      function applyCycle() {
        if (!activeThumbs || !activeSrcs || activeSrcs.length === 0) return;
        var n = activeSrcs.length;
        for (var i = 0; i < activeThumbs.length; i++) {
          var thumb = activeThumbs[i];
          var srcIndex = ((cycleState + i) % n + n) % n;
          var newSrc = activeSrcs[srcIndex];
          if (thumb.getAttribute('src') !== newSrc) {
            thumb.setAttribute('src', newSrc);
            /* Brief opacity flicker so the swap registers as a
               beat. Removing the class on the next frame restarts
               the transition cleanly even on rapid swaps. */
            thumb.classList.add('is-pulsing');
            /* Force reflow so removing the class triggers transition. */
            /* eslint-disable-next-line no-unused-expressions */
            thumb.offsetWidth;
            thumb.classList.remove('is-pulsing');
          }
        }
      }

      function updatePosition() {
        rafId = null;
        if (!activePreview) return;

        /* Lerp toward the cursor — 0.18 gives a subtle ~6-frame
           lag at 60fps, organic without feeling laggy. */
        var damping = prefersReducedMotion ? 1 : 0.18;
        posX += (mouseX - posX) * damping;
        posY += (mouseY - posY) * damping;

        /* Smart positioning — start 40px right of cursor, vertically
           centered on cursor; flip to the left side when cursor is
           in the right half of the viewport; clamp against viewport
           edges so the preview never gets clipped. */
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var x = (posX > vw / 2) ? posX - STACK_SIZE - 40 : posX + 40;
        var y = posY - STACK_SIZE / 2;
        x = clamp(x, EDGE_MARGIN, vw - STACK_SIZE - EDGE_MARGIN);
        y = clamp(y, EDGE_MARGIN, vh - STACK_SIZE - EDGE_MARGIN);

        activePreview.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

        if (Math.abs(mouseX - posX) > 0.3 || Math.abs(mouseY - posY) > 0.3) {
          rafId = requestAnimationFrame(updatePosition);
        }
      }

      function onMouseMove(e) {
        mouseX = e.clientX;
        mouseY = e.clientY;

        /* Accumulate cursor travel since last cycle advance.
           Manhattan distance (|dx| + |dy|) is cheap and the small
           imprecision vs euclidean distance is irrelevant for
           feel. When the accumulator passes the threshold we
           advance the cycle by however many steps fit. Only runs
           when the merchant has enabled cycling — otherwise the
           server-rendered initial product set stays put. */
        if (ENABLE_CYCLING && activeRow) {
          var dx = e.clientX - lastCycleX;
          var dy = e.clientY - lastCycleY;
          travelAccumulator += Math.abs(dx) + Math.abs(dy);
          lastCycleX = e.clientX;
          lastCycleY = e.clientY;

          if (travelAccumulator >= CYCLE_DISTANCE) {
            var steps = Math.floor(travelAccumulator / CYCLE_DISTANCE);
            travelAccumulator -= steps * CYCLE_DISTANCE;
            cycleState += steps;
            applyCycle();
          }
        }

        if (activePreview && rafId === null) {
          rafId = requestAnimationFrame(updatePosition);
        }
      }

      /* Wire each row independently. Tracking which row is active
         is implicit: only one row can be hovered at a time, so a
         single `activeRow` ref is enough. */
      var rows = section.querySelectorAll('.cidx__row');
      rows.forEach(function(row) {
        var preview = row.querySelector('.cidx__preview');
        if (!preview) return;

        var thumbs = preview.querySelectorAll('[data-thumb]');
        var pool = preview.querySelector('.cidx__pool');
        var srcsRaw = pool ? pool.getAttribute('data-srcs') || '' : '';
        var srcs = srcsRaw ? srcsRaw.split('|').filter(function(s) { return s; }) : [];

        row.addEventListener('mouseenter', function(e) {
          activePreview = preview;
          activeRow = row;
          activeThumbs = thumbs;
          activeSrcs = srcs;

          /* Reset cycle state on each entry so the row always opens
             with products 0..T-1 visible — predictable starting
             point. The original images rendered server-side already
             match this, so applyCycle() is unnecessary on entry. */
          cycleState = 0;
          travelAccumulator = 0;
          lastCycleX = e.clientX;
          lastCycleY = e.clientY;

          /* Snap the interpolated position to the cursor so the
             preview doesn't fly across the screen from wherever the
             previous row's preview ended up. */
          posX = e.clientX;
          posY = e.clientY;
          mouseX = e.clientX;
          mouseY = e.clientY;
          preview.classList.add('is-active');

          /* Set initial transform so the first paint shows the
             preview at the right spot, not at translate(0,0). */
          var vw = window.innerWidth;
          var vh = window.innerHeight;
          var x = (posX > vw / 2) ? posX - STACK_SIZE - 40 : posX + 40;
          var y = posY - STACK_SIZE / 2;
          x = clamp(x, EDGE_MARGIN, vw - STACK_SIZE - EDGE_MARGIN);
          y = clamp(y, EDGE_MARGIN, vh - STACK_SIZE - EDGE_MARGIN);
          preview.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        });

        row.addEventListener('mouseleave', function() {
          if (activeRow === row) {
            activeRow = null;
            activeThumbs = null;
            activeSrcs = null;
          }
          preview.classList.remove('is-active');
          if (activePreview === preview) {
            activePreview = null;
          }
          if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
        });
      });

      document.addEventListener('mousemove', onMouseMove, { passive: true });
    }

    function initAll(root) {
      (root || document).querySelectorAll('.cidx').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function(e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-the-look"] && !Shopify.designMode) return;
  try {
    
  /* Complete-the-look section script.
     Liquid-free: every per-section setting and global setting that
     used to be interpolated inline is now read at runtime from
     data-ctl-config (a JSON blob on .ctl-section). Section id is
     read from data-section-id. Multi-instance safe, with a
     data-csp-init guard, and re-runs on shopify:section:load. */
  (function () {
    function initSection(ctlSection) {
      if (!ctlSection || ctlSection.dataset.cspInit === 'true') return;
      ctlSection.dataset.cspInit = 'true';

      var sectionId = ctlSection.dataset.sectionId;
      if (!sectionId) return;

      var sectionEl = document.getElementById('shopify-section-' + sectionId);
      if (!sectionEl) {
        /* Fall back to the closest shopify-section wrapper if id lookup fails */
        sectionEl = ctlSection.closest('[id^="shopify-section-"]') || ctlSection.parentNode;
      }

      /* ── Parse config blob (replaces every former Liquid interpolation) ── */
      var cfg = {};
      try { cfg = JSON.parse(ctlSection.dataset.ctlConfig || '{}'); } catch (e) { cfg = {}; }

      var ctlT = {
        addToCart:              cfg.addToCart              || 'Add to cart',
        addToWishlist:          cfg.addToWishlist          || 'Add to wishlist',
        removeFromList:         cfg.removeFromList         || 'Remove from wishlist',
        adding:                 cfg.adding                 || 'Adding...',
        soldOut:                cfg.soldOut                || 'Sold out',
        unavailable:            cfg.unavailable            || 'Unavailable',
        errorGeneric:           cfg.errorGeneric           || "Sorry, we couldn't add that to cart.",
        addToWishlistAria:      cfg.addToWishlistAria      || '',
        removeFromWishlistAria: cfg.removeFromWishlistAria || ''
      };
      var soldoutMsg    = cfg.soldoutMsg || 'This product is sold out.';
      var stockMsg      = cfg.stockMsg   || "Sorry, only %available% available and you already have %in_cart% in your cart.";
      var addedMsg      = cfg.addedMsg   || 'Your selection has been reserved.';
      var ATC_STYLE_CART     = cfg.atcStyleCart     || 'primary';
      var ATC_STYLE_WISHLIST = cfg.atcStyleWishlist || 'secondary';
      var cartType      = cfg.cartType      || 'drawer';
      var cartAddAction = cfg.cartAddAction || 'drawer';

      /* ── QA Drawer ────────────────────────────────────────────── */
      (function () {
        var drawer  = document.getElementById('ctl-qa-drawer-' + sectionId);
        var overlay = document.getElementById('ctl-qa-overlay-' + sectionId);
        if (!drawer) return;

        var titleEl   = drawer.querySelector('.ctl-qa-drawer__product-title');
        var priceEl   = drawer.querySelector('.ctl-qa-drawer__price');
        var imageEl   = drawer.querySelector('.ctl-qa-drawer__image');
        var optionsEl = drawer.querySelector('.ctl-qa-drawer__options');
        var atcBtn    = drawer.querySelector('.ctl-qa-drawer__atc');
        var closeBtn  = drawer.querySelector('.ctl-qa-drawer__close');

        /* ATC button style swap: 'cart' on add-to-cart flow, 'wishlist' on wishlist flow */
        function applyAtcStyle(mode) {
          atcBtn.dataset.buttonStyle = (mode === 'wishlist') ? ATC_STYLE_WISHLIST : ATC_STYLE_CART;
          atcBtn.dataset.qaMode = mode;
        }

        var currentVariants = [];
        var selectedOptions = {};
        var wishlistMode = false;
        var wishlistRemoveMode = false;
        var wishlistSourceBtn = null;
        var wishlistHandle = null;

        /* ── Cart toast wrapper ──────────────────────────────────
           Thin shim around the global window.cartToast API (rendered
           once via cart-toast snippet in theme.liquid). */
        function showToast(msg, isError, btn) {
          if (!window.cartToast) return;
          var productImage = btn && btn.dataset ? (btn.dataset.productImage || '') : '';
          var productTitle = btn && btn.dataset ? (btn.dataset.productTitle || '') : '';
          window.cartToast.show({
            type:         isError ? 'error' : 'success',
            message:      msg,
            productImage: productImage,
            productTitle: productTitle,
            quantity:     1
          });
        }

        var cartQty = {};
        function refreshCartQty(cb) {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            cartQty = {};
            cart.items.forEach(function (item) { cartQty[String(item.variant_id)] = item.quantity; });
            if (cb) cb();
          }).catch(function () { if (cb) cb(); });
        }
        refreshCartQty();

        /* Swatch map for color rendering inside QA drawer */
        var swatchMap = {};
        function buildSwatchMap() {
          swatchMap = {};
          (drawer.dataset.swatches || '').split('||').forEach(function (entry) {
            if (!entry) return;
            var parts = entry.split(':');
            swatchMap[parts[0]] = { type: parts[1], val: parts.slice(2).join(':') };
          });
        }
        buildSwatchMap();
        function getSwatchStyle(val) {
          if (!val) return null;
          var key = String(val).toLowerCase().replace(/\s/g, '');
          var s = swatchMap[key];
          if (s && s.type === 'image' && s.val) return { backgroundImage: 'url(' + s.val + ')', backgroundSize: 'cover' };
          if (s && s.type === 'color' && s.val) return { backgroundColor: s.val };
          /* Fallback: when Shopify didn't auto-resolve a swatch for this
             option value (no swatch.color or swatch.image set, type is
             'none', or the value isn't in the map at all), try the value
             name itself as a CSS color. "Light Green" → "lightgreen" is
             a valid CSS named color, so the dot renders without the
             merchant having to set the swatch metafield. Strips spaces,
             hyphens, and underscores so values entered as "Light-Green"
             or "Light_Green" also resolve. Returns null for unknown
             names so the option renders as a plain text button. */
          var cssCandidate = String(val).toLowerCase().replace(/[\s\-_]/g, '');
          if (!cssCandidate) return null;
          var valid = false;
          if (typeof CSS !== 'undefined' && CSS.supports) {
            valid = CSS.supports('color', cssCandidate);
          } else {
            var tester = getSwatchStyle._tester || (getSwatchStyle._tester = document.createElement('div'));
            tester.style.backgroundColor = '';
            tester.style.backgroundColor = cssCandidate;
            valid = tester.style.backgroundColor !== '';
          }
          if (valid) return { backgroundColor: cssCandidate };
          return null;
        }

        function openDrawer() {
          drawer.setAttribute('aria-hidden', 'false');
          overlay.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          if (wishlistRemoveMode)      { atcBtn.textContent = ctlT.removeFromList; atcBtn.classList.add('ctl-qa-drawer__atc--wishlist', 'ctl-qa-drawer__atc--remove'); }
          else if (wishlistMode)       { atcBtn.textContent = ctlT.addToWishlist;  atcBtn.classList.add('ctl-qa-drawer__atc--wishlist'); atcBtn.classList.remove('ctl-qa-drawer__atc--remove'); }
          else                         { atcBtn.textContent = ctlT.addToCart;      atcBtn.classList.remove('ctl-qa-drawer__atc--wishlist', 'ctl-qa-drawer__atc--remove'); }
        }
        function closeDrawer() {
          drawer.setAttribute('aria-hidden', 'true');
          overlay.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          wishlistMode = false; wishlistRemoveMode = false;
          wishlistSourceBtn = null; wishlistHandle = null;
          atcBtn.textContent = ctlT.addToCart;
          atcBtn.classList.remove('ctl-qa-drawer__atc--wishlist', 'ctl-qa-drawer__atc--remove');
          applyAtcStyle('cart');
        }

        function money(cents) {
          var n = (cents / 100).toFixed(2);
          var p = n.split('.');
          p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return '$ ' + p.join('.');
        }
        function findVariant() {
          return currentVariants.find(function (v) {
            return v.options.every(function (opt, i) { return selectedOptions['o' + (i + 1)] === opt; });
          }) || null;
        }
        function updateAtcBtn() {
          var v = findVariant();
          if (v && (wishlistMode || wishlistRemoveMode)) {
            var inWl = window.wishlistDrawer ? window.wishlistDrawer.isInWishlist(v.id) :
              (function () { try { return (JSON.parse(localStorage.getItem('wishlist_items')) || []).some(function (i) { return String(i.variantId) === String(v.id); }); } catch (e) { return false; } })();
            wishlistRemoveMode = inWl; wishlistMode = !inWl;
            atcBtn.classList.toggle('ctl-qa-drawer__atc--remove', inWl);
          }
          if (!v) {
            atcBtn.textContent = wishlistRemoveMode ? ctlT.removeFromList : (wishlistMode ? ctlT.addToWishlist : ctlT.unavailable);
            atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
            delete atcBtn.dataset.variantId;
          } else if (!v.available) {
            atcBtn.textContent = wishlistRemoveMode ? ctlT.removeFromList : (wishlistMode ? ctlT.addToWishlist : ctlT.soldOut);
            atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
            atcBtn.dataset.variantId = v.id;
          } else {
            atcBtn.textContent = wishlistRemoveMode ? ctlT.removeFromList : (wishlistMode ? ctlT.addToWishlist : ctlT.addToCart);
            atcBtn.disabled = false;
            atcBtn.dataset.variantId = v.id;
          }
          if (v) { priceEl.textContent = money(v.price); if (v.featured_image) imageEl.src = v.featured_image.src; }
          optionsEl.querySelectorAll('.ctl-qa-option-btn,.ctl-qa-color-btn').forEach(function (b) {
            var testKey = 'o' + b.dataset.pos;
            var test = Object.assign({}, selectedOptions); test[testKey] = b.dataset.value;
            b.classList.toggle('is-unavailable', !currentVariants.some(function (v) { return v.options.every(function (o, i) { return test['o' + (i + 1)] === o; }); }));
            var other = Object.assign({}, selectedOptions); delete other[testKey];
            b.classList.toggle('is-sold-out', !currentVariants.some(function (v) { return v.available && v.options[parseInt(b.dataset.pos, 10) - 1] === b.dataset.value && Object.keys(other).every(function (k) { return other[k] === v.options[parseInt(k.slice(1), 10) - 1]; }); }));
          });
        }
        function renderOptions(product, preselectId) {
          currentVariants = product.variants; selectedOptions = {};
          var hasReal = product.variants.length > 1 || (product.variants.length === 1 && product.variants[0].title !== 'Default Title');
          optionsEl.style.display = hasReal ? '' : 'none';
          var first = product.variants[0];
          if (preselectId) { var pv = product.variants.find(function (v) { return String(v.id) === String(preselectId); }); if (pv) first = pv; }
          if (!first) first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
          product.options.forEach(function (name, i) { selectedOptions['o' + (i + 1)] = first.options[i]; });
          optionsEl.innerHTML = '';
          product.options.forEach(function (optRaw, idx) {
            var optName = typeof optRaw === 'object' ? optRaw.name : optRaw;
            var pos = idx + 1;
            var vals = [];
            product.variants.forEach(function (v) { if (vals.indexOf(v.options[idx]) === -1) vals.push(v.options[idx]); });
            var isColor = vals.some(function (v) { return !!getSwatchStyle(v); });
            var wrap = document.createElement('div'); wrap.className = 'ctl-qa-option';
            var label = document.createElement('p'); label.className = 'ctl-qa-option__label';
            var selSpan = document.createElement('span'); selSpan.className = 'ctl-qa-option__selected'; selSpan.textContent = selectedOptions['o' + pos];
            label.textContent = optName + ': '; label.appendChild(selSpan);
            var btns = document.createElement('div'); btns.className = isColor ? 'ctl-qa-option__btns ctl-qa-option__btns--colors' : 'ctl-qa-option__btns';
            vals.forEach(function (val) {
              var swatch = isColor ? getSwatchStyle(val) : null;
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.dataset.pos = pos; btn.dataset.value = val;
              var colorSoldOut = isColor && !currentVariants.some(function (v) { return v.options[idx] === val && v.available; });
              if (swatch) {
                btn.className = 'ctl-qa-color-btn'; if (colorSoldOut) btn.classList.add('is-sold-out');
                var dot = document.createElement('span'); dot.className = 'ctl-qa-color-dot'; Object.assign(dot.style, swatch);
                var nm = document.createElement('span'); nm.className = 'ctl-qa-color-name'; nm.textContent = val.toUpperCase();
                btn.appendChild(dot); btn.appendChild(nm);
              } else {
                btn.className = 'ctl-qa-option-btn'; btn.textContent = val;
                if (!currentVariants.some(function (v) { return v.options[idx] === val && v.available; })) btn.classList.add('is-sold-out');
              }
              if (selectedOptions['o' + pos] === val) btn.classList.add('is-selected');
              btn.addEventListener('click', function () {
                selectedOptions['o' + pos] = val; selSpan.textContent = val;
                btns.querySelectorAll('.ctl-qa-option-btn,.ctl-qa-color-btn').forEach(function (b) { b.classList.remove('is-selected'); });
                btn.classList.add('is-selected'); updateAtcBtn();
              });
              btns.appendChild(btn);
            });
            wrap.appendChild(label); wrap.appendChild(btns); optionsEl.appendChild(wrap);
          });
          updateAtcBtn();
        }
        var variantInvMap = {};
        function parseVariantInvMap(card) {
          variantInvMap = {};
          if (!card) return;
          (card.dataset.variantInv || '').split('|').forEach(function (e) { if (!e) return; var p = e.split(':'); if (p.length < 3) return; variantInvMap[p[0]] = { qty: parseInt(p[1], 10), policy: p[2] }; });
        }
        function loadAndOpen(handle, btn, preselectId) {
          var card = btn.closest ? btn.closest('.product-card') : null;
          parseVariantInvMap(card);
          if (btn.classList) btn.classList.add('is-loading');
          fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
            if (btn.classList) btn.classList.remove('is-loading');
            titleEl.textContent = p.title; priceEl.textContent = money(p.price_min);
            imageEl.src = p.featured_image || ''; imageEl.alt = p.title;
            atcBtn.dataset.productTitle = p.title;
            renderOptions(p, preselectId);
            refreshCartQty(function () { openDrawer(); });
          }).catch(function () { if (btn.classList) btn.classList.remove('is-loading'); });
        }

        /* Click delegation: only inside this section */
        document.addEventListener('click', function (e) {
          if (!sectionEl.contains(e.target)) return;

          var qaBtn = e.target.closest('.product-card__quick-add');
          if (qaBtn) {
            e.preventDefault(); e.stopPropagation();
            if (qaBtn.dataset.multiVariant !== 'true' && qaBtn.dataset.variantId) {
              var vid = String(qaBtn.dataset.variantId);
              var invQty = parseInt(qaBtn.dataset.inventory, 10);
              var invPolicy = qaBtn.dataset.inventoryPolicy || 'deny';
              var inCart = cartQty[vid] || 0;
              if (qaBtn.dataset.available === 'false') { showToast(soldoutMsg, true); return; }
              if (invPolicy === 'deny' && !isNaN(invQty) && invQty > 0 && inCart >= invQty) { showToast(stockMsg.replace('%available%', invQty).replace('%in_cart%', inCart), true); return; }
              qaBtn.classList.add('is-loading');
              fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
                .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
                .then(function (res) {
                  qaBtn.classList.remove('is-loading');
                  if (res.ok) { cartQty[vid] = (cartQty[vid] || 0) + 1; showToast(addedMsg, false, btn); document.dispatchEvent(new CustomEvent('cart:updated')); handlePostAdd(); }
                  else { refreshCartQty(); showToast((res.data && (res.data.description || res.data.message)) || ctlT.errorGeneric, true); }
                }).catch(function () { qaBtn.classList.remove('is-loading'); showToast(ctlT.errorGeneric, true); });
            } else {
              loadAndOpen(qaBtn.dataset.productHandle, qaBtn, qaBtn.dataset.variantId);
            }
            return;
          }
        });

        atcBtn.addEventListener('click', function () {
          var vid = atcBtn.dataset.variantId;
          if (!vid || vid === 'undefined') return;
          if (wishlistRemoveMode) {
            if (window.wishlistDrawer) window.wishlistDrawer.remove(vid);
            document.querySelectorAll('[data-wishlist-add="' + vid + '"]').forEach(function (b) { b.classList.remove('is-wishlisted'); b.setAttribute('aria-label', ctlT.addToWishlistAria); });
            closeDrawer(); return;
          }
          if (wishlistMode) {
            var handle = wishlistHandle;
            if (window.wishlistDrawer) { window.wishlistDrawer.add(vid, handle); }
            else { try { var wl = JSON.parse(localStorage.getItem('wishlist_items')) || []; if (!wl.some(function (i) { return i.variantId == vid; })) { wl.push({ variantId: vid, productHandle: handle, addedAt: Date.now() }); localStorage.setItem('wishlist_items', JSON.stringify(wl)); } } catch (e) {} }
            if (wishlistSourceBtn) { wishlistSourceBtn.classList.add('is-wishlisted'); wishlistSourceBtn.setAttribute('aria-label', ctlT.removeFromWishlistAria); }
            document.querySelectorAll('[data-wishlist-add="' + vid + '"]').forEach(function (b) { b.classList.add('is-wishlisted'); });
            closeDrawer();
            if (window.wishlistDrawer) window.wishlistDrawer.open();
            return;
          }
          var invData = variantInvMap[vid] || {}; var invQty = invData.qty != null ? invData.qty : NaN; var invPolicy = invData.policy || 'deny'; var inCart = cartQty[vid] || 0;
          if (invPolicy === 'deny' && !isNaN(invQty) && invQty > 0 && inCart >= invQty) { showToast(stockMsg.replace('%available%', invQty).replace('%in_cart%', inCart), true); return; }
          atcBtn.textContent = ctlT.adding; atcBtn.disabled = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
            .then(function (res) {
              if (res.ok) { cartQty[String(vid)] = (cartQty[String(vid)] || 0) + 1; closeDrawer(); var qaCtx = { dataset: { productImage: (imageEl && imageEl.src) || '', productTitle: (titleEl && titleEl.textContent) || '' } }; showToast(addedMsg, false, qaCtx); document.dispatchEvent(new CustomEvent('cart:updated')); handlePostAdd(); }
              else { atcBtn.textContent = ctlT.addToCart; atcBtn.disabled = false; refreshCartQty(); showToast((res.data && (res.data.description || res.data.message)) || ctlT.errorGeneric, true); }
            }).catch(function () { atcBtn.textContent = ctlT.addToCart; atcBtn.disabled = false; showToast(ctlT.errorGeneric, true); });
        });

        closeBtn.addEventListener('click', closeDrawer);
        overlay.addEventListener('click', closeDrawer);
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

        /* Expose API for global wishlist click handler */
        window.ctlQuickAdd = window.ctlQuickAdd || {};
        window.ctlQuickAdd[sectionId] = {
          openForWishlistRemove: function (handle, sourceBtn, preselectId) {
            wishlistMode = false; wishlistRemoveMode = true;
            wishlistSourceBtn = sourceBtn; wishlistHandle = handle;
            fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
              titleEl.textContent = p.title; priceEl.textContent = money(p.price_min);
              imageEl.src = p.featured_image || ''; imageEl.alt = p.title;
              atcBtn.dataset.productTitle = p.title;
              renderOptions(p, preselectId);
              applyAtcStyle('wishlist');
              openDrawer();
            }).catch(function () { wishlistRemoveMode = false; if (window.wishlistDrawer) window.wishlistDrawer.remove(sourceBtn ? sourceBtn.dataset.wishlistAdd : null); });
          },
          openForWishlist: function (handle, sourceBtn) {
            fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
              var hasReal = p.variants.length > 1 || (p.variants.length === 1 && p.variants[0].title !== 'Default Title');
              if (!hasReal) {
                var vid = p.variants[0].id;
                if (window.wishlistDrawer) { window.wishlistDrawer.add(vid, handle); }
                else { try { var wl = JSON.parse(localStorage.getItem('wishlist_items')) || []; if (!wl.some(function (i) { return i.variantId == vid; })) { wl.push({ variantId: vid, productHandle: handle, addedAt: Date.now() }); localStorage.setItem('wishlist_items', JSON.stringify(wl)); } } catch (e) {} }
                if (sourceBtn) { sourceBtn.classList.add('is-wishlisted'); sourceBtn.setAttribute('aria-label', ctlT.removeFromWishlistAria); }
                if (window.wishlistDrawer) window.wishlistDrawer.open();
              } else {
                wishlistMode = true; wishlistSourceBtn = sourceBtn; wishlistHandle = handle;
                titleEl.textContent = p.title; priceEl.textContent = money(p.price_min);
                imageEl.src = p.featured_image || ''; imageEl.alt = p.title;
                atcBtn.dataset.productTitle = p.title;
                var preselectId = sourceBtn ? sourceBtn.dataset.wishlistAdd : null;
                renderOptions(p, preselectId);
                applyAtcStyle('wishlist');
                openDrawer();
              }
            }).catch(function () { wishlistMode = true; wishlistSourceBtn = sourceBtn; wishlistHandle = handle; var preselectId = sourceBtn ? sourceBtn.dataset.wishlistAdd : null; applyAtcStyle('wishlist'); loadAndOpen(handle, { classList: { add: function () {}, remove: function () {} } }, preselectId); });
          }
        };

        function handlePostAdd() {
          if (cartAddAction === 'drawer' && cartType === 'drawer') { if (window.cartDrawer) window.cartDrawer.open(); }
          else if (cartAddAction === 'page') { window.location.href = '/cart'; }
        }
        document.addEventListener('cart:updated', function () { refreshCartQty(); });
      })();

      /* ── Card image swatch sync + swatch click delegation ─────── */
      function syncCardButtons(card, variantId) {
        var qabtns = card.querySelectorAll('.product-card__quick-add');
        var wlbtns = card.querySelectorAll('.product-card__wishlist');
        if (variantId === null) {
          qabtns.forEach(function (b) { if (b.dataset.defaultVariantId) b.dataset.variantId = b.dataset.defaultVariantId; });
          wlbtns.forEach(function (b) { if (b.dataset.defaultVariantId) b.dataset.wishlistAdd = b.dataset.defaultVariantId; });
        } else {
          qabtns.forEach(function (b) { if (!b.dataset.defaultVariantId) b.dataset.defaultVariantId = b.dataset.variantId; b.dataset.variantId = variantId; });
          wlbtns.forEach(function (b) { if (!b.dataset.defaultVariantId) b.dataset.defaultVariantId = b.dataset.wishlistAdd; b.dataset.wishlistAdd = variantId; });
        }
        if (window.wishlistDrawer && window.wishlistDrawer.sync) window.wishlistDrawer.sync();
      }

      /* Swatch delegation: clicking a swatch navigates to the product variant page */
      sectionEl.addEventListener('click', function (e) {
        var swatch = e.target.closest('.product-card__swatch[data-color]');
        if (!swatch) return;
        var card = swatch.closest('.product-card');
        if (!card) return;

        e.preventDefault(); e.stopPropagation();
        var url = swatch.dataset.productUrl || ''; var variantId = swatch.dataset.variantId || '';
        if (url) window.location.href = variantId ? url + '?variant=' + variantId : url;
      });

      if (window.wishlistDrawer && window.wishlistDrawer.sync) window.wishlistDrawer.sync();
    }

    function init(root) {
      (root || document).querySelectorAll('.ctl-section').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init: when a merchant saves a setting, Shopify
       replaces the section's DOM with a fresh node that has no
       data-csp-init flag, so initSection runs cleanly on it. */
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    function initSection(section) {
      if (!section) return;
      if (section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

      var form = section.querySelector('.csp-cf__form');
      if (!form) return;

      /* ── Custom dropdown component ──────────────────────────────
         Click trigger to toggle panel. Click an option (or use
         arrow keys + Enter) to select it. Selected value gets
         written to the hidden input that the form submit handler
         reads when building contact[body]. */
      section.querySelectorAll('[data-csp-dropdown]').forEach(function(dropdown) {
        var trigger = dropdown.querySelector('[data-csp-dropdown-trigger]');
        var panel   = dropdown.querySelector('[data-csp-dropdown-panel]');
        var input   = dropdown.querySelector('[data-csp-dropdown-input]');
        var label   = dropdown.querySelector('[data-csp-dropdown-value]');
        var options = Array.prototype.slice.call(dropdown.querySelectorAll('[role="option"]'));
        if (!trigger || !panel || !input || !label || options.length === 0) return;

        var activeIndex = -1;

        /* If an option has aria-selected="true" at page load (e.g. the
           country dropdown defaults to United States), sync the
           hidden input and label with it. */
        var preSelected = options.find(function(o) {
          return o.getAttribute('aria-selected') === 'true';
        });
        if (preSelected) {
          input.value = preSelected.getAttribute('data-value') || '';
          label.textContent = preSelected.textContent.trim();
          label.classList.remove('csp-cf__dropdown-value--placeholder');
        }

        function openPanel() {
          panel.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          var selectedIdx = -1;
          for (var i = 0; i < options.length; i++) {
            if (options[i].getAttribute('aria-selected') === 'true') { selectedIdx = i; break; }
          }
          activeIndex = selectedIdx >= 0 ? selectedIdx : 0;
          setActive(activeIndex);
        }
        function closePanel() {
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          activeIndex = -1;
          options.forEach(function(o) { o.removeAttribute('data-active'); });
        }
        function setActive(idx) {
          options.forEach(function(o, i) {
            if (i === idx) {
              o.setAttribute('data-active', 'true');
              o.scrollIntoView({ block: 'nearest' });
            } else {
              o.removeAttribute('data-active');
            }
          });
          activeIndex = idx;
        }
        function selectOption(opt) {
          input.value = opt.getAttribute('data-value') || '';
          label.textContent = opt.textContent.trim();
          label.classList.remove('csp-cf__dropdown-value--placeholder');
          options.forEach(function(o) { o.removeAttribute('aria-selected'); });
          opt.setAttribute('aria-selected', 'true');
          dropdown.classList.remove('is-invalid');
          closePanel();
          trigger.focus();
        }

        trigger.addEventListener('click', function(e) {
          e.stopPropagation();
          if (panel.hidden) openPanel(); else closePanel();
        });

        options.forEach(function(opt) {
          opt.addEventListener('click', function(e) {
            e.stopPropagation();
            selectOption(opt);
          });
          opt.addEventListener('mouseenter', function() {
            setActive(options.indexOf(opt));
          });
        });

        document.addEventListener('click', function(e) {
          if (!dropdown.contains(e.target)) closePanel();
        });

        trigger.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            if (panel.hidden) {
              openPanel();
            } else {
              var dir = e.key === 'ArrowDown' ? 1 : -1;
              setActive((activeIndex + dir + options.length) % options.length);
            }
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (panel.hidden) openPanel();
            else if (activeIndex >= 0) selectOption(options[activeIndex]);
          } else if (e.key === 'Escape' && !panel.hidden) {
            e.preventDefault();
            closePanel();
          }
        });
      });

      /* ── Character counter ──────────────────────────────────
         Live update + warning/error states near and over the limit. */
      var textarea = section.querySelector('[data-csp-cf-message]');
      var counter  = section.querySelector('[data-csp-cf-counter]');
      if (textarea && counter) {
        var max = parseInt(textarea.getAttribute('data-max'), 10) || 400;
        var counterLabel = section.getAttribute('data-counter-label') || 'character(s) left';

        var updateCounter = function() {
          var len = textarea.value.length;
          var remaining = max - len;
          counter.textContent = remaining + ' ' + counterLabel;
          counter.classList.toggle('is-near-limit', remaining <= max * 0.1 && remaining > 0);
          counter.classList.toggle('is-over-limit', remaining <= 0);
        };
        textarea.addEventListener('input', updateCounter);
        updateCounter();
      }

      /* ── Submit handler ─────────────────────────────────────────
         Three responsibilities:

         1. Build the final field values:
            - phone gets the country code prepended (e.g. "+1 555-1234")
            - contact[body] gets Order/Topic dropdown context prepended

         2. Run client-side validation BEFORE the network. If a
            required field is empty or an email looks malformed, we
            mark the field invalid and show an inline error.

         3. If validation passes, submit via fetch. We parse the
            returned HTML to see if Shopify accepted the message
            or rejected it with errors, then update the DOM without
            a page reload.

         If JS fails / fetch isn't available, the native form
         submit takes over as a graceful fallback. */
      form.addEventListener('submit', function(event) {

        function showFieldError(fieldEl, message) {
          if (!fieldEl) return;
          fieldEl.classList.add('is-invalid');
          var errEl = fieldEl.querySelector('[data-csp-cf-error]');
          if (errEl) {
            errEl.textContent = message;
            errEl.hidden = false;
          }
        }
        function clearFieldError(fieldEl) {
          if (!fieldEl) return;
          fieldEl.classList.remove('is-invalid');
          var errEl = fieldEl.querySelector('[data-csp-cf-error]');
          if (errEl) {
            errEl.textContent = '';
            errEl.hidden = true;
          }
        }
        /* Walk every field and clear any previous error state — we
           re-validate from scratch on each submit. */
        form.querySelectorAll('.csp-cf__field').forEach(clearFieldError);

        /* Pull every field reference up-front for clarity. */
        var firstName = form.querySelector('input[name="contact[first_name]"]');
        var lastName  = form.querySelector('input[name="contact[last_name]"]');
        var email     = form.querySelector('input[name="contact[email]"]');
        var phone     = form.querySelector('input[name="contact[phone]"]');
        var msg       = form.querySelector('[data-csp-cf-message]');

        /* — Client-side validation — */
        var hasError = false;
        var validations = [
          { el: firstName, msg: 'First name is required' },
          { el: lastName,  msg: 'Last name is required' },
          { el: msg,       msg: 'Message is required' }
        ];
        validations.forEach(function(v) {
          if (v.el && v.el.required && !v.el.value.trim()) {
            showFieldError(v.el.closest('.csp-cf__field'), v.msg);
            hasError = true;
          }
        });
        /* Email needs format check on top of presence. The regex is
           intentionally loose — Shopify's own validator is the
           authoritative one; this just catches obvious typos before
           a network round-trip. */
        if (email) {
          var emailValue = email.value.trim();
          if (!emailValue) {
            showFieldError(email.closest('.csp-cf__field'), 'Email is required');
            hasError = true;
          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
            showFieldError(email.closest('.csp-cf__field'), 'Please enter a valid email address');
            hasError = true;
          }
        }
        /* Phone: only validate if shown AND required AND filled.
           Empty + optional is fine. */
        if (phone && phone.required && !phone.value.trim()) {
          showFieldError(phone.closest('.csp-cf__field'), 'Phone is required');
          hasError = true;
        }
        if (hasError) {
          event.preventDefault();
          /* Scroll to the first invalid field so the user sees it. */
          var firstInvalid = form.querySelector('.csp-cf__field.is-invalid');
          if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }

        /* — Field transformations (phone prefix, body composition) — */
        var countryInput = form.querySelector('input[name="csp_cf_country"]');
        if (phone && countryInput && countryInput.value && phone.value.trim()) {
          var rawPhone = phone.value.trim();
          if (rawPhone.charAt(0) !== '+') {
            phone.value = countryInput.value + ' ' + rawPhone;
          }
        }

        var hidden = form.querySelector('[data-csp-cf-body]');
        if (hidden && msg) {
          var parts = [];
          var orderInput = form.querySelector('input[name="csp_cf_order"]');
          if (orderInput && orderInput.value) parts.push('Order: ' + orderInput.value);
          var topicInput = form.querySelector('input[name="csp_cf_topic"]');
          if (topicInput && topicInput.value) parts.push('Topic: ' + topicInput.value);
          var prefix = parts.length ? parts.join('\n') + '\n\n' : '';
          hidden.value = prefix + msg.value;
        }

        /* — AJAX submission via fetch — */
        /* If fetch isn't available (very old browsers), let the
           native form submit run as a fallback. */
        if (typeof window.fetch !== 'function' || typeof FormData !== 'function') {
          return;
        }

        event.preventDefault();

        var submitBtn = form.querySelector('.csp-cf__submit');
        if (submitBtn) submitBtn.disabled = true;

        /* Build the FormData payload. We let the browser construct
           the multipart body so file inputs / encoding edge cases
           are handled correctly. */
        var formData = new FormData(form);
        var sectionId = section.getAttribute('data-section-id');

        fetch(window.location.pathname, {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'text/html' },
          credentials: 'same-origin'
        })
        .then(function(response) {
          return response.text().then(function(html) {
            return { html: html, status: response.status, ok: response.ok };
          });
        })
        .then(function(result) {
          /* Parse the response HTML and look for our section's
             rendered DOM. Shopify re-renders the whole page; we just
             need our own section's updated state. */
          var parser = new DOMParser();
          var doc = parser.parseFromString(result.html, 'text/html');
          var newSection = doc.querySelector('[data-section-id="' + sectionId + '"].csp-cf');

          if (!newSection) {
            /* Couldn't find our section in the response — fall back
               to a hard reload so the user isn't left in limbo. */
            window.location.reload();
            return;
          }

          /* Did Shopify accept the submission? Look for our success
             card class. If present, swap in the new content. */
          var newSuccess = newSection.querySelector('.csp-cf__success');
          if (newSuccess) {
            var content = section.querySelector('.csp-cf__content');
            var newContent = newSection.querySelector('.csp-cf__content');
            if (content && newContent) {
              content.innerHTML = newContent.innerHTML;
              content.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
          }

          /* Otherwise, look for an error block. If the response had
             form.errors, our markup rendered the .csp-cf__errors
             div above the form — pluck it out and inject it. */
          var newErrors = newSection.querySelector('.csp-cf__errors');
          var existingErrors = form.querySelector('.csp-cf__errors');
          if (newErrors) {
            if (existingErrors) {
              existingErrors.replaceWith(newErrors);
            } else {
              form.insertBefore(newErrors, form.firstChild);
            }
            form.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else if (existingErrors) {
            /* Server response had no errors and no success — odd
               state. Clear stale errors. */
            existingErrors.remove();
          }

          if (submitBtn) submitBtn.disabled = false;
        })
        .catch(function(error) {
          /* Network failure or parse error — re-enable the button
             and show a generic error so the user can retry. */
          console.error('[contact-form] submit failed:', error);
          if (submitBtn) submitBtn.disabled = false;

          var existingErrors = form.querySelector('.csp-cf__errors');
          var failMsg = 'Something went wrong sending your message. Please try again.';
          if (existingErrors) {
            existingErrors.textContent = failMsg;
          } else {
            var errBlock = document.createElement('div');
            errBlock.className = 'csp-cf__errors';
            errBlock.setAttribute('role', 'alert');
            errBlock.textContent = failMsg;
            form.insertBefore(errBlock, form.firstChild);
          }
        });
      });

      /* Clear inline field errors when the user starts editing the
         field again — feels much better than leaving a red error
         sitting under a field they've already corrected. */
      form.querySelectorAll('.csp-cf__field input, .csp-cf__field textarea').forEach(function(el) {
        el.addEventListener('input', function() {
          var fieldEl = el.closest('.csp-cf__field');
          if (fieldEl && fieldEl.classList.contains('is-invalid')) {
            fieldEl.classList.remove('is-invalid');
            var errEl = fieldEl.querySelector('[data-csp-cf-error]');
            if (errEl) {
              errEl.textContent = '';
              errEl.hidden = true;
            }
          }
        });
      });

      /* ── Reveal animation ─────────────────────────────────────
         Gated by the data-reveal-enabled attribute so the merchant
         toggle still works without inlining Liquid here. */
      if (section.getAttribute('data-reveal-enabled') === 'true') {
        var revealEls = section.querySelectorAll('[data-reveal]');
        if (revealEls.length) {
          if (!('IntersectionObserver' in window)) {
            revealEls.forEach(function(el) { el.classList.add('is-visible'); });
          } else {
            var io = new IntersectionObserver(function(entries) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-visible');
                  io.unobserve(entry.target);
                }
              });
            }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
            revealEls.forEach(function(el) { io.observe(el); });
          }
        }
      }
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-csp-cf-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAll(document); });
    } else {
      initAll(document);
    }

    /* Theme editor support — re-init when this section is
       re-rendered, and reset the init guard so the new DOM
       gets wired up. */
    document.addEventListener('shopify:section:load', function(e) {
      if (!e.target) return;
      e.target.querySelectorAll('[data-csp-cf-section]').forEach(function(el) {
        el.dataset.cspInit = '';
      });
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  /* Countdown driver. One interval per section instance, ticking
     each second, updating the four <text> nodes, and adding
     .is-ticking briefly on whichever digit just changed (so the
     tick animation only fires on the segment that actually moved
     — not all four every second).

     Multi-instance: iterates every .cd[data-countdown] element,
     registers a separate cspManagedInterval keyed by section-id
     (read from data-section-id). Each section's target, tick
     duration, and expiry action come from data-* attributes so
     this block stays free of Liquid interpolation and is cached.

     On expiry: show_message / hide / freeze, mirroring the
     previous countdown behaviors. */
  (function() {
    function initSection(cd) {
      if (!cd || cd.dataset.cspInit === 'true') return;
      cd.dataset.cspInit = 'true';

      var targetStr = cd.getAttribute('data-target');
      var target = new Date(targetStr).getTime();
      if (isNaN(target)) return;

      var expiredAction = cd.getAttribute('data-expired-action') || 'show_message';
      var tickDuration = parseInt(cd.getAttribute('data-tick-duration'), 10) || 600;
      var sectionId = cd.getAttribute('data-section-id');

      var daysEl    = cd.querySelector('[data-cd-days]');
      var hoursEl   = cd.querySelector('[data-cd-hours]');
      var minutesEl = cd.querySelector('[data-cd-minutes]');
      var secondsEl = cd.querySelector('[data-cd-seconds]');

      var prev = { d: null, h: null, m: null, s: null };

      function pad(n, width) {
        var s = String(n);
        while (s.length < width) s = '0' + s;
        return s;
      }

      function setIfChanged(el, prevKey, value, width) {
        var formatted = pad(value, width);
        if (prev[prevKey] === formatted) return;
        prev[prevKey] = formatted;
        /* Force-restart the animation: yank the class so any prior
           tick aborts cleanly. Then on the next animation frame,
           update textContent AND add the class together — same
           frame, no paint between them — so the user never sees
           the new digit briefly at full opacity before the
           animation kicks in. */
        el.classList.remove('is-ticking');
        void el.getBBox; // touch the element to flush
        requestAnimationFrame(function() {
          el.textContent = formatted;
          el.classList.add('is-ticking');
          setTimeout(function() { el.classList.remove('is-ticking'); }, tickDuration);
        });
      }

      var intervalId = null;

      function tick() {
        var diff = target - Date.now();

        if (diff <= 0) {
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minutesEl) minutesEl.textContent = '00';
          if (secondsEl) secondsEl.textContent = '00';

          if (expiredAction === 'hide') {
            cd.classList.add('cd--hidden');
          } else if (expiredAction === 'show_message') {
            cd.classList.add('cd--expired');
          }
          // 'freeze' just leaves it at 00:00:00:00, no class
          if (intervalId) clearInterval(intervalId);
          return;
        }

        var days    = Math.floor(diff / 86400000);
        var hours   = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);

        /* Days padding width auto-grows: ≤99 days uses 2, ≥100 uses 3.
           Avoids "099" weirdness for short countdowns and "1000"
           overflow for long ones. */
        var daysWidth = days >= 100 ? 3 : 2;

        /* Days slot is 400 viewBox units wide (centered at x=200).
           At font-size 200, 2-digit numbers fit comfortably with
           room to spare. 3+ digit numbers can overflow into the
           colon separator at x=400 — so when days hits triple-
           digits, apply textLength to compress the digits to a max
           of 360 units (leaving 20 units gap on each side from the
           slot center). For 1-2 digit days, no textLength so digits
           render at natural width. */
        if (daysEl) {
          if (days >= 100) {
            daysEl.setAttribute('textLength', '360');
            daysEl.setAttribute('lengthAdjust', 'spacingAndGlyphs');
          } else {
            daysEl.removeAttribute('textLength');
            daysEl.removeAttribute('lengthAdjust');
          }
        }

        if (daysEl)    setIfChanged(daysEl,    'd', days,    daysWidth);
        if (hoursEl)   setIfChanged(hoursEl,   'h', hours,   2);
        if (minutesEl) setIfChanged(minutesEl, 'm', minutes, 2);
        if (secondsEl) setIfChanged(secondsEl, 's', seconds, 2);
      }

      tick();
      intervalId = (window.cspManagedInterval || setInterval)(tick, 1000, sectionId);
    }

    function init(root) {
      (root || document).querySelectorAll('.cd[data-countdown]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init: merchant saves a setting, Shopify
       replaces the section's DOM. The fresh node has no
       data-csp-init flag, so initSection runs cleanly. */
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-editorial"] && !Shopify.designMode) return;
  try {
    
  /* ────────────────────────────────────────────────────────────
     FAQ Editorial — question switcher + mobile accordion
     ──────────────────────────────────────────────────────────── */
  (function () {
    var inDesignMode = !!(window.Shopify && window.Shopify.designMode);

    function initSection(section) {
      initSplit(section);
      initStack(section);
    }

    /* Desktop split. Clicking a question swaps which answer
       has `.is-active`. The panel container's height is
       managed by JS so it shrinks/grows to match the active
       answer's height (instead of being pinned to the
       tallest). Counter at the top reads from the chosen
       answer's data-lqa-index. */
    function initSplit(section) {
      var buttons = section.querySelectorAll('[data-lqa-target]');
      var answers = section.querySelectorAll('.lqa__answer');
      var answersWrap = section.querySelector('.lqa__answers');
      var counterEl = section.querySelector('[data-lqa-counter-current]');
      if (!buttons.length || !answers.length || !answersWrap) return;

      function syncHeight() {
        var active = answersWrap.querySelector('.lqa__answer.is-active');
        if (!active) return;
        answersWrap.style.height = active.scrollHeight + 'px';
      }

      // Initial height sync after fonts/layout settle.
      requestAnimationFrame(syncHeight);
      // Re-sync on viewport resize (font re-wrap changes height).
      window.addEventListener('resize', debounce(syncHeight, 120));

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetId = btn.getAttribute('data-lqa-target');
          var target = section.querySelector('#' + cssEscape(targetId));
          if (!target) return;

          buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          answers.forEach(function (a) {
            var isActive = a === target;
            a.classList.toggle('is-active', isActive);
            if (isActive) {
              a.removeAttribute('aria-hidden');
            } else {
              a.setAttribute('aria-hidden', 'true');
            }
          });

          if (counterEl) counterEl.textContent = target.getAttribute('data-lqa-index') || '01';
          syncHeight();
        });
      });
    }

    /* Mobile accordion. Reuses the height-based animation
       from the order-tracking section — JS measures scrollHeight
       and animates `height` between 0 and that value. Only
       runs on viewports where the stack is actually shown. */
    function initStack(section) {
      var items = section.querySelectorAll('.lqa__stack-item');
      if (!items.length) return;
      items.forEach(function (details) {
        var summary  = details.querySelector('summary');
        var collapse = details.querySelector('.lqa__stack-collapse');
        if (!summary || !collapse) return;
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (details.open) {
            closeItem(details, collapse);
          } else {
            // Accordion behavior on mobile too — one open at a time.
            items.forEach(function (other) {
              if (other !== details && other.open) {
                closeItem(other, other.querySelector('.lqa__stack-collapse'));
              }
            });
            openItem(details, collapse);
          }
        });
      });
    }

    function openItem(details, collapse) {
      details.setAttribute('open', '');
      collapse.style.height = '0px';
      void collapse.offsetHeight;
      requestAnimationFrame(function () {
        collapse.style.height = collapse.scrollHeight + 'px';
      });
      onHeightEnd(collapse, function () { collapse.style.height = ''; });
    }
    function closeItem(details, collapse) {
      details.classList.add('is-closing');
      collapse.style.height = collapse.scrollHeight + 'px';
      void collapse.offsetHeight;
      requestAnimationFrame(function () { collapse.style.height = '0px'; });
      onHeightEnd(collapse, function () {
        details.removeAttribute('open');
        details.classList.remove('is-closing');
        collapse.style.height = '';
      });
    }
    function onHeightEnd(el, fn) {
      function h(e) { if (e.propertyName !== 'height') return; el.removeEventListener('transitionend', h); fn(); }
      el.addEventListener('transitionend', h);
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments, ctx = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    }

    /* Tiny CSS.escape polyfill — section ids contain dashes
       and digits that querySelector tolerates, but escape is
       safer for any future id schemes. */
    function cssEscape(id) {
      if (window.CSS && window.CSS.escape) return window.CSS.escape(id);
      return id.replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-lqa-section]').forEach(initSection);
    }
    initAll(document);
    if (inDesignMode) {
      document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-localization"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Modal open/close, body scroll lock, group toggle. The body
       lock uses position:fixed (not just overflow:hidden) because
       iOS Safari ignores overflow:hidden for touch scrolling.

       Multi-instance safe: each section root carries data-loc-section
       and its own modal. We bind per-section but share a single body
       lock state (only one modal can be open at a time across the
       page). */

    var savedScrollY = 0;
    var activeModal = null;
    var activeTrigger = null;

    function lockBody() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      var body = document.body;
      body.style.position = 'fixed';
      body.style.top = '-' + savedScrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    }

    function unlockBody() {
      var body = document.body;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      window.scrollTo(0, savedScrollY);
    }

    function closeAllGroups(modal) {
      modal.querySelectorAll('[data-loc-group]').forEach(function (g) {
        g.removeAttribute('data-open');
      });
      modal.querySelectorAll('[data-loc-toggle]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    }

    function openModal(modal, trigger) {
      modal.removeAttribute('hidden');
      lockBody();
      activeModal = modal;
      activeTrigger = trigger;
      var first = modal.querySelector('[data-loc-toggle]');
      if (first) first.focus();
    }

    function closeModal() {
      if (!activeModal) return;
      activeModal.setAttribute('hidden', '');
      unlockBody();
      closeAllGroups(activeModal);
      if (activeTrigger) activeTrigger.focus();
      activeModal = null;
      activeTrigger = null;
    }

    function initSection(section) {
      if (section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

      var modal = section.querySelector('[data-loc-modal]');
      if (!modal) return;
      var trigger = section.querySelector('[data-loc-open]');

      if (trigger) {
        trigger.addEventListener('click', function () {
          openModal(modal, trigger);
        });
      }

      modal.querySelectorAll('[data-loc-close]').forEach(function (c) {
        c.addEventListener('click', closeModal);
      });

      modal.querySelectorAll('[data-loc-toggle]').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var group = toggle.closest('[data-loc-group]');
          if (!group) return;
          var wasOpen = group.hasAttribute('data-open');
          closeAllGroups(modal);
          if (!wasOpen) {
            group.setAttribute('data-open', '');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    function init(root) {
      var sections = (root || document).querySelectorAll('[data-loc-section]');
      sections.forEach(initSection);
    }

    /* Single global Escape handler — closes whichever modal is
       currently active. Bound once at module load, not per-section,
       to avoid duplicate close calls when multiple sections init. */
    if (!window.__locEscBound) {
      window.__locEscBound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && activeModal) closeModal();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-navigation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── Mobile accordion / desktop static columns ──────
       The <details> element gives us native semantics + keyboard
       support for free, but its toggle is an instantaneous snap.
       On mobile we hijack the click to add a smooth height +
       opacity animation via WAAPI. On desktop, every column is
       force-open and click-toggle is blocked so the headings
       and link lists read as static columns.

       Chevron rotation is driven by an .is-expanded class we
       manage manually, NOT by the [open] attribute. This is
       intentional: on close we keep [open] until the collapse
       animation finishes (so the content stays visible during
       the transition), but the chevron should flip the moment
       the user taps. Tying chevron to .is-expanded gives us
       precise control over its timing. */
    function init(root) {
      var cols = (root || document).querySelectorAll('[data-fnav-column]');
      if (!cols.length) return;
      /* Filter out any columns already initialised — relevant when
         shopify:section:load re-renders one section but other
         existing sections shouldn't double-bind. */
      var fresh = [];
      cols.forEach(function (d) {
        if (d.dataset.cspInit !== 'true') {
          d.dataset.cspInit = 'true';
          fresh.push(d);
        }
      });
      if (!fresh.length) return;

      var mq = window.matchMedia('(min-width: 601px)');
      var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var DURATION = REDUCED ? 0 : 280;
      /* Different easings for open vs close. The OPEN easing is a
         heavy ease-out — it lands softly into the final position,
         which feels great for entering. The CLOSE easing is an
         accelerate curve (ease-in) — it builds momentum toward the
         end so the last bit of collapse doesn't trail off. Using
         the same ease-out for close would make the column appear
         "stuck" at ~10% remaining height before snapping shut,
         because the curve flattens dramatically near the end. */
      var EASING_OPEN  = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
      var EASING_CLOSE = 'cubic-bezier(0.4, 0, 1, 1)';

      function syncToViewport() {
        var isDesktop = mq.matches;
        fresh.forEach(function (d) {
          if (isDesktop) {
            d.setAttribute('open', '');
            d.classList.add('is-expanded');
          } else {
            d.removeAttribute('open');
            d.classList.remove('is-expanded');
          }
          /* Clear any inline animation styles that might persist
             from a prior breakpoint crossing during animation. */
          var c = d.querySelector('.fnav__column-content');
          if (c) {
            c.style.height = '';
            c.style.overflow = '';
            c.style.opacity = '';
            if (c._fnavAnim) {
              try { c._fnavAnim.cancel(); } catch (e) {}
              c._fnavAnim = null;
            }
          }
        });
      }

      function animateOpen(d, content) {
        /* Cancel any in-flight animation on this column first.
           commitStyles preserves the visually current values as
           inline styles before cancel resets the animation, so
           the next animation can start from the actual current
           height (not snap back to 0 mid-transition). */
        if (content._fnavAnim) {
          try { content._fnavAnim.commitStyles(); } catch (e) {}
          try { content._fnavAnim.cancel(); } catch (e) {}
        }

        /* Reveal content and flip chevron synchronously. */
        d.setAttribute('open', '');
        d.classList.add('is-expanded');

        if (REDUCED) {
          content._fnavAnim = null;
          content.style.overflow = '';
          return;
        }

        /* scrollHeight gives us the natural target height including
           padding (border-box is global, so 0 → scrollHeight is a
           clean transition with no padding-flash at either end). */
        var targetH = content.scrollHeight;
        content.style.overflow = 'hidden';

        var anim = content.animate(
          [
            { height: '0px', opacity: 0 },
            { height: targetH + 'px', opacity: 1 }
          ],
          { duration: DURATION, easing: EASING_OPEN }
        );
        content._fnavAnim = anim;

        anim.onfinish = function () {
          if (content._fnavAnim === anim) {
            content._fnavAnim = null;
            content.style.overflow = '';
          }
        };
      }

      function animateClose(d, content) {
        if (content._fnavAnim) {
          try { content._fnavAnim.commitStyles(); } catch (e) {}
          try { content._fnavAnim.cancel(); } catch (e) {}
        }

        /* Flip chevron immediately (synced with animation start). */
        d.classList.remove('is-expanded');

        if (REDUCED) {
          d.removeAttribute('open');
          content._fnavAnim = null;
          content.style.overflow = '';
          return;
        }

        var startH = content.scrollHeight;
        content.style.overflow = 'hidden';

        var anim = content.animate(
          [
            { height: startH + 'px', opacity: 1 },
            { height: '0px', opacity: 0 }
          ],
          { duration: DURATION, easing: EASING_CLOSE, fill: 'forwards' }
        );
        content._fnavAnim = anim;

        anim.onfinish = function () {
          if (content._fnavAnim === anim) {
            content._fnavAnim = null;
            /* Order matters: remove [open] BEFORE cancelling the
               animation. removeAttribute('open') makes the content
               display:none via the user-agent stylesheet, hiding
               it. Cancelling after means the brief moment when the
               forwards-fill is released is invisible. */
            d.removeAttribute('open');
            content.style.overflow = '';
            try { anim.cancel(); } catch (e) {}
          }
        };
      }

      fresh.forEach(function (d) {
        var summary = d.querySelector('summary');
        var content = d.querySelector('.fnav__column-content');
        if (!summary || !content) return;

        summary.addEventListener('click', function (ev) {
          /* Always block native toggle — we drive open/close
             ourselves so the animation runs cleanly. */
          ev.preventDefault();

          /* Desktop: columns are pinned open, clicks are no-ops. */
          if (mq.matches) return;

          /* Mobile: toggle with smooth animation. */
          if (d.hasAttribute('open')) {
            animateClose(d, content);
          } else {
            /* Single-open accordion behavior: closing any other
               column that is currently open before expanding this
               one. The two animations run in parallel — each column
               owns its own WAAPI animation, so the close of the
               previous and the open of this one play simultaneously
               over the same duration, which reads as a clean swap. */
            fresh.forEach(function (other) {
              if (other !== d && other.hasAttribute('open')) {
                var otherContent = other.querySelector('.fnav__column-content');
                if (otherContent) animateClose(other, otherContent);
              }
            });
            animateOpen(d, content);
          }
        });
      });

      syncToViewport();
      mq.addEventListener('change', syncToViewport);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center"] && !Shopify.designMode) return;
  try {
    
  /* ────────────────────────────────────────────────────────────
     Help center — view router (categories ↔ category ↔ article)
     URL-driven via ?c=<slug> / ?a=<slug>, with browser history.
     ──────────────────────────────────────────────────────────── */
  (function () {
    var inDesignMode = !!(window.Shopify && window.Shopify.designMode);

    function initSection(section) {
      var views = section.querySelectorAll('[data-hcat-view]');
      if (!views.length) return;

      /* Build a quick lookup so we don't re-query repeatedly. */
      var byArt = {}, byCat = {};
      section.querySelectorAll('[data-hcat-view="category"]').forEach(function (el) {
        byCat[el.getAttribute('data-hcat-cat')] = el;
      });
      section.querySelectorAll('[data-hcat-view="article"]').forEach(function (el) {
        byArt[el.getAttribute('data-hcat-art')] = el;
      });

      var bc = section.querySelector('[data-hcat-breadcrumb]');
      var crumbCategory     = section.querySelector('[data-hcat-crumb="category"]');
      var crumbArticle      = section.querySelector('[data-hcat-crumb="article"]');
      var sepBeforeCategory = section.querySelector('[data-hcat-crumb-after="category"]');
      var sepBeforeArticle  = section.querySelector('[data-hcat-crumb-after="article"]');

      function show(view) {
        views.forEach(function (v) { v.hidden = true; });
        if (view) view.hidden = false;
      }

      function setBreadcrumb(state) {
        if (!bc) return;
        if (state.view === 'categories') {
          crumbCategory.hidden = true;
          crumbArticle.hidden = true;
          sepBeforeCategory.hidden = true;
          sepBeforeArticle.hidden = true;
        } else if (state.view === 'category') {
          var el = byCat[state.slug];
          if (el) {
            crumbCategory.textContent = el.getAttribute('data-hcat-cat-title') || '';
            crumbCategory.setAttribute('href', '?c=' + encodeURIComponent(state.slug));
            crumbCategory.setAttribute('data-hcat-slug', state.slug);
            crumbCategory.hidden = false;
            sepBeforeCategory.hidden = false;
          }
          crumbArticle.hidden = true;
          sepBeforeArticle.hidden = true;
        } else if (state.view === 'article') {
          var artEl = byArt[state.slug];
          var catSlug  = artEl ? artEl.getAttribute('data-hcat-art-cat') : '';
          var catTitle = artEl ? artEl.getAttribute('data-hcat-art-cat-title') : '';
          var artTitle = artEl ? artEl.getAttribute('data-hcat-art-title') : '';
          if (catSlug && byCat[catSlug]) {
            crumbCategory.textContent = catTitle;
            crumbCategory.setAttribute('href', '?c=' + encodeURIComponent(catSlug));
            crumbCategory.setAttribute('data-hcat-slug', catSlug);
            crumbCategory.hidden = false;
            sepBeforeCategory.hidden = false;
          } else {
            crumbCategory.hidden = true;
            sepBeforeCategory.hidden = true;
          }
          crumbArticle.textContent = artTitle;
          crumbArticle.hidden = false;
          sepBeforeArticle.hidden = false;
        }
      }

      function readUrl() {
        var qs = window.location.search || '';
        var params = new URLSearchParams(qs);
        if (params.get('a')) return { view: 'article',  slug: params.get('a') };
        if (params.get('c')) return { view: 'category', slug: params.get('c') };
        return { view: 'categories' };
      }

      function applyState(state, opts) {
        opts = opts || {};
        if (state.view === 'article' && byArt[state.slug]) {
          show(byArt[state.slug]);
        } else if (state.view === 'category' && byCat[state.slug]) {
          show(byCat[state.slug]);
        } else {
          show(section.querySelector('[data-hcat-view="categories"]'));
          state = { view: 'categories' };
        }
        setBreadcrumb(state);
        if (opts.scroll) {
          var rect = section.getBoundingClientRect();
          var y = window.scrollY + rect.top - 24;
          window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
        }
      }

      /* Wire click handlers via delegation on the section root. */
      section.addEventListener('click', function (e) {
        // Internal nav link (category card, article card, breadcrumb link)
        var link = e.target.closest('a[data-hcat-link], a[data-hcat-go]');
        if (link) {
          e.preventDefault();
          var goType = link.getAttribute('data-hcat-go');
          var linkType = link.getAttribute('data-hcat-link');
          var slug = link.getAttribute('data-hcat-slug') || '';
          var state, url;
          if (goType === 'root' || (!linkType && goType !== 'category')) {
            state = { view: 'categories' };
            url = window.location.pathname;
          } else if (linkType === 'category' || goType === 'category') {
            state = { view: 'category', slug: slug };
            url = '?c=' + encodeURIComponent(slug);
          } else if (linkType === 'article') {
            state = { view: 'article', slug: slug };
            url = '?a=' + encodeURIComponent(slug);
          }
          if (state) {
            history.pushState(state, '', url);
            applyState(state, { scroll: true });
          }
          return;
        }

        // View toggle (grid ↔ list)
        var viewBtn = e.target.closest('[data-hcat-view-btn]');
        if (viewBtn) {
          var mode = viewBtn.getAttribute('data-hcat-view-btn');
          section.querySelectorAll('[data-hcat-view-mode]').forEach(function (g) {
            g.setAttribute('data-hcat-view-mode', mode);
          });
          section.querySelectorAll('[data-hcat-view-btn]').forEach(function (b) {
            b.setAttribute('aria-pressed', b === viewBtn ? 'true' : 'false');
          });
          return;
        }

        // Feedback buttons
        var fbBtn = e.target.closest('[data-hcat-feedback-vote]');
        if (fbBtn) {
          var wrap = fbBtn.closest('[data-hcat-feedback]');
          if (!wrap) return;
          wrap.querySelectorAll('[data-hcat-feedback-vote]').forEach(function (b) {
            b.classList.toggle('is-pressed', b === fbBtn);
            b.setAttribute('disabled', '');
          });
          var thanks = wrap.querySelector('[data-hcat-feedback-thanks]');
          if (thanks) thanks.hidden = false;
          return;
        }
      });

      /* Browser back/forward */
      window.addEventListener('popstate', function () {
        applyState(readUrl(), { scroll: false });
      });

      /* Initial state from URL */
      applyState(readUrl(), { scroll: false });
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-hcat-section]').forEach(initSection);
    }
    initAll(document);
    if (inDesignMode) {
      document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-menu"] && !Shopify.designMode) return;
  try {
    
  /* Hero menu interactive logic — bundled and cached by Shopify.
     Runs against every .hero-menu element on the page (multi-instance safe).
     All config comes from data-* attributes on the .hero-menu__nav element
     so this block stays fully static. Idempotent via dataset.cspInit so
     repeated calls (theme editor reloads via shopify:section:load) don't
     double-bind. */
  (function() {
    'use strict';

    function initHM(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

    function updateHeaderOffset() {
      var header = document.querySelector('.header-wrapper, #site-header, header[data-sticky]');
      if (!header) return;
      // Reserve the header's height regardless of its current position state.
      // This handles "sticky on scroll up" headers that switch between static
      // and fixed: we stay at the reserved height so the rail never jumps
      // when the header's state changes.
      var h = header.offsetHeight;
      if (h > 0) {
        section.style.setProperty('--hm-header-offset', h + 'px');
      }
    }

    /* Measure menu list height so the sticky-group's top: formula can
       anchor correctly for middle/bottom valign (subtracts --hm-menu-height
       or half of it from the raw anchor y). No longer needed for button
       positioning — buttons live inside the same sticky-group as the menu. */
    function updateMenuOffset() {
      var list = section.querySelector('.hero-menu__list');
      if (!list) return;
      var rect = list.getBoundingClientRect();
      section.style.setProperty('--hm-menu-height', rect.height + 'px');
    }

    updateHeaderOffset();
    updateMenuOffset();
    /* Re-measure only on resize — NOT on scroll. Scroll-triggered re-measurement
       caused the rail to jump when scroll-up-reveal headers flipped between
       static and fixed states. */
    window.addEventListener('resize', function() {
      updateHeaderOffset();
      updateMenuOffset();
    }, { passive: true });

    // Re-measure menu offset once a bit later, when all initial rendering has settled.
    // We avoid document.fonts.ready here because it can fire mid-scroll when the user
    // starts interacting, causing the button rail to visibly shift. A fixed delay
    // after initial render catches most layout-settled scenarios silently.
    setTimeout(updateMenuOffset, 400);

    // ── Nested menu interactions ─────────────────────────────────
    var nav = section.querySelector('.hero-menu__nav');
    if (!nav) return;
    var revealStyle = nav.getAttribute('data-reveal-style');
    var menuSource = nav.getAttribute('data-menu-source');

    // Nested-menu logic runs only when there's actually a nested menu to manage
    if (revealStyle && revealStyle !== 'disabled') {

    // Both level-1 parent <li>s and level-2 parent <li>s (the ones with grandchildren)
    var parentItems = nav.querySelectorAll('.hero-menu__item--has-children');
    var subParentItems = nav.querySelectorAll('.hero-menu__subitem--has-children');
    var allParents = [].concat(
      Array.prototype.slice.call(parentItems),
      Array.prototype.slice.call(subParentItems)
    );

    var isMobileWidth = function() { return window.matchMedia('(max-width: 749px)').matches; };

    function setExpanded(item, expanded) {
      var btn = item.querySelector(':scope > .hero-menu__link--parent, :scope > .hero-menu__sublink--parent-toggle');
      if (btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    /* When a side_drawer sublist opens with a long item list and not
       enough room below the parent (parent sits low in the hero
       section), the natural top:0 position lets the bottom of the
       sublist drop past the hero's bottom edge — out of sight. Lift
       it up by exactly the amount that's overflowing, clamped so the
       sublist's top never escapes the slide's top. If the list is
       taller than the entire slide (no amount of shifting fits it),
       cap max-height to the slide's interior and let it scroll.

       Only fires for side_drawer (replace mode swaps the menu in place
       — no overflow risk) and only on desktop (mobile uses an
       accordion fallback that grows the surrounding flow). Measurement
       runs in rAF so it happens after the hover/open style takes
       effect and the sublist has its true rendered height. */
    var DROPDOWN_PADDING = 16;
    function adjustSublistPosition(parent) {
      if (revealStyle !== 'side_drawer') return;
      if (isMobileWidth()) return;
      var sublist = parent.querySelector(':scope > .hero-menu__sublist');
      if (!sublist) return;
      /* Use the slide as the visual bounding box. Falls back to the
         section itself if the menu is rendered outside a slide. */
      var bounds = parent.closest('.hero-menu__slide') || section;
      if (!bounds) return;

      /* Clear any prior adjustment before measuring so the previous
         shift doesn't bias this one. */
      sublist.style.top = '';
      sublist.style.maxHeight = '';
      sublist.style.overflowY = '';

      requestAnimationFrame(function() {
        var sublistRect = sublist.getBoundingClientRect();
        var boundsRect = bounds.getBoundingClientRect();
        var interiorHeight = boundsRect.height - DROPDOWN_PADDING * 2;

        /* List taller than the slide can hold even at full shift —
           cap it and enable scroll, then remeasure for shift math. */
        if (sublistRect.height > interiorHeight) {
          sublist.style.maxHeight = interiorHeight + 'px';
          sublist.style.overflowY = 'auto';
          sublistRect = sublist.getBoundingClientRect();
        }

        var bottomOverflow = sublistRect.bottom - (boundsRect.bottom - DROPDOWN_PADDING);
        if (bottomOverflow > 0) {
          /* Don't lift above the slide's top — clamp the shift to
             how much room there actually is above the sublist's
             natural position. */
          var topRoom = sublistRect.top - (boundsRect.top + DROPDOWN_PADDING);
          var shift = Math.min(bottomOverflow, Math.max(0, topRoom));
          if (shift > 0) {
            sublist.style.top = (-shift) + 'px';
          }
        }
      });
    }

    function resetSublistPosition(parent) {
      var sublist = parent.querySelector(':scope > .hero-menu__sublist');
      if (!sublist) return;
      sublist.style.top = '';
      sublist.style.maxHeight = '';
      sublist.style.overflowY = '';
    }

    function openItem(item) {
      item.classList.add('is-open');
      setExpanded(item, true);
      adjustSublistPosition(item);
    }

    function closeItem(item) {
      item.classList.remove('is-open');
      setExpanded(item, false);
      resetSublistPosition(item);
    }

    // Close everything back to root state
    function closeAll() {
      allParents.forEach(function(item) {
        item.classList.remove('is-open', 'is-active-parent');
        setExpanded(item, false);
      });
      nav.classList.remove('is-viewing-sublist', 'is-viewing-subsublist');
    }

    // Replace mode: step back ONE level (from depth 2 → 1, or depth 1 → 0)
    // Plays an outgoing slide animation on the current view before swapping.
    var backAnimating = false;
    function replaceGoBack() {
      if (backAnimating) return; // avoid double-clicks mid-animation
      backAnimating = true;

      nav.classList.add('is-going-back');

      // Animation duration matches the CSS keyframe (0.25s)
      setTimeout(function() {
        if (nav.classList.contains('is-viewing-subsublist')) {
          // Pop depth 2 → depth 1
          subParentItems.forEach(function(sp) {
            sp.classList.remove('is-open', 'is-active-parent');
            setExpanded(sp, false);
          });
          nav.classList.remove('is-viewing-subsublist');
        } else {
          // Pop depth 1 → depth 0
          allParents.forEach(function(item) {
            item.classList.remove('is-open', 'is-active-parent');
            setExpanded(item, false);
          });
          nav.classList.remove('is-viewing-sublist');
        }
        nav.classList.remove('is-going-back');
        backAnimating = false;
      }, 250);
    }

    // Wire up every parent toggle (level 1 AND level 2)
    allParents.forEach(function(item) {
      var btn = item.querySelector(':scope > .hero-menu__link--parent, :scope > .hero-menu__sublink--parent-toggle');
      if (!btn) return;

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = item.classList.contains('is-open');
        var isSubParent = item.classList.contains('hero-menu__subitem--has-children');

        if (revealStyle === 'replace') {
          if (isSubParent) {
            // Level-2 click in replace mode: drill to depth 2
            // Clear any other level-2 active siblings under the same level-1 parent
            var level1Parent = item.closest('.hero-menu__item--has-children');
            if (level1Parent) {
              level1Parent.querySelectorAll('.hero-menu__subitem--has-children').forEach(function(sp) {
                if (sp !== item) {
                  sp.classList.remove('is-open', 'is-active-parent');
                  setExpanded(sp, false);
                }
              });
            }
            if (isOpen) {
              // If already drilled in, treat as "go back to depth 1"
              replaceGoBack();
            } else {
              item.classList.add('is-open', 'is-active-parent');
              setExpanded(item, true);
              nav.classList.add('is-viewing-subsublist');
            }
          } else {
            // Level-1 click in replace mode
            if (isOpen) {
              closeAll();
            } else {
              closeAll();
              item.classList.add('is-open', 'is-active-parent');
              setExpanded(item, true);
              nav.classList.add('is-viewing-sublist');
            }
          }
        } else {
          // Side drawer mode (both levels): click toggles. On mobile (accordion fallback),
          // close sibling drawers at the SAME level for a clean in-place reveal.
          var isOnMobile = isMobileWidth();
          if (isOnMobile) {
            var siblings = isSubParent ? subParentItems : parentItems;
            siblings.forEach(function(other) {
              // Only close siblings at the same level AND under the same parent chain
              if (other !== item && (!isSubParent || other.parentElement === item.parentElement)) {
                closeItem(other);
              }
            });
          }
          if (isOpen) {
            closeItem(item);
          } else {
            openItem(item);
          }
        }
      });

      /* Hover wiring for the side_drawer reveal — the CSS opens the
         sublist on :hover (no .is-open class needed), so the click
         handler above never fires for hover-only desktop interactions.
         Without these listeners, a hover-revealed sublist would skip
         the bottom-overflow shift and the last items would drop off
         the hero's bottom edge. mouseenter (not over) avoids
         re-firing every time the cursor moves between child rows. */
      item.addEventListener('mouseenter', function() {
        adjustSublistPosition(item);
      });
      item.addEventListener('mouseleave', function() {
        /* Only reset on hover-out when the item isn't pinned open via
           click — otherwise we'd snap the shift away while the panel
           is still visible. */
        if (!item.classList.contains('is-open')) {
          resetSublistPosition(item);
        }
      });
    });

    // Back buttons — go back one level (not all the way to root)
    nav.querySelectorAll('[data-menu-back]').forEach(function(backBtn) {
      backBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (revealStyle === 'replace') {
          replaceGoBack();
        } else {
          closeAll();
        }
      });
    });

    // Click outside closes hover-based open states (helpful after mobile tap)
    document.addEventListener('click', function(e) {
      if (!nav.contains(e.target)) {
        if (revealStyle !== 'replace') {
          allParents.forEach(closeItem);
        }
      }
    });

    // Escape key — in replace mode, steps back one level; otherwise closes all
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (revealStyle === 'replace') {
          replaceGoBack();
        } else {
          closeAll();
        }
      }
    });
    } // end: nested-menu logic

    // ── Per-slide menu tracking ──────────────────────────────────
    // Runs only when menu_source == 'per_slide'. Tracks which slide is most
    // visible and highlights the matching menu item, animates the progress
    // line, and handles click-to-scroll navigation.
    if (menuSource === 'per_slide') {
      var slideLinkItems = nav.querySelectorAll('.hero-menu__item--slide-link');
      var progressFill = nav.querySelector('[data-progress-fill]');
      var scrollNavEnabled = nav.getAttribute('data-scroll-nav') === 'true';
      var slides = section.querySelectorAll('.hero-menu__slide');

      if (slideLinkItems.length && slides.length) {
        var totalSlides = slides.length;

        // Track which slide is currently "active" — the one most in-view.
        // Starts at 0 (sentinel) so the initial setActiveSlide(1) call isn't
        // short-circuited by the idempotency guard.
        var activeSlideIdx = 0;

        // Floating button groups — now inside the nav's .hero-menu__sticky-group
        var buttonGroups = section.querySelectorAll('.hero-menu__nav .hero-menu__buttons[data-buttons-for]');

        function setActiveSlide(idx) {
          if (idx === activeSlideIdx) return;
          activeSlideIdx = idx;

          slideLinkItems.forEach(function(item) {
            var target = parseInt(item.getAttribute('data-slide-target'), 10);
            if (target === idx) {
              item.classList.add('is-slide-active');
            } else {
              item.classList.remove('is-slide-active');
            }
          });

          // Keep .is-slide-active on slide elements for any future per-slide-inside behaviors
          slides.forEach(function(slide) {
            var sIdx = parseInt(slide.getAttribute('data-slide-index'), 10);
            if (sIdx === idx) {
              slide.classList.add('is-slide-active');
            } else {
              slide.classList.remove('is-slide-active');
            }
          });

          // Swap which floating button group is visible
          buttonGroups.forEach(function(group) {
            var gIdx = parseInt(group.getAttribute('data-buttons-for'), 10);
            if (gIdx === idx) {
              group.classList.add('is-active-buttons');
            } else {
              group.classList.remove('is-active-buttons');
            }
          });

          if (progressFill) {
            // Progress is ratio of active slide to total (1/N ... N/N)
            var progress = idx / totalSlides;
            progressFill.style.setProperty('--hm-progress', progress);
          }
        }

        // IntersectionObserver: find which slide has the highest visibility ratio
        var visibilityMap = {}; // slide index -> ratio
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            var idx = parseInt(entry.target.getAttribute('data-slide-index'), 10);
            visibilityMap[idx] = entry.intersectionRatio;
          });

          // Pick the slide with the highest visibility
          var maxRatio = -1;
          var maxIdx = activeSlideIdx || 1;
          Object.keys(visibilityMap).forEach(function(key) {
            var r = visibilityMap[key];
            if (r > maxRatio) {
              maxRatio = r;
              maxIdx = parseInt(key, 10);
            }
          });

          if (maxRatio > 0.1) {
            setActiveSlide(maxIdx);
          }
        }, {
          // Multiple thresholds so we get fine-grained updates as slides scroll through
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0]
        });

        slides.forEach(function(s) { io.observe(s); });

        // Initial state — activate first slide
        setActiveSlide(1);

        // Click-to-scroll: intercepts link clicks, smooth-scrolls to target slide
        if (scrollNavEnabled) {
          nav.querySelectorAll('[data-slide-link]').forEach(function(link) {
            link.addEventListener('click', function(e) {
              var target = parseInt(link.getAttribute('data-slide-link'), 10);
              var slideEl = section.querySelector('[data-slide-index="' + target + '"]');
              if (slideEl) {
                e.preventDefault();
                slideEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              // If slide not found, let the default link navigation happen
            });
          });
        }
      }
    }
    } /* end initHM */

    function initAll(root) {
      (root || document).querySelectorAll('.hero-menu').forEach(initHM);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAll(document); });
    } else {
      initAll(document);
    }

    /* Theme editor re-init: when the merchant saves a setting, Shopify
       replaces the section's DOM and fires this event. The new DOM
       doesn't have data-csp-init, so initHM runs fresh. */
    document.addEventListener('shopify:section:load', function(e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* HERO -- multi-instance behaviors:
       1. Text animation on scroll-into-view (fade/blur/typewriter)
       2. Header-offset tracking for the scroll-reveal sticky content
       3. Video controls (play/pause, mute, progress) for video heroes

     All three iterate every .hero on init and guard each with
     dataset.cspInit so a section that's already been wired isn't
     double-initialized. Theme editor re-init wires fresh DOM on
     shopify:section:load. */
  (function() {

    /* ----- Animation -------------------------------------------- */
    function initAnimation(hero) {
      var animationType = hero.dataset.textAnimation;
      if (!animationType || animationType === 'none') return;

      var elements = hero.querySelectorAll('.animate-element');
      if (!elements.length) return;

      var animationDuration = parseInt(hero.dataset.animationDuration, 10) || 600;
      var animationDelay    = parseInt(hero.dataset.animationDelay, 10) || 0;
      var staggerEnabled    = hero.dataset.animationStagger === 'true';

      function typeWriter(element, callback) {
        var typewriterSpan = element.querySelector('.typewriter-text');
        var cursor = element.querySelector('.typewriter-cursor');
        if (!typewriterSpan) {
          element.classList.add('animated');
          if (callback) callback();
          return;
        }
        var text = typewriterSpan.getAttribute('data-text') || '';
        var speed = Math.max(20, Math.floor(animationDuration / Math.max(text.length, 1)));
        var i = 0;
        typewriterSpan.textContent = '';
        function type() {
          if (i < text.length) {
            typewriterSpan.textContent += text.charAt(i);
            i++;
            setTimeout(type, speed);
          } else {
            setTimeout(function() {
              if (cursor) cursor.classList.add('hidden');
              if (callback) callback();
            }, 1500);
          }
        }
        type();
      }

      function startAnimations() {
        if (animationType === 'typewriter') {
          elements.forEach(function(el, index) {
            var typewriterSpan = el.querySelector('.typewriter-text');
            if (typewriterSpan) {
              var delay = staggerEnabled ? (index * 100) : 0;
              setTimeout(function() { typeWriter(el, null); }, animationDelay + delay);
            } else {
              el.classList.add('animated');
            }
          });
        } else {
          elements.forEach(function(el) { el.classList.add('animated'); });
        }
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            startAnimations();
            observer.disconnect();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(hero);

      /* If hero is already in view at init time, kick off immediately
         and stop the observer so it can't fire a second time. */
      var rect = hero.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        setTimeout(startAnimations, 100);
        observer.disconnect();
      }
    }

    /* ----- Scroll-reveal header offset --------------------------
       When the sticky content is enabled, account for any site
       header that's fixed at the top so the content doesn't slide
       under it. Walks up to find a positioned ancestor; if one's
       fixed, treat its height as the offset. */
    function initScrollReveal(hero) {
      if (hero.dataset.scrollReveal !== 'true') return;

      function updateHeaderOffset() {
        var header = document.querySelector('#site-header, .site-header, header[data-sticky]');
        var h = 0;
        if (header) {
          var el = header.closest('[style*="position: fixed"], [style*="position:fixed"]') || header;
          if (el && (el.style.position === 'fixed' || window.getComputedStyle(el).position === 'fixed')) {
            h = el.offsetHeight;
          }
        }
        hero.style.setProperty('--hero-header-offset', h + 'px');
      }

      updateHeaderOffset();
      window.addEventListener('scroll', updateHeaderOffset, { passive: true });
      window.addEventListener('resize', updateHeaderOffset, { passive: true });
    }

    /* ----- Video controls ---------------------------------------
       Wires every .hero__video-controls inside the section. Each
       controls block has its own video sibling (.hero__media). The
       250ms tick uses cspManagedInterval when available so the host
       can cancel it on section unload. The interval is keyed by the
       section id read from the data attribute. */
    function initVideoControls(hero) {
      if (hero.dataset.showVideoControls !== 'true') return;
      if (hero.dataset.hasAnyVideo !== 'true') return;
      var sectionId = hero.dataset.sectionId;

      hero.querySelectorAll('.hero__video-controls').forEach(function(controls) {
        var mediaEl = controls.closest('.hero__media');
        if (!mediaEl) return;
        var video = mediaEl.querySelector('.hero__video');
        if (!video) return;

        var playBtn  = controls.querySelector('.hero__vc-playpause');
        var muteBtn  = controls.querySelector('.hero__vc-mute');
        var fill     = controls.querySelector('.hero__vc-progress-fill');
        var progress = controls.querySelector('.hero__vc-progress');

        var iconPause = playBtn ? playBtn.querySelector('.hero__vc-icon--pause') : null;
        var iconPlay  = playBtn ? playBtn.querySelector('.hero__vc-icon--play') : null;
        var iconSound = muteBtn ? muteBtn.querySelector('.hero__vc-icon--sound') : null;
        var iconMuted = muteBtn ? muteBtn.querySelector('.hero__vc-icon--muted') : null;

        function syncPlayIcon() {
          if (!playBtn || !iconPause || !iconPlay) return;
          iconPause.style.display = video.paused ? 'none' : '';
          iconPlay.style.display  = video.paused ? '' : 'none';
          playBtn.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        }

        function syncMuteIcon() {
          if (!muteBtn || !iconSound || !iconMuted) return;
          iconSound.style.display = video.muted ? 'none' : '';
          iconMuted.style.display = video.muted ? '' : 'none';
          muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        }

        if (playBtn) {
          playBtn.addEventListener('click', function() {
            if (video.paused) { video.play(); } else { video.pause(); }
            syncPlayIcon();
          });
        }

        if (muteBtn) {
          muteBtn.addEventListener('click', function() {
            video.muted = !video.muted;
            syncMuteIcon();
          });
        }

        if (progress) {
          progress.addEventListener('click', function(e) {
            if (!video.duration) return;
            var rect = progress.getBoundingClientRect();
            video.currentTime = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width)) * video.duration;
          });
        }

        (window.cspManagedInterval || setInterval)(function() {
          if (fill && video.duration) fill.style.width = ((video.currentTime / video.duration) * 100) + '%';
          syncPlayIcon();
          syncMuteIcon();
        }, 250, sectionId);
      });
    }

    function initSection(hero) {
      if (!hero || hero.dataset.cspInit === 'true') return;
      hero.dataset.cspInit = 'true';
      initAnimation(hero);
      initScrollReveal(hero);
      initVideoControls(hero);
    }

    function init(root) {
      (root || document).querySelectorAll('.hero').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init: merchant saves a setting, Shopify
       replaces the section's DOM with a fresh node that has no
       data-csp-init flag, so initSection runs cleanly on it. */
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page"]) return;
  try {
    
  /* Landing page interactive logic — bundled and cached by Shopify.
     Runs against every .lp element on the page (singleton in practice,
     but handles multi-instance for safety). All per-merchant settings
     come from data-* attributes on the .lp element so this block stays
     fully static. Idempotent via dataset.cspInit so repeated calls
     (theme editor reloads via shopify:section:load) don't double-bind. */
  (function() {
    'use strict';

    function initLP(lp) {
      if (!lp || lp.dataset.cspInit === 'true') return;
      lp.dataset.cspInit = 'true';

    /* ── Storage keys ───────────────────────────────────────── */
    var KEY_DISMISSED  = 'csp_landing_dismissed_at';
    var KEY_SESSION    = 'csp_landing_session_seen';

    /* ── Read config from data attributes ───────────────────── */
    var cfg = {
      sectionId:       lp.getAttribute('data-section-id'),
      cooldownMode:    lp.getAttribute('data-cooldown-mode'),
      homepageOnly:    lp.getAttribute('data-homepage-only') === 'true',
      method:          lp.getAttribute('data-dismiss-method'),
      holdDuration:    parseFloat(lp.getAttribute('data-hold-duration')) || 1.5,
      template:        lp.getAttribute('data-template'),
      redirectActive:  lp.getAttribute('data-redirect-active') === 'true',
      redirectPath:    lp.getAttribute('data-redirect-path') || '',
      excludedUrls:    (lp.getAttribute('data-excluded-urls') || '').split(',').map(function(s){return s.trim();}).filter(Boolean)
    };

    /* ── Editor detection ───────────────────────────────────── */
    var isEditor = (window.Shopify && window.Shopify.designMode) ||
                   document.documentElement.classList.contains('shopify-design-mode');

    /* ── Body scroll lock — non-disruptive approach ────────────
       Old approach: position:fixed + top:-scrollY. This visually
       preserved scroll position but DISRUPTED layout. While locked,
       scrollY was effectively 0 from JS's perspective; sticky
       elements lost their reference; viewport width changed when
       the scrollbar disappeared. On dismiss, ALL of those things
       had to recompute simultaneously — and any parallax/sticky
       library using internal requestAnimationFrame would glitch
       for at least one frame.

       New approach: overflow:hidden + touch-action:none on <html>
       + padding-right scrollbar compensation. The page layout stays
       EXACTLY THE SAME. scrollY keeps its real value. Sticky
       elements keep their reference. Parallax JS keeps tracking the
       correct scroll position throughout. On dismiss, nothing has
       changed, so nothing can flicker. */
    var bodyLocked = false;
    var lockedScrollbarWidth = 0;

    function lockBodyScroll() {
      if (bodyLocked) return;
      bodyLocked = true;

      /* Measure scrollbar width so we can compensate when it
         disappears — otherwise content shifts right by ~15px on
         platforms with persistent scrollbars (Windows/Linux). */
      lockedScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      document.documentElement.style.overflow = 'hidden';
      /* touch-action:none prevents touch gestures from scrolling on
         iOS, where overflow:hidden alone is not always sufficient. */
      document.documentElement.style.touchAction = 'none';

      if (lockedScrollbarWidth > 0) {
        document.body.style.paddingRight = lockedScrollbarWidth + 'px';
      }
    }

    function unlockBodyScroll() {
      if (!bodyLocked) return;
      bodyLocked = false;

      document.documentElement.style.overflow = '';
      document.documentElement.style.touchAction = '';
      document.body.style.paddingRight = '';
      /* No scroll restoration needed — layout never moved, scrollY
         never changed, no events to dispatch. The page is exactly
         where the user left it. */
    }

    /* ── Pause background videos on dismiss ──────────────────────
       When the LP closes, browsers don't auto-pause video elements
       just because their container has [hidden] / display:none —
       the videos keep playing (and consuming resources / streaming
       bytes) in memory. Explicitly pause them so they stop using
       CPU and bandwidth, and so the user doesn't suddenly hear
       audio if they had unmuted via the video controls. Iterates
       all .lp__bg-video elements (covers both desktop + mobile
       videos when bg_video_mobile is set). */
    function pauseBgVideos() {
      var vids = lp.querySelectorAll('.lp__bg-video');
      for (var i = 0; i < vids.length; i++) {
        try { vids[i].pause(); } catch (e) {}
      }
    }

    /* ── Eligibility ────────────────────────────────────────── */
    function isEligible() {
      /* Note: in the Shopify theme editor we still respect the
         homepage_only and URL exclusion rules — merchants need
         to see what real visitors will see. We only skip the
         cooldown check (further down) so dismiss-state doesn't
         lock the merchant out of previewing the LP. */

      /* Homepage-only restriction.
         "Homepage" = template is 'index' OR (the theme's global
         skip_enter_screen redirect is configured AND the current
         page is the redirect destination — making it the merchant's
         effective homepage). */
      if (cfg.homepageOnly) {
        var isHomepage = cfg.template === 'index';
        if (!isHomepage && cfg.redirectActive && cfg.redirectPath) {
          var redirPath = cfg.redirectPath;
          /* Strip protocol+host if redirect_url is absolute */
          if (redirPath.indexOf('://') !== -1) {
            try { redirPath = new URL(redirPath).pathname; } catch (e) {}
          }
          var current = window.location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
          var target = redirPath.toLowerCase().replace(/\/+$/, '') || '/';
          if (current === target) isHomepage = true;
        }
        if (!isHomepage) return false;
      }

      /* Excluded URL? */
      var path = window.location.pathname.toLowerCase();
      for (var i = 0; i < cfg.excludedUrls.length; i++) {
        var excl = cfg.excludedUrls[i].toLowerCase();
        if (excl && path.indexOf(excl) === 0) return false;
      }

      /* Cooldown mode — skipped in editor so merchants can
         preview repeatedly without dismiss-state interfering. */
      if (!isEditor) {
        try {
          if (cfg.cooldownMode === 'session') {
            if (sessionStorage.getItem(KEY_SESSION) === 'true') return false;
          } else if (cfg.cooldownMode === 'always') {
            /* Always show — no check */
          } else {
            /* Numeric cooldown: '1', '7', '30', '-1' (never again) */
            var dismissedAt = localStorage.getItem(KEY_DISMISSED);
            if (dismissedAt) {
              if (cfg.cooldownMode === '-1') return false;
              var days = parseInt(cfg.cooldownMode, 10);
              if (!isNaN(days) && days > 0) {
                var elapsed = Date.now() - new Date(dismissedAt).getTime();
                var cooldownMs = days * 24 * 60 * 60 * 1000;
                if (elapsed < cooldownMs) return false;
              }
            }
          }
        } catch (e) { /* storage blocked — fail-open */ }
      }

      return true;
    }

    /* ── State ──────────────────────────────────────────────── */
    var isOpen = false;
    var lastFocused = null;

    /* ── Open ───────────────────────────────────────────────── */
    function open() {
      if (isOpen) return;
      isOpen = true;

      lastFocused = document.activeElement;
      /* Lock body scroll WITHOUT disrupting layout (see helper above
         for full rationale). Page stays exactly where it is — no
         scroll position to save, no parallax frame to glitch. */
      lockBodyScroll();

      /* The LP element is already visible at this point thanks to the
         pre-render eligibility check (see top of section). The is-open
         class is added for any state-dependent CSS rules to hook into. */
      lp.classList.add('is-open');

      /* Move focus to the primary action button only — NOT the skip
         link. Auto-focusing the skip link makes it appear visually
         "highlighted" via :focus-visible the moment the LP opens,
         which looks like a defect to most users. For methods without
         a primary button (scroll, click_anywhere, drag), don't auto-
         focus anything; keyboard users can still Tab into the dialog. */
      requestAnimationFrame(function() {
        var primary = lp.querySelector('[data-lp-hold], .lp__btn');
        if (primary) primary.focus();
      });

      attachMethodHandlers();
    }

    /* ── Dismiss ────────────────────────────────────────────── */
    function dismiss() {
      if (!isOpen) return;
      isOpen = false;

      lp.classList.add('is-dismissing');

      /* Unlock body scroll. Page hasn't moved during the LP-open
         period (we used overflow:hidden, not position:fixed), so
         there's nothing to "restore" and nothing to recompute.
         Parallax / sticky / scroll-driven elements have been
         tracking the correct scroll position the whole time. */
      unlockBodyScroll();

      /* Record dismiss in storage */
      if (!isEditor) {
        try {
          if (cfg.cooldownMode === 'session') {
            sessionStorage.setItem(KEY_SESSION, 'true');
          } else if (cfg.cooldownMode !== 'always') {
            localStorage.setItem(KEY_DISMISSED, new Date().toISOString());
          }
        } catch (e) {}
      }

      /* Wait for fade-out animation, then unmount.
         Body is already unlocked above — only DOM cleanup and
         focus restoration remain. */
      setTimeout(function() {
        lp.classList.remove('is-open', 'is-dismissing');
        lp.setAttribute('hidden', '');
        pauseBgVideos();

        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }, 500);

      detachMethodHandlers();
    }

    /* ── Universal close handlers ──────────────────────────── */
    /* Skip link + any [data-lp-dismiss] element */
    lp.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-lp-dismiss]');
      if (btn) { dismiss(); }
    });

    /* ESC — only acts as a skip; intentional, not the primary
       dismiss path. Confirms our skip-link-always-available pledge. */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) dismiss();
    });

    /* Focus trap */
    document.addEventListener('keydown', function(e) {
      if (!isOpen || e.key !== 'Tab') return;
      var focusables = lp.querySelectorAll(
        'button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last  = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });

    /* ── Method-specific handlers ─────────────────────────── */
    var holdEl = null;
    var holdRafId = null;
    var scrollHandler = null;
    var clickAnywhereHandler = null;
    /* Drag method state — holds references for cleanup */
    var dragStartHandler = null;
    var dragMoveHandler = null;
    var dragEndHandler = null;

    function attachMethodHandlers() {
      switch (cfg.method) {

        case 'hold':
          holdEl = lp.querySelector('[data-lp-hold]');
          if (!holdEl) break;

          /* ── Bidirectional hold state machine ─────────────────
             Instead of a CSS transition that only knows two states
             (idle / holding-to-full), we track progress as a
             continuous value (0 to 1) that moves either direction
             on each animation frame. This means:
               • Press    → progress moves toward 1 at hold rate
               • Release  → progress moves toward 0 at same rate
               • Re-press → progress continues forward FROM CURRENT
                            position (not from 0)
             The same per-millisecond rate is used for both directions
             so the user feels symmetrical, predictable motion.  */
          var progressEl = holdEl.querySelector('.lp__hold-ring-progress');
          var CIRCUMFERENCE = 308;            /* matches the SVG path circumference */
          var durationMs = cfg.holdDuration * 1000;
          var progress = 0;                   /* 0..1 — the current ring fill */
          var direction = 0;                  /* 1 forward, -1 reverse, 0 idle */
          var lastTime = 0;
          var isComplete = false;

          function setProgress(p) {
            progress = Math.max(0, Math.min(1, p));
            if (progressEl) {
              progressEl.style.strokeDashoffset = String(CIRCUMFERENCE * (1 - progress));
            }
          }

          function tick(now) {
            if (isComplete) return;
            if (lastTime === 0) lastTime = now;
            var dt = now - lastTime;
            lastTime = now;

            if (direction !== 0) {
              setProgress(progress + direction * (dt / durationMs));

              /* Reached the top — complete */
              if (progress >= 1 && direction === 1) {
                isComplete = true;
                holdRafId = null;
                completeHold();
                return;
              }
              /* Reached the bottom — idle, stop the loop */
              if (progress <= 0 && direction === -1) {
                direction = 0;
                holdRafId = null;
                return;
              }
              holdRafId = requestAnimationFrame(tick);
            } else {
              holdRafId = null;
            }
          }

          function startMotion(dir) {
            direction = dir;
            if (holdRafId === null) {
              lastTime = 0;
              holdRafId = requestAnimationFrame(tick);
            }
          }

          var startHold = function(e) {
            if (isComplete) return;
            if (e && e.cancelable) e.preventDefault();
            startMotion(1);
          };
          var cancelHold = function() {
            if (isComplete) return;
            /* Only switch to reverse if we actually have progress to
               unwind. If we're already at 0, do nothing. */
            if (progress > 0) startMotion(-1);
            else direction = 0;
          };

          /* ── Completion: spawn particle dust, then dismiss ────
             The ring + label fade out via .is-completed CSS class.
             ~30 small particles burst outward from the ring in
             randomized directions/distances/durations. The dismiss
             fires shortly after so the page transition overlaps
             with the particle animation. */
          function completeHold() {
            setProgress(1);
            holdEl.classList.add('is-completed');

            var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reduced) {
              dismiss();
              return;
            }

            spawnParticles();
            /* Let particles play for a beat, then dismiss. The dismiss
               fade-out runs ON TOP of the still-animating particles
               so the moment lands without feeling slow. */
            setTimeout(dismiss, 200);
          }

          function spawnParticles() {
            var ring = holdEl.querySelector('.lp__hold-ring');
            if (!ring) return;
            var ringRadius = ring.offsetWidth / 2;
            var particleCount = 30;

            for (var i = 0; i < particleCount; i++) {
              var p = document.createElement('span');
              p.className = 'lp__hold-particle';

              /* Distribute roughly evenly around the ring with slight
                 random jitter so particles don't form a perfect grid */
              var angleBase = (Math.PI * 2 * i) / particleCount;
              var angle = angleBase + (Math.random() * 0.4 - 0.2);

              /* Start position: on the ring's circumference */
              var startX = Math.cos(angle) * ringRadius;
              var startY = Math.sin(angle) * ringRadius;

              /* End position: outward in the same angle, varying distance */
              var distance = 60 + Math.random() * 80;
              var endX = Math.cos(angle) * (ringRadius + distance);
              var endY = Math.sin(angle) * (ringRadius + distance);

              /* Per-particle randomization for organic feel */
              var duration = 500 + Math.random() * 300;
              var delay = Math.random() * 100;
              var size = 3 + Math.random() * 3;

              p.style.width = size + 'px';
              p.style.height = size + 'px';
              p.style.setProperty('--start-x', startX + 'px');
              p.style.setProperty('--start-y', startY + 'px');
              p.style.setProperty('--end-x', endX + 'px');
              p.style.setProperty('--end-y', endY + 'px');
              p.style.animationDuration = duration + 'ms';
              p.style.animationDelay = delay + 'ms';

              holdEl.appendChild(p);
            }
          }

          holdEl.addEventListener('mousedown',  startHold);
          holdEl.addEventListener('touchstart', startHold, { passive: false });
          holdEl.addEventListener('mouseup',    cancelHold);
          holdEl.addEventListener('mouseleave', cancelHold);
          holdEl.addEventListener('touchend',   cancelHold);
          holdEl.addEventListener('touchcancel',cancelHold);
          /* Keyboard accessibility — Space/Enter mirrors press/release */
          holdEl.addEventListener('keydown', function(e) {
            if (e.key === ' ' || e.key === 'Enter') startHold(e);
          });
          holdEl.addEventListener('keyup', function(e) {
            if (e.key === ' ' || e.key === 'Enter') cancelHold();
          });

          /* Store handles for cleanup */
          holdEl._handlers = { startHold: startHold, cancelHold: cancelHold };
          break;

        case 'scroll':
          /* In the Shopify theme editor, skip the scroll-to-dismiss
             wiring entirely. Otherwise, the body scroll unlock below
             plus the scroll listener would mean any merchant scroll
             input dismisses the LP — preventing them from inspecting
             or styling the section. The LP just stays visible, locked
             at full opacity. The skip link still lets the merchant
             test the dismiss flow. */
          if (isEditor) break;

          /* First scroll dismiss. We track delta from open-time scroll
             position; once user scrolls > 30px, fade the LP based on
             scroll progress, completing dismiss at ~120px. */
          var startY = window.scrollY;
          /* Re-allow scroll so the user can scroll-to-dismiss. Page
             position doesn't change because we never used position:fixed. */
          unlockBodyScroll();

          lp.classList.add('is-scroll-fading');

          scrollHandler = function() {
            var delta = window.scrollY - startY;
            if (delta < 0) delta = 0;
            var progress = Math.min(delta / 120, 1);
            lp.style.opacity = String(1 - progress);
            if (progress >= 1) {
              window.removeEventListener('scroll', scrollHandler);
              scrollHandler = null;
              /* Fade is complete — finalize the dismiss without the
                 default scale animation since fade already happened. */
              isOpen = false;
              try {
                if (!isEditor) {
                  if (cfg.cooldownMode === 'session') sessionStorage.setItem(KEY_SESSION, 'true');
                  else if (cfg.cooldownMode !== 'always') localStorage.setItem(KEY_DISMISSED, new Date().toISOString());
                }
              } catch (e) {}
              lp.classList.remove('is-open');
              lp.setAttribute('hidden', '');
              lp.style.opacity = '';
              pauseBgVideos();
              if (lastFocused && lastFocused.focus) lastFocused.focus();
            }
          };
          window.addEventListener('scroll', scrollHandler, { passive: true });
          /* Also dismiss on touch-drag for mobile (where wheel events
             are absent and scroll-y events can be sluggish to start) */
          var touchStartY = null;
          var touchHandler = function(e) {
            if (touchStartY == null) {
              touchStartY = e.touches[0].clientY;
              return;
            }
            var delta = touchStartY - e.touches[0].clientY;
            if (delta > 30) {
              dismiss();
              window.removeEventListener('touchmove', touchHandler);
            }
          };
          window.addEventListener('touchmove', touchHandler, { passive: true });
          break;

        case 'click_anywhere':
          /* Click anywhere on the LP dismisses, EXCEPT clicks on
             the skip button (which already dismisses via its own
             handler) and any link-like child if we add one later. */
          clickAnywhereHandler = function(e) {
            if (e.target.closest('[data-lp-dismiss]')) return; /* skip link */
            dismiss();
          };
          lp.addEventListener('click', clickAnywhereHandler);
          break;

        case 'drag':
          /* ── Drag-up to enter ──────────────────────────────────
             The whole .lp follows the pointer's vertical position
             1:1 while the user holds. On release:
               • Past threshold → animate up off-screen + dismiss
               • Short of threshold → smooth snap-back to position 0
             Resistance is applied if user drags DOWN (rubber band)
             so the page doesn't visibly slide downward — only up
             motion contributes to the dismiss progress.
             Threshold = 25% of viewport height.
             Skip button clicks are excluded (closest check). */
          var isDragging = false;
          var dragStartY = 0;
          var dragDeltaY = 0;
          var dragThreshold = window.innerHeight * 0.25;

          function getY(e) {
            return e.touches ? e.touches[0].clientY :
                   e.changedTouches ? e.changedTouches[0].clientY :
                   e.clientY;
          }

          dragStartHandler = function(e) {
            /* Don't initiate drag from the skip button */
            if (e.target.closest('[data-lp-dismiss]')) return;
            isDragging = true;
            dragStartY = getY(e);
            dragDeltaY = 0;
            lp.classList.remove('is-snap-back', 'is-drag-dismiss');
            lp.classList.add('is-dragging');
          };

          dragMoveHandler = function(e) {
            if (!isDragging) return;
            var currentY = getY(e);
            var raw = currentY - dragStartY;
            /* Only allow UPWARD drag (negative delta). Downward drag
               is locked to 0 — the LP doesn't move and the page
               content underneath stays hidden. Without this clamp the
               user could pull the LP down and reveal what's beneath. */
            dragDeltaY = raw < 0 ? raw : 0;

            lp.style.transform = 'translateY(' + dragDeltaY + 'px)';

            /* Prevent browser pan/scroll on touch */
            if (e.cancelable) e.preventDefault();
          };

          dragEndHandler = function() {
            if (!isDragging) return;
            isDragging = false;
            lp.classList.remove('is-dragging');

            if (dragDeltaY < -dragThreshold) {
              /* Past threshold — slide the page completely off-screen.
                 Pure translate, no fade — page leaves as a solid unit. */
              lp.classList.add('is-drag-dismiss');
              lp.style.transform = 'translateY(-100vh)';

              /* Unlock body scroll. Page hasn't moved during the
                 LP-open period (overflow:hidden, not position:fixed)
                 so there's nothing to restore or recompute. */
              unlockBodyScroll();

              if (!isEditor) {
                try {
                  if (cfg.cooldownMode === 'session') {
                    sessionStorage.setItem(KEY_SESSION, 'true');
                  } else if (cfg.cooldownMode !== 'always') {
                    localStorage.setItem(KEY_DISMISSED, new Date().toISOString());
                  }
                } catch (e) {}
              }

              /* Wait for the slide-up animation (0.45s), then unmount
                 cleanly — body styles already restored above. */
              setTimeout(function() {
                isOpen = false;
                lp.classList.remove('is-open', 'is-drag-dismiss');
                lp.setAttribute('hidden', '');
                lp.style.transform = '';
                pauseBgVideos();

                if (lastFocused && lastFocused.focus) lastFocused.focus();
              }, 450);
            } else {
              /* Short of threshold — smooth snap back to origin */
              lp.classList.add('is-snap-back');
              lp.style.transform = '';
              lp.style.opacity = '';
              /* Remove the snap-back class after animation finishes so
                 the next drag starts fresh without lingering transitions */
              setTimeout(function() {
                lp.classList.remove('is-snap-back');
              }, 350);
            }
            dragDeltaY = 0;
          };

          lp.addEventListener('mousedown',  dragStartHandler);
          lp.addEventListener('mousemove',  dragMoveHandler);
          lp.addEventListener('mouseup',    dragEndHandler);
          lp.addEventListener('mouseleave', dragEndHandler);
          lp.addEventListener('touchstart', dragStartHandler, { passive: false });
          lp.addEventListener('touchmove',  dragMoveHandler,  { passive: false });
          lp.addEventListener('touchend',   dragEndHandler);
          lp.addEventListener('touchcancel',dragEndHandler);
          break;

        case 'button':
        default:
          /* Button method: handled via the universal [data-lp-dismiss]
             listener above. Nothing extra to wire. */
          break;
      }
    }

    function detachMethodHandlers() {
      if (holdEl) {
        /* Cancel any in-progress RAF loop so the ring stops mid-animation
           when the popup is dismissed externally (e.g. via skip link or
           ESC during a hold). */
        if (holdRafId !== null) {
          cancelAnimationFrame(holdRafId);
          holdRafId = null;
        }
      }
      if (scrollHandler) {
        window.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
      }
      if (clickAnywhereHandler) {
        lp.removeEventListener('click', clickAnywhereHandler);
        clickAnywhereHandler = null;
      }
      /* Drag handlers — remove if present */
      if (dragStartHandler) {
        lp.removeEventListener('mousedown',  dragStartHandler);
        lp.removeEventListener('mousemove',  dragMoveHandler);
        lp.removeEventListener('mouseup',    dragEndHandler);
        lp.removeEventListener('mouseleave', dragEndHandler);
        lp.removeEventListener('touchstart', dragStartHandler);
        lp.removeEventListener('touchmove',  dragMoveHandler);
        lp.removeEventListener('touchend',   dragEndHandler);
        lp.removeEventListener('touchcancel',dragEndHandler);
        dragStartHandler = dragMoveHandler = dragEndHandler = null;
      }
    }

    /* ── Video controls ──────────────────────────────────────
       When show_video_controls is on, wire up the play/pause,
       mute, and progress bar elements rendered above. The LP can
       have one or two video elements (desktop + mobile); we always
       operate on the currently visible one (offsetParent !== null
       means displayed). The hidden video keeps its own muted/loop/
       autoplay state independently. */
    /* Video controls — only takes effect when the .lp__video-controls
       element is rendered (i.e., when the merchant has bg_type=video AND
       show_video_controls=true). The querySelector + early return guards
       it without needing a Liquid {% if %} wrap, which was incompatible
       with the {% javascript %} bundle. */
    (function() {
      var controls = lp.querySelector('.lp__video-controls');
      if (!controls) return;

      function getVisibleVideo() {
        var vids = lp.querySelectorAll('.lp__bg-video');
        for (var i = 0; i < vids.length; i++) {
          if (vids[i].offsetParent !== null) return vids[i];
        }
        /* Fallback: return the first one if none are detected as
           visible (rare — occurs while CSS is still loading). */
        return vids[0] || null;
      }

      var playBtn  = controls.querySelector('.lp__vc-playpause');
      var muteBtn  = controls.querySelector('.lp__vc-mute');
      var fill     = controls.querySelector('.lp__vc-progress-fill');
      var progress = controls.querySelector('.lp__vc-progress');

      var iconPause = playBtn ? playBtn.querySelector('.lp__vc-icon--pause') : null;
      var iconPlay  = playBtn ? playBtn.querySelector('.lp__vc-icon--play')  : null;
      var iconSound = muteBtn ? muteBtn.querySelector('.lp__vc-icon--sound') : null;
      var iconMuted = muteBtn ? muteBtn.querySelector('.lp__vc-icon--muted') : null;

      function syncPlayIcon(video) {
        if (!playBtn || !iconPause || !iconPlay) return;
        iconPause.style.display = video.paused ? 'none' : '';
        iconPlay.style.display  = video.paused ? '' : 'none';
        playBtn.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      }

      function syncMuteIcon(video) {
        if (!muteBtn || !iconSound || !iconMuted) return;
        iconSound.style.display = video.muted ? 'none' : '';
        iconMuted.style.display = video.muted ? '' : 'none';
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }

      if (playBtn) {
        playBtn.addEventListener('click', function() {
          var video = getVisibleVideo();
          if (!video) return;
          if (video.paused) { video.play().catch(function(){}); }
          else { video.pause(); }
          syncPlayIcon(video);
        });
      }

      if (muteBtn) {
        muteBtn.addEventListener('click', function() {
          var video = getVisibleVideo();
          if (!video) return;
          /* Toggle mute on ALL video elements so when the viewport
             changes (mobile↔desktop) the sound state stays consistent. */
          var newMuted = !video.muted;
          var vids = lp.querySelectorAll('.lp__bg-video');
          for (var i = 0; i < vids.length; i++) vids[i].muted = newMuted;
          syncMuteIcon(video);
        });
      }

      if (progress) {
        progress.addEventListener('click', function(e) {
          var video = getVisibleVideo();
          if (!video || !video.duration) return;
          var rect = progress.getBoundingClientRect();
          var pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
          video.currentTime = pct * video.duration;
        });
      }

      /* Periodically sync icons + progress bar. Lightweight setInterval
         (every 250ms) — matches the hero implementation. */
      (window.cspManagedInterval || setInterval)(function() {
        var video = getVisibleVideo();
        if (!video) return;
        if (fill && video.duration) {
          fill.style.width = ((video.currentTime / video.duration) * 100) + '%';
        }
        syncPlayIcon(video);
        syncMuteIcon(video);
      }, 250, cfg.sectionId);
    })();

    /* ── Initialize ─────────────────────────────────────────── */
    /* isEligible() now handles editor mode correctly: it respects
       homepage_only and URL exclusions in editor too, only skipping
       the cooldown so merchants can preview repeatedly. */
    if (isEligible()) {
      /* Open synchronously to avoid flash-of-page-content before LP mounts */
      open();
    }
    } /* end initLP */

    function initAll(root) {
      (root || document).querySelectorAll('.lp').forEach(initLP);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAll(document); });
    } else {
      initAll(document);
    }

    /* Theme editor re-init: when the merchant saves an LP setting,
       Shopify replaces the section's DOM and fires this event. The
       new DOM doesn't have data-csp-init, so initLP runs fresh. */
    document.addEventListener('shopify:section:load', function(e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["large-heading"] && !Shopify.designMode) return;
  try {
    
  /* Reveal-on-scroll for large-heading sections.
     Multi-instance: scans every .lh element on init, observes each one
     independently. Cached/bundled with no Liquid interpolation —
     section-specific behavior reads from data-* attributes.
     Re-runs on shopify:section:load so theme-editor reloads pick up
     newly-rendered sections. */
  (function() {
    function initSection(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';
      if (section.dataset.revealEnabled !== 'true') return;

      var items = section.querySelectorAll('[data-reveal]');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        items.forEach(function(el) { el.classList.add('is-visible'); });
        return;
      }

      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            /* Stagger reveals by their position in the section so
               eyebrow → heading → body fade in sequentially rather
               than as one block. */
            var delay = Array.prototype.indexOf.call(items, entry.target) * 100;
            setTimeout(function() { entry.target.classList.add('is-visible'); }, delay);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px', threshold: 0.05 });

      items.forEach(function(el) { io.observe(el); });
    }

    function init(root) {
      (root || document).querySelectorAll('.lh').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init: merchant saves a setting, Shopify replaces
       the section's DOM. The fresh node has no data-csp-init flag so
       initSection runs cleanly. */
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

      var revealOnScroll = section.getAttribute('data-reveal-on-scroll') === 'true';
      var enableLightbox = section.getAttribute('data-enable-lightbox') === 'true';
      var stagger = parseInt(section.getAttribute('data-reveal-stagger'), 10);
      if (isNaN(stagger)) stagger = 60;

      /* ── Cell reveal on scroll ── */
      if (revealOnScroll) {
        if ('IntersectionObserver' in window) {
          var revealObs = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var item = entry.target;
              var idx = parseInt(item.getAttribute('data-index'), 10) || 0;
              var capped = Math.min(idx, 10);
              setTimeout(function () { item.classList.add('is-revealed'); }, capped * stagger);
              revealObs.unobserve(item);
            });
          }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
          Array.prototype.forEach.call(section.querySelectorAll('[data-lkg-item]'), function (item) {
            revealObs.observe(item);
          });
        } else {
          Array.prototype.forEach.call(section.querySelectorAll('[data-lkg-item]'), function (item) {
            item.classList.add('is-revealed');
          });
        }
      }

      if (!enableLightbox) return;

      /* ════════════════════════════════════════════════════════════
         LIGHTBOX — film-frame navigation

         State held in closure: `current` is the active slide index.
         All slides are pre-rendered; we toggle the `is-active` class
         on the current slide AND its corresponding thumb. On open/
         close we lock/unlock body scroll. Navigation supports:
         - arrow key (left / right)
         - space (next)
         - escape (close)
         - swipe (left/right > 50px)
         - click on prev/next arrows
         - click on any thumb in the strip
         ──────────────────────────────────────────────────────────── */
      var lightbox = section.querySelector('[data-lkg-lightbox]');
      if (!lightbox) return;

      var slides   = lightbox.querySelectorAll('[data-lkg-slide]');
      var thumbs   = lightbox.querySelectorAll('[data-lkg-thumb]');
      var triggers = section.querySelectorAll('[data-lkg-trigger]');
      var counter  = lightbox.querySelector('[data-lkg-current]');
      var titleEl  = lightbox.querySelector('[data-lkg-title]');
      var bodyEl   = lightbox.querySelector('[data-lkg-body]');
      var strip    = lightbox.querySelector('[data-lkg-strip]');
      var stage    = lightbox.querySelector('[data-lkg-media-wrap]');
      var prevBtn  = lightbox.querySelector('[data-lkg-prev]');
      var nextBtn  = lightbox.querySelector('[data-lkg-next]');
      var closeBtn = lightbox.querySelector('[data-lkg-close]');
      var total    = slides.length;
      var current  = 0;

      /* Body scroll lock — overflow:hidden on <html>.

         Why not the position:fixed pattern? That pattern works but
         requires saving + restoring scroll position on close, which
         visibly flashes a scroll-up-then-back-down on the page
         behind the fading lightbox: removing position:fixed sends
         the page to scroll Y=0, then window.scrollTo restores it.
         Both happen in the same JS tick but the browser can paint
         between them, and the lightbox fade-out (0.35s) makes the
         glitch visible.

         overflow:hidden on <html> doesn't change scroll position at
         all, so there's nothing to restore and nothing to flash.
         Modern browsers including iOS Safari 13+ respect this on
         the html element (the old "overflow:hidden on body alone
         doesn't work on iOS" rule applied to body, not html).

         Scrollbar-width compensation prevents a horizontal layout
         shift visible behind the fading lightbox on desktop. */
      var savedScrollbarComp = '';
      var savedHtmlOverflow = '';
      function lockBody() {
        var html = document.documentElement;
        var scrollbarWidth = window.innerWidth - html.clientWidth;
        savedHtmlOverflow = html.style.overflow;
        html.style.overflow = 'hidden';
        if (scrollbarWidth > 0) {
          savedScrollbarComp = document.body.style.paddingRight;
          document.body.style.paddingRight = scrollbarWidth + 'px';
        }
      }
      function unlockBody() {
        document.documentElement.style.overflow = savedHtmlOverflow;
        document.body.style.paddingRight = savedScrollbarComp;
      }

      function pad2(n) { return n < 10 ? '0' + n : '' + n; }

      function setActive(index) {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;
        if (index === current) return;

        /* Brief fade-out of caption during transition */
        lightbox.classList.add('is-transitioning');

        /* Pause any video on the leaving slide */
        var leavingVid = slides[current].querySelector('video');
        if (leavingVid && leavingVid.pause) { try { leavingVid.pause(); } catch(e) {} }

        slides[current].classList.remove('is-active');
        thumbs[current].classList.remove('is-active');
        current = index;
        slides[current].classList.add('is-active');
        thumbs[current].classList.add('is-active');

        /* Update counter + caption */
        counter.textContent = pad2(current + 1);
        var slide = slides[current];
        var newTitle = slide.getAttribute('data-lkg-slide-title') || '';
        var newBody  = slide.getAttribute('data-lkg-slide-body')  || '';
        /* Slight delay so caption fades back in AFTER text changes */
        setTimeout(function () {
          titleEl.textContent = newTitle;
          bodyEl.textContent  = newBody;
          lightbox.classList.remove('is-transitioning');
        }, 200);

        /* Auto-play video on the entering slide if it has one */
        var enteringVid = slides[current].querySelector('video');
        if (enteringVid && enteringVid.play) {
          enteringVid.currentTime = 0;
          var p = enteringVid.play();
          if (p && p.catch) p.catch(function(){});
        }

        /* Auto-scroll thumb strip to keep active thumb centered */
        var activeThumb = thumbs[current];
        if (activeThumb && activeThumb.scrollIntoView) {
          activeThumb.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
          });
        }
      }

      function open(index) {
        /* Set the active slide first (without transition since lightbox is hidden) */
        slides[current].classList.remove('is-active');
        thumbs[current].classList.remove('is-active');
        current = index;
        slides[current].classList.add('is-active');
        thumbs[current].classList.add('is-active');
        counter.textContent = pad2(current + 1);
        var slide = slides[current];
        titleEl.textContent = slide.getAttribute('data-lkg-slide-title') || '';
        bodyEl.textContent  = slide.getAttribute('data-lkg-slide-body')  || '';

        lightbox.hidden = false;
        /* Force reflow so opacity transition runs */
        void lightbox.offsetWidth;
        lightbox.classList.add('is-open');
        lockBody();

        /* Center active thumb in strip on next frame (after lightbox shows) */
        requestAnimationFrame(function () {
          var activeThumb = thumbs[current];
          if (activeThumb && activeThumb.scrollIntoView) {
            activeThumb.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
          }
          /* Play video if active slide has one */
          var enteringVid = slides[current].querySelector('video');
          if (enteringVid && enteringVid.play) {
            var p = enteringVid.play();
            if (p && p.catch) p.catch(function(){});
          }
        });
      }

      function close() {
        lightbox.classList.remove('is-open');
        unlockBody();
        /* Pause any currently-playing video */
        var vid = slides[current].querySelector('video');
        if (vid && vid.pause) { try { vid.pause(); } catch(e) {} }
        /* Hide after transition completes (matches CSS visibility delay) */
        setTimeout(function () { lightbox.hidden = true; }, 350);
      }

      function next() { setActive(current + 1); }
      function prev() { setActive(current - 1); }

      /* Wire grid triggers — each item opens the lightbox at its index */
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var idx = parseInt(trigger.getAttribute('data-lkg-trigger'), 10) || 0;
          open(idx);
        });
      });

      /* Wire arrows / close */
      if (prevBtn)  prevBtn.addEventListener('click', prev);
      if (nextBtn)  nextBtn.addEventListener('click', next);
      if (closeBtn) closeBtn.addEventListener('click', close);

      /* Wire each thumbnail */
      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = parseInt(thumb.getAttribute('data-lkg-thumb'), 10) || 0;
          setActive(idx);
        });
      });

      /* Click on lightbox background (outside media) closes it */
      lightbox.addEventListener('click', function (e) {
        /* Close only if clicking the lightbox itself or the stage area
           (NOT a thumb, arrow, slide, or any descendant button). */
        if (e.target === lightbox) {
          close();
        }
      });

      /* Keyboard navigation */
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden || !lightbox.classList.contains('is-open')) return;
        if (e.key === 'ArrowLeft')      { e.preventDefault(); prev();  }
        else if (e.key === 'ArrowRight') { e.preventDefault(); next();  }
        else if (e.key === 'Escape')     { e.preventDefault(); close(); }
        else if (e.key === ' ')          { e.preventDefault(); next();  }
      });

      /* Touch swipe on the stage — left swipe = next, right = prev */
      var touchStartX = 0;
      var touchEndX   = 0;
      var touchActive = false;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchActive = true;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (!touchActive || e.touches.length !== 1) return;
        touchEndX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function () {
        if (!touchActive) return;
        touchActive = false;
        var dx = touchEndX - touchStartX;
        if (Math.abs(dx) > 50) {
          if (dx < 0) next();
          else        prev();
        }
        touchStartX = 0;
        touchEndX   = 0;
      });
    }

    function init(root) {
      (root || document).querySelectorAll('.lkg').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (!section || section.dataset.lbgInit === 'true') return;
      section.dataset.lbgInit = 'true';

      var revealEnabled = section.getAttribute('data-reveal') === 'true';
      var stagger = parseInt(section.getAttribute('data-reveal-stagger'), 10);
      if (isNaN(stagger)) stagger = 80;

      if (revealEnabled) {
        // Reveal cells on scroll with cascading stagger. Each cell's
        // data-cell-index drives the setTimeout delay so cells animate
        // in sequence as the grid enters the viewport. We unobserve
        // after reveal so memory drops to baseline.
        if ('IntersectionObserver' in window) {
          var revealObs = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var cell = entry.target;
              var idx  = parseInt(cell.getAttribute('data-cell-index'), 10) || 0;
              setTimeout(function () { cell.classList.add('is-revealed'); }, idx * stagger);
              revealObs.unobserve(cell);
            });
          }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
          Array.prototype.forEach.call(section.querySelectorAll('.lbg__cell'), function (c) {
            revealObs.observe(c);
          });
        } else {
          // No IO support -> show everything immediately
          Array.prototype.forEach.call(section.querySelectorAll('.lbg__cell'), function (c) {
            c.classList.add('is-revealed');
          });
        }
      }

      // Video play modes:
      //   - "always" (autoplay attribute handles it, no JS needed)
      //   - "on-hover" (desktop): pause initially, play on cell hover.
      //     On touch devices: fall back to play-on-intersection so videos
      //     play when scrolled into view. play() returns a promise that
      //     may reject (e.g. autoplay blocked) — we swallow the rejection
      //     so it doesn't error in the console.
      var videos = section.querySelectorAll('video[data-video-mode="on-hover"]');
      if (videos.length) {
        var canHover = window.matchMedia
          && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        Array.prototype.forEach.call(videos, function (video) {
          if (canHover) {
            // Desktop: pause on init, play on cell hover, pause on leave.
            video.pause();
            var cell = video.closest('.lbg__cell');
            if (!cell) return;
            cell.addEventListener('mouseenter', function () {
              var p = video.play(); if (p && p.catch) p.catch(function(){});
            });
            cell.addEventListener('mouseleave', function () { video.pause(); });
          } else if ('IntersectionObserver' in window) {
            // Touch: play when scrolled into view, pause when out.
            // Threshold 0.5 means video plays once half-visible — feels
            // natural and avoids playing many at once on tall pages.
            video.pause();
            var vobs = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  var p = video.play(); if (p && p.catch) p.catch(function(){});
                } else {
                  video.pause();
                }
              });
            }, { threshold: 0.5 });
            vobs.observe(video);
          }
        });
      }
    }

    function init(root) {
      (root || document).querySelectorAll('[data-lbg-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  /* Lookbook interactive logic — bundled and cached by Shopify.
     Runs against every [data-lbk-section] on the page (multi-instance
     safe). All config comes from data-* attributes on the section root
     so this block stays fully static. Idempotent via dataset.lbkCspInit
     so repeated calls (theme editor reloads via shopify:section:load)
     don't double-bind. */
  (function () {
    function initAll(root) {
      (root || document).querySelectorAll('[data-lbk-section]').forEach(initLBK);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    function initLBK(section) {
      if (!section || section.dataset.lbkCspInit === 'true') return;
      section.dataset.lbkCspInit = 'true';

      var STICKY_INDEX  = section.dataset.lbkStickyIndex   === 'true';
      var OPEN_ON_HOVER = section.dataset.lbkOpenOnHover   === 'true';
      var HOVER_CLOSE_DELAY = parseInt(section.dataset.lbkHoverCloseDelay, 10) || 250;
      var MSG_ADDED = section.dataset.lbkMsgAdded || 'Added to bag';
      var MSG_ERROR = section.dataset.lbkMsgError || 'Could not add to bag';

    if (STICKY_INDEX) {
    /* ── Sticky offset measurement ──────────────────────────
       The index strip is position:sticky with top:var(--lbk-sticky-offset).
       That offset is the live combined height of any element pinned
       to the top of the viewport above the lookbook — handles every
       case the merchant might configure:

       • Announcement bar with sticky_bar=true (any height)
       • Header with sticky_header='always' (any height, including
         inline menu rows that add to header height on mobile/desktop)
       • Header with sticky_header='reveal' — measure only when the
         header is currently revealed at the top
       • Header with sticky_header='none' — skipped entirely
       • Different screen sizes — we measure live so the inline-menu's
         actual rendered height (which differs between mobile/desktop)
         is used automatically.

       We don't read the data-sticky attributes; we just check whether
       each candidate element is currently pinned at the top of the
       viewport (rect.top ≈ 0 AND rect.bottom > 0). That makes the
       calculation correct regardless of mode/scroll-state, including
       for the reveal-mode header that comes and goes. */
    var stickyCandidates = [
      document.getElementById('announcement-bar'),
      document.getElementById('site-header')
    ].filter(function (el) { return el; });

    function updateStickyOffset() {
      var offset = 0;
      /* Candidates are in DOM order (announcement bar first, header
         second). We accumulate by checking each one against the offset
         we've already built up from earlier candidates — so when the
         announcement bar and header are BOTH sticky and stacked, the
         header's rect.top (which equals the announcement bar's height,
         not 0) still passes the check and contributes its own height.
         The previous logic used a fixed `rect.top <= 1` threshold,
         which only ever caught the topmost element and left the
         lookbook strip docking underneath the header. */
      for (var i = 0; i < stickyCandidates.length; i++) {
        var rect = stickyCandidates[i].getBoundingClientRect();
        if (rect.bottom > 0 && rect.top <= offset + 1) {
          if (rect.bottom > offset) offset = rect.bottom;
        }
      }
      section.style.setProperty('--lbk-sticky-offset', Math.ceil(offset) + 'px');
    }

    updateStickyOffset();
    /* rAF-throttled scroll listener so we recompute when the
       reveal-mode header animates in/out. */
    var stickyTickPending = false;
    window.addEventListener('scroll', function () {
      if (stickyTickPending) return;
      stickyTickPending = true;
      requestAnimationFrame(function () {
        updateStickyOffset();
        stickyTickPending = false;
      });
    }, { passive: true });
    window.addEventListener('resize', updateStickyOffset);
    /* Re-measure after fonts/images load — header height can change
       as web fonts swap in. */
    window.addEventListener('load', updateStickyOffset);
    } /* end if STICKY_INDEX */

    /* ── Pin → product card open/close ──────────────────
       Tap a pin to open its matching product card. Tapping
       another pin closes the previous and opens the new one.
       Tapping the close button or anywhere outside closes the
       active card. */
    var pins = section.querySelectorAll('[data-pin]');
    var backdrop = section.querySelector('[data-lbk-backdrop]');
    var activeCard = null;
    var activePin  = null;

    /* Body scroll lock — only activates on mobile when the drawer
       is open. Uses overflow:hidden on <html> rather than the
       position:fixed pattern.

       Why not position:fixed? That pattern requires saving and
       restoring scroll position on close, which visibly flashes
       a scroll-up-then-back-down on the page behind the drawer:
       removing position:fixed sends the page to scroll Y=0, then
       window.scrollTo restores it. Both happen in the same JS
       tick but the browser can paint between them, and any close
       transition (drawer fade-out, backdrop fade-out) makes the
       glitch visible.

       overflow:hidden on <html> doesn't change scroll position
       at all, so there's nothing to restore and nothing to flash.
       Modern browsers including iOS Safari 13+ respect this on
       the html element (the old "overflow:hidden doesn't work on
       iOS" rule applied to body alone, not html).

       Scrollbar-width compensation prevents a horizontal layout
       shift behind the drawer on the rare desktop tablet case. */
    var bodyLocked = false;
    var body = document.body;
    var savedHtmlOverflow = '';
    var savedBodyPaddingRight = '';

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function lockBodyIfMobile() {
      if (!isMobile() || bodyLocked) return;
      var html = document.documentElement;
      var scrollbarWidth = window.innerWidth - html.clientWidth;
      savedHtmlOverflow = html.style.overflow;
      html.style.overflow = 'hidden';
      if (scrollbarWidth > 0) {
        savedBodyPaddingRight = body.style.paddingRight;
        body.style.paddingRight = scrollbarWidth + 'px';
      }
      bodyLocked = true;
    }

    function unlockBody() {
      if (!bodyLocked) return;
      document.documentElement.style.overflow = savedHtmlOverflow;
      body.style.paddingRight = savedBodyPaddingRight;
      bodyLocked = false;
    }

    function closeActive() {
      if (!activeCard) return;
      activeCard.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      if (activePin) activePin.setAttribute('aria-expanded', 'false');
      unlockBody();
      resetCard(activeCard);
      activeCard = null;
      activePin  = null;
    }

    /* When a card closes, reset its picker so the next time it opens the
       customer starts fresh: Add-to-bag button visible, picker hidden,
       all selections cleared, step 2+ re-hidden. Stepped pickers also
       need their JS-side selected[] array cleared, which we do via a
       reset function attached during stepped-picker init. */
    function resetCard(card) {
      if (!card) return;
      /* Show the Add to bag button (was faded + hidden when picker revealed).
         Clear all the inline styles set during the reveal transition. */
      var addBtn = card.querySelector('[data-quick-add]');
      if (addBtn) {
        addBtn.style.display = '';
        addBtn.style.opacity = '';
        addBtn.style.pointerEvents = '';
      }
      /* Hide every picker in this card */
      var pickers = card.querySelectorAll('[data-variant-picker]');
      Array.prototype.forEach.call(pickers, function (picker) {
        picker.hidden = true;
        /* Clear any inline styles left over from the step-reveal FLIP
           animation in case the card closes mid-transition. */
        picker.style.height = '';
        picker.style.transition = '';
        picker.style.overflow = '';
        /* Clear is-selected from every option button */
        var btns = picker.querySelectorAll('.lbk__card-picker-btn');
        Array.prototype.forEach.call(btns, function (b) {
          b.classList.remove('is-selected');
        });
        /* Re-hide all step elements except the first */
        var steps = picker.querySelectorAll('.lbk__card-picker-step');
        Array.prototype.forEach.call(steps, function (step, i) {
          if (i === 0) step.classList.remove('is-hidden');
          else         step.classList.add('is-hidden');
        });
        /* If the stepped picker exposed a reset hook, call it (resets the
           closure-scoped selected[] back to its initial state, including
           any locked values). */
        if (typeof picker._lbkReset === 'function') {
          picker._lbkReset();
        }
      });
    }

    function openCard(pin) {
      var pinId = pin.getAttribute('data-pin');
      var card  = section.querySelector('[data-card="' + pinId + '"]');
      if (!card) return;
      closeActive();
      card.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      pin.setAttribute('aria-expanded', 'true');
      lockBodyIfMobile();
      activeCard = card;
      activePin  = pin;
    }

    /* Backdrop click closes the active card. */
    if (backdrop) {
      backdrop.addEventListener('click', closeActive);
    }

    Array.prototype.forEach.call(pins, function (pin) {
      pin.addEventListener('click', function (e) {
        e.stopPropagation();
        if (pin === activePin) {
          closeActive();
        } else {
          openCard(pin);
        }
      });
    });

    if (OPEN_ON_HOVER) {
    /* ── Hover-open behavior (desktop only) ──────────────────
       When merchant enables "Open card on hover," hovering a pin
       opens its card; the card stays open while the cursor is over
       either the pin OR the card, so customers can read and quick-add
       without clicking. Moving the cursor away from both starts a
       short close timer (default 250ms) — long enough to traverse the
       small gap between pin and card without the card snapping closed,
       short enough that it doesn't feel sticky.

       Touch input is filtered out via matchMedia: '(hover: hover) and
       (pointer: fine)' is true on devices with a real mouse. iPads in
       hover mode still work (some have hover:hover); pure touch phones
       don't, so they keep the tap-to-open behavior unchanged.

       The X close button still works for explicit close even with hover
       behavior on. Click on a pin opens (instead of toggle) since the
       card is usually already open from hover anyway. */
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover) {
      var closeTimer    = null;
      var closeDelay    = HOVER_CLOSE_DELAY;
      var hoverPin      = null;  /* pin we're currently hovering */
      var hoverCard     = null;  /* card we're currently hovering */

      function cancelClose() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      }

      function scheduleClose() {
        cancelClose();
        closeTimer = setTimeout(function () {
          /* Re-check hover state at fire time. If cursor jumped back
             onto the pin or card during the delay, abort the close. */
          if (!hoverPin && !hoverCard) {
            closeActive();
          }
          closeTimer = null;
        }, closeDelay);
      }

      Array.prototype.forEach.call(pins, function (pin) {
        pin.addEventListener('mouseenter', function () {
          hoverPin = pin;
          cancelClose();
          /* If a different card is already open from hover, switch.
             If this pin's card is already open (from prior hover), no-op. */
          if (activePin !== pin) {
            openCard(pin);
          }
        });
        pin.addEventListener('mouseleave', function () {
          if (hoverPin === pin) hoverPin = null;
          /* Only schedule close if we're not also hovering the card. */
          if (!hoverCard) scheduleClose();
        });
      });

      /* Wire each card so cursor sitting on it keeps it open. */
      var cards = section.querySelectorAll('[data-card]');
      Array.prototype.forEach.call(cards, function (card) {
        card.addEventListener('mouseenter', function () {
          hoverCard = card;
          cancelClose();
        });
        card.addEventListener('mouseleave', function () {
          if (hoverCard === card) hoverCard = null;
          if (!hoverPin) scheduleClose();
        });
      });
    }
    } /* end if OPEN_ON_HOVER */

    /* Close on outside click, Escape, or close button */
    document.addEventListener('click', function (e) {
      if (!activeCard) return;
      if (activeCard.contains(e.target)) return;
      if (activePin && activePin.contains(e.target)) return;
      closeActive();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeActive();
    });
    var closes = section.querySelectorAll('[data-card-close]');
    Array.prototype.forEach.call(closes, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeActive();
      });
    });

    /* ════════════════════════════════════════════════════════════
       QUICK ADD — adds product to cart from the lookbook card.

       Two flows:
       - data-quick-add="single" → button calls /cart/add.js directly
                                   with default variant
       - data-quick-add="options" → button reveals an inline variant
                                    picker; tapping a variant button
                                    adds that specific variant

       Cart notifications use the global window.cartToast API
       (defined in snippets/cart-toast.liquid). */
    /* ── Cart toast wrapper ──────────────────────────────────
       Thin shim around the global window.cartToast API (rendered
       once via cart-toast snippet in theme.liquid). */
    function showToast(msg, isError, btn) {
      if (!window.cartToast) return;
      var productImage = btn && btn.dataset ? (btn.dataset.productImage || '') : '';
      var productTitle = btn && btn.dataset ? (btn.dataset.productTitle || '') : '';
      window.cartToast.show({
        type:         isError ? 'error' : 'success',
        message:      msg,
        productImage: productImage,
        productTitle: productTitle,
        quantity:     1
      });
    }

    function addToCart(variantId, button) {
      if (!variantId) return;
      if (button) button.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (button) button.classList.remove('is-loading');
        if (res.ok) {
          /* Title is now passed to the global toast as a separate field
             (productTitle) via data-product-title — no need to append it
             to the message string. */
          showToast(MSG_ADDED, false, button);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          /* Close lookbook card after successful add */
          closeActive();
        } else {
          var errMsg = (res.data && (res.data.description || res.data.message))
            || MSG_ERROR;
          showToast(errMsg, true);
        }
      })
      .catch(function () {
        if (button) button.classList.remove('is-loading');
        showToast(MSG_ERROR, true);
      });
    }

    /* Quick-add buttons (the main "Add to bag" CTA) */
    var addBtns = section.querySelectorAll('[data-quick-add]');
    Array.prototype.forEach.call(addBtns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var mode = btn.getAttribute('data-quick-add');
        if (mode === 'options' || mode === 'steps') {
          /* Reveal the variant picker, fade out the add button.
             The button has a 0.25s opacity transition (CSS); we wait
             for it to finish before flipping display:none + showing
             the picker, which then runs its own enter animation. */
          var card = btn.closest('.lbk__card');
          var picker = card && card.querySelector('[data-variant-picker]');
          if (picker) {
            btn.style.opacity = '0';
            btn.style.pointerEvents = 'none';
            setTimeout(function () {
              btn.style.display = 'none';
              picker.hidden = false;
            }, 220);
          }
        } else {
          /* Single variant — add directly */
          var variantId = btn.getAttribute('data-variant-id');
          addToCart(variantId, btn);
        }
      });
    });

    /* Variant picker buttons — each adds a specific variant directly.
       Used for 'options' mode (1 option, or color-filtered to 1 option). */
    var variantBtns = section.querySelectorAll('[data-variant-add]');
    Array.prototype.forEach.call(variantBtns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('is-unavailable')) return;
        var variantId = btn.getAttribute('data-variant-add');
        addToCart(variantId, btn);
      });
    });

    /* ════════════════════════════════════════════════════════════
       STEPPED PICKER — multi-option products

       Each picker exposes its variants via a data-lbk-variants
       attribute (JSON-encoded). Each remaining option renders as a
       step with value buttons; the first step is visible, others
       hidden. Customer picks option in step 1 → step 2 reveals →
       (if step 3 exists) step 3 reveals → matched variant adds.

       When a color filter is active on a 3+ option product, that
       option is "locked": pre-selected to the merchant's color and
       not rendered as a step. The picker reads `data-locked-pos`
       (1-3) and `data-locked-val` to prefill the selection, then
       cascades through the remaining options.

       Step elements carry `data-step-pos="N"` indicating which
       option position (1-3) they represent — needed because the
       locked option may be skipped, breaking 1:1 step-index mapping. */

    var steppedPickers = section.querySelectorAll('.lbk__card-picker--steps');
    if (window.console && steppedPickers.length) {
      console.log('[lookbook] Found ' + steppedPickers.length + ' stepped picker(s)');
    }
    Array.prototype.forEach.call(steppedPickers, function (picker, pickerIdx) {
      var variantsAttr = picker.getAttribute('data-lbk-variants');
      if (!variantsAttr) {
        if (window.console) console.warn('[lookbook] picker #' + pickerIdx + ' has no data-lbk-variants');
        return;
      }
      var variants;
      try { variants = JSON.parse(variantsAttr); }
      catch (e) {
        if (window.console) console.warn('[lookbook] picker #' + pickerIdx + ' JSON parse failed:', e);
        return;
      }
      if (!variants || !variants.length) {
        if (window.console) console.warn('[lookbook] picker #' + pickerIdx + ' empty variants');
        return;
      }

      var productTitle = picker.getAttribute('data-product-title') || '';
      var lockedPos    = parseInt(picker.getAttribute('data-locked-pos') || '0', 10);
      var lockedVal    = picker.getAttribute('data-locked-val') || '';
      var steps        = picker.querySelectorAll('.lbk__card-picker-step');
      var totalSteps   = steps.length;

      /* selected[] is indexed by option POSITION (0=option1, 1=option2, 2=option3),
         not by step order. Locked positions stay set throughout. */
      var selected = [null, null, null];
      if (lockedPos > 0) {
        selected[lockedPos - 1] = lockedVal;
      }

      if (window.console) {
        console.log('[lookbook] picker #' + pickerIdx + ' for "' + productTitle + '": ' +
                    variants.length + ' variants, ' + totalSteps + ' visible steps' +
                    (lockedPos ? ' (option ' + lockedPos + ' locked to "' + lockedVal + '")' : ''));
      }

      if (totalSteps === 0) {
        if (window.console) console.warn('[lookbook] picker #' + pickerIdx + ' has no step elements!');
        return;
      }

      /* Find a variant whose options match every non-null entry in selected[]. */
      function findVariant() {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < 3; j++) {
            if (selected[j] !== null && v.o[j] !== selected[j]) {
              match = false; break;
            }
          }
          if (match) return v;
        }
        return null;
      }

      /* For step `stepIndex` (NodeList index), mark each button as available
         only if some available variant matches all currently-set selections
         (locked + prior steps) AND has the button's value at this step's
         option position. */
      function refreshAvailability(stepIndex) {
        var step    = steps[stepIndex];
        var stepPos = parseInt(step.getAttribute('data-step-pos'), 10);
        var optIdx  = stepPos - 1;
        var btns    = step.querySelectorAll('.lbk__card-picker-btn');
        Array.prototype.forEach.call(btns, function (btn) {
          var val = btn.getAttribute('data-option-value');
          var anyAvail = false;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            if (!v.a) continue;
            /* Every set selection (except the position we're testing) must match. */
            var match = true;
            for (var j = 0; j < 3; j++) {
              if (j === optIdx) continue;
              if (selected[j] !== null && v.o[j] !== selected[j]) {
                match = false; break;
              }
            }
            if (match && v.o[optIdx] === val) {
              anyAvail = true; break;
            }
          }
          if (anyAvail) {
            btn.classList.remove('is-unavailable');
            btn.removeAttribute('aria-disabled');
          } else {
            btn.classList.add('is-unavailable');
            btn.setAttribute('aria-disabled', 'true');
          }
        });
      }

      /* Initial sweep on the first visible step */
      refreshAvailability(0);

      /* Expose a reset hook so the card-close handler can clear selections
         when the customer dismisses the panel. Restores the locked value
         (if any) and refreshes step 1's availability. DOM-side resets
         (re-hiding pickers, clearing is-selected) are handled by resetCard. */
      picker._lbkReset = function () {
        selected = [null, null, null];
        if (lockedPos > 0) selected[lockedPos - 1] = lockedVal;
        refreshAvailability(0);
      };

      /* Bind clicks to each step's buttons */
      Array.prototype.forEach.call(steps, function (step, stepIndex) {
        var stepPos = parseInt(step.getAttribute('data-step-pos'), 10);
        var optIdx  = stepPos - 1;
        var btns    = step.querySelectorAll('.lbk__card-picker-btn');
        Array.prototype.forEach.call(btns, function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (btn.classList.contains('is-unavailable')) return;

            /* Mark selected, deselect siblings */
            Array.prototype.forEach.call(btns, function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');
            selected[optIdx] = btn.getAttribute('data-option-value');

            /* Reset selections for all FOLLOWING visible steps */
            for (var k = stepIndex + 1; k < totalSteps; k++) {
              var laterPos = parseInt(steps[k].getAttribute('data-step-pos'), 10);
              selected[laterPos - 1] = null;
              var laterBtns = steps[k].querySelectorAll('.lbk__card-picker-btn');
              Array.prototype.forEach.call(laterBtns, function (b) {
                b.classList.remove('is-selected');
              });
            }

            /* Reveal next visible step OR finalize */
            if (stepIndex + 1 < totalSteps) {
              /* FLIP-style height animation on the picker so the card
                 doesn't snap to its new height when step 2+ appears.
                 Read current height → reveal next step → read new
                 height → animate from old to new, then clear inline
                 styles. The step itself has its own fade-in animation
                 layered on top, so both run together. */
              var h1 = picker.offsetHeight;
              steps[stepIndex + 1].classList.remove('is-hidden');
              for (var k = stepIndex + 2; k < totalSteps; k++) {
                steps[k].classList.add('is-hidden');
              }
              refreshAvailability(stepIndex + 1);
              var h2 = picker.offsetHeight;
              picker.style.height   = h1 + 'px';
              picker.style.overflow = 'hidden';
              /* Force reflow so the height change registers */
              void picker.offsetHeight;
              picker.style.transition = 'height 0.45s cubic-bezier(0.22, 0.61, 0.36, 1)';
              picker.style.height = h2 + 'px';
              setTimeout(function () {
                picker.style.height = '';
                picker.style.transition = '';
                picker.style.overflow = '';
              }, 460);
              /* Scroll the new step into view on mobile (drawer can clip). */
              if (window.innerWidth < 750) {
                setTimeout(function () {
                  if (steps[stepIndex + 1].scrollIntoView) {
                    steps[stepIndex + 1].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                  }
                }, 100);
              }
            } else {
              /* Last visible step — find variant matching locked + picked. */
              var matchedVariant = findVariant();
              if (matchedVariant && matchedVariant.a) {
                btn.setAttribute('data-product-title', productTitle);
                addToCart(matchedVariant.i, btn);
              }
            }
          });
        });
      });
    });

    /* ── Sticky look index — active state + smooth scroll ──
       Observe each look. Whichever look is most central in the
       viewport gets its index button highlighted. Clicking an
       index button smooth-scrolls to that look. */
    var indexItems = section.querySelectorAll('[data-jump]');
    Array.prototype.forEach.call(indexItems, function (btn) {
      btn.addEventListener('click', function () {
        var target = section.querySelector('[data-lbk-look="' + btn.getAttribute('data-jump') + '"]');
        if (!target) return;
        /* Use the live --lbk-sticky-offset (computed from announcement
           bar + header rects) when available so the click lands the
           target's top below the actual sticky stack. Plus a small
           buffer for the index strip itself + a touch of breathing
           room. Falls back to 80px if the var hasn't been set yet
           (e.g. sticky_index is off, or just before first paint). */
        var stickyOffset = parseFloat(getComputedStyle(section).getPropertyValue('--lbk-sticky-offset')) || 0;
        var indexStrip   = section.querySelector('.lbk__index');
        var indexHeight  = indexStrip ? indexStrip.offsetHeight : 0;
        var headerOffset = stickyOffset + indexHeight + 16;
        if (!stickyOffset && !indexHeight) headerOffset = 80;
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    if (indexItems.length) {
      var looks = section.querySelectorAll('[data-lbk-look]');
      var byId = {};
      Array.prototype.forEach.call(indexItems, function (item) {
        byId[item.getAttribute('data-jump')] = item;
      });

      /* Active-look tracking.
         Earlier we used IntersectionObserver but had two problems:
         - The default threshold of 0.45 was unreachable on mobile,
           where stacked diptych looks become 1500px+ tall and can
           never reach 45% intersection in a 60% viewport band.
         - During smooth-scroll animations (triggered by clicking an
           index number), browsers coalesce IO events to save CPU,
           which sometimes drops the "look 1 entered the band" event
           when the user scrolls quickly back up.

         Switched to direct scroll tracking. On every scroll tick
         (rAF-throttled), we compute an "activation line" near the
         top of the viewport (just below the sticky stack), then
         find which look the line currently sits inside. That look
         becomes active. Deterministic — no event-dropping, no
         threshold math, works at any look height. */
      var activeId = null;

      function updateActiveLook() {
        var stickyOffset = parseFloat(getComputedStyle(section).getPropertyValue('--lbk-sticky-offset')) || 0;
        var indexStrip   = section.querySelector('.lbk__index');
        var indexHeight  = indexStrip ? indexStrip.offsetHeight : 0;
        /* Activation line: 60px below the sticky stack. This puts the
           trigger just below whatever's pinned to the top, so a look's
           "top edge crosses below the line" reads as "this look is now
           the one I'm reading." 60px is enough to feel deliberate but
           not so far down that short content is missed. */
        var triggerLine = stickyOffset + indexHeight + 60;

        /* Find the look whose body currently spans the activation line
           (top above line, bottom below line). */
        var winner = null;
        Array.prototype.forEach.call(looks, function (look) {
          var rect = look.getBoundingClientRect();
          if (rect.top <= triggerLine && rect.bottom > triggerLine) {
            winner = look.getAttribute('data-lbk-look');
          }
        });

        /* Fallback: between looks (small gap, neither spans the line),
           use the last look whose top is above the line. This keeps the
           previous look highlighted during the gap rather than losing
           the active state. Above all looks (page top, looking at
           heading/intro) this stays null, so nothing is highlighted. */
        if (!winner) {
          var bestTop = -Infinity;
          Array.prototype.forEach.call(looks, function (look) {
            var rect = look.getBoundingClientRect();
            if (rect.top <= triggerLine && rect.top > bestTop) {
              bestTop = rect.top;
              winner = look.getAttribute('data-lbk-look');
            }
          });
        }

        if (winner && winner !== activeId) {
          activeId = winner;
          Array.prototype.forEach.call(indexItems, function (i) { i.classList.remove('is-active'); });
          if (byId[winner]) byId[winner].classList.add('is-active');
        }
      }

      /* rAF-throttled scroll handler so we update once per animation
         frame max — keeps CPU low during fast scrolling. */
      var activePending = false;
      function onScroll() {
        if (activePending) return;
        activePending = true;
        requestAnimationFrame(function () {
          updateActiveLook();
          activePending = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', updateActiveLook);
      /* Initial computation + after fonts/images settle (header height
         can change as web fonts swap in, shifting our trigger line). */
      updateActiveLook();
      window.addEventListener('load', updateActiveLook);
    }

    /* ── Look reveal on scroll ────────────────────────── */
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      var lookEls = section.querySelectorAll('[data-lbk-look]');
      Array.prototype.forEach.call(lookEls, function (l) { revealObserver.observe(l); });
    } else {
      /* No IO support → just show everything */
      var lookEls2 = section.querySelectorAll('[data-lbk-look]');
      Array.prototype.forEach.call(lookEls2, function (l) { l.classList.add('is-visible'); });
    }
    } /* end initLBK */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["music-player"]) return;
  try {
    
  /* Music player driver. Multi-instance: iterates every
     .csp-music section and initializes a separate player keyed by
     section-id (read from data-section-id). Each section's settings
     come from data-* attributes so this block stays free of Liquid
     interpolation and is cached.

     A per-section cleanup registry on window.__cspMusicPlayer
     supports Shopify editor live-preview: when the merchant changes
     a setting, Shopify replaces the section's DOM. The shopify:
     section:load listener re-initializes the fresh node, and any
     prior instance's document/window listeners are torn down first. */
  (function() {
    var REGISTRY_KEY = '__cspMusicPlayer';
    if (!window[REGISTRY_KEY]) window[REGISTRY_KEY] = {};

    function initSection(section) {
      if (!section) return;
      var sectionId = section.getAttribute('data-section-id');
      if (!sectionId) return;

      /* Tear down the previous instance for THIS section ID, if any.
         (Storefront visitors never trigger this path; editor re-render
         does.) */
      if (window[REGISTRY_KEY][sectionId] && typeof window[REGISTRY_KEY][sectionId].cleanup === 'function') {
        try { window[REGISTRY_KEY][sectionId].cleanup(); } catch (e) {}
      }

      /* Re-init guard: bail if THIS node was already initialized.
         Editor re-render delivers a fresh node without the flag. */
      if (section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

      /* Track listeners we add to document/window — gets cleaned up
         on next init OR when the user navigates away. */
      var trackedListeners = [];
      function addTrackedListener(target, event, handler, options) {
        target.addEventListener(event, handler, options);
        trackedListeners.push({ target: target, event: event, handler: handler, options: options });
      }
      function cleanup() {
        for (var i = 0; i < trackedListeners.length; i++) {
          var L = trackedListeners[i];
          try { L.target.removeEventListener(L.event, L.handler, L.options); } catch (e) {}
        }
        trackedListeners.length = 0;
      }
      window[REGISTRY_KEY][sectionId] = { cleanup: cleanup };

      /* ── Collect tracks from data divs ─────────────────────── */
      var trackEls = section.querySelectorAll('.csp-music__tracks > div');
      var tracks = Array.prototype.map.call(trackEls, function(el) {
        return {
          title:  el.getAttribute('data-title')  || 'Untitled',
          artist: el.getAttribute('data-artist') || '',
          art:    el.getAttribute('data-art')    || '',
          src:    el.getAttribute('data-audio')  || ''
        };
      }).filter(function(t) { return t.src; });

      if (!tracks.length) return;

      /* ── Editor mode detection ─────────────────────────────── */
      var isEditor = !!(window.Shopify && window.Shopify.designMode) ||
                     document.documentElement.classList.contains('shopify-design-mode');

      /* ── URL exclusion check ───────────────────────────────── */
      /* Hardcoded never-show paths regardless of merchant config */
      var hardcodedExcluded = ['/checkout', '/account', '/admin'];
      /* Optional pause-on-cart and merchant-supplied excluded URLs */
      var pauseOnCheckout = section.getAttribute('data-pause-on-checkout') === 'true';
      var merchantExcluded = (section.getAttribute('data-excluded-urls') || '')
        .split(',').map(function(s){ return s.trim().toLowerCase(); }).filter(Boolean);
      var allExcluded = hardcodedExcluded.concat(merchantExcluded);

      var path = window.location.pathname.toLowerCase();
      for (var i = 0; i < allExcluded.length; i++) {
        var ex = allExcluded[i];
        if (ex && path.indexOf(ex) === 0) {
          /* On excluded URL — don't even render the player */
          if (!isEditor) return;
          /* In editor, still render so merchant can see it */
          break;
        }
      }

      /* ── Element refs ──────────────────────────────────────── */
      var audio       = section.querySelector('.csp-music__audio');
      var toggleBtn   = section.querySelector('.csp-music__toggle');
      var closeBtn    = section.querySelector('.csp-music__close');
      var playBtn     = section.querySelector('.csp-music__playpause');
      var prevBtn     = section.querySelector('.csp-music__prev');
      var nextBtn     = section.querySelector('.csp-music__next');
      var volSlider   = section.querySelector('.csp-music__volume');
      var titleEl     = section.querySelector('.csp-music__title');
      var artistEl    = section.querySelector('.csp-music__artist');
      var artSmall    = section.querySelector('.csp-music__art--small');
      var artLarge    = section.querySelector('.csp-music__art--large');
      var ringFill    = section.querySelector('.csp-music__progress-ring-fill');
      var progressBar  = section.querySelector('.csp-music__progress-bar');
      var progressFill = section.querySelector('.csp-music__progress-bar-fill');
      var timeCurrent  = section.querySelector('.csp-music__time--current');
      var timeDuration = section.querySelector('.csp-music__time--duration');
      var songbar      = section.querySelector('.csp-music__songbar');
      var songbarText  = section.querySelector('.csp-music__songbar-text');
      var showSongBar  = section.getAttribute('data-show-song-bar') === 'true';

      /* ── CUSTOM CURSOR (Plain Jane pattern) ──────────────────
         If the theme defines a --custom-cursor CSS variable on body,
         apply it as the document's cursor. Same logic as Plain Jane.
         Niche feature for themes with branded cursors. */
      try {
        var customCursor = getComputedStyle(document.body).getPropertyValue('--custom-cursor').trim();
        if (customCursor && customCursor !== 'none') {
          document.documentElement.style.cursor = 'url("' + customCursor + '"), auto';
        }
      } catch (e) {}

      /* ── Progress ring math ────────────────────────────────── */
      var ringRadius = ringFill ? parseFloat(ringFill.getAttribute('r')) : 27;
      var ringCircumference = 2 * Math.PI * ringRadius;
      if (ringFill) {
        ringFill.style.strokeDasharray  = ringCircumference;
        ringFill.style.strokeDashoffset = ringCircumference;
      }

      /* ── Storage + tab coordination ────────────────────────── */
      var STORAGE_KEY = 'csp_music_state';
      var TAB_ID = 'csp_music_tab_' + Date.now() + '_' + Math.random().toString(36).slice(2);

      /* ── State ─────────────────────────────────────────────── */
      var defaultVolume = parseFloat(section.getAttribute('data-default-volume') || '50') / 100;
      var startMinimized = section.getAttribute('data-start-minimized') === 'true';
      var autoResume = section.getAttribute('data-auto-resume') === 'true';
      var autoPlayFirstSession = section.getAttribute('data-auto-play-first-session') === 'true';
      var repeatMode = section.getAttribute('data-repeat-mode') || 'all';
      var shuffleMode = section.getAttribute('data-shuffle') === 'true';

      var state = {
        trackIndex: 0,
        currentTime: 0,
        isPlaying: false,
        volume: defaultVolume,
        expanded: !startMinimized,
        lastUpdated: 0,
        tabId: TAB_ID
      };

      /* Restore from localStorage if present (overrides defaults
         except for the merchant-controlled toggles which are
         authoritative on every page load) */
      try {
        var saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
        if (saved && typeof saved === 'object') {
          if (typeof saved.trackIndex  === 'number' && saved.trackIndex < tracks.length) state.trackIndex = saved.trackIndex;
          if (typeof saved.currentTime === 'number') state.currentTime = saved.currentTime;
          if (typeof saved.isPlaying   === 'boolean') state.isPlaying = saved.isPlaying;
          if (typeof saved.volume      === 'number') state.volume = saved.volume;
        }
      } catch (e) {}

      /* ── State save (throttled) ────────────────────────────── */
      var lastSave = 0;
      function saveState(force) {
        var now = Date.now();
        if (!force && now - lastSave < 500) return;
        lastSave = now;
        try {
          state.currentTime = audio.currentTime || state.currentTime;
          state.lastUpdated = now;
          state.tabId = TAB_ID;
          localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
        } catch (e) {}
      }

      /* ── Track loading ─────────────────────────────────────── */
      function loadTrack(index, autoplay) {
        var track = tracks[index];
        if (!track) return;

        state.trackIndex = index;
        audio.src = track.src;
        audio.load();

        titleEl.textContent  = track.title;
        artistEl.textContent = track.artist;

        /* Update song bar marquee text */
        if (songbarText) {
          var bar = track.title + (track.artist ? ' — ' + track.artist : '');
          songbarText.textContent = bar;
        }

        /* Update both art elements (small + large) */
        [artSmall, artLarge].forEach(function(el) {
          if (!el) return;
          if (track.art) {
            el.style.backgroundImage = 'url("' + track.art + '")';
            el.classList.remove('csp-music__art--placeholder');
          } else {
            el.style.backgroundImage = '';
            el.classList.add('csp-music__art--placeholder');
          }
        });

        /* Reset progress UI immediately — avoid showing the previous
           track's duration/fill during the brief metadata load gap */
        if (progressFill)  progressFill.style.width = '0%';
        if (timeCurrent)   timeCurrent.textContent = '0:00';
        if (timeDuration)  timeDuration.textContent = '0:00';
        if (ringFill)      ringFill.style.strokeDashoffset = ringCircumference;

        if (autoplay) {
          attemptPlay();
        } else {
          saveState(true);
        }
      }

      /* ── Play / Pause ──────────────────────────────────────── */
      /* attemptPlay() is called when SOMETHING (user click, auto-resume,
         track-end auto-advance, ring click) wants playback to start.
         It sets the user-intent flag to "playing" and asks the audio
         element to play. If the browser blocks the play() promise, the
         intent stays TRUE so the gesture-resume listeners can pick up
         on the next user interaction. The UI updates via the audio's
         own `play`/`pause` events, not from this function. */
      function attemptPlay() {
        state.isPlaying = true;
        saveState(true);
        var p = audio.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function() {
            /* Autoplay blocked. Intent preserved for gesture retry.
               UI already reflects audio.paused === true (correct). */
          });
        }
      }

      /* pause() is the user-initiated pause path: explicit "stop the
         music" intent. The audio's pause event will fire and sync the
         UI; we only handle intent + persistence here. */
      function pause() {
        state.isPlaying = false;
        saveState(true);
        audio.pause();
      }

      function togglePlay() {
        if (audio.paused) attemptPlay();
        else pause();
      }

      /* ── Next / Prev ───────────────────────────────────────── */
      function nextTrack() {
        var newIndex;
        if (shuffleMode && tracks.length > 1) {
          do { newIndex = Math.floor(Math.random() * tracks.length); }
          while (newIndex === state.trackIndex);
        } else {
          newIndex = (state.trackIndex + 1) % tracks.length;
        }
        loadTrack(newIndex, true);
      }

      function prevTrack() {
        /* Industry standard: if past 3 seconds, restart current
           track instead of going to previous */
        if (audio.currentTime > 3) {
          audio.currentTime = 0;
          return;
        }
        var newIndex = (state.trackIndex - 1 + tracks.length) % tracks.length;
        loadTrack(newIndex, true);
      }

      /* ── UI updates ────────────────────────────────────────── */
      function updatePlayUI() {
        /* UI reflects what the audio element is ACTUALLY doing right
           now (audio.paused), not what the user wants to be happening
           (state.isPlaying). When autoplay is blocked on a fresh page,
           user intent says "playing" but the audio is paused — the
           play button correctly shows "Play" until the user taps to
           unblock, at which point the play event fires and the UI
           updates to "Pause". */
        if (!audio.paused) {
          section.classList.add('is-playing');
          if (playBtn) playBtn.setAttribute('aria-label', 'Pause');
        } else {
          section.classList.remove('is-playing');
          if (playBtn) playBtn.setAttribute('aria-label', 'Play');
        }
      }

      function formatTime(seconds) {
        if (!isFinite(seconds) || seconds < 0) return '0:00';
        var mins = Math.floor(seconds / 60);
        var secs = Math.floor(seconds % 60);
        return mins + ':' + (secs < 10 ? '0' : '') + secs;
      }

      function updateProgress() {
        var dur = audio.duration;
        var cur = audio.currentTime || 0;
        var hasDur = dur && isFinite(dur);
        var pct = hasDur ? cur / dur : 0;

        /* SVG ring around the collapsed circle */
        if (ringFill && hasDur) {
          ringFill.style.strokeDashoffset = ringCircumference * (1 - pct);
        }

        /* Mobile linear progress bar */
        if (progressFill) {
          progressFill.style.width = (pct * 100) + '%';
        }
        if (progressBar && hasDur) {
          progressBar.setAttribute('aria-valuenow', Math.round(pct * 100));
        }

        /* Mobile time labels */
        if (timeCurrent) timeCurrent.textContent = formatTime(cur);
        if (timeDuration) timeDuration.textContent = hasDur ? formatTime(dur) : '0:00';
      }

      /* Click / tap to seek on the mobile progress bar.
         Uses pointer coordinates relative to the bar's bounding box.
         Keyboard users can also seek via Left/Right arrow keys when
         the bar is focused (5% increments). */
      if (progressBar) {
        progressBar.addEventListener('click', function(e) {
          if (!audio.duration || !isFinite(audio.duration)) return;
          var rect = progressBar.getBoundingClientRect();
          var pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
          audio.currentTime = pct * audio.duration;
          updateProgress();
          saveState(true);
        });
        progressBar.addEventListener('keydown', function(e) {
          if (!audio.duration || !isFinite(audio.duration)) return;
          var step = audio.duration * 0.05; /* 5% jumps */
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
            e.preventDefault();
            audio.currentTime = Math.max(0, audio.currentTime - step);
            updateProgress();
            saveState(true);
          } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
            e.preventDefault();
            audio.currentTime = Math.min(audio.duration, audio.currentTime + step);
            updateProgress();
            saveState(true);
          }
        });
      }

      function expand() {
        state.expanded = true;
        section.classList.add('is-expanded');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
        /* Immediately hide the song name bar — the expanded panel
           already shows the title, so the hover hint is redundant
           (and visually competes with the panel). */
        if (songbar) songbar.classList.remove('is-visible');
        saveState(true);
      }

      function collapse() {
        state.expanded = false;
        section.classList.remove('is-expanded');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
        saveState(true);
      }

      /* ── Event wiring ──────────────────────────────────────── */
      if (toggleBtn) toggleBtn.addEventListener('click', expand);
      if (closeBtn)  closeBtn.addEventListener('click', collapse);
      if (playBtn)   playBtn.addEventListener('click', togglePlay);
      if (nextBtn)   nextBtn.addEventListener('click', nextTrack);
      if (prevBtn)   prevBtn.addEventListener('click', prevTrack);

      /* CLICK ON ALBUM ART = SKIP TO NEXT TRACK (Plain Jane pattern).
         The large art in the expanded panel acts as a quick-skip button.
         Hover state shows a "next" overlay icon (CSS-driven). */
      if (artLarge) {
        artLarge.addEventListener('click', function(e) {
          e.stopPropagation();   /* Don't bubble to panel/toggle */
          nextTrack();
        });
      }

      /* SONG NAME BAR — show on hover of toggle, hide after delay on
         leave. Plain Jane pattern, adapted for our toggle position.
         Suppressed entirely while the expanded panel is open — the
         panel itself shows the track info, so the hover hint would
         just be visual noise. */
      if (showSongBar && songbar && toggleBtn) {
        var hideTimeout = null;
        var showSongBarBar = function() {
          /* Don't show the hover bar while the expanded panel is open */
          if (state.expanded) return;
          if (hideTimeout) {
            clearTimeout(hideTimeout);
            hideTimeout = null;
          }
          songbar.classList.add('is-visible');
        };
        var hideSongBarBar = function() {
          if (hideTimeout) clearTimeout(hideTimeout);
          hideTimeout = setTimeout(function() {
            songbar.classList.remove('is-visible');
            hideTimeout = null;
          }, 600);
        };
        toggleBtn.addEventListener('mouseenter', showSongBarBar);
        toggleBtn.addEventListener('mouseleave', hideSongBarBar);
        /* Also keep it open if hovering the bar itself */
        songbar.addEventListener('mouseenter', showSongBarBar);
        songbar.addEventListener('mouseleave', hideSongBarBar);
      }

      if (volSlider) {
        volSlider.value = Math.round(state.volume * 100);
        volSlider.addEventListener('input', function() {
          state.volume = parseFloat(volSlider.value) / 100;
          audio.volume = state.volume;
          saveState();
        });
      }

      /* ── Audio events ──────────────────────────────────────── */
      audio.addEventListener('timeupdate', function() {
        updateProgress();
        saveState();   /* Throttled internally to once every 500ms */
      });

      audio.addEventListener('ended', function() {
        if (repeatMode === 'one') {
          audio.currentTime = 0;
          attemptPlay();
        } else if (repeatMode === 'all' || shuffleMode) {
          nextTrack();
        } else {
          /* repeatMode === 'none' and not shuffling — stop at end */
          state.isPlaying = false;
          updatePlayUI();
          saveState(true);
        }
      });

      audio.addEventListener('error', function() {
        /* If a track URL fails (404, CORS, etc.), skip to next.
           Avoid infinite loops if all tracks are broken. */
        if (tracks.length > 1) {
          setTimeout(nextTrack, 500);
        } else {
          state.isPlaying = false;
          updatePlayUI();
        }
      });

      audio.addEventListener('play', function() {
        /* Audio actually started playing — sync UI only.
           Do NOT touch state.isPlaying here: that variable tracks USER
           INTENT (was the user playing music when they navigated?), not
           the moment-to-moment audio element state. The UI reads
           audio.paused directly via updatePlayUI(). */
        updatePlayUI();
      });

      audio.addEventListener('pause', function() {
        /* Audio paused — sync UI only.
           Critical: do NOT set state.isPlaying = false here. The audio
           element fires `pause` for many reasons that aren't "the user
           paused": browser blocking an autoplay attempt, source change,
           tab going to background, etc. If we mutated state.isPlaying
           on every such event we'd lose the user's intent across page
           navigation, which broke the gesture-resume mechanism on
           mobile. User-driven pause is handled by the pause() function
           below, which sets state.isPlaying = false explicitly. */
        updatePlayUI();
      });

      /* ── Cross-tab coordination ────────────────────────────── */
      /* When another tab updates state, check if it took over
         playback. If so, pause this tab. */
      if (!isEditor) {
        addTrackedListener(window, 'storage', function(e) {
          if (e.key !== STORAGE_KEY || !e.newValue) return;
          try {
            var newState = JSON.parse(e.newValue);
            if (!newState || newState.tabId === TAB_ID) return;
            /* Another tab is now the active one. If we're playing,
               pause to yield control. */
            if (newState.isPlaying && state.isPlaying) {
              audio.pause();
              state.isPlaying = false;
              updatePlayUI();
            }
          } catch (err) {}
        });
      }

      /* ── Persist on navigation ─────────────────────────────── */
      /* pagehide is more reliable than beforeunload on Safari */
      addTrackedListener(window, 'pagehide', function() {
        saveState(true);
      });

      /* ── Initialization ────────────────────────────────────── */

      /* SESSION DETECTION
         sessionStorage clears when the browser tab/window closes, so it
         naturally tracks "is this the first page load of the current
         browser session?" If the merchant has enabled auto-play on
         first session, we force state.isPlaying = true here, which
         triggers the muted-autoplay path below. */
      var SESSION_KEY = 'csp_music_session_started';
      var isFirstSessionLoad = false;
      try {
        isFirstSessionLoad = !sessionStorage.getItem(SESSION_KEY);
      } catch (e) {}

      if (autoPlayFirstSession && isFirstSessionLoad && !isEditor) {
        /* First page of the session AND merchant wants auto-play.
           Set audio.muted = true synchronously BEFORE loadTrack — this
           enables guaranteed muted autoplay (browsers always allow it).
           Override state.isPlaying so the resume logic kicks in. */
        audio.muted = true;
        state.isPlaying = true;
      }
      /* Mark session started either way so we don't re-trigger this
         on navigation within the session */
      try {
        sessionStorage.setItem(SESSION_KEY, 'true');
      } catch (e) {}

      audio.volume = state.volume;
      loadTrack(state.trackIndex, false);

      /* Wait for metadata before applying saved currentTime,
         otherwise the seek silently fails on some browsers */
      audio.addEventListener('loadedmetadata', function onMeta() {
        audio.removeEventListener('loadedmetadata', onMeta);
        if (state.currentTime > 0 && state.currentTime < (audio.duration || Infinity)) {
          try { audio.currentTime = state.currentTime; } catch (e) {}
        }
        updateProgress();
        /* Auto-resume if was playing AND merchant allows it.
           For the muted-autoplay path (session-autoplay), audio.muted
           was set true above so attemptPlay() will succeed. For regular
           resume, attemptPlay relies on browser engagement (Chrome MEI). */
        if (state.isPlaying && autoResume && !isEditor) {
          attemptPlay();
        }
      }, { once: false });

      /* PLAIN JANE PATTERN — gesture-driven resume.
         The exact listener set Plain Jane theme uses, with the same
         logic: on any user interaction, if intent is "playing", call
         playSong() (= unmute + play). Listeners stay attached forever
         (only inert when intent is paused, due to the early-return).

         This is the definitive cross-page auto-resume mechanism.
         Browsers only allow audio.play() inside qualifying user
         gesture handlers (click, mousedown, mouseup, touchstart,
         touchend, keydown, pointerdown). mousemove and touchmove are
         included for mass-coverage even though they don't qualify —
         the user almost always clicks/taps something within seconds
         of landing on a new page, and that click WILL qualify. */
      if (state.isPlaying && autoResume && !isEditor) {
        var resumeOnGesture = function() {
          if (!state.isPlaying) return;
          /* Unmute first (in case session-autoplay or muted-autoplay
             was active), then call play() — the calling event provides
             user activation, so play() will succeed even if browser
             was blocking earlier autoplay attempts. */
          if (audio.muted) audio.muted = false;
          if (audio.paused) {
            var p = audio.play();
            if (p && typeof p.catch === 'function') p.catch(function() {});
          }
        };
        addTrackedListener(document, 'click',       resumeOnGesture);
        addTrackedListener(document, 'mousedown',   resumeOnGesture);
        addTrackedListener(document, 'mouseup',     resumeOnGesture);
        addTrackedListener(document, 'mousemove',   resumeOnGesture);
        addTrackedListener(document, 'touchstart',  resumeOnGesture);
        addTrackedListener(document, 'touchend',    resumeOnGesture);
        addTrackedListener(document, 'touchmove',   resumeOnGesture);
        addTrackedListener(document, 'keydown',     resumeOnGesture);
        addTrackedListener(document, 'pointerdown', resumeOnGesture);
      }

      /* Apply expanded state */
      if (state.expanded) {
        section.classList.add('is-expanded');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      }

      /* Reveal player */
      section.removeAttribute('hidden');
    }

    function init(root) {
      (root || document).querySelectorAll('.csp-music').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init: merchant saves a setting, Shopify replaces
       the section's DOM with a fresh node that has no data-csp-init
       flag, so initSection runs cleanly on it. The cleanup() for the
       prior instance is invoked from inside initSection via the
       per-section-id registry. */
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-hero"] && !Shopify.designMode) return;
  try {
    
  /* NEWSLETTER HERO -- multi-instance behaviors, all keyed off
     data-* attributes on the .nh-hero element so this block stays
     fully static. Uses dataset.nhCspInit for idempotency (a separate
     flag from .hero in sections/hero.liquid so the two systems coexist
     on pages with both kinds of hero). Theme editor reload (the
     shopify:section:load event) re-runs init against the fresh DOM. */
  (function() {
    'use strict';

    /* ----- Text animation on scroll-into-view -------------------- */
    function initAnimation(hero) {
      var animationType = hero.dataset.nhTextAnimation;
      if (!animationType || animationType === 'none') return;

      var elements = hero.querySelectorAll('.animate-element');
      if (!elements.length) return;

      var animationDuration = parseInt(hero.dataset.nhAnimationDuration, 10) || 600;
      var animationDelay    = parseInt(hero.dataset.nhAnimationDelay, 10) || 0;
      var staggerEnabled    = hero.dataset.nhAnimationStagger === 'true';

      function typeWriter(element, callback) {
        var typewriterSpan = element.querySelector('.typewriter-text');
        var cursor = element.querySelector('.typewriter-cursor');
        if (!typewriterSpan) {
          element.classList.add('animated');
          if (callback) callback();
          return;
        }
        var text = typewriterSpan.getAttribute('data-text') || '';
        var speed = Math.max(20, Math.floor(animationDuration / Math.max(text.length, 1)));
        var i = 0;
        typewriterSpan.textContent = '';
        function type() {
          if (i < text.length) {
            typewriterSpan.textContent += text.charAt(i);
            i++;
            setTimeout(type, speed);
          } else {
            setTimeout(function() {
              if (cursor) cursor.classList.add('hidden');
              if (callback) callback();
            }, 1500);
          }
        }
        type();
      }

      function startAnimations() {
        if (animationType === 'typewriter') {
          elements.forEach(function(el, index) {
            var typewriterSpan = el.querySelector('.typewriter-text');
            if (typewriterSpan) {
              var delay = staggerEnabled ? (index * 100) : 0;
              setTimeout(function() { typeWriter(el, null); }, animationDelay + delay);
            } else {
              el.classList.add('animated');
            }
          });
        } else {
          elements.forEach(function(el) { el.classList.add('animated'); });
        }
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            startAnimations();
            observer.disconnect();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(hero);

      var rect = hero.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        setTimeout(startAnimations, 100);
        observer.disconnect();
      }
    }

    /* ----- Scroll-reveal header offset --------------------------- */
    function initScrollReveal(hero) {
      if (hero.dataset.nhScrollReveal !== 'true') return;

      function updateHeaderOffset() {
        var header = document.querySelector('#site-header, .site-header, header[data-sticky]');
        var h = 0;
        if (header) {
          var el = header.closest('[style*="position: fixed"], [style*="position:fixed"]') || header;
          if (el && (el.style.position === 'fixed' || window.getComputedStyle(el).position === 'fixed')) {
            h = el.offsetHeight;
          }
        }
        hero.style.setProperty('--hero-header-offset', h + 'px');
      }

      updateHeaderOffset();
      window.addEventListener('scroll', updateHeaderOffset, { passive: true });
      window.addEventListener('resize', updateHeaderOffset, { passive: true });
    }

    /* ----- Video controls ---------------------------------------- */
    function initVideoControls(hero) {
      if (hero.dataset.nhShowVideoControls !== 'true') return;
      if (hero.dataset.nhHasAnyVideo !== 'true') return;
      var sectionId = hero.dataset.sectionId;

      hero.querySelectorAll('.hero__video-controls').forEach(function(controls) {
        var mediaEl = controls.closest('.hero__media');
        if (!mediaEl) return;
        var video = mediaEl.querySelector('.hero__video');
        if (!video) return;

        var playBtn  = controls.querySelector('.hero__vc-playpause');
        var muteBtn  = controls.querySelector('.hero__vc-mute');
        var fill     = controls.querySelector('.hero__vc-progress-fill');
        var progress = controls.querySelector('.hero__vc-progress');

        var iconPause = playBtn ? playBtn.querySelector('.hero__vc-icon--pause') : null;
        var iconPlay  = playBtn ? playBtn.querySelector('.hero__vc-icon--play') : null;
        var iconSound = muteBtn ? muteBtn.querySelector('.hero__vc-icon--sound') : null;
        var iconMuted = muteBtn ? muteBtn.querySelector('.hero__vc-icon--muted') : null;

        function syncPlayIcon() {
          if (!playBtn || !iconPause || !iconPlay) return;
          iconPause.style.display = video.paused ? 'none' : '';
          iconPlay.style.display  = video.paused ? '' : 'none';
          playBtn.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        }

        function syncMuteIcon() {
          if (!muteBtn || !iconSound || !iconMuted) return;
          iconSound.style.display = video.muted ? 'none' : '';
          iconMuted.style.display = video.muted ? '' : 'none';
          muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        }

        if (playBtn) {
          playBtn.addEventListener('click', function() {
            if (video.paused) { video.play(); } else { video.pause(); }
            syncPlayIcon();
          });
        }

        if (muteBtn) {
          muteBtn.addEventListener('click', function() {
            video.muted = !video.muted;
            syncMuteIcon();
          });
        }

        if (progress) {
          progress.addEventListener('click', function(e) {
            if (!video.duration) return;
            var rect = progress.getBoundingClientRect();
            video.currentTime = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width)) * video.duration;
          });
        }

        (window.cspManagedInterval || setInterval)(function() {
          if (fill && video.duration) fill.style.width = ((video.currentTime / video.duration) * 100) + '%';
          syncPlayIcon();
          syncMuteIcon();
        }, 250, sectionId);
      });
    }

    /* ----- Custom gender / select dropdowns ----------------------
       Each [data-dropdown] inside the hero gets independent open/close,
       keyboard navigation (ArrowUp/Down, Enter, Space, Escape), click-
       outside-to-close, and a form-submit validation fallback (the
       hidden input has `required` but browsers can't show their
       native tooltip on a hidden field, so we trap submit and open
       the panel for the user). */
    function initDropdowns(hero) {
      /* The .shopify-section wrapper carries the .is-nh-dropdown-open
         flag while any dropdown in this hero is open — see the
         matching scoped CSS that switches .hero to overflow: visible
         and lifts the section's z-index so the panel paints above
         neighbours. Fallback to .nh-hero itself if for some reason
         we can't find the wrapper (e.g. rendered outside Shopify). */
      var sectionWrapper = hero.closest('[id^="shopify-section-"]') || hero;

      hero.querySelectorAll('[data-dropdown]').forEach(function(dropdown) {
        var trigger = dropdown.querySelector('[data-dropdown-trigger]');
        var panel   = dropdown.querySelector('[data-dropdown-panel]');
        var input   = dropdown.querySelector('[data-dropdown-input]');
        var label   = dropdown.querySelector('[data-dropdown-value]');
        var options = Array.prototype.slice.call(dropdown.querySelectorAll('[role="option"]'));
        if (!trigger || !panel || !input || !label || options.length === 0) return;

        var activeIndex = -1;

        function openPanel() {
          panel.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          sectionWrapper.classList.add('is-nh-dropdown-open');
          var selectedIdx = options.findIndex(function(o) { return o.getAttribute('aria-selected') === 'true'; });
          activeIndex = selectedIdx >= 0 ? selectedIdx : 0;
          setActive(activeIndex);
        }
        function closePanel() {
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          activeIndex = -1;
          options.forEach(function(o) { o.removeAttribute('data-active'); });
          /* Only drop the section-level flag once EVERY dropdown in
             the hero is closed. Multiple newsletter-hero blocks can
             each render their own dropdown, so we ref-count via the
             DOM rather than a counter variable. */
          if (hero.querySelectorAll('[data-dropdown-panel]:not([hidden])').length === 0) {
            sectionWrapper.classList.remove('is-nh-dropdown-open');
          }
        }
        function setActive(idx) {
          options.forEach(function(o, i) {
            if (i === idx) {
              o.setAttribute('data-active', 'true');
              o.scrollIntoView({ block: 'nearest' });
            } else {
              o.removeAttribute('data-active');
            }
          });
          activeIndex = idx;
        }
        function selectOption(opt) {
          input.value = opt.getAttribute('data-value') || '';
          label.textContent = opt.textContent.trim();
          label.classList.remove('nh-dropdown__value--placeholder');
          options.forEach(function(o) { o.removeAttribute('aria-selected'); });
          opt.setAttribute('aria-selected', 'true');
          input.dispatchEvent(new Event('change', { bubbles: true }));
          closePanel();
          trigger.focus();
        }

        trigger.addEventListener('click', function(e) {
          e.stopPropagation();
          if (panel.hidden) openPanel();
          else closePanel();
        });

        options.forEach(function(opt) {
          opt.addEventListener('click', function(e) {
            e.stopPropagation();
            selectOption(opt);
          });
          opt.addEventListener('mouseenter', function() {
            setActive(options.indexOf(opt));
          });
        });

        document.addEventListener('click', function(e) {
          if (!dropdown.contains(e.target)) closePanel();
        });

        trigger.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            if (panel.hidden) {
              openPanel();
            } else {
              var dir = e.key === 'ArrowDown' ? 1 : -1;
              var next = (activeIndex + dir + options.length) % options.length;
              setActive(next);
            }
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (panel.hidden) {
              openPanel();
            } else if (activeIndex >= 0) {
              selectOption(options[activeIndex]);
            }
          } else if (e.key === 'Escape' && !panel.hidden) {
            e.preventDefault();
            closePanel();
          }
        });

        var form = trigger.closest('form');
        if (form) {
          form.addEventListener('submit', function(e) {
            if (input.required && !input.value) {
              e.preventDefault();
              dropdown.classList.add('nh-dropdown--error');
              openPanel();
              trigger.focus();
            }
          });
          input.addEventListener('change', function() {
            dropdown.classList.remove('nh-dropdown--error');
          });
        }
      });
    }

    function initSection(hero) {
      if (!hero || hero.dataset.nhCspInit === 'true') return;
      hero.dataset.nhCspInit = 'true';
      initAnimation(hero);
      initScrollReveal(hero);
      initVideoControls(hero);
      initDropdowns(hero);
    }

    function init(root) {
      (root || document).querySelectorAll('.nh-hero').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    'use strict';

    /* ── Init guard (singleton popup, but use multi-instance pattern) ──
       The popup root carries the section id; guard against double-bind
       on shopify:section:load. */
    function init(root) {
      var scope = root || document;
      var popups = scope.querySelectorAll('.np[data-section-id]');
      if (!popups.length) return;
      popups.forEach(function (popup) {
        if (popup.dataset.cspInit === 'true') return;
        popup.dataset.cspInit = 'true';
        initPopup(popup);
      });
    }

    function initPopup(popup) {
      /* Storage keys */
      var KEY_SUBSCRIBED = 'csp_newsletter_subscribed';
      var KEY_DISMISSED  = 'csp_newsletter_dismissed_at';
      var KEY_SEEN_COUNT = 'csp_newsletter_seen_count';

      /* Read config from data attributes */
      var cfg = {
        cooldownDays:        parseInt(popup.getAttribute('data-cooldown-days'), 10),
        timeEnabled:         popup.getAttribute('data-trigger-time') === 'true',
        timeSeconds:         parseInt(popup.getAttribute('data-trigger-time-seconds'), 10),
        scrollEnabled:       popup.getAttribute('data-trigger-scroll') === 'true',
        scrollPercent:       parseInt(popup.getAttribute('data-trigger-scroll-percent'), 10),
        exitEnabled:         popup.getAttribute('data-trigger-exit') === 'true',
        pagesEnabled:        popup.getAttribute('data-trigger-pages') === 'true',
        pagesValue:          parseInt(popup.getAttribute('data-trigger-pages-value'), 10),
        successAutoCloseMs:  parseInt(popup.getAttribute('data-success-auto-close-ms'), 10) || 5000,
        errorMessage:        popup.getAttribute('data-error-message') || 'Something went wrong. Please try again.',
        excludedUrls:        (popup.getAttribute('data-excluded-urls') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean)
      };

      /* Detect Shopify theme editor — when open in editor, always show
         so merchant can style visually. Detected via Shopify global
         (set by Shopify) or via the .shopify-design-mode class on body. */
      var isEditor = (window.Shopify && window.Shopify.designMode) ||
                     document.documentElement.classList.contains('shopify-design-mode');

      /* ── Eligibility check ────────────────────────────────────
         Determine if the popup should ever appear on this load.
         Returns false if any disqualifying condition is true.

         In the editor, subscribed/cooldown gates are bypassed so
         the merchant can preview triggers repeatedly without being
         locked out by a prior test dismissal. URL exclusion still
         applies so they can verify which pages the popup is hidden
         on. The `shopify:section:select` listener at the bottom of
         this file always force-opens regardless of eligibility. */
      function isEligible() {
        if (!isEditor) {
          /* Already subscribed? Never show again. */
          try {
            if (localStorage.getItem(KEY_SUBSCRIBED) === 'true') return false;
          } catch (e) { /* localStorage may be blocked — fail-open and allow */ }

          /* Inside cooldown period after dismiss? */
          if (cfg.cooldownDays > 0) {
            try {
              var dismissedAt = localStorage.getItem(KEY_DISMISSED);
              if (dismissedAt) {
                var elapsed = Date.now() - new Date(dismissedAt).getTime();
                var cooldownMs = cfg.cooldownDays * 24 * 60 * 60 * 1000;
                if (elapsed < cooldownMs) return false;
              }
            } catch (e) {}
          } else if (cfg.cooldownDays === -1) {
            /* -1 = never show again after any dismiss */
            try {
              if (localStorage.getItem(KEY_DISMISSED)) return false;
            } catch (e) {}
          }
        }

        /* Excluded URL? */
        var path = window.location.pathname.toLowerCase();
        for (var i = 0; i < cfg.excludedUrls.length; i++) {
          var excl = cfg.excludedUrls[i].toLowerCase();
          if (excl && path.indexOf(excl) === 0) return false;
        }

        return true;
      }

      /* ── State ──────────────────────────────────────────────── */
      var isOpen = false;
      var triggersBound = false;
      var lastFocused = null;
      var scrollY = 0;

      /* ── Open / close ───────────────────────────────────────── */
      function openPopup(opts) {
        opts = opts || {};
        if (isOpen) return;
        isOpen = true;

        /* Increment seen count for analytics */
        try {
          var n = parseInt(localStorage.getItem(KEY_SEEN_COUNT) || '0', 10);
          localStorage.setItem(KEY_SEEN_COUNT, (n + 1).toString());
        } catch (e) {}

        /* Save current focus + lock scroll */
        lastFocused = document.activeElement;
        scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + scrollY + 'px';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';

        popup.removeAttribute('hidden');
        popup.classList.add('is-open');

        /* Focus the popup container itself (tabindex="-1") rather than
           the close button. The popup typically opens via a non-pointer
           trigger (timer/scroll/exit-intent), and Chromium treats a JS
           .focus() call in that context as keyboard-like — which triggers
           :focus-visible on the close button and shows a visible outline
           ring that only clears when the user interacts with something
           else. Focusing the container instead keeps screen-reader
           dialog announcement and a11y, while leaving the close button
           visually untouched. The container has outline:none below to
           suppress any default focus styling. First Tab press still
           lands on the close button (it's the first focusable child),
           and the existing trap keeps focus inside the popup. */
        requestAnimationFrame(function () {
          popup.focus();
        });

        /* Stop further triggers from firing once popup is open */
        teardownTriggers();
      }

      function closePopup(opts) {
        opts = opts || {};
        if (!isOpen) return;
        isOpen = false;

        popup.classList.add('is-closing');

        /* Wait for closing animation, then unmount */
        setTimeout(function () {
          popup.classList.remove('is-open', 'is-closing');
          popup.setAttribute('hidden', '');

          /* Restore body scroll */
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflow = '';
          window.scrollTo(0, scrollY);

          /* Restore focus */
          if (lastFocused && typeof lastFocused.focus === 'function') {
            lastFocused.focus();
          }
        }, 250);

        /* Record dismiss timestamp (skip if subscribed — they're already
           marked permanently and we don't want to re-write the dismiss flag).
           Also skip in editor mode so the merchant's preview dismissals
           don't accumulate into a cooldown that blocks subsequent test runs. */
        if (!opts.subscribed && !isEditor) {
          try {
            localStorage.setItem(KEY_DISMISSED, new Date().toISOString());
          } catch (e) {}
        }
      }

      /* ── Triggers ───────────────────────────────────────────── */
      var timeTimer = null;
      var scrollHandler = null;
      var exitHandler = null;

      function setupTriggers() {
        if (triggersBound || isOpen) return;
        triggersBound = true;

        /* Time delay */
        if (cfg.timeEnabled && cfg.timeSeconds > 0) {
          timeTimer = setTimeout(function () {
            openPopup({ trigger: 'time' });
          }, cfg.timeSeconds * 1000);
        }

        /* Scroll depth */
        if (cfg.scrollEnabled && cfg.scrollPercent > 0) {
          scrollHandler = function () {
            var docH = document.documentElement.scrollHeight - window.innerHeight;
            if (docH <= 0) return;
            var pct = (window.scrollY / docH) * 100;
            if (pct >= cfg.scrollPercent) {
              openPopup({ trigger: 'scroll' });
            }
          };
          window.addEventListener('scroll', scrollHandler, { passive: true });
        }

        /* Exit intent (desktop only — relies on mouse leaving via the top edge) */
        if (cfg.exitEnabled && window.matchMedia('(min-width: 768px) and (pointer: fine)').matches) {
          exitHandler = function (e) {
            /* Mouse left the viewport via the top edge */
            if (e.clientY <= 0 && e.relatedTarget == null) {
              openPopup({ trigger: 'exit' });
            }
          };
          document.addEventListener('mouseout', exitHandler);
        }

        /* Page count — counts visits across same-session navigation */
        if (cfg.pagesEnabled && cfg.pagesValue > 0) {
          var COUNT_KEY = 'csp_newsletter_session_pages';
          try {
            var cur = parseInt(sessionStorage.getItem(COUNT_KEY) || '0', 10) + 1;
            sessionStorage.setItem(COUNT_KEY, cur.toString());
            if (cur >= cfg.pagesValue) {
              openPopup({ trigger: 'pages' });
            }
          } catch (e) {}
        }
      }

      function teardownTriggers() {
        if (timeTimer) { clearTimeout(timeTimer); timeTimer = null; }
        if (scrollHandler) { window.removeEventListener('scroll', scrollHandler); scrollHandler = null; }
        if (exitHandler) { document.removeEventListener('mouseout', exitHandler); exitHandler = null; }
      }

      /* ── Manual trigger ─────────────────────────────────────── */
      function manualOpen() {
        /* Manual triggers ALWAYS open — bypass eligibility checks */
        openPopup({ trigger: 'manual' });
      }
      /* Listen for click on any element with [data-newsletter-popup-open]
         and for clicks on anchors with #newsletter-popup hash */
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-newsletter-popup-open]');
        if (!trigger) {
          var link = e.target.closest('a[href="#newsletter-popup"]');
          if (!link) return;
          trigger = link;
        }
        e.preventDefault();
        manualOpen();
      });

      /* Close handlers — backdrop click + close button + ESC */
      popup.addEventListener('click', function (e) {
        if (e.target.closest('[data-np-close]')) {
          closePopup();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) {
          closePopup();
        }
      });

      /* ── Focus trap ────────────────────────────────────────── */
      document.addEventListener('keydown', function (e) {
        if (!isOpen || e.key !== 'Tab') return;
        var focusables = popup.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last  = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      });

      /* ── Form submit via urlencoded fetch ──────────────────────────

         We're doing fetch(), but the body encoding matters more than
         you might expect. Shopify's /contact endpoint distinguishes:

           • Native form submission → application/x-www-form-urlencoded.
             This is what the browser sends by default. Shopify processes
             it as a real customer subscribe, creates the customer record.
           • FormData fetch → multipart/form-data. Shopify accepts the
             request shape but appears to handle it through a different
             code path that doesn't always commit the customer record
             (we suspect a CSRF/origin check that requires the urlencoded
             Content-Type as a "real form" signal).
           • Hidden iframe target → also urlencoded, but adds
             Sec-Fetch-Dest: iframe to the request, which some Shopify
             anti-spam paths flag as suspicious and silently drop.

         Solution: rebuild the FormData as URLSearchParams and POST it
         with explicit Content-Type: application/x-www-form-urlencoded.
         The HTTP request now matches a native form submission byte-for-
         byte, so Shopify treats it identically. We just don't navigate
         afterward. */

      var form = popup.querySelector('.np__form');
      if (form) {
        var submit       = form.querySelector('[data-np-submit]');
        var submitText   = form.querySelector('[data-np-submit-text]');
        var errorEl      = form.querySelector('[data-np-error]');
        var originalText = submitText ? submitText.textContent : '';

        var resetSubmitState = function () {
          if (submit) submit.disabled = false;
          if (submitText) submitText.textContent = originalText;
        };

        var handleSuccess = function () {
          resetSubmitState();
          try { localStorage.setItem(KEY_SUBSCRIBED, 'true'); } catch (e) {}
          popup.classList.add('is-success');
          setTimeout(function () {
            closePopup({ subscribed: true });
          }, cfg.successAutoCloseMs);
        };

        var handleError = function () {
          resetSubmitState();
          if (errorEl) {
            errorEl.textContent = cfg.errorMessage;
            errorEl.classList.add('is-visible');
          }
        };

        /* Form submission strategy: classic hidden-iframe.

           Why not fetch? Earlier fetch-based submission triggered
           the optimistic-success path (.catch swallowing failures
           as "probably worked") on this storefront. Shopify was
           never seeing the customer create — likely an anti-spam /
           redirect-handling quirk on this domain.

           Hidden iframe sidesteps all of that: it's a NATIVE form
           submission, byte-for-byte identical to what would happen
           with JS off entirely. The form's `action` and `method`
           are honored, all hidden inputs ({% form 'customer' %}'s
           authenticity_token, utf8, form_type) are sent verbatim,
           and the browser handles redirects/cookies as normal.
           The only twist is the response loads inside an off-screen
           iframe instead of replacing the page — we never see it,
           we don't need to. The iframe's `load` event tells us
           Shopify acknowledged the POST. */
        var submitting = false;

        function submitForm() {
          if (submitting) return;
          if (submit && submit.disabled) return;

          if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
            if (typeof form.reportValidity === 'function') form.reportValidity();
            return;
          }

          submitting = true;
          if (errorEl) errorEl.classList.remove('is-visible');
          if (submit) submit.disabled = true;
          if (submitText) submitText.textContent = 'Submitting…';

          var iframeName = 'np-submit-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
          var iframe = document.createElement('iframe');
          iframe.name = iframeName;
          iframe.setAttribute('aria-hidden', 'true');
          iframe.tabIndex = -1;
          iframe.style.position = 'absolute';
          iframe.style.width = '0';
          iframe.style.height = '0';
          iframe.style.border = '0';
          iframe.style.opacity = '0';
          iframe.style.pointerEvents = 'none';
          document.body.appendChild(iframe);

          var prevTarget = form.target;
          form.target = iframeName;

          var done = false;
          function finish() {
            if (done) return;
            done = true;
            submitting = false;
            form.target = prevTarget;
            /* Detach the iframe on the next tick so the load callback
               can finish without invalidating its own context. */
            setTimeout(function () {
              try { document.body.removeChild(iframe); } catch (e) {}
            }, 0);
            handleSuccess();
          }

          iframe.addEventListener('load', finish);
          /* Belt-and-suspenders: if the load event never fires (the
             iframe got stuck, or the response was an opaque
             cross-origin redirect that confuses the browser),
             still flip into success state after a generous timeout
             so the user isn't stuck on "Submitting…" forever. */
          setTimeout(finish, 8000);

          form.submit();
        }

        /* Click on the submit button: ALWAYS block the default
           action. The button is type="submit"; its native default
           is to fire the form's submit event and navigate the
           parent page on form.submit(). We route through
           submitForm() instead, which retargets the form at the
           hidden iframe and then triggers form.submit() manually. */
        if (submit) {
          submit.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            submitForm();
          });
        }

        /* Enter-key submission inside an input fires the form's
           submit event directly (bypassing the button click).
           Same treatment: block the default and route through
           submitForm. */
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();
          submitForm();
        });
      }

      /* ── Discount code copy-to-clipboard ────────────────────── */
      var copyBtn = popup.querySelector('[data-np-copy]');
      var fallbackCopy = function (text, cb) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); cb(); } catch (e) {}
        document.body.removeChild(ta);
      };
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var codeEl = popup.querySelector('[data-np-code]');
          var copyText = popup.querySelector('[data-np-copy-text]');
          if (!codeEl || !copyText) return;
          var code = codeEl.textContent.trim();

          var done = function () {
            var orig = copyText.textContent;
            copyText.textContent = 'Copied';
            copyBtn.classList.add('is-copied');
            setTimeout(function () {
              copyText.textContent = orig;
              copyBtn.classList.remove('is-copied');
            }, 2000);
          };

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done).catch(function () {
              /* Fallback for older browsers */
              fallbackCopy(code, done);
            });
          } else {
            fallbackCopy(code, done);
          }
        });
      }

      /* ── Initialize ───────────────────────────────────────────
         In the theme editor, the popup is silent on initial load —
         it shows only when:
           (a) the merchant clicks this section in the editor sidebar
               (Shopify fires `shopify:section:select` with this
               section's id) — force open so they can style it; OR
           (b) a configured trigger (time / scroll / exit / pages)
               fires naturally — same flow as a real visitor.
         On deselect, the popup auto-closes so it doesn't sit over
         the other sections the merchant is editing.

         Outside the editor, only the trigger path runs. */
      var sectionId = popup.getAttribute('data-section-id');

      if (isEditor) {
        document.addEventListener('shopify:section:select', function (e) {
          if (e && e.detail && e.detail.sectionId === sectionId) {
            openPopup({ trigger: 'editor-select' });
          }
        });
        document.addEventListener('shopify:section:deselect', function (e) {
          if (e && e.detail && e.detail.sectionId === sectionId) {
            closePopup({ trigger: 'editor-deselect' });
          }
        });
      }

      if (isEligible()) {
        /* Wait until DOM is interactive to avoid jank */
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', setupTriggers);
        } else {
          setupTriggers();
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  /* ────────────────────────────────────────────────────────────
     Order Tracking — viewport reveal + form lookup + demo loop
     ──────────────────────────────────────────────────────────── */
  (function () {
    var reduceMotion = false;
    try {
      reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}
    /* Shopify's theme editor (Shopify.designMode === true) replaces
       the section's HTML on every settings change, but the {% javascript %}
       block does NOT re-run — it's injected once per page load. That
       means on every edit, the new HTML has no `.is-in-view` class
       and there's nothing to add it back, so the section vanishes.
       Two safeguards:
         1. In design mode, skip the reveal animation entirely — snap
            everything to its final state immediately.
         2. Listen for `shopify:section:load` (fired after each editor
            re-render) and re-init on the new DOM. */
    var inDesignMode = !!(window.Shopify && window.Shopify.designMode);

    function initAll(root) {
      var sections = (root || document).querySelectorAll('[data-ot-section]');
      sections.forEach(function (section) {
        initReveal(section);
        initForm(section);
        initFaq(section);
      });
    }

    initAll(document);

    if (inDesignMode) {
      document.addEventListener('shopify:section:load', function (e) {
        initAll(e.target);
      });
    }

    /* IntersectionObserver toggles .is-in-view exactly once. All
       the staggered CSS transitions hang off this class so JS
       stays out of the choreography. After the reveal finishes
       (~1.6s), kick the optional demo loop.

       Idempotent — safe to call repeatedly on the same section
       (the design-mode handler does exactly that). */
    function initReveal(section) {
      // Already revealed? Don't double-init.
      if (section.classList.contains('is-in-view')) return;

      /* Design mode, reduced motion, or no IO support → snap
         straight to the final visible state. No flash of empty
         section while waiting for an observer that might never
         fire (e.g., editor iframe paints before IO callback
         runs, leaving the section invisible until next scroll). */
      if (reduceMotion || inDesignMode || !('IntersectionObserver' in window)) {
        section.classList.add('is-in-view');
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in-view');
          io.disconnect();
          if (section.classList.contains('ot--demo')) {
            setTimeout(function () { startDemo(section); }, 1600);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      io.observe(section);
    }

    /* Demo loop — walk .is-active across the five stages once
       at ~550ms per stage, then clear. Purely cosmetic; visible
       only when the merchant enables "Demo animation" and a
       timeline is rendered. */
    function startDemo(section) {
      var stages = section.querySelectorAll('.ot__stage');
      if (!stages.length) return;
      var i = 0;
      function step() {
        stages.forEach(function (s, idx) {
          s.classList.toggle('is-active', idx === i);
        });
        i++;
        if (i < stages.length) {
          setTimeout(step, 550);
        } else {
          setTimeout(function () {
            stages.forEach(function (s) { s.classList.remove('is-active'); });
          }, 600);
        }
      }
      step();
    }

    /* Form lookup. The merchant configures a URL template; we
       substitute {order} and {email} tokens (URL-encoded). If
       neither token is present, we append them as ?order=…
       &email=… query params so the merchant can point the URL
       at a generic landing page and still get the values.

       The button is `type="button"` (see Liquid comment) so it
       doesn't pick up the theme's global button styling. We
       wire the submission to the button's click event, and we
       also listen for Enter on either input — without a
       `type="submit"` button, the browser doesn't fire implicit
       form submission on Enter, so we have to do it ourselves. */
    function initForm(section) {
      var form = section.querySelector('[data-ot-form]');
      if (!form) return;
      var orderEl  = form.querySelector('[data-ot-input="order"]');
      var emailEl  = form.querySelector('[data-ot-input="email"]');
      var submitEl = form.querySelector('[data-ot-submit]');
      var errorEl  = form.querySelector('[data-ot-error]');
      var template = section.getAttribute('data-lookup-url') || '/account';

      function trySubmit() {
        var order = (orderEl && orderEl.value || '').trim();
        var email = (emailEl && emailEl.value || '').trim();
        var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!order || !emailValid) {
          if (errorEl) errorEl.hidden = false;
          (order ? emailEl : orderEl).focus();
          return;
        }
        if (errorEl) errorEl.hidden = true;
        if (submitEl) submitEl.classList.add('is-loading');

        var url = buildLookupUrl(template, order, email);
        window.location.href = url;
      }

      if (submitEl) {
        submitEl.addEventListener('click', function (e) {
          e.preventDefault();
          trySubmit();
        });
      }
      [orderEl, emailEl].forEach(function (el) {
        if (!el) return;
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            trySubmit();
          }
        });
      });
      /* Defensive: if some integration still triggers a native
         submit on the form, suppress it so the page doesn't
         reload to a no-op action URL. */
      form.addEventListener('submit', function (e) { e.preventDefault(); trySubmit(); });
    }

    /* FAQ accordion. Click → height animates from 0 to natural
       scrollHeight (open) or scrollHeight to 0 (close), via
       inline-styled height + the CSS transition on .ot__faq-
       collapse. On transitionend the inline height is cleared
       so the open item can grow/shrink naturally if its content
       changes (e.g., a long answer reflows on resize).

       Accordion behavior: opening any item closes every other
       open item in the same section. */
    function initFaq(section) {
      var items = section.querySelectorAll('.ot__faq-item');
      if (!items.length) return;

      items.forEach(function (details) {
        var summary  = details.querySelector('summary');
        var collapse = details.querySelector('.ot__faq-collapse');
        if (!summary || !collapse) return;

        summary.addEventListener('click', function (e) {
          /* Stop the native toggle so JS owns the [open] timing
             — we need [open] to stay TRUE during a close
             animation so the content keeps rendering. */
          e.preventDefault();
          if (details.open) {
            closeItem(details, collapse);
          } else {
            // Accordion — close any open sibling first
            items.forEach(function (other) {
              if (other === details) return;
              if (!other.open) return;
              closeItem(other, other.querySelector('.ot__faq-collapse'));
            });
            openItem(details, collapse);
          }
        });
      });
    }

    function openItem(details, collapse) {
      if (reduceMotion) {
        details.setAttribute('open', '');
        return;
      }
      details.setAttribute('open', '');
      collapse.style.height = '0px';
      // Force a synchronous layout at height: 0 so the next
      // value change (to the target height) starts a transition
      // instead of being collapsed by the browser into a single
      // paint at the final value.
      void collapse.offsetHeight;
      requestAnimationFrame(function () {
        collapse.style.height = collapse.scrollHeight + 'px';
      });
      onHeightEnd(collapse, function () {
        // Clear the inline height so the open item can adapt
        // to content changes (richtext rendering shifts, etc.)
        // without being pinned to a measured pixel value.
        collapse.style.height = '';
      });
    }

    function closeItem(details, collapse) {
      if (reduceMotion) {
        details.removeAttribute('open');
        return;
      }
      // Mark the item as closing so the toggle's plus/minus
      // CSS rule can flip immediately, even though [open] is
      // still set (we remove [open] at transitionend).
      details.classList.add('is-closing');
      collapse.style.height = collapse.scrollHeight + 'px';
      void collapse.offsetHeight;
      requestAnimationFrame(function () {
        collapse.style.height = '0px';
      });
      onHeightEnd(collapse, function () {
        details.removeAttribute('open');
        details.classList.remove('is-closing');
        collapse.style.height = '';
      });
    }

    function onHeightEnd(el, fn) {
      function handler(e) {
        if (e.propertyName !== 'height') return;
        el.removeEventListener('transitionend', handler);
        fn();
      }
      el.addEventListener('transitionend', handler);
    }

    function buildLookupUrl(template, order, email) {
      var o = encodeURIComponent(order);
      var e = encodeURIComponent(email);
      if (template.indexOf('{order}') !== -1 || template.indexOf('{email}') !== -1) {
        return template.replace(/\{order\}/g, o).replace(/\{email\}/g, e);
      }
      var sep = template.indexOf('?') === -1 ? '?' : '&';
      return template + sep + 'order=' + o + '&email=' + e;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"] && !Shopify.designMode) return;
  try {
    
  /* Multi-instance reveal driver. Skips sections where reveal is
     disabled (data-reveal-enabled !== "true"). */
  (function() {
    function initSection(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';
      if (section.dataset.revealEnabled !== 'true') return;

      var items = section.querySelectorAll('[data-reveal]');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        items.forEach(function(el) { el.classList.add('is-visible'); });
        return;
      }

      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var delay = Array.prototype.indexOf.call(items, entry.target) * 80;
            setTimeout(function() { entry.target.classList.add('is-visible'); }, delay);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px', threshold: 0.05 });

      items.forEach(function(el) { io.observe(el); });
    }

    function init(root) {
      (root || document).querySelectorAll('.page-x').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  /* Password page section behaviors.
     Multi-instance: scans every .pwd element on init, observes each
     one independently. Cached/bundled with no Liquid interpolation —
     section-specific behavior reads from data-* attributes.
     Re-runs on shopify:section:load so theme-editor reloads pick up
     newly-rendered sections. */
  (function() {
    function initSection(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

      var sectionId = section.getAttribute('data-section-id') || '';

      /* ── Reveal animation ─────────────────────────────────── */
      if (section.dataset.revealEnabled === 'true') {
        var revealItems = section.querySelectorAll('[data-reveal]');
        if (revealItems.length) {
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function(entries) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                  /* Stagger across the visible items */
                  var delay = Array.prototype.indexOf.call(revealItems, entry.target) * 80;
                  setTimeout(function() { entry.target.classList.add('is-visible'); }, delay);
                  io.unobserve(entry.target);
                }
              });
            }, { rootMargin: '0px', threshold: 0.05 });
            revealItems.forEach(function(el) { io.observe(el); });
          } else {
            revealItems.forEach(function(el) { el.classList.add('is-visible'); });
          }
        }
      }

      /* ── Cursor spotlight ──────────────────────────────────── */
      if (section.dataset.enableSpotlight === 'true') {
        var spotlight = section.querySelector('.pwd__spotlight');
        if (spotlight && window.matchMedia('(hover: hover)').matches) {
          var rafId = null;
          var pendingX = 50, pendingY = 50;
          section.addEventListener('mousemove', function(e) {
            var r = section.getBoundingClientRect();
            pendingX = ((e.clientX - r.left) / r.width) * 100;
            pendingY = ((e.clientY - r.top) / r.height) * 100;
            if (rafId) return;
            rafId = requestAnimationFrame(function() {
              section.style.setProperty('--mx', pendingX + '%');
              section.style.setProperty('--my', pendingY + '%');
              rafId = null;
            });
          });
        }
      }

      /* ── Word morph ────────────────────────────────────────── */
      section.querySelectorAll('[data-morph]').forEach(function(el) {
        var raw = el.getAttribute('data-morph-words') || '';
        var words = raw.split(/\r?\n/).map(function(s) { return s.trim(); }).filter(Boolean);
        if (words.length < 2) return;
        var interval = parseInt(el.getAttribute('data-morph-interval'), 10) || 2800;
        var span = el.querySelector('.pwd-heading__word');
        if (!span) return;
        var idx = 0;
        (window.cspManagedInterval || setInterval)(function() {
          span.classList.add('is-out');
          setTimeout(function() {
            idx = (idx + 1) % words.length;
            span.textContent = words[idx];
            span.classList.remove('is-out');
            span.classList.add('is-in');
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                span.classList.remove('is-in');
              });
            });
          }, 600);
        }, interval, sectionId);
      });

      /* ── Countdown ─────────────────────────────────────────── */
      section.querySelectorAll('[data-countdown]').forEach(function(el) {
        var targetStr = (el.getAttribute('data-target') || '').trim();
        if (!targetStr) return;
        /* Accept "YYYY-MM-DD HH:MM:SS" or ISO; treat as local time */
        var iso = targetStr.replace(' ', 'T');
        var target = new Date(iso).getTime();
        if (isNaN(target)) return;

        var doneText = el.getAttribute('data-done-text') || 'We are live';
        var elDays = el.querySelector('[data-cd-days]');
        var elHrs  = el.querySelector('[data-cd-hours]');
        var elMin  = el.querySelector('[data-cd-minutes]');
        var elSec  = el.querySelector('[data-cd-seconds]');

        function pad(n) { return n < 10 ? '0' + n : '' + n; }

        var intervalId;
        function tick() {
          var diff = target - Date.now();
          if (diff <= 0) {
            el.classList.add('pwd-countdown--done');
            el.innerHTML = '<span>' + doneText + '</span>';
            if (intervalId) clearInterval(intervalId);
            return;
          }
          var s = Math.floor(diff / 1000);
          var d = Math.floor(s / 86400); s -= d * 86400;
          var h = Math.floor(s / 3600);  s -= h * 3600;
          var m = Math.floor(s / 60);    s -= m * 60;
          if (elDays) elDays.textContent = d;
          if (elHrs)  elHrs.textContent  = pad(h);
          if (elMin)  elMin.textContent  = pad(m);
          if (elSec)  elSec.textContent  = pad(s);
        }

        tick();
        intervalId = (window.cspManagedInterval || setInterval)(tick, 1000, sectionId);
      });

      /* ── Password unlock toggle ────────────────────────────── */
      section.querySelectorAll('[data-pwd-unlock]').forEach(function(wrap) {
        /* Auto-open if there was a server-side error */
        if (wrap.hasAttribute('data-open')) wrap.classList.add('is-open');
        var trigger = wrap.querySelector('[data-pwd-unlock-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function() {
          wrap.classList.add('is-open');
          var input = wrap.querySelector('.pwd-unlock__input');
          if (input) setTimeout(function() { input.focus(); }, 150);
        });
      });

      /* ── Email signup submit ──────────────────────────────────
         The Notify me button is type="button" (not "submit") to keep
         it visually disconnected from the theme's global Buttons
         settings (which target button[type="submit"] via critical.css).
         Clicking it triggers form.requestSubmit() so HTML5 validation
         still runs. Enter inside the email input still submits via
         HTML's implicit-submission rule (single text input, no submit
         button -> Enter submits). */
      section.querySelectorAll('.pwd-email__submit').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var form = btn.closest('form');
          if (!form) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });

      /* ── Klaviyo popup open/close ─────────────────────────────
         For each Klaviyo block in popup mode, wire up:
           • trigger button -> open overlay
           • close button -> close overlay
           • backdrop click -> close overlay
           • Escape key -> close overlay (when open)
           • body scroll lock while overlay is open

         Each block handles its own dialog independently.

         Containing-block escape — IMPORTANT
         ────────────────────────────────────
         The overlay is rendered inside the block element, but on
         init we move it to <body>. Reason: the block container has
         data-reveal which sets transform: translateY(12px) while
         the reveal animation is idle. Per CSS spec, ANY ancestor
         with a transform (other than none) becomes the containing
         block for descendants with position: fixed — which breaks
         the overlay's "cover the viewport" intent. Moving it to
         body sidesteps every potential containing-block ancestor. */
      section.querySelectorAll('[data-pwd-klaviyo-trigger]').forEach(function(trigger) {
        var blockId = trigger.getAttribute('data-pwd-klaviyo-trigger');
        /* Overlay may already have been moved to <body> by a prior
           init pass (in the theme editor, scripts can re-run). Look
           inside the section first, then fall back to document. */
        var overlay = section.querySelector('[data-pwd-klaviyo-overlay="' + blockId + '"]')
                   || document.querySelector('[data-pwd-klaviyo-overlay="' + blockId + '"]');
        var close   = overlay && overlay.querySelector('[data-pwd-klaviyo-close="' + blockId + '"]');
        if (!overlay || !close) return;

        /* Move the overlay to <body> so it's not contained by any
           transformed ancestor. We do this once at init. */
        if (overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }

        var lastFocused = null;

        function openPopup() {
          lastFocused = document.activeElement;
          overlay.hidden = false;
          /* Force reflow before adding the open class so the
             transition runs (display: none -> flex doesn't animate
             on its own). */
          void overlay.offsetWidth;
          overlay.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('pwd-klaviyo-locked');
          /* Move focus into the dialog for keyboard / screen-reader
             users. The close button is a safe target. */
          if (close) close.focus();
        }
        function closePopup() {
          overlay.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          /* Wait for transition to finish before hiding so the
             fade-out is visible. */
          setTimeout(function() {
            overlay.hidden = true;
            document.documentElement.classList.remove('pwd-klaviyo-locked');
            if (lastFocused && typeof lastFocused.focus === 'function') {
              lastFocused.focus();
            }
          }, 250);
        }

        trigger.addEventListener('click', openPopup);
        close.addEventListener('click', closePopup);

        /* Click on the backdrop (not the card itself) closes too. */
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) closePopup();
        });

        /* Global ESC handler — only closes if THIS overlay is open.
           Multiple blocks on the page won't fight each other. */
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
            closePopup();
          }
        });
      });
    }

    function init(root) {
      (root || document).querySelectorAll('.pwd').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init: merchant saves a setting, Shopify replaces
       the section's DOM. The fresh node has no data-csp-init flag so
       initSection runs cleanly. */
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-alt"] && !Shopify.designMode) return;
  try {
    
/* PRODUCT-ALT interactive logic — bundled and cached by Shopify.
   The IIFE below contains many independent forEach blocks that each
   scan for `.palt` (or its descendants) and wire per-section behavior.
   Per-section config comes from data-* attributes on the .palt root,
   so this block stays fully static. Each forEach is self-guarded by
   the markup it queries — if a feature's HTML isn't rendered for a
   given section, the forEach finds nothing and silently no-ops. */
(function() {
  /* Variant picker state machine.

     Reads the JSON variant data embedded in the markup, tracks the
     currently-selected option values per option position, and
     updates the UI on each click:

       • marks clicked button as is-selected (siblings as not)
       • updates the label "selected" span to show the new value
       • walks all buttons and re-evaluates is-sold-out (a value is
         sold-out if no available variant exists with that value
         given the current selections in OTHER options — same logic
         as product-grid)
       • updates the page URL with ?variant=N so refreshes/links
         preserve the selection (without triggering a page reload)
       • emits a custom event 'palt:variant-change' on the .palt-vs
         element so future iterations (image swap, ATC button) can
         react without coupling to this internal logic */

  document.querySelectorAll('.palt-vs').forEach(function(picker) {
    var dataScript = picker.querySelector('.palt-vs__variants-data');
    if (!dataScript) return;
    var variants = [];
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }
    if (!variants.length) return;

    /* Track selection per option position (1-based to match Liquid). */
    var selected = {};
    picker.querySelectorAll('.palt-vs-option').forEach(function(opt) {
      var pos = opt.dataset.optionPos;
      var selectedBtn = opt.querySelector('.is-selected');
      if (selectedBtn) selected[pos] = selectedBtn.dataset.value;
    });

    /* Find the variant matching all currently-selected options. */
    function findMatchingVariant() {
      return variants.find(function(v) {
        return Object.keys(selected).every(function(pos) {
          var idx = parseInt(pos, 10) - 1;
          return v.options[idx] === selected[pos];
        });
      });
    }

    /* Update sold-out states: a value at position P is "sold-out" if
       no variant exists where (option[P] = value AND all other
       option positions match the current selection AND variant is
       available). This matches product-grid's UX — the user gets
       contextual feedback as they change options. */
    function refreshSoldOutStates() {
      picker.querySelectorAll('.palt-vs-option').forEach(function(opt) {
        var pos = opt.dataset.optionPos;
        var idx = parseInt(pos, 10) - 1;

        /* Color options skip the sold-out visual treatment entirely
           (no grayscale, no strikethrough, no diagonal stripe). The
           merchant has indicated that colors should always render
           normally regardless of stock — sold-out feedback for
           colors is communicated elsewhere (e.g. the gallery / ATC
           when the user actually attempts that color + size combo). */
        var isColorOption = opt.querySelector('.palt-vs-color-btn, .palt-vs-img-btn') !== null;

        opt.querySelectorAll('[data-value]').forEach(function(btn) {
          if (isColorOption) {
            /* Make sure no stale is-sold-out class lingers on color
               buttons (e.g. if a previous render added one). */
            btn.classList.remove('is-sold-out');
            return;
          }
          var value = btn.dataset.value;
          var hasAvailableMatch = variants.some(function(v) {
            if (v.options[idx] !== value) return false;
            if (!v.available) return false;
            /* Must match other current selections */
            return Object.keys(selected).every(function(otherPos) {
              if (otherPos === pos) return true;
              var otherIdx = parseInt(otherPos, 10) - 1;
              return v.options[otherIdx] === selected[otherPos];
            });
          });
          btn.classList.toggle('is-sold-out', !hasAvailableMatch);
        });

        /* If this option uses the dropdown variant, sync the
           trigger's sold-out state to match the currently-selected
           value's availability. Mirrors the row's sold-out tag —
           shown next to the trigger value when the selected size
           is unavailable for the current overall combination. */
        var dropdown = opt.querySelector('.palt-vs-dropdown');
        if (dropdown) {
          var currentVal = selected[pos];
          var currentAvailable = variants.some(function(v) {
            if (v.options[idx] !== currentVal) return false;
            if (!v.available) return false;
            return Object.keys(selected).every(function(otherPos) {
              if (otherPos === pos) return true;
              var otherIdx = parseInt(otherPos, 10) - 1;
              return v.options[otherIdx] === selected[otherPos];
            });
          });
          dropdown.classList.toggle('is-selection-sold-out', !currentAvailable);
        }
      });
    }

    /* Update URL ?variant=N without triggering a reload — uses
       history.replaceState so back-button navigation isn't polluted
       with intermediate states. */
    function updateUrlVariant(variantId) {
      if (!variantId || !window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    /* Click handler: update selection, swap is-selected class, update
       label, refresh sold-out states, sync URL, emit event. */
    picker.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-pos][data-value]');
      if (!btn) return;
      if (btn.classList.contains('is-unavailable')) return;

      var pos = btn.dataset.pos;
      var value = btn.dataset.value;
      selected[pos] = value;

      /* Clear is-selected on siblings, mark this one */
      var optionBlock = btn.closest('.palt-vs-option');
      optionBlock.querySelectorAll('.is-selected').forEach(function(el) {
        el.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');

      /* Update the label's "selected" span text */
      var selectedSpan = optionBlock.querySelector('.palt-vs-option__selected');
      if (selectedSpan) selectedSpan.textContent = value;

      refreshSoldOutStates();

      /* Find matching variant and dispatch event for downstream
         consumers (image swap, ATC button updates). */
      var matched = findMatchingVariant();
      if (matched) {
        updateUrlVariant(matched.id);
      }

      picker.dispatchEvent(new CustomEvent('palt:variant-change', {
        detail: { selected: Object.assign({}, selected), variant: matched },
        bubbles: true
      }));
    });

    /* ── Hover preview (image swatches only) ──────────────────
       When the user hovers an image-swatch tile, temporarily
       update the option label's "selected" span to show the
       hovered color name. On mouseleave, restore the actual
       selected value. Provides a quick "what color is this?"
       affordance since image-only tiles don't show names. */
    picker.querySelectorAll('.palt-vs-option__btns--image-swatches').forEach(function(btnsEl) {
      var optionBlock = btnsEl.closest('.palt-vs-option');
      var pos = optionBlock.dataset.optionPos;
      var selectedSpan = optionBlock.querySelector('.palt-vs-option__selected');
      if (!selectedSpan) return;

      btnsEl.querySelectorAll('.palt-vs-img-btn').forEach(function(tile) {
        tile.addEventListener('mouseenter', function() {
          selectedSpan.textContent = tile.dataset.value;
        });
        tile.addEventListener('mouseleave', function() {
          /* Restore to current selection (might have changed if
             the user clicked a different tile mid-hover; the
             click handler already wrote the new value to selected). */
          selectedSpan.textContent = selected[pos];
        });
      });
    });
  });

  /* ── Dropdown UI behavior ──────────────────────────────
     Independent of the picker's main click handler (which
     already picks up data-pos/data-value selections from
     dropdown rows the same way it does pills). This block
     adds:
       • trigger click opens/closes the panel
       • outside click closes any open dropdown
       • Escape closes any open dropdown
       • after selecting a row, panel closes + trigger
         text updates to the new value
     The variant change itself (sold-out refresh, URL update,
     gallery filter) is handled by the existing handler. */
  document.querySelectorAll('.palt-vs-dropdown').forEach(function(dropdown) {
    var trigger = dropdown.querySelector('.palt-vs-dropdown__trigger');
    var panel = dropdown.querySelector('.palt-vs-dropdown__panel');
    var triggerValue = dropdown.querySelector('.palt-vs-dropdown__trigger-value');

    if (!trigger || !panel) return;

    function openDropdown() {
      /* Close any other open dropdowns first — only one at a time. */
      document.querySelectorAll('.palt-vs-dropdown.is-open').forEach(function(d) {
        if (d !== dropdown) {
          d.classList.remove('is-open');
          var t = d.querySelector('.palt-vs-dropdown__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      dropdown.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    /* Trigger click toggles open/close. Stop propagation so the
       outside-click handler doesn't immediately close it again. */
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      if (dropdown.classList.contains('is-open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    /* Row click — close the dropdown after selection. The actual
       variant-change logic (selected state, sold-out refresh,
       URL update, gallery filter) is handled by the picker's
       main click handler since dropdown rows have the same
       data-pos/data-value attributes pills do.

       Sold-out rows are still selectable — the user picks a
       size, the variant gets selected, and downstream UI (ATC
       button) can show "Sold out" or "Notify me" state. Better
       UX than disabling the row entirely.

       Update trigger text on the way out so the trigger reflects
       the new selection without waiting for a re-render. */
    panel.addEventListener('click', function(e) {
      var row = e.target.closest('.palt-vs-dropdown__row');
      if (!row) return;
      if (triggerValue) triggerValue.textContent = row.dataset.value;

      /* Update aria-selected on rows to match new selection */
      panel.querySelectorAll('.palt-vs-dropdown__row').forEach(function(r) {
        r.setAttribute('aria-selected', r === row ? 'true' : 'false');
      });

      /* Brief delay so the user sees the row's selected state
         apply before the panel closes — feels intentional rather
         than abrupt. */
      setTimeout(closeDropdown, 80);
    });
  });

  /* Outside click + Escape — close any open dropdown. Single
     document-level listener handles all dropdowns on the page. */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.palt-vs-dropdown')) {
      document.querySelectorAll('.palt-vs-dropdown.is-open').forEach(function(d) {
        d.classList.remove('is-open');
        var t = d.querySelector('.palt-vs-dropdown__trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.palt-vs-dropdown.is-open').forEach(function(d) {
        d.classList.remove('is-open');
        var t = d.querySelector('.palt-vs-dropdown__trigger');
        if (t) {
          t.setAttribute('aria-expanded', 'false');
          t.focus(); /* return focus to trigger after Escape close */
        }
      });
    }
  });

  /* ── Gallery: filter slides by selected color ──────────────
     Listens for the picker's palt:variant-change event and
     shows/hides slides whose data-colors attribute either is
     empty (color-agnostic) or includes the new color value.
     Uses the same algorithm as the server-side initial-render
     logic above so the visible set is consistent.

     For mobile (horizontal swipe carousel), also resets the
     scroll position to the start so the user sees the first
     image of the newly-selected color rather than mid-scroll. */
  /* Read per-section value inside the forEach below — see palt.dataset.colorOptionIndex */
  function filterGalleryByColor(galleryEl, colorValue) {
    if (!galleryEl) return;
    var colorLower = (colorValue || '').toLowerCase();

    /* Pin the gallery's current width via min-width before flipping
       slide visibility. In single layout (.palt__layout--single) the
       grid track is `auto`, sized to the gallery's intrinsic width.
       Slides that were display:none for other colors haven't been
       laid out and their lazy <img> tags haven't downloaded — so the
       moment we show them, the gallery briefly has no measurable
       widest-image and the auto track collapses toward 0, letting
       the info column expand to full width until the new images
       finish loading. We hold the prior width during that gap and
       release it once every newly-visible <img> has settled (load
       or error). 2x2 layout uses a fixed `1fr` track and isn't
       affected, but pinning is harmless there. */
    var pinnedWidth = galleryEl.offsetWidth;
    if (pinnedWidth > 0) {
      galleryEl.style.minWidth = pinnedWidth + 'px';
    }

    galleryEl.querySelectorAll('.palt__slide').forEach(function(slide) {
      if (slide.classList.contains('palt__slide--empty')) return;
      var colors = slide.dataset.colors || '';
      var match = colors === '' ||
                  colors.split('|').some(function(c) { return c === colorLower; });
      slide.style.display = match ? '' : 'none';
    });
    /* Reset scroll position so user sees first image of new color.
       Only matters on mobile horizontal carousel; on desktop the
       gallery scrolls with the page so this is a no-op there. */
    if (galleryEl.scrollLeft !== undefined) {
      galleryEl.scrollTo({ left: 0, behavior: 'instant' });
    }

    /* Collect every now-visible <img> that hasn't completed. We
       release the pin only after they've all settled so the gallery
       can resize naturally to the new color's widest image. */
    function releasePin() {
      galleryEl.style.minWidth = '';
    }
    var pending = [];
    galleryEl.querySelectorAll('.palt__slide').forEach(function(slide) {
      if (slide.style.display === 'none') return;
      slide.querySelectorAll('img').forEach(function(img) {
        if (!img.complete) pending.push(img);
      });
    });
    if (pending.length === 0) {
      /* All images already cached / decoded — release after one
         frame so the browser commits at least one paint with the
         pin in place (avoids a sub-frame flicker on instant swaps). */
      requestAnimationFrame(releasePin);
      return;
    }
    var remaining = pending.length;
    function onSettled() {
      if (--remaining <= 0) releasePin();
    }
    pending.forEach(function(img) {
      img.addEventListener('load',  onSettled, { once: true });
      img.addEventListener('error', onSettled, { once: true });
    });
    /* Safety net — release after 4s even if no load/error events
       fire (e.g. request killed or stuck behind a slow network). */
    setTimeout(releasePin, 4000);
  }

  /* Wire the picker's variant-change event to gallery filtering.
     Only fires when color changes — re-running the filter with
     the same color is a cheap no-op anyway, but the explicit
     check keeps logs cleaner during debugging.

     colorOptionIndex is read per-section from data-color-option-index.
     If the section has no color option, the attr is empty → NaN →
     the early `return` skips wiring for that section. */
  document.querySelectorAll('.palt').forEach(function(palt) {
    var colorOptionIndex = parseInt(palt.dataset.colorOptionIndex, 10);
    if (isNaN(colorOptionIndex)) return;

    var picker = palt.querySelector('.palt-vs');
    var gallery = palt.querySelector('.palt__gallery');
    if (!picker || !gallery) return;

    var lastColor = null;
    picker.addEventListener('palt:variant-change', function(e) {
      if (!e.detail || !e.detail.variant) return;
      var newColor = e.detail.variant.options[colorOptionIndex];
      if (newColor === lastColor) return;
      lastColor = newColor;
      filterGalleryByColor(gallery, newColor);
    });
  });

  /* ── Wishlist sync ─────────────────────────────────────
     The wishlist button's data-wishlist-add attribute holds
     the variant ID it represents. As variant selection changes,
     update that attribute to the new variant ID, and toggle
     is-wishlisted based on whether the new variant is in the
     wishlist. Mirrors the pattern from product.liquid.

     Sources of truth (in priority order):
       1. window.wishlistDrawer.isInWishlist(variantId) — the
          wishlist drawer's public API if loaded
       2. localStorage 'wishlist_items' — fallback if drawer
          hasn't bound yet (e.g. first paint before scripts run)

     Listens for 'wishlist:ready' (fires when drawer initializes)
     to do an initial sync, plus 'palt:variant-change' for
     selection changes during the session. */
  function getWishlistState(variantId) {
    if (window.wishlistDrawer && typeof window.wishlistDrawer.isInWishlist === 'function') {
      return window.wishlistDrawer.isInWishlist(String(variantId));
    }
    try {
      var items = JSON.parse(localStorage.getItem('wishlist_items')) || [];
      return items.some(function(i) { return String(i.variantId) === String(variantId); });
    } catch (e) {
      return false;
    }
  }

  function syncWishlistButton(btn, variantId) {
    if (!btn) return;
    btn.dataset.wishlistAdd = variantId;
    var inWl = getWishlistState(variantId);
    btn.classList.toggle('is-wishlisted', inWl);
    /* Update aria-label so screen readers announce the right action.
       Falls back to literal English if no translation system exists. */
    var t = window.wdTranslations || {};
    btn.setAttribute('aria-label', inWl
      ? (t.removeFromWishlist || 'Remove from wishlist')
      : (t.addToWishlist || 'Add to wishlist')
    );
  }

  document.querySelectorAll('.palt').forEach(function(palt) {
    var picker = palt.querySelector('.palt-vs');
    var wlBtn = palt.querySelector('.palt__wishlist');
    if (!wlBtn) return;

    /* Initial sync — runs after wishlist drawer fires its ready
       event so the API is available. Fallback timer handles the
       case where the drawer doesn't load (e.g. wishlist disabled
       theme-wide) so the localStorage fallback still kicks in. */
    var initialId = wlBtn.dataset.wishlistAdd;
    document.addEventListener('wishlist:ready', function() {
      syncWishlistButton(wlBtn, wlBtn.dataset.wishlistAdd);
    });
    /* Belt-and-suspenders: if wishlist:ready never fires (drawer
       absent), do a localStorage-based sync after a short delay. */
    setTimeout(function() {
      syncWishlistButton(wlBtn, wlBtn.dataset.wishlistAdd);
    }, 100);

    /* Variant change — re-sync to the new variant's ID. */
    if (picker) {
      picker.addEventListener('palt:variant-change', function(e) {
        if (!e.detail || !e.detail.variant) return;
        syncWishlistButton(wlBtn, e.detail.variant.id);
      });
    }
  });

  /* ── Add to Cart ───────────────────────────────────────
     For each .palt section: hook the ATC form submit, post
     to /cart/add.js, show toast, sync hidden variant input
     and button state on palt:variant-change.

     Variant inventory data is embedded server-side per
     section so stock checks happen synchronously without
     needing /products/{handle}.js requests. Mirrors the
     pattern from product.liquid but contained per-section. */
  document.querySelectorAll('.palt').forEach(function(palt) {
    var picker = palt.querySelector('.palt-vs');
    var atcForm = palt.querySelector('.palt-atc form');
    if (!atcForm) return;

    var variantInput = atcForm.querySelector('input[name="id"]');
    var atcBtn = atcForm.querySelector('.palt-atc__btn');
    var atcText = atcBtn.querySelector('.palt-atc__btn-text');

    /* Embedded variant data — id → { available, qty, policy, image, title }.
       Used for client-side stock check before fetch + populating the
       global cart toast with product image and variant title. */
    var variantInfo = {};
    var dataScript = palt.querySelector('.palt-vs__variants-data');
    if (dataScript) {
      try {
        var parsed = JSON.parse(dataScript.textContent);
        parsed.forEach(function(v) {
          variantInfo[String(v.id)] = {
            available: !!v.available,
            qty: typeof v.inventory_quantity === 'number' ? v.inventory_quantity : -1,
            policy: v.inventory_policy || 'deny',
            image: (v.featured_image && v.featured_image.src) ? v.featured_image.src : '',
            title: v.title || ''
          };
        });
      } catch (e) {}
    }

    /* Product-level fallbacks for the toast (used when variant has no image
       or when the product has only a default variant). All sourced from
       data-* attrs on the .palt root so this stays static for bundling. */
    var productTitle       = palt.dataset.productTitle || '';
    var productFeaturedSrc = palt.dataset.productFeaturedSrc || '';
    var hasOnlyDefault     = palt.dataset.hasOnlyDefault === 'true';

    var labels = {
      atc:       palt.dataset.atcLabel        || 'Add to cart',
      soldOut:   palt.dataset.atcSoldoutLabel || 'Sold out',
      adding:    palt.dataset.atcAddingLabel  || 'Adding...',
      added:     palt.dataset.msgAdded        || 'Your selection has been reserved.',
      stockMsg:  palt.dataset.msgStock        || 'Sorry, only %available% available and you already have %in_cart% in your cart.',
      soldOutMsg:palt.dataset.msgSoldout      || 'This product is sold out.',
      errorMsg:  palt.dataset.msgError        || 'Could not add to cart'
    };

    /* ── Cart toast wrapper ──────────────────────────────────
       Thin shim around the global window.cartToast API (rendered
       once via cart-toast snippet in theme.liquid). Configure the
       notification's appearance in Theme Settings → Cart Notification.

       Optional `variantId` arg lets us pass the variant's image and
       title so the toast can show a thumbnail. When omitted (e.g. on
       errors), the toast still shows but without product context. */
    function showToast(msg, isError, variantId) {
      if (!window.cartToast) return;
      var image = '';
      var title = '';
      if (!isError && variantId != null) {
        var info = variantInfo[String(variantId)];
        image = (info && info.image) || productFeaturedSrc;
        if (info && info.title && !hasOnlyDefault) {
          title = productTitle + ' — ' + info.title;
        } else {
          title = productTitle;
        }
      }
      window.cartToast.show({
        type:         isError ? 'error' : 'success',
        message:      msg,
        productImage: image,
        productTitle: title,
        quantity:     1
      });
    }

    /* Update button label + class based on variant availability.
       Called on init + every variant change. */
    function syncAtcState(variantId) {
      var info = variantInfo[String(variantId)];
      var isAvailable = info ? info.available : true;
      atcBtn.classList.toggle('is-sold-out', !isAvailable);
      atcText.textContent = isAvailable ? labels.atc : labels.soldOut;
    }

    /* Listen for variant change — update hidden input + button */
    if (picker) {
      picker.addEventListener('palt:variant-change', function(e) {
        if (!e.detail || !e.detail.variant) return;
        var newId = e.detail.variant.id;
        variantInput.value = newId;
        syncAtcState(newId);
      });
    }

    /* Cart-quantity lookup — fetches /cart.js to know how many of
       this variant the user already has. Used for stock-cap check. */
    var cartQty = {};
    function refreshCartQty(cb) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          cartQty = {};
          (d.items || []).forEach(function(i) {
            cartQty[String(i.variant_id)] = (cartQty[String(i.variant_id)] || 0) + i.quantity;
          });
          if (cb) cb();
        })
        .catch(function() { if (cb) cb(); });
    }

    /* Submit handler — refresh cart, check stock, fetch add. */
    atcForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var id = String(variantInput.value);
      if (!id) return;
      var info = variantInfo[id] || {};

      /* Sold-out short-circuit: if variant unavailable per server-side
         data, show sold-out toast immediately without hitting the API. */
      if (!info.available) {
        showToast(labels.soldOutMsg, true);
        return;
      }

      atcText.textContent = labels.adding;

      refreshCartQty(function() {
        var inCart = cartQty[id] || 0;
        if (info.policy === 'deny' && info.qty > 0 && inCart >= info.qty) {
          showToast(labels.stockMsg.replace('%available%', info.qty).replace('%in_cart%', inCart), true);
          atcText.textContent = labels.atc;
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
        .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
        .then(function(res) {
          atcText.textContent = labels.atc;
          if (res.ok) {
            cartQty[id] = inCart + 1;
            showToast(labels.added, false, id);
            /* Notify cart drawer + other listeners. */
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } else {
            var desc = (res.data && (res.data.description || res.data.message)) || labels.errorMsg;
            showToast(desc, true);
          }
        })
        .catch(function() {
          atcText.textContent = labels.atc;
          showToast(labels.errorMsg, true);
        });
      });
    });

    /* Strip Shopify-injected dynamic checkout buttons (Apple Pay,
       Shop Pay, etc.) — they get auto-injected into the product
       form on first paint and would clutter the lux design. */
    function stripPaymentBtns() {
      atcForm.querySelectorAll('.shopify-payment-button, .shopify-cleanslate').forEach(function(el) {
        el.remove();
      });
    }
    stripPaymentBtns();
    new MutationObserver(stripPaymentBtns).observe(atcForm, { childList: true, subtree: true });

    /* Initial sync on page load. */
    syncAtcState(variantInput.value);

    /* ── Buy It Now ──────────────────────────────────────
       Click adds current variant to /cart and redirects
       straight to /checkout. Loading state during the fetch
       prevents double-submission. On error, falls back to
       removing the loading state so the user can retry. */
    var binBtn = palt.querySelector('.palt-bin__btn');
    if (binBtn) {
      binBtn.addEventListener('click', function() {
        var id = String(variantInput.value);
        if (!id) return;
        binBtn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
        .then(function(r) {
          if (r.ok) {
            window.location.href = '/checkout';
          } else {
            binBtn.classList.remove('is-loading');
            showToast(labels.errorMsg, true);
          }
        })
        .catch(function() {
          binBtn.classList.remove('is-loading');
          showToast(labels.errorMsg, true);
        });
      });
    }

    /* ── Payment buttons variant sync ────────────────────
       Shopify's payment_button form has its own hidden
       variant input. Keep it in sync with the main picker
       so Shop Pay / PayPal etc. checkout uses the right
       variant when the user clicks. */
    var paymentForm = palt.querySelector('.palt-payment form');
    if (paymentForm && picker) {
      var paymentVariantInput = paymentForm.querySelector('input[name="id"]');
      picker.addEventListener('palt:variant-change', function(e) {
        if (!e.detail || !e.detail.variant) return;
        if (paymentVariantInput) paymentVariantInput.value = e.detail.variant.id;
      });
    }
  });

  /* ── Description: read-more toggle (smooth height) ──────
     Same animation philosophy as the accordion: measure the
     actual content height and animate to/from it for a smooth,
     consistent open/close pace.

     Initial collapsed height is computed from line-height ×
     clamp-lines so the merchant's "Visible lines before clamp"
     setting still controls how many lines show. After the
     transition completes on open, height is set to 'auto' so
     dynamic content reflows don't get clipped. On close, we
     pin the auto height back to a pixel value first (forcing
     a reflow) before transitioning to the collapsed value. */
  document.querySelectorAll('.palt-description.is-clampable').forEach(function(desc) {
    var toggle = desc.querySelector('.palt-description__toggle');
    var text = desc.querySelector('.palt-description__text');
    if (!toggle || !text) return;

    /* Compute the collapsed height: line-height × visible lines.
       Read line-height from computed style (ensures we get the
       resolved px value even if CSS specifies it as a multiplier).
       clampLines comes from data-clamp-lines on the .palt section. */
    var paltRoot = desc.closest('.palt');
    var clampLines = paltRoot ? (parseInt(paltRoot.dataset.clampLines, 10) || 4) : 4;

    function getCollapsedHeight() {
      var computed = window.getComputedStyle(text);
      var lh = parseFloat(computed.lineHeight);
      /* Fallback: if line-height is 'normal', estimate from font-size × 1.2 */
      if (isNaN(lh)) {
        lh = parseFloat(computed.fontSize) * 1.2;
      }
      return lh * clampLines;
    }

    /* Measure full content height (scrollHeight gives natural
       height regardless of currently-applied height). */
    function getExpandedHeight() {
      return text.scrollHeight;
    }

    /* If the content is shorter than the clamped height, hide the
       toggle entirely — no need for read-more on short copy.
       Also adds .is-short class to the wrapper so CSS can hide
       the bottom fade gradient (which would otherwise still show
       even though there's nothing being clipped). */
    function checkClampNeeded() {
      var collapsed = getCollapsedHeight();
      var expanded = getExpandedHeight();
      if (expanded <= collapsed + 4) { /* 4px tolerance for sub-pixel rounding */
        toggle.style.display = 'none';
        text.style.height = 'auto';
        desc.classList.add('is-short');
        return false;
      }
      toggle.style.display = '';
      desc.classList.remove('is-short');
      return true;
    }

    /* Initial state: only set the collapsed height if the content
       actually exceeds the clamp threshold. Otherwise leave height
       as auto so short content displays naturally without a brief
       FOUC where it gets clamped, then expanded.

       We measure scrollHeight first (works regardless of current
       height since auto is the default), compare to the collapsed
       target, and either clamp or leave alone. */
    if (checkClampNeeded()) {
      text.style.height = getCollapsedHeight() + 'px';
    }

    /* Re-check on resize since line wrapping may change content
       height (especially on responsive breakpoint shifts). Debounced
       to avoid running on every pixel of resize. */
    var resizeTimer = null;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        var stillNeedsClamp = checkClampNeeded();
        if (stillNeedsClamp && !desc.classList.contains('is-expanded')) {
          text.style.height = getCollapsedHeight() + 'px';
        }
      }, 150);
    });

    /* Re-run check after a tick so any web fonts loading async don't
       throw off the measurement. Web fonts can change line-height
       which would mis-compute the collapsed height — if a font loads
       and pushes the content past the threshold, we need to clamp
       AFTER the font kicks in. */
    setTimeout(function() {
      if (checkClampNeeded() && !desc.classList.contains('is-expanded')) {
        text.style.height = getCollapsedHeight() + 'px';
      }
    }, 100);

    toggle.addEventListener('click', function() {
      var isExpanded = desc.classList.contains('is-expanded');

      if (isExpanded) {
        /* Collapse: pin current pixel height first (forces reflow
           so transition has a starting value), then set to collapsed. */
        var current = text.scrollHeight;
        text.style.height = current + 'px';
        /* eslint-disable-next-line no-unused-expressions */
        text.offsetHeight; /* force reflow */
        text.style.height = getCollapsedHeight() + 'px';
        desc.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        /* Expand: set to natural full height. After the transition
           completes, swap to height: auto so future content changes
           (responsive reflow, etc.) don't get clipped by a stale
           pixel value. */
        var target = getExpandedHeight();
        text.style.height = target + 'px';
        desc.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');

        function onEnd(e) {
          if (e.propertyName !== 'height') return;
          if (desc.classList.contains('is-expanded')) {
            text.style.height = 'auto';
          }
          text.removeEventListener('transitionend', onEnd);
        }
        text.addEventListener('transitionend', onEnd);
      }
    });
  });

  /* ── Size Guide drawer ────────────────────────────────
     Reuses the size-guide-drawer snippet from product.liquid
     but with overridden CSS so it positions inside the gallery
     container on desktop (slides in from the right edge of the
     gallery) and as a bottom sheet on mobile.

     Trigger class .size-guide-trigger-class matches product.liquid's
     pattern, so any future trigger placement just needs that class.

     Behavior:
       - Click trigger → drawer + overlay open
       - Click overlay or close button → close
       - Escape → close
       - Body scroll lock on mobile (where it's a fixed sheet)
         to prevent background scroll while sheet is open */
  document.querySelectorAll('.palt').forEach(function(palt) {
    var triggers = palt.querySelectorAll('.size-guide-trigger-class');
    var drawer = palt.querySelector('.sg-drawer');
    var overlay = palt.querySelector('.sg-overlay');
    var closeBtn = palt.querySelector('.sg-drawer__close');

    if (!drawer || triggers.length === 0) return;

    function openSg() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      /* Lock body scroll while the modal is open. The modal covers
         the entire viewport on both desktop and mobile (it's a
         centered popup over a dark overlay), so scrolling the page
         behind it would feel disorienting. */
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeSg() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      /* Return focus to the first trigger so keyboard users
         don't lose their place. */
      if (triggers[0]) triggers[0].focus();
    }

    /* Trigger acts as a toggle — clicking it while the drawer is
       open closes it, clicking while closed opens it. This matches
       the lux pattern where the trigger feels like a single
       interactive surface rather than a fire-and-forget action. */
    triggers.forEach(function(t) {
      t.addEventListener('click', function() {
        if (drawer.classList.contains('is-open')) {
          closeSg();
        } else {
          openSg();
        }
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', closeSg);
    if (overlay) overlay.addEventListener('click', closeSg);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeSg();
      }
    });

    /* Auto-open in Shopify customizer when a size_guide_entry block
       is selected — gives merchants instant preview while editing.
       sectionId comes from data-section-id on the .palt root. */
    if (window.Shopify && window.Shopify.designMode) {
      var sectionId = palt.dataset.sectionId;
      document.addEventListener('shopify:block:select', function(e) {
        if (e.detail.sectionId === sectionId) openSg();
      });
      document.addEventListener('shopify:block:deselect', function(e) {
        if (e.detail.sectionId === sectionId) closeSg();
      });
    }
  });

  /* ── Mobile gallery navigation (arrows + dots) ─────────
     Wires up the optional mobile-only navigation overlaying the
     horizontal-swipe gallery. The gallery is a CSS scroll-snap
     container — we use programmatic scrollBy to navigate, which
     respects the snap points naturally.

     Behaviors:
       - Arrow click → scroll one slide width left/right
       - Dot click → scroll directly to that slide
       - On scroll → update which dot is active based on scroll
         position
       - On color filter change → rebuild dots for visible slides only

     Active dot is recomputed from scrollLeft / clientWidth, so the
     dots stay in sync regardless of how the user navigates (swipe,
     click arrow, click dot, or any combination). */
  document.querySelectorAll('.palt').forEach(function(palt) {
    var gallery = palt.querySelector('.palt__gallery');
    if (!gallery) return;
    var prevBtn = palt.querySelector('.palt__gallery-nav--prev');
    var nextBtn = palt.querySelector('.palt__gallery-nav--next');
    var dotsContainer = palt.querySelector('.palt__gallery-dots');

    /* Bail if neither arrows nor dots are present — nothing to do. */
    if (!prevBtn && !nextBtn && !dotsContainer) return;

    /* visibleSlides is recomputed each time the color filter
       changes. Only color-matching slides are navigable. */
    var visibleSlides = [];

    function rebuildVisibleSlides() {
      visibleSlides = [];
      gallery.querySelectorAll('.palt__slide').forEach(function(slide) {
        /* Skip hidden slides (display:none from color filter). */
        if (slide.offsetParent === null) return;
        visibleSlides.push(slide);
      });
      buildDots();
    }

    function buildDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      /* Hide the dots container entirely if 0-1 visible slides — no
         indicator needed when there's nothing to navigate between. */
      if (visibleSlides.length <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = '';
      visibleSlides.forEach(function(slide, idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'palt__gallery-dot';
        dot.setAttribute('aria-label', 'Go to image ' + (idx + 1));
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          /* Use scroll-into-view-with-offset since the gallery's
             scroll-snap will pull the slide to the start anyway. */
          var targetLeft = slide.offsetLeft;
          gallery.scrollTo({ left: targetLeft, behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      });
      updateActiveDot();
    }

    /* Compute which slide is currently centered/snapped based on
       scrollLeft. Each slide is 100% of gallery's clientWidth (mobile
       carousel mode), so the index = round(scrollLeft / clientWidth).
       We compute relative to visible slides' positions to stay
       accurate when some are filtered out. */
    function getCurrentIndex() {
      if (visibleSlides.length === 0) return 0;
      var scrollLeft = gallery.scrollLeft;
      var clientWidth = gallery.clientWidth;
      if (clientWidth === 0) return 0;
      var rawIndex = Math.round(scrollLeft / clientWidth);
      /* Clamp to visibleSlides bounds. */
      return Math.max(0, Math.min(rawIndex, visibleSlides.length - 1));
    }

    function updateActiveDot() {
      if (!dotsContainer) return;
      var current = getCurrentIndex();
      var dots = dotsContainer.querySelectorAll('.palt__gallery-dot');
      dots.forEach(function(dot, idx) {
        dot.classList.toggle('is-active', idx === current);
      });
      /* Disable arrows at boundaries (first slide → prev disabled,
         last slide → next disabled). Wrapping isn't natural for a
         scroll-snap carousel since there's no fluid wraparound
         behavior — the user would jump from end to start abruptly. */
      if (prevBtn) prevBtn.classList.toggle('is-disabled', current === 0);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', current >= visibleSlides.length - 1);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var current = getCurrentIndex();
        var target = visibleSlides[Math.max(0, current - 1)];
        if (target) gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var current = getCurrentIndex();
        var target = visibleSlides[Math.min(visibleSlides.length - 1, current + 1)];
        if (target) gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      });
    }

    /* Update active dot + arrow disabled states on scroll. Debounced
       via requestAnimationFrame to avoid running on every scroll
       pixel. */
    var scrollRafId = null;
    gallery.addEventListener('scroll', function() {
      if (scrollRafId) return;
      scrollRafId = requestAnimationFrame(function() {
        scrollRafId = null;
        updateActiveDot();
      });
    }, { passive: true });

    /* Sync visible slides when the variant (color) changes. */
    var picker = palt.querySelector('.palt-vs');
    if (picker) {
      picker.addEventListener('palt:variant-change', function() {
        rebuildVisibleSlides();
        /* Reset gallery to the first visible slide so the user
           starts at a meaningful position after filtering. */
        if (visibleSlides[0]) {
          gallery.scrollTo({ left: visibleSlides[0].offsetLeft, behavior: 'auto' });
        }
        updateActiveDot();
      });
    }

    /* Initial setup. */
    rebuildVisibleSlides();
    updateActiveDot();
  });

  /* ── Fullscreen image lightbox ─────────────────────────
     Behaviors:
       - Click any gallery image → open lightbox at that image
       - Click image OR backdrop in lightbox → close
       - Click prev/next nav buttons → navigate
       - Click progress dot → jump to that image
       - Arrow keys → navigate (when lightbox open)
       - Escape → close
       - Stays in sync with current color filter (only shows
         images for the active color variant) */
  document.querySelectorAll('.palt').forEach(function(palt) {
    var lightbox = palt.querySelector('.palt-lightbox');
    if (!lightbox) return;

    var stack = lightbox.querySelector('.palt-lightbox__stack');
    var slides = stack.querySelectorAll('.palt-lightbox__slide');
    var closeBtn = lightbox.querySelector('.palt-lightbox__close');
    var prevBtn = lightbox.querySelector('.palt-lightbox__nav--prev');
    var nextBtn = lightbox.querySelector('.palt-lightbox__nav--next');
    var dotsContainer = lightbox.querySelector('.palt-lightbox__dots');
    var galleryImgs = palt.querySelectorAll('.palt__gallery .palt__img');

    /* visibleSlides is the list of slides matching the current
       color filter — recomputed each time the lightbox opens or
       the variant changes. The user navigates within this list. */
    var visibleSlides = [];
    var currentIndex = 0;

    /* Read the currently active color from any variant-change event
       OR by inspecting which gallery slides are currently visible.
       The gallery's data-colors attributes mirror what the lightbox
       has, so we can use the gallery state as the source of truth. */
    function getCurrentColor() {
      /* Find first visible (non-display:none) gallery slide and
         pull its color attr. If color filter isn't active, returns ''. */
      var visibleGallerySlides = palt.querySelectorAll('.palt__slide:not([style*="display:none"]):not([style*="display: none"])');
      for (var i = 0; i < visibleGallerySlides.length; i++) {
        var colors = visibleGallerySlides[i].getAttribute('data-colors') || '';
        if (colors !== '') return colors.split('|')[0]; /* take first match */
      }
      return '';
    }

    function rebuildVisibleSlides() {
      var currentColor = getCurrentColor();
      visibleSlides = [];
      slides.forEach(function(slide) {
        var slideColors = (slide.getAttribute('data-colors') || '').toLowerCase();
        /* Empty data-colors = color-agnostic = always visible.
           Otherwise must include the current color. */
        if (slideColors === '' || (currentColor && slideColors.split('|').indexOf(currentColor) !== -1)) {
          visibleSlides.push(slide);
        }
      });
      /* Rebuild progress dots to match visible count. */
      buildDots();
    }

    function buildDots() {
      dotsContainer.innerHTML = '';
      visibleSlides.forEach(function(slide, idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'palt-lightbox__dot';
        dot.setAttribute('aria-label', 'Go to image ' + (idx + 1));
        dot.addEventListener('click', function(e) {
          e.stopPropagation();
          goTo(idx);
        });
        dotsContainer.appendChild(dot);
      });
    }

    function updateActiveSlide() {
      visibleSlides.forEach(function(slide, idx) {
        slide.classList.toggle('is-active', idx === currentIndex);
      });
      var dots = dotsContainer.querySelectorAll('.palt-lightbox__dot');
      dots.forEach(function(dot, idx) {
        dot.classList.toggle('is-active', idx === currentIndex);
      });
      /* Disable prev/next at boundaries (single-image case hides
         both completely; otherwise wrap around). We could wrap
         instead of disable — for lux UX, wrapping is more fluid.
         Keep arrows visible at all positions; navigation wraps. */
      var hasMultiple = visibleSlides.length > 1;
      prevBtn.classList.toggle('is-disabled', !hasMultiple);
      nextBtn.classList.toggle('is-disabled', !hasMultiple);
      /* Hide dots if only one image */
      dotsContainer.style.display = hasMultiple ? '' : 'none';
    }

    function goTo(idx) {
      if (visibleSlides.length === 0) return;
      /* Wrap around at boundaries for fluid navigation. */
      if (idx < 0) idx = visibleSlides.length - 1;
      if (idx >= visibleSlides.length) idx = 0;
      currentIndex = idx;
      updateActiveSlide();
      /* Reset scroll position on the newly-active slide. Since
         each slide is its own scroll container (overflow-y: auto),
         scroll state persists per slide. We want each navigation
         to start the new image from the top — fresh view. Use
         scrollTop = 0 (instant, before the cross-dissolve fully
         completes, so the user doesn't see the previous scroll
         state through the fading slide). */
      var newSlide = visibleSlides[currentIndex];
      if (newSlide) newSlide.scrollTop = 0;
    }

    function openLightbox(startIndex) {
      rebuildVisibleSlides();
      if (visibleSlides.length === 0) return;
      currentIndex = Math.max(0, Math.min(startIndex || 0, visibleSlides.length - 1));
      updateActiveSlide();
      /* Reset scroll on the starting slide so the image starts
         from the top regardless of previous lightbox state. */
      var startSlide = visibleSlides[currentIndex];
      if (startSlide) startSlide.scrollTop = 0;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      /* Focus the close button after a short delay (after the
         opacity transition starts) so screen readers announce
         the modal context. */
      setTimeout(function() {
        if (closeBtn) closeBtn.focus();
      }, 100);
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      /* Clear .is-active from all slides so they lose pointer-events.
         If we leave .is-active on a slide while the lightbox is closed,
         the slide (which is position: absolute; inset: 0 fills the
         viewport) keeps pointer-events: all and silently captures
         every click on the page. The .is-active class is re-applied
         the next time the lightbox opens. */
      slides.forEach(function(s) { s.classList.remove('is-active'); });
    }

    /* Click handlers on the gallery images: open lightbox at the
       clicked image's index. Map gallery slide → lightbox visible
       index by matching data-slide-index. */
    galleryImgs.forEach(function(img) {
      img.addEventListener('click', function(e) {
        e.preventDefault();
        var gallerySlide = img.closest('.palt__slide');
        if (!gallerySlide) return;
        var slideIdx = gallerySlide.getAttribute('data-slide-index');

        rebuildVisibleSlides();
        /* Find the matching lightbox slide by data-slide-index. */
        var startIdx = 0;
        for (var i = 0; i < visibleSlides.length; i++) {
          if (visibleSlides[i].getAttribute('data-slide-index') === slideIdx) {
            startIdx = i;
            break;
          }
        }
        openLightbox(startIdx);
      });
    });

    /* Click-to-close on the lightbox surface (the image / backdrop).
       The challenge: users also scroll the image vertically, and on
       desktop wheel scrolling doesn't trigger click events but on
       trackpads with click-drag (or touch devices) the user may
       drag-scroll which CAN fire a click on release.

       Solution: track mousedown position, compare to mouseup
       position. If the cursor moved more than ~5px between down and
       up, treat it as a drag (scroll attempt) and don't close. If
       it barely moved, it was a real click → close.

       We also exclude clicks on the explicit interactive elements
       (close, nav arrows, dots) since those have their own handlers. */
    var mouseDownX = null;
    var mouseDownY = null;
    var DRAG_THRESHOLD = 5; /* pixels */

    lightbox.addEventListener('mousedown', function(e) {
      mouseDownX = e.clientX;
      mouseDownY = e.clientY;
    });

    lightbox.addEventListener('click', function(e) {
      /* Ignore clicks on the explicit UI controls — they have their
         own handlers. */
      if (e.target.closest('.palt-lightbox__nav') ||
          e.target.closest('.palt-lightbox__close') ||
          e.target.closest('.palt-lightbox__dots')) {
        return;
      }

      /* If we have a recorded mousedown, check if the click was
         actually a drag. Only close if the cursor barely moved. */
      if (mouseDownX !== null && mouseDownY !== null) {
        var dx = Math.abs(e.clientX - mouseDownX);
        var dy = Math.abs(e.clientY - mouseDownY);
        mouseDownX = null;
        mouseDownY = null;
        if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
          /* User dragged (probably scrolling) — don't close. */
          return;
        }
      }

      closeLightbox();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        closeLightbox();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        goTo(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        goTo(currentIndex + 1);
      });
    }

    /* Keyboard navigation when lightbox is open. */
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        goTo(currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        goTo(currentIndex + 1);
      }
    });

    /* Touch swipe navigation. Track touch start/end x-positions;
       if horizontal delta exceeds threshold, navigate. Vertical
       drag closes the lightbox (like iOS photo viewer). */
    var touchStartX = null;
    var touchStartY = null;
    lightbox.addEventListener('touchstart', function(e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    lightbox.addEventListener('touchend', function(e) {
      if (touchStartX === null) return;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;
      var absDx = Math.abs(dx);
      var absDy = Math.abs(dy);
      /* Horizontal swipe (>40px) = navigate */
      if (absDx > 40 && absDx > absDy) {
        if (dx > 0) goTo(currentIndex - 1);
        else goTo(currentIndex + 1);
      }
      touchStartX = null;
      touchStartY = null;
    }, { passive: true });

    /* Sync visible slides when the variant (color) changes — so
       opening the lightbox always shows the right images. */
    var picker = palt.querySelector('.palt-vs');
    if (picker) {
      picker.addEventListener('palt:variant-change', function() {
        /* If lightbox is open and current slide gets filtered out,
           reset to first visible. */
        rebuildVisibleSlides();
        if (lightbox.classList.contains('is-open')) {
          currentIndex = 0;
          updateActiveSlide();
        }
      });
    }
  });

  /* ── Accordion: single-open behavior + smooth height ──
     Click a row → close any other open row → toggle this row.
     We measure the panel's actual content height via
     scrollHeight and animate `height` to that exact value
     (instead of CSS max-height to a fixed ceiling). This
     keeps the open/close pace consistent regardless of
     content length and avoids the "transition feels slow then
     snaps" issue with a too-large max-height ceiling.

     Open sequence:
       1. measure panel.scrollHeight → set inline height
       2. CSS transitions height: 0 → measured value
       3. on transitionend, set height: auto so dynamic
          content (e.g. variant-driven changes) doesn't get
          clipped by the static pixel value

     Close sequence is the inverse:
       1. read current height (likely 'auto'), set it back
          to the measured pixel value (forces a layout flush)
       2. next frame, set height: 0 — transition runs */
  document.querySelectorAll('.palt-accordion').forEach(function(accordion) {

    function closeRow(row) {
      var panel = row.querySelector('.palt-accordion__panel');
      if (!panel) return;
      /* If it's currently 'auto' (post-open finalization), pin it
         to its current pixel height first so the transition has
         a starting value to interpolate from. Force layout flush
         via offsetHeight read between sets. */
      var currentHeight = panel.scrollHeight;
      panel.style.height = currentHeight + 'px';
      /* eslint-disable-next-line no-unused-expressions */
      panel.offsetHeight; /* force reflow */
      panel.style.height = '0px';
      row.classList.remove('is-open');
      var t = row.querySelector('.palt-accordion__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    }

    function openRow(row) {
      var panel = row.querySelector('.palt-accordion__panel');
      if (!panel) return;
      row.classList.add('is-open');
      var t = row.querySelector('.palt-accordion__trigger');
      if (t) t.setAttribute('aria-expanded', 'true');

      /* scrollHeight gives the natural content height even when
         the element is currently height: 0. Set it inline so the
         CSS transition kicks in. */
      var targetHeight = panel.scrollHeight;
      panel.style.height = targetHeight + 'px';

      /* On transitionend, switch to height: auto so future
         content size changes (e.g. responsive reflow) don't
         get clipped. Listener is one-shot. */
      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        if (row.classList.contains('is-open')) {
          panel.style.height = 'auto';
        }
        panel.removeEventListener('transitionend', onEnd);
      }
      panel.addEventListener('transitionend', onEnd);
    }

    accordion.addEventListener('click', function(e) {
      var trigger = e.target.closest('.palt-accordion__trigger');
      if (!trigger) return;
      var row = trigger.closest('.palt-accordion__row');
      if (!row) return;

      var wasOpen = row.classList.contains('is-open');

      /* Close any other open row first (single-open enforcement). */
      accordion.querySelectorAll('.palt-accordion__row.is-open').forEach(function(r) {
        if (r !== row) closeRow(r);
      });

      /* Toggle this row. */
      if (wasOpen) {
        closeRow(row);
      } else {
        openRow(row);
      }
    });
  });
})();

/* ── Video playback gating + corner toggle ──────────
   The Liquid render intentionally omits the `autoplay`
   attribute and uses `preload="none"` on every <video>.
   This script is the actual playback controller:

     1. IntersectionObserver watches each [data-palt-video].
        When a video becomes ≥ 60% visible we call .play()
        (which kicks off loading thanks to preload="none").
        When it scrolls out we .pause().
     2. The corner button works as a manual toggle. Clicking
        pause sets a "user paused" flag on the wrapper, so
        the IO won't auto-resume on re-entry — until the
        user hits play again.
     3. The `.is-paused` class on the wrapper is driven by
        the video's own `play` / `pause` events, so the
        icon stays accurate regardless of who paused.

   Outcome: at most one video decodes at any moment, keeping
   the main thread free for touch input — which is what
   fixes the high-image-count swipe degradation. */
(function () {
  function init(root) {
    var wraps = (root || document).querySelectorAll('.palt__video-wrap');
    if (!wraps.length) return;

    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        var wrap = video.closest('.palt__video-wrap');
        if (!wrap) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          /* Respect user pauses — don't auto-resume something
             they explicitly stopped. */
          if (wrap.dataset.userPaused === '1') return;
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          if (!video.paused) video.pause();
        }
      });
    }, { threshold: [0, 0.6, 1] }) : null;

    wraps.forEach(function (wrap) {
      if (wrap.dataset.videoBound === '1') return;
      wrap.dataset.videoBound = '1';
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('.palt__video-toggle');
      if (!video) return;

      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            wrap.dataset.userPaused = '0';
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            wrap.dataset.userPaused = '1';
            video.pause();
          }
        });
      }

      video.addEventListener('play', function () {
        wrap.classList.remove('is-paused');
        if (btn) btn.setAttribute('aria-label', 'Pause video');
      });
      video.addEventListener('pause', function () {
        wrap.classList.add('is-paused');
        if (btn) btn.setAttribute('aria-label', 'Play video');
      });

      if (io) io.observe(video);
    });
  }
  init(document);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-centered"] && !Shopify.designMode) return;
  try {
    
  /* Product-Centered interactive logic — bundled and cached.
     Iterates every .pc section on the page, idempotent via
     dataset.pcInit so theme-editor reloads don't double-wire. */
  (function() {
    'use strict';

    function init(root) {
      (root || document).querySelectorAll('[data-pc-section]').forEach(initSection);
    }

    function initSection(section) {
      if (section.dataset.pcInit === 'true') return;
      section.dataset.pcInit = 'true';

      /* ── Read variant data ──
         JSON blob is inside a <script type="application/json">
         block so Shopify's Liquid filters don't have to escape it
         for an attribute. Parses once on init. */
      var dataEl = section.querySelector('[data-pc-variants]');
      var variants = [];
      if (dataEl) {
        try { variants = JSON.parse(dataEl.textContent); } catch (e) { /* malformed JSON — variant picker becomes a no-op */ }
      }

      /* Initial selection — picks the active button per option
         index. Mirrors what Liquid set as `option.selected_value`. */
      var selected = {};
      section.querySelectorAll('.pc__option').forEach(function(optEl) {
        var idx = parseInt(optEl.dataset.pcOptionIndex, 10);
        if (Number.isNaN(idx)) return;
        var active = optEl.querySelector('.pc__option-value.is-active');
        if (active) selected[idx] = active.dataset.value;
      });

      function findVariant() {
        if (!variants.length) return null;
        return variants.find(function(v) {
          return v.options.every(function(opt, i) { return opt === selected[i]; });
        }) || null;
      }

      function formatMoney(cents) {
        /* Prefer Shopify's global formatter when available — it
           respects the merchant's "Money format" setting. Falls
           back to a US-style "$X.XX" so the editor preview still
           shows something readable before shop-common.js loads. */
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
          return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
        }
        return '$' + (cents / 100).toFixed(2);
      }

      function syncUI(variant) {
        if (!variant) {
          /* No match for this combination — disable purchase and
             flag the conflicting option button as unavailable. */
          section.querySelectorAll('[data-pc-atc]').forEach(function(btn) {
            btn.disabled = true;
            var label = btn.querySelector('[data-pc-atc-text]');
            if (label) label.textContent = 'UNAVAILABLE';
            /* Blank the inline price — "UNAVAILABLE · $X" reads
               awkwardly when the variant isn't actually purchasable. */
            var priceEl = btn.querySelector('[data-pc-atc-price]');
            if (priceEl) priceEl.textContent = '';
          });
          return;
        }
        section.querySelectorAll('[data-pc-price]').forEach(function(el) {
          el.textContent = formatMoney(variant.price);
        });
        section.querySelectorAll('[data-pc-variant-id]').forEach(function(input) {
          input.value = variant.id;
        });
        /* ── Variant URL sync ──
           Reflect the active variant id in the browser URL as
           ?variant=<id> so bookmarks, shares, and the back button
           land on the exact color/size combination the customer
           was viewing. Uses history.replaceState so no new entry
           is added per click (avoids polluting back-button history
           with every variant change). Mirrors product.liquid's
           behavior. */
        if (variant.id && window.history && window.history.replaceState) {
          try {
            var pcUrl = new URL(window.location.href);
            pcUrl.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', pcUrl.toString());
          } catch (e) { /* legacy browser without URL constructor — skip silently */ }
        }
        section.querySelectorAll('[data-pc-atc]').forEach(function(btn) {
          btn.disabled = !variant.available;
          /* Toggle .is-sold-out so the sold-out CSS rules (custom
             palette in Custom mode, opacity dim in Primary/Secondary
             modes) kick in client-side after a variant switch. */
          btn.classList.toggle('is-sold-out', !variant.available);
          var label = btn.querySelector('[data-pc-atc-text]');
          if (label) label.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
          /* Inline price: show "· $X.XX" next to ADD TO CART when
             purchasable; clear it for SOLD OUT so the button reads
             as a single SOLD OUT word. The " · " separator (middle
             dot with spaces) sits flush with the action text and
             reads as one continuous label. */
          var priceEl = btn.querySelector('[data-pc-atc-price]');
          if (priceEl) {
            priceEl.textContent = variant.available ? ' · ' + formatMoney(variant.price) : '';
          }
        });
        /* ── Wishlist sync on variant change ──
           Re-point every wishlist button at the new variant ID and
           re-check the wishlist state so the heart fills/empties to
           match. Mirrors the pattern from product-alt.liquid /
           product.liquid (data-wishlist-add holds the variant id;
           .is-wishlisted toggles fill via --wishlist-active-color). */
        section.querySelectorAll('[data-pc-wishlist]').forEach(function(wlBtn) {
          syncWishlistButton(wlBtn, variant.id);
        });

        /* ── Stock indicator sync on variant change ──
           Reads inventory_quantity / inventory_policy from
           variantInv (built once on init from the variants JSON),
           computes the tier vs. the merchant's thresholds, then
           updates data-stock-state, the label text (with %qty%
           interpolation), and the capacity bar fill percentage.

           Bar width math:
             • sold out         → 0%
             • low (qty ≤ low)  → 8–28% (scales within tier)
             • mid (qty ≤ mid)  → 28–72% (scales)
             • high / untracked → 100%
           Mapping the tier to a width range gives the bar a
           pleasing rhythm — never empty for low (would read as
           sold out), never quite full for mid (preserves the
           "abundance" signal of high). */
        syncStockIndicator(variant);
      }

      function syncStockIndicator(variant) {
        if (!cartCfg.stock || !cartCfg.stock.enabled) return;
        var stockEls = section.querySelectorAll('[data-pc-stock]');
        if (stockEls.length === 0) return;
        var inv = variantInv[variant.id] || {};
        var qty = inv.qty;
        var thresholds = cartCfg.stock.thresholds || { low: 5, mid: 20 };
        var labels = cartCfg.stock.labels || {};
        var state, text, width;

        if (!variant.available) {
          state = 'sold-out';
          text  = labels.soldOut || 'Sold out';
          width = 0;
        } else if (qty == null || qty < 0) {
          /* Untracked inventory — Shopify returns null/-1 when the
             variant has inventory_management disabled. Show the
             high-stock signal but skip the count interpolation. */
          state = 'high';
          text  = (labels.high || 'In stock').replace('%qty%', '');
          width = 100;
        } else if (qty <= thresholds.low) {
          state = 'low';
          text  = (labels.low || 'Only %qty% left').replace('%qty%', qty);
          /* Bar fill range for low tier: 8–28%. The 8% floor keeps
             a visible sliver even at qty=1 so the bar doesn't read
             as sold-out; the 28% cap keeps the urgency signal even
             when at the top of the low band. */
          width = 8 + ((qty - 1) / Math.max(thresholds.low - 1, 1)) * 20;
        } else if (qty <= thresholds.mid) {
          state = 'mid';
          text  = (labels.mid || '%qty% in stock').replace('%qty%', qty);
          /* Mid tier maps to 28–72%. Same idea — visually distinct
             from low (always > 28%) and from high (never reaches
             100%). */
          var midSpan = Math.max(thresholds.mid - thresholds.low, 1);
          width = 28 + ((qty - thresholds.low) / midSpan) * 44;
        } else {
          state = 'high';
          text  = (labels.high || 'In stock').replace('%qty%', qty);
          width = 100;
        }

        /* Show-on-high gate: if the merchant set it off and we're
           at high tier (or untracked), hide the badge entirely.
           Keeps the UI quiet when there's no urgency to signal. */
        var hide = !cartCfg.stock.showOnHigh && state === 'high';

        stockEls.forEach(function(el) {
          el.style.display = hide ? 'none' : '';
          if (hide) return;
          el.setAttribute('data-stock-state', state);
          var textEl = el.querySelector('[data-pc-stock-text]');
          if (textEl) textEl.textContent = text;
          var barEl = el.querySelector('[data-pc-stock-bar-fill]');
          if (barEl) barEl.style.width = width + '%';
        });
      }
      /* (Initial syncStockIndicator call lives down where variantInv
         is built, since this function reads from variantInv via
         closure and we need that map populated before the first
         call. Out-of-order Liquid pre-render still covers first
         paint via the data-stock-state attribute + CSS fallback bar
         widths — so it's belt-and-suspenders rather than required
         for visual correctness.) */

      /* ── Wishlist state helpers ──
         Source of truth (in priority order):
           1. window.wishlistDrawer.isInWishlist(id) — the theme's
              global wishlist drawer API, if loaded.
           2. localStorage 'wishlist_items' — fallback for first
              paint before the drawer's scripts run, or when the
              drawer is disabled and the merchant only wants the
              icon for visual brand continuity. */
      function getWishlistState(variantId) {
        if (window.wishlistDrawer && typeof window.wishlistDrawer.isInWishlist === 'function') {
          return window.wishlistDrawer.isInWishlist(String(variantId));
        }
        try {
          var items = JSON.parse(localStorage.getItem('wishlist_items')) || [];
          return items.some(function(i) { return String(i.variantId) === String(variantId); });
        } catch (e) {
          return false;
        }
      }
      function syncWishlistButton(btn, variantId) {
        if (!btn) return;
        btn.dataset.wishlistAdd = variantId;
        var inWl = getWishlistState(variantId);
        btn.classList.toggle('is-wishlisted', inWl);
        /* Aria label tracks the action the click will perform. */
        var t = window.wdTranslations || {};
        btn.setAttribute('aria-label', inWl
          ? (t.removeFromWishlist || 'Remove from wishlist')
          : (t.addToWishlist || 'Add to wishlist')
        );
      }
      /* Initial wishlist sync — runs once per section init. Listens
         for wishlist:ready (fires when the drawer's JS initializes)
         AND a 100ms fallback so the localStorage path still kicks in
         if the drawer never loads. */
      section.querySelectorAll('[data-pc-wishlist]').forEach(function(wlBtn) {
        var initialId = wlBtn.dataset.wishlistAdd;
        document.addEventListener('wishlist:ready', function() {
          syncWishlistButton(wlBtn, wlBtn.dataset.wishlistAdd);
        });
        setTimeout(function() {
          syncWishlistButton(wlBtn, wlBtn.dataset.wishlistAdd);
        }, 100);
      });

      /* ── Buy It Now ─────────────────────────────────────────
         Mirrors product.liquid: read the live variant id, post
         /cart/add.js, then redirect straight to /checkout — the
         user skips the cart step entirely. Any data-pc-variant-id
         input within this section is kept synced by syncUI, so
         querying the first one always gives the active variant. */
      section.querySelectorAll('[data-pc-bin]').forEach(function(binBtn) {
        binBtn.addEventListener('click', function() {
          var variantInput = section.querySelector('[data-pc-variant-id]');
          var id = variantInput && variantInput.value;
          if (!id) return;
          binBtn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: 1 })
          })
          .then(function() { window.location.href = '/checkout'; })
          .catch(function() { binBtn.disabled = false; });
        });
      });

      /* ── Cart config (read once on init) ──
         The {% javascript %} bundle can't reference Liquid, so the
         merchant's Theme Settings (cart_type / cart_add_action /
         cart_notif_message_*) and the per-product variant images
         + titles are passed in via a JSON script tag. We parse it
         once, fall back to safe defaults if parsing fails. */
      var cartCfg = { cartType: 'drawer', addAction: 'drawer',
                      messages: { added: 'Added to cart', error: 'Could not add to cart',
                                  stock: 'Sorry, only %available% available and you already have %in_cart% in your cart.',
                                  soldout: 'This product is sold out.' },
                      productTitle: '', hasOnlyDefaultVariant: false,
                      variantTitles: {}, variantImages: {} };
      var cfgEl = section.querySelector('[data-pc-cart-config]');
      if (cfgEl) {
        try {
          var parsed = JSON.parse(cfgEl.textContent);
          for (var k in parsed) { cartCfg[k] = parsed[k]; }
        } catch (e) { /* malformed — use defaults */ }
      }

      /* ── Post-add behavior dispatcher ──
         Mirrors product.liquid's handlePostAdd. Drawer-mode opens
         the global cart drawer (window.cartDrawer.open); page-mode
         redirects to /cart; 'none' leaves the user where they are
         so only the toast is shown. */
      function handlePostAdd() {
        if (cartCfg.addAction === 'drawer' && cartCfg.cartType === 'drawer') {
          if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
            window.cartDrawer.open();
          }
        } else if (cartCfg.addAction === 'page') {
          window.location.href = '/cart';
        }
        /* 'none' → just the toast, no nav */
      }

      /* ── Cart quantity cache ──
         Used for inventory checks so a customer can't add more
         than (inventory_quantity - cart_quantity) when the variant's
         inventory_policy is 'deny'. Refreshed from /cart.js on
         init and on every cart:updated event. */
      var cartQty = {};
      function refreshCartQty(cb) {
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            cartQty = {};
            (cart.items || []).forEach(function(item) {
              var k = String(item.variant_id);
              cartQty[k] = (cartQty[k] || 0) + item.quantity;
            });
            if (cb) cb();
          })
          .catch(function() { if (cb) cb(); });
      }
      refreshCartQty();
      document.addEventListener('cart:updated', function() { refreshCartQty(); });

      /* ── Variant inventory map ──
         { variantId: { qty, policy } } — qty=-1 means inventory
         isn't tracked for that variant, so unlimited adds. */
      var variantInv = {};
      variants.forEach(function(v) {
        variantInv[v.id] = {
          qty:    v.inventory_quantity != null ? v.inventory_quantity : -1,
          policy: v.inventory_policy
        };
      });

      /* ── Initial stock-indicator sync ──
         Liquid pre-renders the right state on first paint via
         data-stock-state, and CSS provides tier-default bar widths.
         This pass refines the bar width to the EXACT per-variant
         quantity (so e.g. qty=3 in a low tier with threshold 5
         renders at ~18% rather than the 20% CSS default). Runs
         once at init; subsequent variant changes go through
         syncUI → syncStockIndicator. */
      if (cartCfg.stock && cartCfg.stock.enabled && variants.length > 0) {
        var initialVariantInput = section.querySelector('[data-pc-variant-id]');
        var initialVariantId = initialVariantInput && parseInt(initialVariantInput.value, 10);
        var initialVariant = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === initialVariantId) { initialVariant = variants[i]; break; }
        }
        if (initialVariant) syncStockIndicator(initialVariant);
      }

      /* ── Toast wrapper ──
         Thin façade over window.cartToast (rendered globally by
         theme.liquid). No-ops gracefully if the merchant disables
         the toast in Theme Settings → Cart Notification. */
      function showToast(msg, isError, productImage, productTitle) {
        if (!window.cartToast || typeof window.cartToast.show !== 'function') return;
        window.cartToast.show({
          type:         isError ? 'error' : 'success',
          message:      msg,
          productImage: productImage || '',
          productTitle: productTitle || '',
          quantity:     1
        });
      }

      /* ── AJAX add-to-cart handler ──
         Intercepts the submit on every .pc__form EXCEPT the
         dedicated payment form (which lets Shopify's own Shop
         Pay / Apple Pay handlers take over). Mirrors product.liquid:
           1. refreshCartQty first so inCart count is accurate
           2. inventory check — bail with stock message if maxed
           3. POST /cart/add.js
           4. on success: bump cartQty, show success toast,
              fire cart:updated, then handlePostAdd
           5. on error: re-refresh and show stock or generic error
                       toast based on the response
         The dedicated payment form is skipped because Shop Pay
         intercepts its own submit and shouldn't be redirected. */
      section.querySelectorAll('.pc__form').forEach(function(form) {
        if (form.classList.contains('pc__payment-form')) return;
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var variantInput = form.querySelector('[data-pc-variant-id]')
                          || section.querySelector('[data-pc-variant-id]');
          var id = variantInput && variantInput.value;
          if (!id) return;
          var inv       = variantInv[id] || {};
          var invQty    = inv.qty != null ? inv.qty : -1;
          var invPolicy = inv.policy || 'deny';
          var stockMsg  = cartCfg.messages.stock;
          var variantImage = cartCfg.variantImages[id] || '';
          /* Build a "Title — Variant" subtitle when the product
             has multiple variants (e.g. "Linen Shirt — Beige / L"). */
          var variantText = (function() {
            if (cartCfg.hasOnlyDefaultVariant) return cartCfg.productTitle;
            var vt = cartCfg.variantTitles[id];
            return vt ? (cartCfg.productTitle + ' — ' + vt) : cartCfg.productTitle;
          })();

          refreshCartQty(function() {
            var inCart = cartQty[id] || 0;

            if (invPolicy === 'deny' && invQty > 0 && inCart >= invQty) {
              showToast(stockMsg.replace('%available%', invQty).replace('%in_cart%', inCart), true);
              return;
            }

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: id, quantity: 1 })
            })
            .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
            .then(function(res) {
              if (res.ok) {
                cartQty[id] = inCart + 1;
                showToast(cartCfg.messages.added, false, variantImage, variantText);
                document.dispatchEvent(new CustomEvent('cart:updated'));
                handlePostAdd();
              } else {
                /* 422 fallback — Shopify rejected the add. Usually
                   because stock changed under us. Re-fetch cart so
                   inCart is fresh, then show a stock-aware message. */
                refreshCartQty(function() {
                  var inCartNow = cartQty[id] || 0;
                  if (invPolicy === 'deny' && invQty > 0) {
                    showToast(stockMsg.replace('%available%', invQty).replace('%in_cart%', inCartNow), true);
                  } else {
                    var desc = (res.data && (res.data.description || res.data.message)) || '';
                    showToast(desc || cartCfg.messages.error, true);
                  }
                });
              }
            })
            .catch(function() {
              showToast(cartCfg.messages.error, true);
            });
          });
        });
      });

      /* ── Suppress Shopify's auto-injected payment buttons ──
         Shopify auto-injects `.shopify-payment-button` / `.shopify-
         cleanslate` elements into every {% form 'product' %} that
         DOESN'T explicitly render `{{ form | payment_button }}`.
         We use that filter only inside the dedicated `.pc__payment-
         form` — every OTHER product form on this section (the
         main ATC form, the drawer form, the floating-bar form)
         needs the auto-injected buttons stripped so they don't
         render twice. A MutationObserver catches any reflows that
         re-inject the buttons later (e.g. after a variant change
         triggered by an app block). Mirrors product.liquid's
         removeInjectedPaymentBtns pattern. */
      function removeInjectedPaymentBtns() {
        section.querySelectorAll('.pc__form').forEach(function(form) {
          /* Skip the dedicated payment form — that one OWNS the
             payment buttons. */
          if (form.classList.contains('pc__payment-form')) return;
          form.querySelectorAll('.shopify-payment-button, .shopify-cleanslate')
            .forEach(function(el) { el.remove(); });
        });
      }
      removeInjectedPaymentBtns();
      section.querySelectorAll('.pc__form').forEach(function(form) {
        if (form.classList.contains('pc__payment-form')) return;
        new MutationObserver(removeInjectedPaymentBtns)
          .observe(form, { childList: true, subtree: true });
      });

      /* ── Cursor-follow label + full-screen lightbox ──
         Desktop-only experience. When the user hovers the gallery,
         a small pill follows the cursor (transform set via raf-
         throttled mousemove). When they click an image, a full-
         screen lightbox opens at that image's index. Inside:
         backdrop click / ESC / arrow keys / thumbnail click /
         arrow-button click all navigate. The lightbox reflects
         the active color filter — slides hidden by the gallery's
         display:none are skipped in the prev/next cycle and their
         thumbnails are hidden too. */
      (function setupLightbox() {
        var gallery = section.querySelector('[data-pc-lightbox-trigger]');
        var label   = section.querySelector('[data-pc-cursor-label]');
        var lb      = section.querySelector('[data-pc-lightbox]');
        if (!gallery || !lb) return;

        var lbImg      = lb.querySelector('[data-pc-lightbox-image]');
        var lbWrap     = lb.querySelector('[data-pc-lightbox-image-wrap]');
        var counterEl  = lb.querySelector('[data-pc-lightbox-counter]');
        var thumbsEl   = lb.querySelector('[data-pc-lightbox-thumbs]');
        var prevBtn    = lb.querySelector('[data-pc-lightbox-prev]');
        var nextBtn    = lb.querySelector('[data-pc-lightbox-next]');
        var allSlides  = gallery.querySelectorAll('.pc__slide');
        var allThumbs  = thumbsEl ? thumbsEl.querySelectorAll('[data-pc-lightbox-thumb]') : [];

        /* ── Visible-slide index helpers ──
           The gallery filter hides slides for non-matching colors
           via display:none. The lightbox should walk only those
           that are visible, otherwise prev/next jumps to a hidden
           image and the user sees nothing. */
        function visibleSlides() {
          var arr = [];
          for (var i = 0; i < allSlides.length; i++) {
            if (allSlides[i].style.display !== 'none') arr.push(i);
          }
          return arr;
        }

        function syncThumbsVisibility() {
          for (var i = 0; i < allThumbs.length; i++) {
            var hidden = allSlides[i] && allSlides[i].style.display === 'none';
            if (hidden) allThumbs[i].setAttribute('hidden', '');
            else allThumbs[i].removeAttribute('hidden');
          }
        }

        var currentIdx = 0;  /* original (un-filtered) slide index */

        /* ── Lightbox media renderer ──
           The lightbox stage needs to host THREE different element
           types based on the source slide's media:
             • image           → reuse the static <img data-pc-lightbox-image>
             • video           → clone the gallery's <video> into the stage
             • external_video  → clone the gallery's <iframe> into the stage
           We do this by clearing the wrap and inserting the right
           element. The static <img> is kept as a child so it can be
           swapped back in for image slides without re-creating it.

           Video / iframe clones inherit the gallery's no-controls +
           autoplay + loop + muted attributes, so the lightbox plays
           the media in the same chrome-free way the gallery does —
           just at full-screen scale. */
        function clearLBMedia() {
          /* Tear down any media we previously inserted (video or
             iframe). The static img stays in the DOM but is hidden
             so we can reuse it on image slides. */
          if (!lbWrap) return;
          var oldVid = lbWrap.querySelector('.pc__lightbox-video');
          if (oldVid) {
            try { oldVid.pause(); oldVid.removeAttribute('src'); oldVid.load(); }
            catch (e) {}
            oldVid.remove();
          }
          var oldIframe = lbWrap.querySelector('.pc__lightbox-iframe');
          if (oldIframe) {
            /* Setting src to about:blank stops YouTube/Vimeo playback
               before we remove the node — without this, audio can
               persist for a beat on slow connections. */
            try { oldIframe.src = 'about:blank'; } catch (e) {}
            oldIframe.remove();
          }
        }
        function showImage(idx) {
          var slide = allSlides[idx];
          if (!slide) return;
          clearLBMedia();

          var mediaType = slide.getAttribute('data-pc-media-type') || 'image';

          if (mediaType === 'video') {
            /* Clone the gallery's <video> element so we keep its
               source list, mime types, and poster intact. Cloning
               resets playback state — the new node starts from
               beginning and the muted+autoplay+playsinline attrs
               trigger fresh playback once it's attached. */
            var srcVid = slide.querySelector('video.pc__video');
            if (srcVid) {
              var lbVid = srcVid.cloneNode(true);
              lbVid.className = 'pc__lightbox-video';
              lbVid.removeAttribute('width');
              lbVid.removeAttribute('height');
              lbVid.muted = true;
              lbVid.loop = true;
              lbVid.autoplay = true;
              lbVid.controls = false;
              lbVid.setAttribute('playsinline', '');
              if (lbImg) lbImg.style.display = 'none';
              lbWrap.appendChild(lbVid);
              /* Play promise — silently swallow rejections so users
                 with autoplay blocked still get the poster + can tap
                 to play (browsers fall back to native play UI). */
              var p = lbVid.play();
              if (p && p.catch) p.catch(function() {});
              currentIdx = idx;
            }
          } else if (mediaType === 'external_video') {
            /* Clone the gallery iframe — keeps the no-controls
               YouTube/Vimeo URL with autoplay parameters intact. */
            var srcIfr = slide.querySelector('iframe.pc__video');
            if (srcIfr) {
              var lbIfr = srcIfr.cloneNode(true);
              lbIfr.className = 'pc__lightbox-iframe';
              if (lbImg) lbImg.style.display = 'none';
              lbWrap.appendChild(lbIfr);
              currentIdx = idx;
            }
          } else {
            /* Image — reuse the static <img data-pc-lightbox-image>.
               Pull the largest source from data-pc-lightbox-src (set
               by Liquid to width: 2400) or fall back to the slide's
               own img srcset. */
            var fullSrc = slide.getAttribute('data-pc-lightbox-src') || '';
            var img = slide.querySelector('img.pc__img');
            if (!fullSrc && img) {
              fullSrc = img.getAttribute('src') || '';
              var hi = img.getAttribute('srcset');
              if (hi) {
                var parts = hi.split(',').map(function(s) { return s.trim(); });
                var last  = parts[parts.length - 1];
                if (last) fullSrc = last.split(' ')[0];
              }
            }
            if (!fullSrc) return;
            if (lbImg) {
              lbImg.style.display = '';
              if (lbWrap) lbWrap.classList.add('is-loading');
              lbImg.onload = function() {
                if (lbWrap) lbWrap.classList.remove('is-loading');
              };
              lbImg.src = fullSrc;
              lbImg.alt = (img && img.getAttribute('alt')) || '';
            }
            currentIdx = idx;
          }

          /* Sync thumbnail active state */
          for (var i = 0; i < allThumbs.length; i++) {
            allThumbs[i].classList.toggle('is-active', i === idx);
            if (i === idx && thumbsEl) {
              /* Center the active thumbnail in the strip when many
                 images are present. */
              var rect = allThumbs[i].getBoundingClientRect();
              var stripRect = thumbsEl.getBoundingClientRect();
              if (rect.left < stripRect.left || rect.right > stripRect.right) {
                allThumbs[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
              }
            }
          }

          /* Counter: position within visible set */
          if (counterEl) {
            var vis = visibleSlides();
            var pos = vis.indexOf(idx) + 1;
            counterEl.textContent = pos + ' / ' + vis.length;
          }
        }

        function step(direction) {
          var vis = visibleSlides();
          if (vis.length === 0) return;
          var here = vis.indexOf(currentIdx);
          if (here === -1) here = 0;
          var next = (here + direction + vis.length) % vis.length;
          showImage(vis[next]);
        }

        function openLB(idx) {
          syncThumbsVisibility();
          /* Snap to visible index if requested index was hidden. */
          if (allSlides[idx] && allSlides[idx].style.display === 'none') {
            var vis = visibleSlides();
            idx = vis.length ? vis[0] : 0;
          }
          showImage(idx);
          lb.classList.add('is-open');
          lb.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          /* Hide cursor label while modal is open */
          if (label) label.classList.remove('is-visible');
        }
        function closeLB() {
          lb.classList.remove('is-open');
          lb.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          /* Tear down any active video / iframe so playback (and any
             audio) stops the moment the lightbox closes — otherwise
             a Shopify video would keep buffering offscreen and an
             external_video iframe would keep loading. The static
             img is preserved so the next open can reuse it. */
          clearLBMedia();
          if (lbImg) {
            lbImg.style.display = '';
            lbImg.removeAttribute('src');
          }
        }

        /* ── Cursor follow ──
           Only the IMG itself (not the gallery whitespace) shows the
           label, and only on devices with a fine pointer. requestAnimation-
           Frame throttles mousemove writes so we paint once per frame. */
        var rafPending = false;
        var lastX = 0, lastY = 0;
        function paintLabel() {
          rafPending = false;
          if (!label) return;
          /* Offset the label slightly down-right of the cursor so it
             doesn't sit under the cursor arrow. */
          label.style.transform = 'translate(' + (lastX + 16) + 'px, ' + (lastY + 12) + 'px)';
        }
        function onMove(e) {
          lastX = e.clientX;
          lastY = e.clientY;
          if (!rafPending) {
            rafPending = true;
            requestAnimationFrame(paintLabel);
          }
        }
        function isFinePointer() {
          return window.matchMedia('(min-width: 1024px) and (pointer: fine)').matches;
        }

        /* Show the label while the cursor is over an image; hide
           when it leaves. Per-image listeners (not gallery-level)
           so the whitespace flanking each image doesn't fire the
           label and the lightbox-trigger zone matches what the
           user sees. */
        function wireImage(img, slideIdx) {
          img.addEventListener('mouseenter', function() {
            if (!isFinePointer() || !label) return;
            label.classList.add('is-visible');
          });
          img.addEventListener('mouseleave', function() {
            if (label) label.classList.remove('is-visible');
          });
          img.addEventListener('mousemove', onMove);
          /* Click → open lightbox. Available on BOTH desktop and
             mobile now — desktop users open it from the cursor
             follow click, mobile users tap the image. The browser
             only fires `click` after a tap that wasn't part of a
             scroll/swipe gesture, so this doesn't interfere with
             the mobile horizontal-swipe gallery. */
          img.addEventListener('click', function() {
            openLB(slideIdx);
          });
        }
        allSlides.forEach(function(slide, i) {
          var img = slide.querySelector('.pc__img');
          if (img) wireImage(img, i);
        });

        /* Wire all the close paths — backdrop, X button. */
        lb.querySelectorAll('[data-pc-lightbox-close]').forEach(function(el) {
          el.addEventListener('click', closeLB);
        });
        if (prevBtn) prevBtn.addEventListener('click', function() { step(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function() { step(1); });
        allThumbs.forEach(function(thumb) {
          thumb.addEventListener('click', function() {
            var i = parseInt(thumb.dataset.pcLightboxThumb, 10);
            if (!isNaN(i)) showImage(i);
          });
        });

        /* Keyboard nav — only when the modal is open. */
        document.addEventListener('keydown', function(e) {
          if (!lb.classList.contains('is-open')) return;
          if (e.key === 'Escape')     closeLB();
          if (e.key === 'ArrowLeft')  step(-1);
          if (e.key === 'ArrowRight') step(1);
        });

        /* When the color filter runs, re-check thumb visibility. */
        if (typeof MutationObserver === 'function') {
          var slideObs = new MutationObserver(function() {
            if (lb.classList.contains('is-open')) syncThumbsVisibility();
          });
          allSlides.forEach(function(s) {
            slideObs.observe(s, { attributes: true, attributeFilter: ['style'] });
          });
        }
      })();

      /* ── Mobile floating ATC bar ──
         Watch the inline ATC button inside the drawer block. When
         it scrolls out of the viewport, slide the floating bar up
         from the bottom; when it returns, slide it back down. The
         CSS handles the actual animation (transform + transition);
         we just toggle the .is-visible class on the bar.

         The bar's CSS sets display: none on desktop, so the
         IntersectionObserver still fires there but the bar never
         renders — cheap no-op. Scoping the observer setup to
         (max-width: 1023px) would avoid even creating the observer
         on desktop, but observers are very cheap and a single
         media query check would add more conditional code than it
         saves; the simpler always-on wiring also handles desktop
         users who resize their viewport without a page reload. */
      var floatingBar = section.querySelector('[data-pc-floating-atc]');
      /* Watch the drawer's inline ATC (the one inside the mobile
         product info block under the gallery). When that one leaves
         the viewport, the user has scrolled past it and needs the
         floating bar to take over. */
      var inlineDrawerAtc = section.querySelector('.pc__drawer [data-pc-atc]');
      if (floatingBar && inlineDrawerAtc && 'IntersectionObserver' in window) {
        var floatObs = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              floatingBar.classList.remove('is-visible');
              floatingBar.setAttribute('aria-hidden', 'true');
            } else {
              floatingBar.classList.add('is-visible');
              floatingBar.setAttribute('aria-hidden', 'false');
            }
          });
        }, { threshold: 0 });
        floatObs.observe(inlineDrawerAtc);
      }

      /* ── Color → gallery filter ──
         When the active color changes, hide every slide whose alt
         text doesn't match the new color. Slides with no color in
         their alt (empty data-colors) stay visible — they're
         color-agnostic detail shots that apply to every variant.
         Mirrors product.liquid's filterGalleryByColor pattern. */
      var colorIndexEl = section.querySelector('[data-pc-color-option-index]');
      var colorOptionIndex = colorIndexEl && colorIndexEl.dataset.pcColorOptionIndex !== ''
        ? parseInt(colorIndexEl.dataset.pcColorOptionIndex, 10)
        : null;

      function filterGalleryByColor(colorValue) {
        if (colorOptionIndex === null) return;
        var colorLower = (colorValue || '').toLowerCase().trim();
        var galleryEl = section.querySelector('[data-pc-gallery]');
        if (!galleryEl) return;
        var slides = galleryEl.querySelectorAll('.pc__slide');
        slides.forEach(function(slide) {
          var colors = slide.dataset.colors || '';
          /* Color-agnostic slide (no color tagged) → always show.
             Otherwise show only if the active color is listed. */
          var match = colors === '' || colors.split('|').indexOf(colorLower) !== -1;
          slide.style.display = match ? '' : 'none';
        });
        /* Sync dots — hide the dot for any slide that's now hidden,
           and reset .is-active to the first visible. */
        var dotsEl = section.querySelector('[data-pc-dots]');
        if (dotsEl) {
          var dots = dotsEl.querySelectorAll('.pc__dot');
          var firstVisibleIdx = -1;
          dots.forEach(function(dot, i) {
            var slide = slides[i];
            var hidden = slide && slide.style.display === 'none';
            dot.style.display = hidden ? 'none' : '';
            dot.classList.remove('is-active');
            if (!hidden && firstVisibleIdx === -1) firstVisibleIdx = i;
          });
          if (firstVisibleIdx !== -1 && dots[firstVisibleIdx]) {
            dots[firstVisibleIdx].classList.add('is-active');
          }
        }
        /* Bring the new color's first image into view. The right
           scroll target depends on layout mode:
             • Desktop: the gallery is overflow-y:auto inside its
               own column. Resetting galleryEl.scrollTop = 0 brings
               the first visible slide to the top of the gallery
               viewport without moving the page itself.
             • Mobile: the gallery is overflow-x:auto (horizontal
               swipe carousel). Resetting galleryEl.scrollLeft = 0
               brings the first visible slide to the left edge of
               the gallery viewport — same idea, different axis.
               Using scrollIntoView() here would scroll the document
               instead (pushing the gallery up/away) which is the
               opposite of what we want. */
        var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        if (isDesktop) {
          galleryEl.scrollTop = 0;
        } else {
          /* offsetLeft of first visible slide, in case it isn't slide 0
             (color filter may have hidden the first N slides). */
          var firstVisible;
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].style.display !== 'none') { firstVisible = slides[i]; break; }
          }
          if (firstVisible) {
            galleryEl.scrollLeft = firstVisible.offsetLeft;
          }
        }
      }

      /* ── Wire option buttons ──
         Mirror clicks across BOTH the desktop and mobile DOMs by
         matching data-pc-option-index. One click flips active on
         every instance of that option button. */
      section.querySelectorAll('[data-pc-option-value]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var idx = parseInt(btn.dataset.optionIndex, 10);
          var value = btn.dataset.value;
          section.querySelectorAll('[data-pc-option-index="' + idx + '"] .pc__option-value').forEach(function(other) {
            if (other.dataset.value === value) other.classList.add('is-active');
            else other.classList.remove('is-active');
          });
          /* Sync the inline "Color: ActiveValue" pairing in the
             option label. The data-pc-option-selected span only
             renders for the color option in swatch / image mode,
             but the selector handles all options identically — if
             a label doesn't have the span, the loop is a no-op. */
          section.querySelectorAll('[data-pc-option-selected="' + idx + '"]').forEach(function(el) {
            el.textContent = value;
          });
          selected[idx] = value;
          syncUI(findVariant());
          /* Color click triggers a gallery refilter so the image
             set updates to match. Other options (size, etc.) leave
             the gallery alone. */
          if (idx === colorOptionIndex) {
            filterGalleryByColor(value);
          }
        });
      });

      /* ── Mobile image dot indicators ──
         Build one button-dot per slide. Active dot tracks whichever
         slide is currently centered in the viewport. Tapping a dot
         smooth-scrolls the page to that slide. Once the user has
         scrolled past the gallery entirely (last slide left the
         viewport), the dots fade out so they don't float over
         non-gallery content. */
      var dotsEl = section.querySelector('[data-pc-dots]');
      var slides = section.querySelectorAll('.pc__gallery .pc__slide');
      if (dotsEl && slides.length > 1) {
        /* Build one dot per slide, AND mirror each slide's initial
           visibility on its dot. Liquid pre-applies style="display:
           none" to slides whose alt-text doesn't list the currently-
           selected color, so a product with 6 total images split
           across 2 colors lands with 3 slides visible. The dots need
           to mirror that — otherwise the user sees 6 dots indicating
           "there are 6 images" when only 3 are reachable for the
           active color.

           Active dot tracks the first VISIBLE slide (not necessarily
           index 0) — when the page lands on a color whose first
           image is at slide index 2, that's the dot that should be
           lit on initial paint. */
        var firstVisibleIdx = -1;
        slides.forEach(function(slide, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pc__dot';
          dot.setAttribute('data-pc-dot-idx', i);
          dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
          if (slide.style.display === 'none') {
            dot.style.display = 'none';
          } else if (firstVisibleIdx === -1) {
            firstVisibleIdx = i;
          }
          dotsEl.appendChild(dot);
        });
        var dotsList = dotsEl.querySelectorAll('.pc__dot');
        if (firstVisibleIdx >= 0 && dotsList[firstVisibleIdx]) {
          dotsList[firstVisibleIdx].classList.add('is-active');
        }

        /* Scroll hint dismissal — auto-fade after 2 seconds. Simple
           on-display timer means the hint reliably shows long enough
           to read regardless of whether the user is scrolling or
           sitting still. */
        var hintEl = section.querySelector('[data-pc-scroll-hint]');
        if (hintEl) {
          setTimeout(function() {
            hintEl.classList.add('is-dismissed');
          }, 2000);
        }

        /* Click → scroll the gallery to the corresponding slide.
           Mobile redesign: the gallery is now a horizontal-overflow
           container (display: flex + overflow-x: auto + scroll-snap),
           so we move the gallery's own scrollLeft instead of using
           target.scrollIntoView (which would scroll the page
           vertically). Each slide is one full gallery-width wide,
           so target.offsetLeft is the exact scroll position needed. */
        var galleryScrollEl = section.querySelector('[data-pc-gallery]');
        dotsList.forEach(function(dot, i) {
          dot.addEventListener('click', function() {
            var target = slides[i];
            if (!target || !galleryScrollEl) return;
            if (galleryScrollEl.scrollTo) {
              galleryScrollEl.scrollTo({
                left: target.offsetLeft,
                behavior: 'smooth'
              });
            } else {
              galleryScrollEl.scrollLeft = target.offsetLeft;
            }
          });
        });

        if ('IntersectionObserver' in window) {
          /* root: galleryScrollEl scopes the visibility test to the
             gallery's own scroll viewport instead of the document
             viewport. Critical for the horizontal swipe layout —
             without this, every slide is technically "in the
             document viewport" at all times (they're inside an
             overflow container that's itself visible), so the
             observer would never fire intersection changes. */
          var slideObs = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                var idx = Array.prototype.indexOf.call(slides, entry.target);
                if (idx < 0) return;
                dotsList.forEach(function(d) { d.classList.remove('is-active'); });
                if (dotsList[idx]) dotsList[idx].classList.add('is-active');
              }
            });
          }, { root: galleryScrollEl, threshold: [0.5] });
          slides.forEach(function(s) { slideObs.observe(s); });

          /* Hide dots once the user has scrolled completely past the
             gallery — when the LAST slide leaves the top of the
             viewport, there are no more images to indicate. Uses a
             separate observer with threshold 0 (any vs none) keyed
             on the last slide. The observer fires when the slide
             enters or fully leaves the viewport, flipping
             .is-past-gallery on the dots container. */
          var lastSlide = slides[slides.length - 1];
          var pastObs = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              /* Past the gallery = last slide is above the viewport
                 (rect.bottom <= 0). entry.isIntersecting being false
                 + boundingClientRect.bottom <= 0 is the clearest
                 "scrolled past" signal. */
              if (!entry.isIntersecting && entry.boundingClientRect.bottom <= 0) {
                dotsEl.classList.add('is-past-gallery');
              } else {
                dotsEl.classList.remove('is-past-gallery');
              }
            });
          }, { threshold: 0 });
          pastObs.observe(lastSlide);
        }
      }

      /* ── Mobile drawer interactions ──
         Drag is supported on BOTH the small handle bar AND the entire
         peek row (title/price area), so the user has a big target to
         grab. The drawer-content area below stays scrollable as
         normal — only the handle + peek consume drag gestures.

         A movement threshold (DRAG_THRESHOLD_PX) distinguishes tap
         from drag: if the finger/cursor never moves past it, the
         interaction is treated as a tap and routed to the original
         click semantics (handle = toggle, peek = open). If movement
         exceeds the threshold, it's a drag and the drawer follows the
         finger in real time, then snaps to the nearest state on
         release. */
      var drawer = section.querySelector('[data-pc-drawer]');
      var handle = section.querySelector('[data-pc-drawer-handle]');
      var peek = drawer && drawer.querySelector('.pc__drawer-peek');
      /* Mobile redesign: the drawer is now an inline block under the
         gallery (not a fixed peek-and-drag bottom sheet), so the
         drag/tap/expand behavior below is retired. Wrapped in
         `if (false &&` instead of being deleted so the wiring
         remains intact and the previous behavior is one keyword
         flip away if needed for reference. */
      if (false && drawer && (handle || peek)) {
        var DRAG_THRESHOLD_PX = 6; /* finger slop below which we treat as a tap */
        var dragStartY = 0;
        var drawerStartTransform = 0;
        var isDragging = false;
        var hasMoved = false;
        var collapsedOffset = 0;
        /* Tracks the page scroll position when the drawer opens so we
           can restore it on close. iOS Safari ignores body{overflow:
           hidden} unless body is also taken out of the scroll context
           (position:fixed) — without restoring scrollY on unlock the
           page would jump to the top after closing the drawer. */
        var bodyLockedScrollY = 0;

        function setExpanded(expanded) {
          if (expanded) {
            if (!drawer.classList.contains('is-expanded')) {
              bodyLockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
              document.body.classList.add('pc-drawer-open');
              document.body.style.top = '-' + bodyLockedScrollY + 'px';
            }
            drawer.classList.add('is-expanded');
          } else {
            if (drawer.classList.contains('is-expanded')) {
              drawer.classList.remove('is-expanded');
              document.body.classList.remove('pc-drawer-open');
              document.body.style.top = '';
              window.scrollTo(0, bodyLockedScrollY);
            }
          }
        }

        function getCollapsedOffset() {
          var rect = drawer.getBoundingClientRect();
          var peekH = parseFloat(getComputedStyle(section).getPropertyValue('--pc-drawer-peek-h')) || 140;
          return Math.max(0, rect.height - peekH);
        }

        function readCurrentTransformY() {
          /* Live position in case we're starting a drag mid-snap so
             the drawer doesn't jump to its target before following. */
          var current = window.getComputedStyle(drawer).transform;
          if (current && current !== 'none') {
            var m = current.match(/matrix\(([^)]+)\)/);
            if (m) {
              var parts = m[1].split(',').map(parseFloat);
              return parts[5] || 0;
            }
          }
          return drawer.classList.contains('is-expanded') ? 0 : collapsedOffset;
        }

        function onStart(e) {
          isDragging = true;
          hasMoved = false;
          drawer.classList.add('is-dragging');
          dragStartY = (e.touches ? e.touches[0].clientY : e.clientY);
          collapsedOffset = getCollapsedOffset();
          drawerStartTransform = readCurrentTransformY();
        }

        function onMove(e) {
          if (!isDragging) return;
          var y = (e.touches ? e.touches[0].clientY : e.clientY);
          var deltaY = y - dragStartY;
          if (!hasMoved && Math.abs(deltaY) >= DRAG_THRESHOLD_PX) {
            hasMoved = true;
          }
          if (!hasMoved) return; /* tap-in-progress, no transform write yet */
          var next = Math.max(0, Math.min(collapsedOffset, drawerStartTransform + deltaY));
          drawer.style.transform = 'translateY(' + next + 'px)';
          if (e.cancelable) e.preventDefault();
        }

        function onEnd() {
          if (!isDragging) return;
          isDragging = false;
          drawer.classList.remove('is-dragging');

          if (!hasMoved) {
            /* Tap, not a drag — clear any inline transform and let the
               element's own click handler (set below) flip state. */
            drawer.style.transform = '';
            return;
          }

          /* Drag finished. Snap to whichever state is nearer to the
             drawer's current Y midpoint. CSS transition handles the
             animation since .is-dragging was removed above. */
          var current = drawer.getBoundingClientRect().top;
          var viewportH = window.innerHeight;
          var drawerH = drawer.getBoundingClientRect().height;
          var expandedTop = viewportH - drawerH;
          var collapsedTop = viewportH - (parseFloat(getComputedStyle(section).getPropertyValue('--pc-drawer-peek-h')) || 140);
          var midpoint = (expandedTop + collapsedTop) / 2;

          drawer.style.transform = '';
          setExpanded(current < midpoint);
        }

        function wireTouch(el) {
          if (!el) return;
          el.addEventListener('touchstart', onStart, { passive: false });
          el.addEventListener('touchmove', onMove, { passive: false });
          el.addEventListener('touchend', onEnd);
          el.addEventListener('touchcancel', onEnd);
        }

        function wireMouse(el) {
          if (!el) return;
          el.addEventListener('mousedown', function(e) {
            onStart(e);
            var moveHandler = function(ev) { onMove(ev); };
            var upHandler = function() {
              onEnd();
              document.removeEventListener('mousemove', moveHandler);
              document.removeEventListener('mouseup', upHandler);
            };
            document.addEventListener('mousemove', moveHandler);
            document.addEventListener('mouseup', upHandler);
          });
        }

        wireTouch(handle);
        wireMouse(handle);
        wireTouch(peek);
        wireMouse(peek);

        /* Click semantics — only fire when the gesture was a tap, not
           a drag. The browser fires click after touchend automatically
           when no significant movement occurred; we use hasMoved as a
           guard (set from inside onMove) so a release after a drag
           doesn't also toggle state. */
        if (handle) {
          handle.addEventListener('click', function(e) {
            if (hasMoved) { e.stopPropagation(); hasMoved = false; return; }
            setExpanded(!drawer.classList.contains('is-expanded'));
          });
        }
        if (peek) {
          peek.addEventListener('click', function(e) {
            if (hasMoved) { e.stopPropagation(); hasMoved = false; return; }
            if (!drawer.classList.contains('is-expanded')) {
              setExpanded(true);
            }
          });
        }
      }

      /* ── Description dropdown smooth open/close ──
         Native <details> doesn't animate, and even when CSS animates
         the [open] toggle the close path is jarring because the
         attribute removes synchronously. Intercept the summary click
         here, prevent default, and drive a height transition between
         0 and the wrap's scrollHeight before flipping the attribute.
         The CSS sets transition:height on .pc__description-wrap; we
         only need to write the start/end values and clean up after
         transitionend so the wrap returns to natural sizing (= no
         locked height that would clip if the content resized later). */
      section.querySelectorAll('[data-pc-details]').forEach(function(details) {
        var summary = details.querySelector('summary');
        var wrap = details.querySelector('[data-pc-details-wrap]');
        if (!summary || !wrap) return;
        /* Initial state: closed = explicit 0 so the first open can
           animate from 0 → measured height. If Liquid renders with
           [open] for some reason, leave height natural. */
        if (!details.hasAttribute('open')) {
          wrap.style.height = '0px';
        }
        summary.addEventListener('click', function(e) {
          e.preventDefault();
          var isOpen = details.hasAttribute('open');
          if (isOpen) {
            /* CLOSE — lock current height, force reflow, drop to 0 */
            wrap.style.height = wrap.scrollHeight + 'px';
            void wrap.offsetHeight;
            wrap.style.height = '0px';
            wrap.addEventListener('transitionend', function onEnd() {
              details.removeAttribute('open');
              wrap.removeEventListener('transitionend', onEnd);
            }, { once: false });
          } else {
            /* OPEN — flip the attribute so content is in the box, set
               height:0 first (matches the closed state), force reflow,
               then animate to scrollHeight. Clear the inline height
               on transitionend so the wrap reflows naturally if the
               content resizes later (font load, etc). */
            details.setAttribute('open', '');
            wrap.style.height = '0px';
            void wrap.offsetHeight;
            wrap.style.height = wrap.scrollHeight + 'px';
            wrap.addEventListener('transitionend', function onEnd() {
              wrap.style.height = '';
              wrap.removeEventListener('transitionend', onEnd);
            }, { once: false });
          }
        });
      });

      /* ── Auto-measure peek height + reserve page-bottom space ──
         Reads the live rendered height of (handle + peek row) and
         overwrites --pc-drawer-peek-h with that exact value, so the
         drawer translates by exactly the visible content amount and
         the drawer-content below is fully hidden when collapsed —
         regardless of font scale, eyebrow length, or title wrap.

         Also reserves matching space at the bottom of the document
         so the user can scroll the page far enough that any content
         normally hidden behind the fixed drawer (footer, related
         products, etc.) shifts above the drawer's top edge. Without
         this, the last ~peek-height pixels of the page would be
         permanently obscured.

         Re-runs on resize and after web fonts settle. Only adds the
         bottom-padding reservation on mobile widths — desktop has
         no drawer to overlap. */
      /* Drawer is now an inline block — no peek-height measurement
         needed, no document.body padding reservation needed. The
         --pc-drawer-peek-h CSS variable isn't read anywhere in the
         stylesheet anymore so leaving it unset is fine. */
      if (false && drawer) {
        var handleEl = drawer.querySelector('[data-pc-drawer-handle]');
        var peekEl = drawer.querySelector('.pc__drawer-peek');
        function updatePeekHeight() {
          if (!handleEl || !peekEl) return;
          var measured = handleEl.offsetHeight + peekEl.offsetHeight;
          section.style.setProperty('--pc-drawer-peek-h', measured + 'px');
          if (window.matchMedia('(max-width: 1023px)').matches) {
            document.body.style.paddingBottom = measured + 'px';
          } else {
            document.body.style.paddingBottom = '';
          }
        }
        updatePeekHeight();
        window.addEventListener('resize', updatePeekHeight);
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(updatePeekHeight);
        }
      }
      /* Clean up any padding-bottom the previous version of the
         page might have set on document.body before this section
         re-initialized (e.g. theme editor reload). */
      document.body.style.paddingBottom = '';

    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init when a section reloads */
    document.addEventListener('shopify:section:load', function(e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-images"] && !Shopify.designMode) return;
  try {
    
// Mirror of product-grid.liquid's JS block. Necessary because Shopify
// only loads a section's `{% javascript %}` bundle when that section is
// rendered on the page — so on pages that have product-grid-images but
// not product-grid, the shared handlers were missing. All handlers
// guard against double-binding via window._pgToolbarDelegated and
// per-element data-* init flags, so when both sections coexist on a
// page the bundles execute twice safely.
(function() {

  // ── Pure event delegation — safe to run multiple times ────────────────
  // One click handler on document. Global flag ensures it's only registered once
  // even if this code runs from multiple section bundles simultaneously.

  function openFilterDrawer(drawer, overlay) {
    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeFilterDrawer(drawer, overlay) {
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  function pgLoadShopifyFiltersIntoDrawer(form) {
    if (!form) return;
    if (form.dataset.pgClientsideFilter !== 'true') return;
    var loaded = form.dataset.pgShopifyFiltersLoaded;
    if (loaded === 'true' || loaded === 'pending') return;
    var collectionUrl = form.dataset.collectionUrl;
    if (!collectionUrl) return;

    form.dataset.pgShopifyFiltersLoaded = 'pending';
    fetch(collectionUrl, { credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sourceForm = doc.querySelector('[data-pg-filter-form]');
        if (!sourceForm) { form.dataset.pgShopifyFiltersLoaded = ''; return; }
        form.innerHTML = sourceForm.innerHTML;
        form.dataset.pgShopifyFiltersLoaded = 'true';
        form.dataset.pgRedirectOnApply = 'true';
        form.querySelectorAll('.pg-filter-section').forEach(function(sec) {
          var badge = sec.querySelector('.pg-filter-section__count');
          if (badge) {
            var n = sec.querySelectorAll('input:checked').length;
            badge.textContent = n > 0 ? n : '';
            badge.classList.toggle('is-active', n > 0);
          }
        });
        var sectionEl = form.closest('[id^="shopify-section-"]');
        if (sectionEl) {
          var sid = sectionEl.id.replace('shopify-section-', '');
          var total = form.querySelectorAll('input[name^="filter."]:checked').length;
          var totalBadge = document.getElementById('pg-filter-total-' + sid);
          if (totalBadge) {
            totalBadge.textContent = total > 0 ? total : '';
            totalBadge.classList.toggle('is-active', total > 0);
          }
        }
      })
      .catch(function() { form.dataset.pgShopifyFiltersLoaded = ''; });
  }

  function pgBaseColor(name) {
    var v = (name || '').toLowerCase();
    if (v.indexOf('multi') !== -1 || v.indexOf('rainbow') !== -1) return 'multi';
    if (v.indexOf('off-white') !== -1 || v.indexOf('ivory') !== -1 || v.indexOf('cream') !== -1 || v.indexOf('eggshell') !== -1 || v.indexOf('pearl') !== -1) return 'white';
    if (v.indexOf('charcoal') !== -1 || v.indexOf('graphite') !== -1 || v.indexOf('gunmetal') !== -1) return 'gray';
    if (v.indexOf('gray') !== -1 || v.indexOf('grey') !== -1 || v.indexOf('silver') !== -1 || v.indexOf('slate') !== -1 || v.indexOf('ash') !== -1 || v.indexOf('pewter') !== -1) return 'gray';
    if (v.indexOf('black') !== -1 || v.indexOf('jet') !== -1 || v.indexOf('onyx') !== -1 || v.indexOf('ebony') !== -1) return 'black';
    if (v.indexOf('white') !== -1 || v.indexOf('chalk') !== -1) return 'white';
    if (v.indexOf('pink') !== -1 || v.indexOf('rose') !== -1 || v.indexOf('blush') !== -1 || v.indexOf('fuchsia') !== -1 || v.indexOf('salmon') !== -1 || v.indexOf('magenta') !== -1) return 'pink';
    if (v.indexOf('burgundy') !== -1 || v.indexOf('maroon') !== -1 || v.indexOf('wine') !== -1 || v.indexOf('crimson') !== -1 || v.indexOf('scarlet') !== -1 || v.indexOf('ruby') !== -1 || v.indexOf('cherry') !== -1) return 'red';
    if (v.indexOf('red') !== -1) return 'red';
    if (v.indexOf('rust') !== -1 || v.indexOf('terracotta') !== -1 || v.indexOf('copper') !== -1) return 'orange';
    if (v.indexOf('orange') !== -1 || v.indexOf('peach') !== -1 || v.indexOf('coral') !== -1 || v.indexOf('apricot') !== -1) return 'orange';
    if (v.indexOf('mustard') !== -1 || v.indexOf('gold') !== -1 || v.indexOf('amber') !== -1) return 'yellow';
    if (v.indexOf('yellow') !== -1 || v.indexOf('lemon') !== -1) return 'yellow';
    if (v.indexOf('olive') !== -1 || v.indexOf('forest') !== -1 || v.indexOf('sage') !== -1 || v.indexOf('mint') !== -1 || v.indexOf('lime') !== -1 || v.indexOf('emerald') !== -1 || v.indexOf('jade') !== -1 || v.indexOf('teal') !== -1) return 'green';
    if (v.indexOf('green') !== -1) return 'green';
    if (v.indexOf('turquoise') !== -1 || v.indexOf('aqua') !== -1 || v.indexOf('cyan') !== -1) return 'blue';
    if (v.indexOf('navy') !== -1 || v.indexOf('royal') !== -1 || v.indexOf('azure') !== -1 || v.indexOf('cobalt') !== -1 || v.indexOf('denim') !== -1 || v.indexOf('indigo') !== -1 || v.indexOf('cerulean') !== -1 || v.indexOf('sapphire') !== -1 || v.indexOf('midnight') !== -1) return 'blue';
    if (v.indexOf('blue') !== -1) return 'blue';
    if (v.indexOf('lavender') !== -1 || v.indexOf('lilac') !== -1 || v.indexOf('plum') !== -1 || v.indexOf('aubergine') !== -1 || v.indexOf('eggplant') !== -1 || v.indexOf('mauve') !== -1) return 'purple';
    if (v.indexOf('purple') !== -1 || v.indexOf('violet') !== -1) return 'purple';
    if (v.indexOf('tan') !== -1 || v.indexOf('beige') !== -1 || v.indexOf('khaki') !== -1 || v.indexOf('taupe') !== -1 || v.indexOf('camel') !== -1 || v.indexOf('chocolate') !== -1 || v.indexOf('mocha') !== -1 || v.indexOf('caramel') !== -1 || v.indexOf('sand') !== -1 || v.indexOf('nude') !== -1 || v.indexOf('bronze') !== -1) return 'brown';
    if (v.indexOf('brown') !== -1) return 'brown';
    return v.replace(/\s+/g, '');
  }

  function pgIsKnownBaseColor(s) {
    return s === 'multi' || s === 'white' || s === 'gray' || s === 'black' ||
           s === 'pink' || s === 'red' || s === 'orange' || s === 'yellow' ||
           s === 'green' || s === 'blue' || s === 'purple' || s === 'brown';
  }
  function pgGetCheckedColorValues(form) {
    if (!form) return [];
    var values = [];
    var all = Array.prototype.slice.call(form.querySelectorAll('input:checked'));
    all.forEach(function(input) {
      if (!input.value) return;
      var isColor = false;
      if (input.closest('.pg-filter-section--color')) isColor = true;
      else if (input.closest('.pg-filter-color-item')) isColor = true;
      else {
        var n = (input.name || '').toLowerCase();
        if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 || n.indexOf('couleur') !== -1 || n.indexOf('farbe') !== -1 || n.indexOf('kleur') !== -1) {
          isColor = true;
        } else if (pgIsKnownBaseColor(pgBaseColor(input.value))) {
          isColor = true;
        }
      }
      if (!isColor) return;
      var item = input.closest('.pg-filter-color-item') || input.closest('label');
      var nameSpan = item && item.querySelector('.pg-filter-color-name');
      var label = nameSpan && nameSpan.textContent ? nameSpan.textContent.trim() : '';
      values.push(label || input.value);
    });
    return values;
  }

  function pgFindSwatchForColor(card, color) {
    var lower = (color || '').toLowerCase();
    var target = pgBaseColor(color);
    var swatches = card.querySelectorAll('.product-card__swatch[data-color]');
    var i;
    for (i = 0; i < swatches.length; i++) {
      if ((swatches[i].dataset.color || '').toLowerCase() === lower) return swatches[i];
    }
    for (i = 0; i < swatches.length; i++) {
      if (pgBaseColor(swatches[i].dataset.color) === target) return swatches[i];
    }
    return null;
  }

  function pgApplyActiveColorToCard(card, color) {
    card.dataset.pgActiveColor = color;
    card.querySelectorAll('.product-card__swatch').forEach(function(s) {
      s.style.order = '';
      s.classList.remove('is-preview-active');
    });
    var matchingSwatch = pgFindSwatchForColor(card, color);
    if (matchingSwatch) {
      matchingSwatch.style.order = '-1';
      matchingSwatch.classList.add('is-preview-active');
    }
    var w = card.querySelector('.product-card__image-wrapper');
    if (w && w._pgShowColor) w._pgShowColor(color);
  }

  function pgCloneCardForColor(originalCard, color, prodSec) {
    var clone = originalCard.cloneNode(true);
    clone.dataset.pgClone = '1';
    var cw = clone.querySelector('.product-card__image-wrapper');
    if (cw) cw.removeAttribute('data-nav-init');
    if (prodSec && prodSec._pgInitCardNav && cw) prodSec._pgInitCardNav(cw);
    pgApplyActiveColorToCard(clone, color);
    return clone;
  }

  function pgClearColorFilterState(sectionEl) {
    sectionEl.querySelectorAll('.product-card[data-pg-clone="1"]').forEach(function(c) { c.remove(); });
    sectionEl.querySelectorAll('.product-card').forEach(function(card) {
      delete card.dataset.pgActiveColor;
      card.querySelectorAll('.product-card__swatch').forEach(function(s) {
        s.style.order = '';
        s.classList.remove('is-preview-active');
      });
    });
  }

  function pgRecomputeToolbarActive(sectionEl) {
    try {
      if (!sectionEl) return;
      var prodSec = sectionEl.querySelector && sectionEl.querySelector('.product-grid-section');
      if (!prodSec) return;

      var active = false;

      var form = sectionEl.querySelector('[data-pg-filter-form]');
      if (form) {
        if (form.querySelectorAll('input[name^="filter."]:checked, input[name^="cs_"]:checked').length > 0) {
          active = true;
        }
        if (!active) {
          var pmin = form.querySelector('input[name="cs_price_min"], input[name="filter.v.price.gte"]');
          var pmax = form.querySelector('input[name="cs_price_max"], input[name="filter.v.price.lte"]');
          if ((pmin && pmin.value !== '') || (pmax && pmax.value !== '')) active = true;
        }
      }

      if (!active) {
        try {
          if (new URLSearchParams(window.location.search).get('sort_by')) active = true;
        } catch (e) {}
      }

      if (!active && prodSec.dataset.pgViewChanged === 'true') active = true;
      if (!active && prodSec.dataset.pgSortChanged === 'true') active = true;

      prodSec.classList.toggle('is-toolbar-active', active);
    } catch (e) {
      if (window.console && console.warn) console.warn('pgRecomputeToolbarActive:', e);
    }
  }

  function pgApplyColorFilterState(sectionEl, selectedColors) {
    var prodSec = sectionEl.querySelector('.product-grid-section') || sectionEl;
    pgClearColorFilterState(sectionEl);
    if (!selectedColors || selectedColors.length === 0) {
      sectionEl.querySelectorAll('.product-card').forEach(function(card) {
        var w = card.querySelector('.product-card__image-wrapper');
        if (w && w._pgResetColor) w._pgResetColor();
      });
      return;
    }
    var cards = Array.prototype.slice.call(sectionEl.querySelectorAll('.product-card'));
    cards.forEach(function(card) {
      if (card.style.display === 'none') return;
      if (card.dataset.pgClone === '1') return;
      var cardOptColor = card.getAttribute('data-opt-color') || '';
      if (!cardOptColor) {
        var attrs = card.attributes;
        for (var a = 0; a < attrs.length; a++) {
          var attrName = attrs[a].name;
          if (attrName.indexOf('data-opt-') === 0) {
            var val = attrs[a].value || '';
            if (val.indexOf('|') !== -1) cardOptColor += val;
          }
        }
      }
      if (!cardOptColor) {
        var sw = card.querySelectorAll('.product-card__swatch[data-color]');
        var parts = ['|'];
        for (var s = 0; s < sw.length; s++) {
          parts.push(pgBaseColor(sw[s].dataset.color || ''));
          parts.push('|');
          var raw = (sw[s].dataset.color || '').toLowerCase().replace(/\s+/g, '');
          parts.push(raw);
          parts.push('|');
        }
        cardOptColor = parts.join('');
      }
      var matching = [];
      selectedColors.forEach(function(c) {
        var base = pgBaseColor(c);
        var rawLower = (c || '').toLowerCase().replace(/\s+/g, '');
        if (cardOptColor.indexOf('|' + rawLower + '|') !== -1 || cardOptColor.indexOf('|' + base + '|') !== -1) {
          matching.push(c);
        }
      });
      if (matching.length === 0) matching = [selectedColors[0]];
      pgApplyActiveColorToCard(card, matching[0]);
      var insertAfter = card;
      for (var i = 1; i < matching.length; i++) {
        var clone = pgCloneCardForColor(card, matching[i], prodSec);
        insertAfter.parentNode.insertBefore(clone, insertAfter.nextSibling);
        insertAfter = clone;
      }
    });
  }

  function fetchFilteredGrid(sectionEl, sectionId, overrideUrl) {
    var container = sectionEl.querySelector('.pg-ajax-container');
    var drawer    = document.getElementById('pg-filter-drawer-' + sectionId);
    var form      = document.getElementById('pg-filter-form-' + sectionId);
    if (!container) return;

    var url;
    if (overrideUrl) {
      url = overrideUrl;
    } else if (form) {
      var collectionUrl = form.dataset.collectionUrl || form.getAttribute('action');
      var data = new FormData(form);
      var params = new URLSearchParams();
      data.forEach(function(v, k) {
        if (k === 'page') return;
        if (v === '' || v == null) return;
        params.append(k, v);
      });
      url = collectionUrl + (params.toString() ? '?' + params.toString() : '');
    } else {
      return;
    }

    container.style.transition = 'opacity 0.2s ease';
    container.style.opacity = '0.35';

    fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId)
      .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContainer = doc.querySelector('.pg-ajax-container');
        if (newContainer) container.innerHTML = newContainer.innerHTML;
        var newForm = doc.getElementById('pg-filter-form-' + sectionId);
        if (newForm && form) form.innerHTML = newForm.innerHTML;
        var totalBadge = document.getElementById('pg-filter-total-' + sectionId);
        if (totalBadge && form) {
          var total = form.querySelectorAll('input[name^="filter."]:checked').length;
          totalBadge.textContent = total > 0 ? total : '';
          totalBadge.classList.toggle('is-active', total > 0);
        }
        history.pushState({}, '', url);
        var prodSec = sectionEl.querySelector('.product-grid-section');
        if (prodSec && prodSec._pgInitCardNav) {
          prodSec.querySelectorAll('.product-card__image-wrapper').forEach(prodSec._pgInitCardNav);
        }
        if (form) {
          pgApplyColorFilterState(sectionEl, pgGetCheckedColorValues(form));
        }
        pgRecomputeToolbarActive(sectionEl);
        container.style.opacity = '1';
      })
      .catch(function() { window.location.href = url; });
  }

  function applyClientsideFilters(sectionEl, form) {
    var sectionId = sectionEl.id.replace('shopify-section-', '');
    var toArr = function(nl){ return Array.prototype.slice.call(nl); };

    var avail   = toArr(form.querySelectorAll('input[name="cs_avail"]:checked')).map(function(i){ return i.value; });
    var types   = toArr(form.querySelectorAll('input[name="cs_type"]:checked')).map(function(i){ return i.value; });
    var vendors = toArr(form.querySelectorAll('input[name="cs_vendor"]:checked')).map(function(i){ return i.value; });

    var priceMinInput = form.querySelector('input[name="cs_price_min"]');
    var priceMaxInput = form.querySelector('input[name="cs_price_max"]');
    var priceMin = priceMinInput && priceMinInput.value !== '' ? parseFloat(priceMinInput.value) : null;
    var priceMax = priceMaxInput && priceMaxInput.value !== '' ? parseFloat(priceMaxInput.value) : null;
    if (isNaN(priceMin)) priceMin = null;
    if (isNaN(priceMax)) priceMax = null;

    var optionFilters = {};
    toArr(form.querySelectorAll('input[name^="cs_opt_"]:checked')).forEach(function(input) {
      var key = input.name.replace('cs_opt_', '');
      if (!optionFilters[key]) optionFilters[key] = [];
      optionFilters[key].push(input.value);
    });

    var cards = sectionEl.querySelectorAll('.product-card');
    cards.forEach(function(card) {
      var show = true;
      if (avail.length) {
        var isAvail = card.dataset.available === 'true';
        var wantIn  = avail.indexOf('in-stock') !== -1;
        var wantOut = avail.indexOf('out-of-stock') !== -1;
        if (wantIn && !wantOut && !isAvail) show = false;
        else if (wantOut && !wantIn && isAvail) show = false;
      }
      if (show && (priceMin !== null || priceMax !== null)) {
        var price = parseInt(card.dataset.price || '0', 10) / 100;
        if (priceMin !== null && price < priceMin) show = false;
        if (show && priceMax !== null && price > priceMax) show = false;
      }
      if (show && types.length && types.indexOf(card.dataset.type || '') === -1) show = false;
      if (show && vendors.length && vendors.indexOf(card.dataset.vendor || '') === -1) show = false;
      if (show) {
        for (var key in optionFilters) {
          if (!optionFilters.hasOwnProperty(key)) continue;
          var selected = optionFilters[key];
          var cardValues = (card.getAttribute('data-opt-' + key) || '').split('|').filter(Boolean);
          if (!selected.some(function(v){ return cardValues.indexOf(v) !== -1; })) {
            show = false;
            break;
          }
        }
      }
      card.style.display = show ? '' : 'none';
    });

    pgApplyColorFilterState(sectionEl, pgGetCheckedColorValues(form));

    form.querySelectorAll('[data-filter-count]').forEach(function(badge) {
      var name = badge.dataset.filterCount;
      var n;
      if (name === 'cs_price') {
        n = (priceMin !== null ? 1 : 0) + (priceMax !== null ? 1 : 0);
      } else {
        n = form.querySelectorAll('input[name="' + name + '"]:checked').length;
      }
      badge.textContent = n > 0 ? n : '';
      badge.classList.toggle('is-active', n > 0);
    });

    var total = avail.length + types.length + vendors.length;
    total += toArr(form.querySelectorAll('input[name^="cs_opt_"]:checked')).length;
    if (priceMin !== null) total++;
    if (priceMax !== null) total++;
    var totalBadge = document.getElementById('pg-filter-total-' + sectionId);
    if (totalBadge) {
      totalBadge.textContent = total > 0 ? total : '';
      totalBadge.classList.toggle('is-active', total > 0);
    }
  }

  if (!window._pgToolbarDelegated) {
    window._pgToolbarDelegated = true;

    document.addEventListener('click', function(e) {
      var sectionEl = e.target.closest('[id^="shopify-section-"]');
      var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;

      var swatch = e.target.closest('.product-card__swatch[data-color]');
      if (swatch) {
        var pgSection = swatch.closest('.product-grid-section');
        var swatchMode = pgSection ? pgSection.dataset.swatchMode : 'off';
        var card = swatch.closest('.product-card');
        if (swatchMode === 'click' && window.innerWidth >= 1200) {
          e.preventDefault();
          e.stopPropagation();
          var wrapper = card && card.querySelector('.product-card__image-wrapper');
          var isActive = swatch.classList.contains('is-preview-active');
          card.querySelectorAll('.product-card__swatch.is-preview-active').forEach(function(s) {
            s.classList.remove('is-preview-active');
          });
          var imgLink = card.querySelector('.product-card__image-link');
          if (!imgLink.dataset.baseUrl) imgLink.dataset.baseUrl = imgLink.href;
          if (isActive) {
            if (wrapper && wrapper._pgResetColor) wrapper._pgResetColor();
            if (wrapper && wrapper._pgSyncButtons) wrapper._pgSyncButtons(null);
            if (imgLink) imgLink.href = imgLink.dataset.baseUrl;
          } else {
            swatch.classList.add('is-preview-active');
            if (wrapper && wrapper._pgShowColor) wrapper._pgShowColor(swatch.dataset.color);
            if (wrapper && wrapper._pgSyncButtons) wrapper._pgSyncButtons(swatch.dataset.variantId);
            if (imgLink) imgLink.href = swatch.dataset.variantId ? imgLink.dataset.baseUrl + '?variant=' + swatch.dataset.variantId : imgLink.dataset.baseUrl;
          }
          return;
        } else if (swatchMode === 'click' && window.innerWidth < 1200) {
          e.preventDefault();
          e.stopPropagation();
          var url = swatch.dataset.productUrl || '';
          var variantId = swatch.dataset.variantId || '';
          if (url) window.location.href = variantId ? url + '?variant=' + variantId : url;
          return;
        }
      }

      var viewBtn = e.target.closest('.pg-view-by__btn');
      if (viewBtn) {
        var sec = viewBtn.closest('[id^="shopify-section-"]');
        if (sec) {
          var grid = sec.querySelector('.product-grid');
          if (grid) grid.style.gridTemplateColumns = 'repeat(' + viewBtn.dataset.cols + ', 1fr)';
          viewBtn.closest('.pg-view-by').querySelectorAll('.pg-view-by__btn').forEach(function(b) {
            b.classList.toggle('pg-view-by__btn--active', b === viewBtn);
          });
          var prodSec = sec.querySelector('.product-grid-section');
          if (prodSec) prodSec.dataset.pgViewChanged = 'true';
          pgRecomputeToolbarActive(sec);
        }
        return;
      }

      var sortBtn = e.target.closest('.pg-sort-btn');
      if (sortBtn) {
        e.stopPropagation();
        var panel = sortBtn.nextElementSibling;
        var isOpen = sortBtn.getAttribute('aria-expanded') === 'true';
        sortBtn.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
        return;
      }

      var sortOpt = e.target.closest('.pg-sort-option');
      if (sortOpt) {
        var sec = sortOpt.closest('[id^="shopify-section-"]');
        if (!sec) return;
        var grid = sec.querySelector('.product-grid');
        if (!grid) return;
        var sortValue = sortOpt.dataset.sortValue;
        sortOpt.closest('.pg-sort-panel').hidden = true;
        var sb = sec.querySelector('.pg-sort-btn');
        if (sb) sb.setAttribute('aria-expanded', 'false');
        sec.querySelectorAll('.pg-sort-option').forEach(function(o) {
          o.classList.toggle('pg-sort-option--active', o === sortOpt);
        });
        var cards = Array.from(grid.querySelectorAll('.product-card'));
        cards.sort(function(a, b) {
          var pa = parseInt(a.dataset.price || '0', 10);
          var pb = parseInt(b.dataset.price || '0', 10);
          return sortValue === 'price-ascending' ? pa - pb : pb - pa;
        });
        grid.style.opacity = '0.4';
        grid.style.transition = 'opacity 0.2s';
        setTimeout(function() {
          cards.forEach(function(c, i) {
            c.style.order = i + 1;
          });
          grid.style.opacity = '1';
        }, 200);
        var prodSec = sec.querySelector('.product-grid-section');
        if (prodSec) prodSec.dataset.pgSortChanged = 'true';
        pgRecomputeToolbarActive(sec);
        return;
      }

      var filterBtn = e.target.closest('.pg-filter-btn');
      if (filterBtn) {
        e.stopPropagation();
        var sec = filterBtn.closest('[id^="shopify-section-"]');
        if (!sec) return;
        var sid = sec.id.replace('shopify-section-', '');
        var drawer = document.getElementById('pg-filter-drawer-' + sid);
        var overlay = document.getElementById('pg-filter-overlay-' + sid);
        if (drawer) openFilterDrawer(drawer, overlay);
        // Shopify filter injection intentionally disabled — keeps the
        // drawer using the section's own client-side facets so Apply
        // can filter cards in-place instead of redirecting to the
        // collection page.
        return;
      }

      var closeBtn = e.target.closest('.pg-filter-drawer__close');
      if (closeBtn) {
        var drawer = closeBtn.closest('.pg-filter-drawer');
        var sec = closeBtn.closest('[id^="shopify-section-"]');
        if (!sec) return;
        var sid = sec.id.replace('shopify-section-', '');
        var overlay = document.getElementById('pg-filter-overlay-' + sid);
        closeFilterDrawer(drawer, overlay);
        return;
      }

      if (e.target.classList.contains('pg-filter-overlay')) {
        var sid = e.target.id.replace('pg-filter-overlay-', '');
        var drawer = document.getElementById('pg-filter-drawer-' + sid);
        closeFilterDrawer(drawer, e.target);
        return;
      }

      var filterToggle = e.target.closest('.pg-filter-section__header');
      if (filterToggle) {
        var body = filterToggle.nextElementSibling;
        var isOpen = filterToggle.classList.contains('pg-filter-section__header--open');
        var drawer = filterToggle.closest('.pg-filter-drawer');
        if (!drawer || !body) return;
        drawer.querySelectorAll('.pg-filter-section__header').forEach(function(h) {
          h.classList.remove('pg-filter-section__header--open');
          if (h.nextElementSibling) h.nextElementSibling.classList.remove('is-open');
        });
        if (!isOpen) {
          filterToggle.classList.add('pg-filter-section__header--open');
          body.classList.add('is-open');
        }
        return;
      }

      var resetBtn = e.target.closest('.pg-filter-reset');
      if (resetBtn) {
        var sec = resetBtn.closest('[id^="shopify-section-"]');
        if (!sec) return;
        e.preventDefault();
        var sid = sec.id.replace('shopify-section-', '');
        var form = document.getElementById('pg-filter-form-' + sid);
        if (form) form.querySelectorAll('input[name^="filter."], input[name^="cs_"]').forEach(function(cb) {
          if (cb.type === 'checkbox' || cb.type === 'radio') cb.checked = false;
          else cb.value = '';
        });
        if (form && form.dataset.pgRedirectOnApply === 'true') {
          var target = form.dataset.collectionUrl || form.getAttribute('action') || '';
          if (target) { window.location.href = target; return; }
        }
        if (form && form.dataset.pgClientsideFilter === 'true') {
          applyClientsideFilters(sec, form);
        } else {
          fetchFilteredGrid(sec, sid);
        }
        pgRecomputeToolbarActive(sec);
        return;
      }

      var applyBtn = e.target.closest('.pg-filter-apply');
      if (applyBtn) {
        var sec = applyBtn.closest('[id^="shopify-section-"]');
        if (!sec) return;
        var sid = sec.id.replace('shopify-section-', '');
        var form = document.getElementById('pg-filter-form-' + sid);
        if (form && form.dataset.pgRedirectOnApply === 'true') {
          var data = new FormData(form);
          var params = new URLSearchParams();
          data.forEach(function(v, k) {
            if (k === 'page') return;
            if (v === '' || v == null) return;
            params.append(k, v);
          });
          var target = (form.dataset.collectionUrl || form.getAttribute('action') || '');
          if (target) {
            window.location.href = target + (params.toString() ? '?' + params.toString() : '');
            return;
          }
        }
        if (form && form.dataset.pgClientsideFilter === 'true') {
          applyClientsideFilters(sec, form);
        } else {
          fetchFilteredGrid(sec, sid);
        }
        pgRecomputeToolbarActive(sec);
        var drawer = document.getElementById('pg-filter-drawer-' + sid);
        var overlay = document.getElementById('pg-filter-overlay-' + sid);
        closeFilterDrawer(drawer, overlay);
        return;
      }

      document.querySelectorAll('.pg-sort-panel').forEach(function(p) { p.hidden = true; });
      document.querySelectorAll('.pg-sort-btn').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.pg-filter-drawer[aria-hidden="false"]').forEach(function(drawer) {
        var sid = drawer.id.replace('pg-filter-drawer-', '');
        var overlay = document.getElementById('pg-filter-overlay-' + sid);
        closeFilterDrawer(drawer, overlay);
      });
    });
  }

  window.addEventListener('popstate', function() {
    var sectionEl = document.getElementById('shopify-section-{{ section.id }}');
    if (!sectionEl) return;
    var form = document.getElementById('pg-filter-form-{{ section.id }}');
    if (!form) return;
    fetchFilteredGrid(sectionEl, '{{ section.id }}', window.location.href);
  });

  (function() {
    function initStickyToolbars() {
      document.querySelectorAll('.pg-toolbar[data-sticky="true"]').forEach(function(toolbar) {
        if (toolbar._pgStickyInit) return;
        toolbar._pgStickyInit = true;
        var sectionId = toolbar.dataset.sectionId;
        var spacer = document.getElementById('pg-toolbar-spacer-' + sectionId);
        if (!spacer) return;
        var toolbarHeight = toolbar.offsetHeight;
        var toolbarTop = toolbar.getBoundingClientRect().top + window.scrollY;
        var isFixed = false;
        var ticking = false;
        var sectionEl = toolbar.closest('[id^="shopify-section-"]');
        spacer.style.height = toolbarHeight + 'px';
        function getStickyHeaderBottom() {
          var offset = 0;
          var hw = document.querySelector('.header-wrapper');
          var bar = document.getElementById('announcement-bar');
          if (hw && (hw.style.position === 'fixed' || getComputedStyle(hw).position === 'fixed')) offset = Math.max(offset, hw.getBoundingClientRect().bottom);
          if (bar && (bar.style.position === 'fixed' || getComputedStyle(bar).position === 'fixed')) offset = Math.max(offset, bar.getBoundingClientRect().bottom);
          return Math.round(offset);
        }
        function onScroll() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function() {
            var scrollY = window.scrollY;
            var stickyOffset = getStickyHeaderBottom();
            var pastSection = sectionEl && sectionEl.getBoundingClientRect().bottom <= stickyOffset + toolbarHeight;
            if (!pastSection && scrollY + stickyOffset >= toolbarTop && !isFixed) {
              isFixed = true; toolbar.classList.add('pg-toolbar--sticky'); toolbar.style.top = stickyOffset + 'px'; spacer.style.display = 'block';
            } else if ((scrollY + stickyOffset < toolbarTop || pastSection) && isFixed) {
              isFixed = false; toolbar.classList.remove('pg-toolbar--sticky'); toolbar.style.top = ''; spacer.style.display = 'none';
            } else if (isFixed) {
              toolbar.style.top = stickyOffset + 'px';
            }
            ticking = false;
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        document.addEventListener('shopify:section:load', function() { window.removeEventListener('scroll', onScroll); toolbar._pgStickyInit = false; });
      });
    }
    document.addEventListener('DOMContentLoaded', initStickyToolbars);
    document.addEventListener('shopify:section:load', initStickyToolbars);
  })();

  /* Shopify-filter preload disabled — see product-grid.liquid for the
     rationale. Keeps Apply doing client-side in-place filtering on
     non-collection pages instead of redirecting to the collection. */

})();

(function() {
  function initSection(root) {
    if (!root || root.dataset.cspInit === 'true') return;
    root.dataset.cspInit = 'true';

    var sectionId      = root.dataset.sectionId;
    var swatchPreviewMode = root.dataset.swatchMode || 'off';
    var hoverSecondImg = root.dataset.pgHoverSecondImage === 'true';
    var infoPosition   = root.dataset.pgInfoPosition || '';
    var mobileSwipe    = root.dataset.pgMobileSwipe === 'true';
    var ATC_STYLE_CART     = root.dataset.pgQaAtcStyle      || 'primary';
    var ATC_STYLE_WISHLIST = root.dataset.pgQaWishlistStyle || 'secondary';
    var cartType   = root.dataset.pgCartType      || 'drawer';
    var addAction  = root.dataset.pgCartAddAction || 'drawer';
    var MSG_SOLDOUT = root.dataset.pgMsgSoldout || 'This product is sold out.';
    var MSG_STOCK   = root.dataset.pgMsgStock   || 'Sorry, only %available% available and you already have %in_cart% in your cart.';
    var MSG_ADDED   = root.dataset.pgMsgAdded   || 'Your selection has been reserved.';

    var pgT = {
      addToCart:              root.dataset.pgI18nAddToCart        || 'Add to cart',
      addToWishlist:          root.dataset.pgI18nAddToWishlist    || 'Add to wishlist',
      removeFromList:         root.dataset.pgI18nRemoveFromList   || 'Remove from list',
      adding:                 root.dataset.pgI18nAdding           || 'Adding...',
      soldOut:                root.dataset.pgI18nSoldOut          || 'Sold out',
      unavailable:            root.dataset.pgI18nUnavailable      || 'Unavailable',
      errorStock:             root.dataset.pgI18nErrorStock       || '',
      errorGeneric:           root.dataset.pgI18nErrorGeneric     || 'Something went wrong. Please try again.',
      addToWishlistAria:      root.dataset.pgI18nAddToWishlistAria      || 'Add to wishlist',
      removeFromWishlistAria: root.dataset.pgI18nRemoveFromWishlistAria || 'Remove from wishlist'
    };

    var containerId = 'pg-ajax-container-' + sectionId;
    var sectionEl   = document.getElementById('shopify-section-' + sectionId);

    function handlePaginationClick(e) {
      if (!root.contains(e.target)) return;
      var link = e.target.closest('a.pg-pagination__item');
      if (!link) return;
      var container = document.getElementById(containerId);
      if (!container) return;

      e.preventDefault();
      e.stopPropagation();

      var url = link.href;
      container.style.transition = 'opacity 0.2s ease';
      container.style.opacity = '0';

      fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newContainer = doc.getElementById(containerId);
          if (!newContainer) { window.location.href = url; return; }
          container.innerHTML = newContainer.innerHTML;
          history.pushState({}, '', url);
          var section = container.closest('.product-grid-section');
          if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          container.style.opacity = '0';
          requestAnimationFrame(function() {
            container.style.transition = 'opacity 0.3s ease';
            container.style.opacity = '1';
          });
        })
        .catch(function() { window.location.href = url; });
    }
    document.addEventListener('click', handlePaginationClick);

    (function() {
      if (!sectionEl) return;
      function updateFilterCounts() {
        sectionEl.querySelectorAll('.pg-filter-section').forEach(function(sec) {
          var badge = sec.querySelector('.pg-filter-section__count');
          if (!badge) return;
          var checked = sec.querySelectorAll('input[name^="filter."]:checked').length;
          badge.textContent = checked > 0 ? checked : '';
          badge.classList.toggle('is-active', checked > 0);
        });
        var totalBadge = document.getElementById('pg-filter-total-' + sectionId);
        if (totalBadge) {
          var total = sectionEl.querySelectorAll('.pg-filter-drawer input[name^="filter."]:checked').length;
          totalBadge.textContent = total > 0 ? total : '';
          totalBadge.classList.toggle('is-active', total > 0);
        }
      }
      sectionEl.addEventListener('change', function(e) {
        if (e.target && e.target.name && e.target.name.indexOf('filter.') === 0) updateFilterCounts();
      });
    })();

    (function() {
      var drawer  = document.getElementById('pg-qa-drawer-' + sectionId);
      var overlay = document.getElementById('pg-qa-overlay-' + sectionId);
      if (!drawer) return;

      var titleEl   = drawer.querySelector('.pg-qa-drawer__product-title');
      var priceEl   = drawer.querySelector('.pg-qa-drawer__price');
      var imageEl   = drawer.querySelector('.pg-qa-drawer__image');
      var optionsEl = drawer.querySelector('.pg-qa-drawer__options');
      var atcBtn    = drawer.querySelector('.pg-qa-drawer__atc');
      var closeBtn  = drawer.querySelector('.pg-qa-drawer__close');

      function applyAtcStyle(mode) {
        atcBtn.dataset.buttonStyle = (mode === 'wishlist') ? ATC_STYLE_WISHLIST : ATC_STYLE_CART;
        atcBtn.dataset.qaMode = mode;
      }

      var currentVariants = [];
      var selectedOptions = {};
      var wishlistMode = false;
      var wishlistRemoveMode = false;
      var wishlistSourceBtn = null;
      var wishlistHandle = null;

      function showToast(msg, isError, btn) {
        if (!window.cartToast) return;
        var productImage = btn && btn.dataset ? (btn.dataset.productImage || '') : '';
        var productTitle = btn && btn.dataset ? (btn.dataset.productTitle || '') : '';
        window.cartToast.show({
          type:         isError ? 'error' : 'success',
          message:      msg,
          productImage: productImage,
          productTitle: productTitle,
          quantity:     1
        });
      }

      var cartQty = {};
      function refreshCartQty(cb) {
        fetch('/cart.js')
          .then(function(r){ return r.json(); })
          .then(function(cart){
            cartQty = {};
            cart.items.forEach(function(item){ cartQty[String(item.variant_id)] = item.quantity; });
            if (cb) cb();
          })
          .catch(function(){ if (cb) cb(); });
      }
      refreshCartQty();

      function openDrawer()  {
        drawer.setAttribute('aria-hidden','false');
        overlay.setAttribute('aria-hidden','false');
        document.body.style.overflow = 'hidden';
        if (wishlistRemoveMode) {
          atcBtn.textContent = pgT.removeFromList;
          atcBtn.classList.add('pg-qa-drawer__atc--wishlist');
          atcBtn.classList.add('pg-qa-drawer__atc--remove');
        } else if (wishlistMode) {
          atcBtn.textContent = pgT.addToWishlist;
          atcBtn.classList.add('pg-qa-drawer__atc--wishlist');
          atcBtn.classList.remove('pg-qa-drawer__atc--remove');
        } else {
          atcBtn.textContent = pgT.addToCart;
          atcBtn.classList.remove('pg-qa-drawer__atc--wishlist');
          atcBtn.classList.remove('pg-qa-drawer__atc--remove');
        }
      }
      function closeDrawer() {
        drawer.setAttribute('aria-hidden','true');
        overlay.setAttribute('aria-hidden','true');
        document.body.style.overflow = '';
        wishlistMode = false;
        wishlistRemoveMode = false;
        wishlistSourceBtn = null;
        wishlistHandle = null;
        atcBtn.textContent = pgT.addToCart;
        atcBtn.classList.remove('pg-qa-drawer__atc--wishlist');
        atcBtn.classList.remove('pg-qa-drawer__atc--remove');
        applyAtcStyle('cart');
      }

      function money(cents) {
        var n = (cents / 100).toFixed(2);
        var parts = n.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return '$ ' + parts.join('.');
      }

      function findVariant() {
        return currentVariants.find(function(v) {
          return v.options.every(function(opt, i) { return selectedOptions['o'+(i+1)] === opt; });
        }) || null;
      }

      function updateAtcBtn() {
        var v = findVariant();
        if (v && (wishlistMode || wishlistRemoveMode)) {
          var inWl = window.wishlistDrawer
            ? window.wishlistDrawer.isInWishlist(v.id)
            : (function() {
                try { return (JSON.parse(localStorage.getItem('wishlist_items')) || []).some(function(i) { return String(i.variantId) === String(v.id); }); }
                catch(e) { return false; }
              })();
          wishlistRemoveMode = inWl;
          wishlistMode = !inWl;
          atcBtn.classList.toggle('pg-qa-drawer__atc--remove', inWl);
        }
        if (!v) {
          atcBtn.textContent = wishlistRemoveMode ? pgT.removeFromList : (wishlistMode ? pgT.addToWishlist : pgT.unavailable);
          atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
          delete atcBtn.dataset.variantId;
        } else if (!v.available) {
          atcBtn.textContent = wishlistRemoveMode ? pgT.removeFromList : (wishlistMode ? pgT.addToWishlist : pgT.soldOut);
          atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
          atcBtn.dataset.variantId = v.id;
        } else {
          atcBtn.textContent = wishlistRemoveMode ? pgT.removeFromList : (wishlistMode ? pgT.addToWishlist : pgT.addToCart);
          atcBtn.disabled = false;
          atcBtn.dataset.variantId = v.id;
        }
        if (v) {
          priceEl.textContent = money(v.price);
          if (v.featured_image) imageEl.src = v.featured_image.src;
        }
        optionsEl.querySelectorAll('.pg-qa-option-btn, .pg-qa-color-btn').forEach(function(b) {
          var testKey = 'o' + b.dataset.pos;
          var test = Object.assign({}, selectedOptions);
          test[testKey] = b.dataset.value;
          var ok = currentVariants.some(function(v) {
            return v.options.every(function(o,i){ return test['o'+(i+1)]===o; });
          });
          b.classList.toggle('is-unavailable', !ok);
          var otherSelections = Object.assign({}, selectedOptions);
          delete otherSelections[testKey];
          var soldOut = !currentVariants.some(function(v) {
            return v.available && v.options[parseInt(b.dataset.pos, 10) - 1] === b.dataset.value &&
              Object.keys(otherSelections).every(function(k) {
                return otherSelections[k] === v.options[parseInt(k.slice(1), 10) - 1];
              });
          });
          b.classList.toggle('is-sold-out', soldOut);
        });
      }

      var swatchMap = {};
      function parseSwatchMap(card) {
        swatchMap = {};
        if (!card) return;
        (card.dataset.swatches || '').split('||').forEach(function(entry) {
          if (!entry) return;
          var parts = entry.split(':');
          var key  = parts[0];
          var type = parts[1];
          var val  = parts.slice(2).join(':');
          swatchMap[key] = { type: type, val: val };
        });
      }

      function getSwatchStyle(val) {
        if (!val) return null;
        var key = String(val).toLowerCase().replace(/\s/g, '');
        var s = swatchMap[key];
        if (s && s.type === 'image' && s.val) return { backgroundImage: 'url(' + s.val + ')', backgroundSize: 'cover' };
        if (s && s.type === 'color' && s.val) return { backgroundColor: s.val };
        var cssCandidate = String(val).toLowerCase().replace(/[\s\-_]/g, '');
        if (!cssCandidate) return null;
        var valid = false;
        if (typeof CSS !== 'undefined' && CSS.supports) {
          valid = CSS.supports('color', cssCandidate);
        } else {
          var tester = getSwatchStyle._tester || (getSwatchStyle._tester = document.createElement('div'));
          tester.style.backgroundColor = '';
          tester.style.backgroundColor = cssCandidate;
          valid = tester.style.backgroundColor !== '';
        }
        if (valid) return { backgroundColor: cssCandidate };
        return null;
      }

      function renderOptions(product, preselectId) {
        currentVariants = product.variants;
        selectedOptions = {};
        var hasRealVariants = product.variants.length > 1 ||
          (product.variants.length === 1 && product.variants[0].title !== 'Default Title');
        optionsEl.style.display = hasRealVariants ? '' : 'none';
        var first = product.variants[0];
        if (preselectId) {
          var preVariant = product.variants.find(function(v){ return String(v.id) === String(preselectId); });
          if (preVariant) first = preVariant;
        }
        if (!first) first = product.variants.find(function(v){ return v.available; }) || product.variants[0];
        product.options.forEach(function(name, i) { selectedOptions['o'+(i+1)] = first.options[i]; });

        optionsEl.innerHTML = '';
        product.options.forEach(function(optRaw, idx) {
          var optName = typeof optRaw === 'object' ? optRaw.name : optRaw;
          var pos = idx + 1;
          var vals = [];
          product.variants.forEach(function(v){ if (vals.indexOf(v.options[idx])===-1) vals.push(v.options[idx]); });
          var isColor = vals.some(function(v) { return !!getSwatchStyle(v); });
          var wrap  = document.createElement('div');  wrap.className = 'pg-qa-option';
          var label = document.createElement('p');    label.className = 'pg-qa-option__label';
          var selSpan = document.createElement('span'); selSpan.className = 'pg-qa-option__selected'; selSpan.textContent = selectedOptions['o'+pos];
          label.textContent = optName + ': '; label.appendChild(selSpan);
          var btns = document.createElement('div');
          btns.className = isColor ? 'pg-qa-option__btns pg-qa-option__btns--colors' : 'pg-qa-option__btns';
          vals.forEach(function(val) {
            var swatch = isColor ? getSwatchStyle(val) : null;
            var btn = document.createElement('button');
            btn.dataset.pos = pos; btn.dataset.value = val;
            var colorSoldOut = isColor && !currentVariants.some(function(v) {
              return v.options[idx] === val && v.available;
            });
            if (swatch) {
              btn.className = 'pg-qa-color-btn';
              if (colorSoldOut) btn.classList.add('is-sold-out');
              var dot = document.createElement('span');
              dot.className = 'pg-qa-color-dot';
              Object.assign(dot.style, swatch);
              var name = document.createElement('span');
              name.className = 'pg-qa-color-name';
              name.textContent = val.toUpperCase();
              btn.appendChild(dot); btn.appendChild(name);
            } else {
              btn.className = 'pg-qa-option-btn';
              btn.textContent = val;
              if (!currentVariants.some(function(v) { return v.options[idx] === val && v.available; })) {
                btn.classList.add('is-sold-out');
              }
            }
            if (selectedOptions['o'+pos] === val) btn.classList.add('is-selected');
            btn.addEventListener('click', function() {
              selectedOptions['o'+pos] = val;
              selSpan.textContent = val;
              btns.querySelectorAll('.pg-qa-option-btn, .pg-qa-color-btn').forEach(function(b){ b.classList.remove('is-selected'); });
              btn.classList.add('is-selected');
              updateAtcBtn();
            });
            btns.appendChild(btn);
          });
          wrap.appendChild(label); wrap.appendChild(btns);
          optionsEl.appendChild(wrap);
        });
        updateAtcBtn();
      }

      var variantInvMap = {};
      function parseVariantInvMap(card) {
        variantInvMap = {};
        if (!card) return;
        (card.dataset.variantInv || '').split('|').forEach(function(entry) {
          if (!entry) return;
          var parts = entry.split(':');
          if (parts.length < 3) return;
          variantInvMap[parts[0]] = { qty: parseInt(parts[1], 10), policy: parts[2] };
        });
      }

      function loadAndOpen(handle, btn, preselectId) {
        var card = btn.closest('.product-card');
        parseVariantInvMap(card);
        parseSwatchMap(card);
        btn.classList.add('is-loading');
        fetch('/products/' + handle + '.js')
          .then(function(r){ return r.json(); })
          .then(function(p) {
            btn.classList.remove('is-loading');
            titleEl.textContent = p.title;
            priceEl.textContent = money(p.price_min);
            imageEl.src = p.featured_image || '';
            imageEl.alt = p.title;
            atcBtn.dataset.productTitle = p.title;
            renderOptions(p, preselectId);
            refreshCartQty(function() { openDrawer(); });
          })
          .catch(function(err){ btn.classList.remove('is-loading'); console.error('pg-qa fetch error:', err); });
      }

      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.product-card__quick-add');
        if (!btn) return;
        if (sectionEl && !sectionEl.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();
        if (btn.dataset.multiVariant !== 'true' && btn.dataset.variantId) {
          var vid       = String(btn.dataset.variantId);
          var invQty    = parseInt(btn.dataset.inventory, 10);
          var invPolicy = btn.dataset.inventoryPolicy || 'deny';
          var inCart    = cartQty[vid] || 0;
          if (btn.dataset.available === 'false') {
            showToast(MSG_SOLDOUT, true);
            return;
          }
          if (invPolicy === 'deny' && !isNaN(invQty) && invQty > 0 && inCart >= invQty) {
            showToast(MSG_STOCK.replace('%available%', invQty).replace('%in_cart%', inCart), true);
            return;
          }
          btn.classList.add('is-loading');
          fetch('/cart/add.js', {
            method: 'POST', headers: {'Content-Type':'application/json'},
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
          })
          .then(function(r){ return r.json().then(function(d){ return {ok: r.ok, data: d}; }); })
          .then(function(res){
            btn.classList.remove('is-loading');
            if (res.ok) {
              cartQty[vid] = (cartQty[vid] || 0) + 1;
              showToast(MSG_ADDED, false, btn);
              document.dispatchEvent(new CustomEvent('cart:updated'));
              handlePostAdd();
            } else {
              refreshCartQty();
              var errMsg = (res.data && (res.data.description || res.data.message)) || pgT.errorGeneric;
              showToast(errMsg, true);
            }
          })
          .catch(function(){ btn.classList.remove('is-loading'); showToast(pgT.errorGeneric, true); });
        } else {
          loadAndOpen(btn.dataset.productHandle, btn, btn.dataset.variantId);
        }
      });

      atcBtn.addEventListener('click', function() {
        var vid = atcBtn.dataset.variantId;
        if (!vid || vid === 'undefined') return;
        if (wishlistRemoveMode) {
          if (window.wishlistDrawer) window.wishlistDrawer.remove(vid);
          document.querySelectorAll('[data-wishlist-add="' + vid + '"]').forEach(function(b) {
            b.classList.remove('is-wishlisted');
            b.setAttribute('aria-label', pgT.addToWishlistAria);
          });
          closeDrawer();
          return;
        }
        if (wishlistMode) {
          var srcBtn = wishlistSourceBtn;
          var handle = wishlistHandle;
          if (window.wishlistDrawer) {
            window.wishlistDrawer.add(vid, handle);
          } else {
            try {
              var wlItems = JSON.parse(localStorage.getItem('wishlist_items')) || [];
              if (!wlItems.some(function(i) { return i.variantId == vid; })) {
                wlItems.push({ variantId: vid, productHandle: handle, addedAt: Date.now() });
                localStorage.setItem('wishlist_items', JSON.stringify(wlItems));
              }
            } catch(e) {}
          }
          if (srcBtn) {
            srcBtn.classList.add('is-wishlisted');
            srcBtn.setAttribute('aria-label', pgT.removeFromWishlistAria);
          }
          document.querySelectorAll('[data-wishlist-add="' + vid + '"]').forEach(function(b) {
            b.classList.add('is-wishlisted');
          });
          closeDrawer();
          if (window.wishlistDrawer) window.wishlistDrawer.open();
          return;
        }
        var nvid = String(atcBtn.dataset.variantId);
        var invData = variantInvMap[nvid] || {};
        var invQty = invData.qty != null ? invData.qty : NaN;
        var invPolicy = invData.policy || 'deny';
        var inCart = cartQty[nvid] || 0;
        if (invPolicy === 'deny' && !isNaN(invQty) && invQty > 0 && inCart >= invQty) {
          showToast(MSG_STOCK.replace('%available%', invQty).replace('%in_cart%', inCart), true);
          return;
        }
        atcBtn.textContent = pgT.adding; atcBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json'},
          body: JSON.stringify({ id: nvid, quantity: 1 })
        })
        .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, data: d }; }); })
        .then(function(res){
          if (res.ok) {
            cartQty[String(nvid)] = (cartQty[String(nvid)] || 0) + 1;
            closeDrawer();
            var qaCtx = { dataset: { productImage: (imageEl && imageEl.src) || '', productTitle: (titleEl && titleEl.textContent) || '' } };
            showToast(MSG_ADDED, false, qaCtx);
            document.dispatchEvent(new CustomEvent('cart:updated'));
            handlePostAdd();
          } else {
            atcBtn.textContent = pgT.addToCart; atcBtn.disabled = false;
            refreshCartQty();
            var errMsg = (res.data && (res.data.description || res.data.message)) || pgT.errorGeneric;
            showToast(errMsg, true);
          }
        })
        .catch(function(){ atcBtn.textContent = pgT.addToCart; atcBtn.disabled = false; showToast(pgT.errorGeneric, true); });
      });

      closeBtn.addEventListener('click', closeDrawer);
      overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function(e){ if (e.key==='Escape') closeDrawer(); });

      window.pgQuickAdd = window.pgQuickAdd || {};
      window.pgQuickAdd[sectionId] = {
        openForWishlistRemove: function(handle, sourceBtn, preselectId) {
          wishlistMode = false;
          wishlistRemoveMode = true;
          wishlistSourceBtn = sourceBtn;
          wishlistHandle = handle;
          var srcCardR = sourceBtn ? sourceBtn.closest('.product-card') : null;
          if (srcCardR) { parseVariantInvMap(srcCardR); parseSwatchMap(srcCardR); }
          fetch('/products/' + handle + '.js')
            .then(function(r){ return r.json(); })
            .then(function(p) {
              titleEl.textContent = p.title;
              priceEl.textContent = money(p.price_min);
              imageEl.src = p.featured_image || '';
              imageEl.alt = p.title;
              atcBtn.dataset.productTitle = p.title;
              renderOptions(p, preselectId);
              applyAtcStyle('wishlist');
              openDrawer();
            })
            .catch(function() {
              wishlistRemoveMode = false;
              if (window.wishlistDrawer) window.wishlistDrawer.remove(sourceBtn ? sourceBtn.dataset.wishlistAdd : null);
            });
        },
        openForWishlist: function(handle, sourceBtn) {
          var srcCardW = sourceBtn ? sourceBtn.closest('.product-card') : null;
          if (srcCardW) { parseVariantInvMap(srcCardW); parseSwatchMap(srcCardW); }
          fetch('/products/' + handle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(p) {
              var hasRealVariants = p.variants.length > 1 ||
                (p.variants.length === 1 && p.variants[0].title !== 'Default Title');
              if (!hasRealVariants) {
                var vid = p.variants[0].id;
                if (window.wishlistDrawer) {
                  window.wishlistDrawer.add(vid, handle);
                } else {
                  try {
                    var wlItems = JSON.parse(localStorage.getItem('wishlist_items')) || [];
                    if (!wlItems.some(function(i) { return i.variantId == vid; })) {
                      wlItems.push({ variantId: vid, productHandle: handle, addedAt: Date.now() });
                      localStorage.setItem('wishlist_items', JSON.stringify(wlItems));
                    }
                  } catch(e) {}
                }
                if (sourceBtn) {
                  sourceBtn.classList.add('is-wishlisted');
                  sourceBtn.setAttribute('aria-label', pgT.removeFromWishlistAria);
                }
                if (window.wishlistDrawer) window.wishlistDrawer.open();
              } else {
                wishlistMode = true;
                wishlistSourceBtn = sourceBtn;
                wishlistHandle = handle;
                titleEl.textContent = p.title;
                priceEl.textContent = money(p.price_min);
                imageEl.src = p.featured_image || '';
                imageEl.alt = p.title;
                atcBtn.dataset.productTitle = p.title;
                var preselectId = sourceBtn ? sourceBtn.dataset.wishlistAdd : null;
                renderOptions(p, preselectId);
                applyAtcStyle('wishlist');
                openDrawer();
              }
            })
            .catch(function() {
              wishlistMode = true;
              wishlistSourceBtn = sourceBtn;
              wishlistHandle = handle;
              var preselectId = sourceBtn ? sourceBtn.dataset.wishlistAdd : null;
              applyAtcStyle('wishlist');
              loadAndOpen(handle, { classList: { add: function(){}, remove: function(){} } }, preselectId);
            });
        }
      };

      function handlePostAdd() {
        if (addAction === 'drawer' && cartType === 'drawer') {
          if (window.cartDrawer) window.cartDrawer.open();
        } else if (addAction === 'page') {
          window.location.href = '/cart';
        }
      }

      document.addEventListener('cart:updated', function(){ refreshCartQty(); });
    })();

    (function() {
      function getIndexesForColor(imgs, colorName) {
        var lower = colorName.toLowerCase().trim();
        var matched = [];
        imgs.forEach(function(img, i) {
          var alt = (img.alt || img.getAttribute('alt') || '').toLowerCase().trim();
          var idx = alt.indexOf(lower);
          while (idx !== -1) {
            var before = idx === 0 || !/[a-z0-9]/.test(alt[idx - 1]);
            var after  = (idx + lower.length) >= alt.length || !/[a-z0-9]/.test(alt[idx + lower.length]);
            if (before && after) { matched.push(i); break; }
            idx = alt.indexOf(lower, idx + 1);
          }
        });
        return matched;
      }

      function syncCardButtons(card, variantId) {
        var qabtns = card.querySelectorAll('.product-card__quick-add');
        var wlbtns = card.querySelectorAll('.product-card__wishlist');
        if (variantId === null) {
          qabtns.forEach(function(b){ if (b.dataset.defaultVariantId) b.dataset.variantId   = b.dataset.defaultVariantId; });
          wlbtns.forEach(function(b){ if (b.dataset.defaultVariantId) b.dataset.wishlistAdd = b.dataset.defaultVariantId; });
        } else {
          qabtns.forEach(function(b){ if (!b.dataset.defaultVariantId) b.dataset.defaultVariantId = b.dataset.variantId;   b.dataset.variantId   = variantId; });
          wlbtns.forEach(function(b){ if (!b.dataset.defaultVariantId) b.dataset.defaultVariantId = b.dataset.wishlistAdd; b.dataset.wishlistAdd = variantId; });
        }
        if (window.wishlistDrawer && window.wishlistDrawer.sync) window.wishlistDrawer.sync();
        else {
          wlbtns.forEach(function(b) {
            try {
              var items = JSON.parse(localStorage.getItem('wishlist_items')) || [];
              var vid = b.dataset.wishlistAdd;
              var inList = items.some(function(i){ return String(i.variantId) === String(vid); });
              b.classList.toggle('is-wishlisted', inList);
              b.setAttribute('aria-label', inList ? pgT.removeFromWishlistAria : pgT.addToWishlistAria);
            } catch(e) {}
          });
        }
      }

      function initCardNav(wrapper) {
        if (wrapper.dataset.navInit) return;
        wrapper.dataset.navInit = '1';
        var track = wrapper.querySelector('[data-card-track]');
        if (!track) return;
        var allImgs = Array.from(track.querySelectorAll('.product-card__img'));
        var card = wrapper.closest('.product-card');
        var hasImageSliding = allImgs.length > 1;

        if (swatchPreviewMode === 'click' && card && window.innerWidth >= 1200) {
          // If the server pre-marked a swatch active (split-by-color cards
          // do this for the card's own color), respect that. Otherwise
          // fall back to the first swatch in DOM order, matching the
          // pre-split default.
          var firstSwatch = card.querySelector('.product-card__swatch.is-preview-active[data-color]') ||
                            card.querySelector('.product-card__swatch[data-color]');
          if (firstSwatch && firstSwatch.dataset.variantId) {
            firstSwatch.classList.add('is-preview-active');
            syncCardButtons(card, firstSwatch.dataset.variantId);
            var imgLink = card.querySelector('.product-card__image-link');
            if (imgLink) {
              if (!imgLink.dataset.baseUrl) imgLink.dataset.baseUrl = imgLink.href;
              imgLink.href = imgLink.dataset.baseUrl + '?variant=' + firstSwatch.dataset.variantId;
            }
          }
        }

        if (!hasImageSliding) {
          if (card && swatchPreviewMode !== 'click') {
            card.querySelectorAll('.product-card__swatch[data-color]').forEach(function(swatch) {
              swatch.addEventListener('click', function(e) {
                e.preventDefault(); e.stopPropagation();
                var url = swatch.dataset.productUrl || '';
                var variantId = swatch.dataset.variantId || '';
                if (url) window.location.href = variantId ? url + '?variant=' + variantId : url;
              });
            });
          }
          return;
        }

        var prevBtn = wrapper.querySelector('.product-card__nav--prev');
        var nextBtn = wrapper.querySelector('.product-card__nav--next');
        var scrollbarThumb = wrapper.querySelector('[data-card-scrollbar] .product-card__scrollbar-thumb');

        var firstColor = wrapper.dataset.firstColor || '';
        var visibleIndexes = firstColor.length ? getIndexesForColor(allImgs, firstColor) : [];
        if (!visibleIndexes.length) visibleIndexes = allImgs.map(function(_, i){ return i; });

        var currentPos = 0;
        var slideTransition = hoverSecondImg;

        function updateScrollbar() {
          if (!scrollbarThumb) return;
          var n = visibleIndexes.length;
          if (n <= 0) return;
          scrollbarThumb.style.width = (100 / n) + '%';
          scrollbarThumb.style.transform = 'translateX(' + (currentPos * 100) + '%)';
        }

        function goTo(pos) {
          currentPos = Math.max(0, Math.min(visibleIndexes.length - 1, pos));
          if (slideTransition) {
            track.style.transition = 'transform 0.5s ease';
            void track.offsetWidth;
          }
          track.style.transform = 'translateX(-' + (visibleIndexes[currentPos] * 100) + '%)';
          if (prevBtn) prevBtn.classList.toggle('is-hidden', currentPos === 0);
          if (nextBtn) nextBtn.classList.toggle('is-hidden', currentPos === visibleIndexes.length - 1);
          updateScrollbar();
        }

        function snapTo(pos) {
          currentPos = Math.max(0, Math.min(visibleIndexes.length - 1, pos));
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + (visibleIndexes[currentPos] * 100) + '%)';
          if (prevBtn) prevBtn.classList.toggle('is-hidden', currentPos === 0);
          if (nextBtn) nextBtn.classList.toggle('is-hidden', currentPos === visibleIndexes.length - 1);
          if (scrollbarThumb) {
            wrapper.classList.add('is-snapping');
            updateScrollbar();
            void scrollbarThumb.offsetWidth;
            wrapper.classList.remove('is-snapping');
          }
        }

        var swatchFadeTransition = slideTransition
          ? 'opacity 0.15s ease, transform 0.5s ease'
          : 'opacity 0.15s ease, transform 0.35s ease';

        function pgBaseColor(name) {
          var v = (name || '').toLowerCase();
          if (v.indexOf('multi') !== -1 || v.indexOf('rainbow') !== -1) return 'multi';
          if (v.indexOf('off-white') !== -1 || v.indexOf('ivory') !== -1 || v.indexOf('cream') !== -1 || v.indexOf('eggshell') !== -1 || v.indexOf('pearl') !== -1) return 'white';
          if (v.indexOf('charcoal') !== -1 || v.indexOf('graphite') !== -1 || v.indexOf('gunmetal') !== -1) return 'gray';
          if (v.indexOf('gray') !== -1 || v.indexOf('grey') !== -1 || v.indexOf('silver') !== -1 || v.indexOf('slate') !== -1 || v.indexOf('ash') !== -1 || v.indexOf('pewter') !== -1) return 'gray';
          if (v.indexOf('black') !== -1 || v.indexOf('jet') !== -1 || v.indexOf('onyx') !== -1 || v.indexOf('ebony') !== -1) return 'black';
          if (v.indexOf('white') !== -1 || v.indexOf('chalk') !== -1) return 'white';
          if (v.indexOf('pink') !== -1 || v.indexOf('rose') !== -1 || v.indexOf('blush') !== -1 || v.indexOf('fuchsia') !== -1 || v.indexOf('salmon') !== -1 || v.indexOf('magenta') !== -1) return 'pink';
          if (v.indexOf('burgundy') !== -1 || v.indexOf('maroon') !== -1 || v.indexOf('wine') !== -1 || v.indexOf('crimson') !== -1 || v.indexOf('scarlet') !== -1 || v.indexOf('ruby') !== -1 || v.indexOf('cherry') !== -1) return 'red';
          if (v.indexOf('red') !== -1) return 'red';
          if (v.indexOf('rust') !== -1 || v.indexOf('terracotta') !== -1 || v.indexOf('copper') !== -1) return 'orange';
          if (v.indexOf('orange') !== -1 || v.indexOf('peach') !== -1 || v.indexOf('coral') !== -1 || v.indexOf('apricot') !== -1) return 'orange';
          if (v.indexOf('mustard') !== -1 || v.indexOf('gold') !== -1 || v.indexOf('amber') !== -1) return 'yellow';
          if (v.indexOf('yellow') !== -1 || v.indexOf('lemon') !== -1) return 'yellow';
          if (v.indexOf('olive') !== -1 || v.indexOf('forest') !== -1 || v.indexOf('sage') !== -1 || v.indexOf('mint') !== -1 || v.indexOf('lime') !== -1 || v.indexOf('emerald') !== -1 || v.indexOf('jade') !== -1 || v.indexOf('teal') !== -1) return 'green';
          if (v.indexOf('green') !== -1) return 'green';
          if (v.indexOf('turquoise') !== -1 || v.indexOf('aqua') !== -1 || v.indexOf('cyan') !== -1) return 'blue';
          if (v.indexOf('navy') !== -1 || v.indexOf('royal') !== -1 || v.indexOf('azure') !== -1 || v.indexOf('cobalt') !== -1 || v.indexOf('denim') !== -1 || v.indexOf('indigo') !== -1 || v.indexOf('cerulean') !== -1 || v.indexOf('sapphire') !== -1 || v.indexOf('midnight') !== -1) return 'blue';
          if (v.indexOf('blue') !== -1) return 'blue';
          if (v.indexOf('lavender') !== -1 || v.indexOf('lilac') !== -1 || v.indexOf('plum') !== -1 || v.indexOf('aubergine') !== -1 || v.indexOf('eggplant') !== -1 || v.indexOf('mauve') !== -1) return 'purple';
          if (v.indexOf('purple') !== -1 || v.indexOf('violet') !== -1) return 'purple';
          if (v.indexOf('tan') !== -1 || v.indexOf('beige') !== -1 || v.indexOf('khaki') !== -1 || v.indexOf('taupe') !== -1 || v.indexOf('camel') !== -1 || v.indexOf('chocolate') !== -1 || v.indexOf('mocha') !== -1 || v.indexOf('caramel') !== -1 || v.indexOf('sand') !== -1 || v.indexOf('nude') !== -1 || v.indexOf('bronze') !== -1) return 'brown';
          if (v.indexOf('brown') !== -1) return 'brown';
          return '';
        }

        function showColor(colorName) {
          var indexes = getIndexesForColor(allImgs, colorName);
          if (!indexes.length) {
            var base = pgBaseColor(colorName);
            if (base && base.toLowerCase() !== (colorName || '').toLowerCase()) {
              indexes = getIndexesForColor(allImgs, base);
            }
          }
          if (!indexes.length) return;
          visibleIndexes = indexes;
          track.style.transition = swatchFadeTransition;
          track.style.opacity = '0';
          setTimeout(function() {
            snapTo(0);
            void track.offsetWidth;
            track.style.transition = swatchFadeTransition;
            track.style.opacity = '1';
          }, 150);
        }

        function resetColor() {
          var indexes = firstColor.length ? getIndexesForColor(allImgs, firstColor) : [];
          visibleIndexes = indexes.length ? indexes : allImgs.map(function(_, i){ return i; });
          track.style.transition = swatchFadeTransition;
          track.style.opacity = '0';
          setTimeout(function() {
            snapTo(0);
            void track.offsetWidth;
            track.style.transition = swatchFadeTransition;
            track.style.opacity = '1';
          }, 150);
        }

        // Initial positioning. Use snapTo (transition: none) so split-by-color
        // cards — whose first visible image sits at index > 0 — don't slide
        // through the earlier colors' images on first paint. snapTo leaves
        // `transition: none` inline; clear it after a reflow so subsequent
        // nav-arrow clicks animate via the CSS rule on .product-card__track.
        snapTo(0);
        void track.offsetWidth;
        track.style.transition = '';

        if (prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goTo(currentPos - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goTo(currentPos + 1); });

        if (infoPosition === 'below' && hoverSecondImg) {
          if (wrapper.hasAttribute('data-hover-second-img')) {
            wrapper.addEventListener('mouseenter', function() {
              if (window.innerWidth < 1200) return;
              if (currentPos === 0 && visibleIndexes.length > 1) {
                goTo(1);
              }
            });
            wrapper.addEventListener('mouseleave', function() {
              if (window.innerWidth < 1200) return;
              if (currentPos !== 0) {
                goTo(0);
              }
            });
          }
        }

        if (mobileSwipe) {
          var touchStartX = 0;
          var touchStartY = 0;
          var dragging = false;
          track.addEventListener('touchstart', function(e) {
            if (window.innerWidth >= 1200) return;
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            dragging = false;
          }, { passive: true });
          track.addEventListener('touchmove', function(e) {
            if (window.innerWidth >= 1200) return;
            var dx = e.touches[0].clientX - touchStartX;
            var dy = e.touches[0].clientY - touchStartY;
            if (!dragging && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
              dragging = true;
            }
          }, { passive: true });
          track.addEventListener('touchend', function(e) {
            if (window.innerWidth >= 1200 || !dragging) return;
            var dx = e.changedTouches[0].clientX - touchStartX;
            if (Math.abs(dx) > 40) {
              dx < 0 ? goTo(currentPos + 1) : goTo(currentPos - 1);
            }
            dragging = false;
          }, { passive: true });
        }

        if (card && swatchPreviewMode !== 'click') {
          card.querySelectorAll('.product-card__swatch[data-color]').forEach(function(swatch) {
            swatch.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              var url = swatch.dataset.productUrl || '';
              var variantId = swatch.dataset.variantId || '';
              if (url) window.location.href = variantId ? url + '?variant=' + variantId : url;
            });
          });
        }

        if (swatchPreviewMode === 'hover' && card) {
          card.querySelectorAll('.product-card__swatch[data-color]').forEach(function(swatch) {
            swatch.addEventListener('mouseenter', function() {
              if (window.innerWidth < 1200) return;
              showColor(swatch.dataset.color);
            });
            swatch.addEventListener('mouseleave', function() {
              if (window.innerWidth < 1200) return;
              resetColor();
            });
          });
        }

        wrapper._pgShowColor = showColor;
        wrapper._pgResetColor = resetColor;
        wrapper._pgSyncButtons = function(variantId) { syncCardButtons(card, variantId); };
      }

      var initScope = sectionEl || root;
      initScope.querySelectorAll('.product-card__image-wrapper').forEach(initCardNav);

      root._pgInitCardNav = initCardNav;

      if (swatchPreviewMode === 'click') {
        setTimeout(function() {
          if (window.wishlistDrawer && window.wishlistDrawer.sync) {
            window.wishlistDrawer.sync();
          }
        }, 0);
      }
    })();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.product-grid-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
})();

(function() {
  var tip = null;
  var transform = '';

  function findEnabledRoot() {
    var all = document.querySelectorAll('.product-grid-section[data-pg-hover-label="true"]');
    return all.length ? all[0] : null;
  }

  function ensureTip() {
    if (tip && tip.parentNode) return;
    tip = document.createElement('div');
    document.body.appendChild(tip);
  }

  function applyTipStyles(root) {
    if (!tip) return;
    var bg       = root.dataset.pgHoverLabelBg       || '';
    var color    = root.dataset.pgHoverLabelColor    || '';
    var size     = root.dataset.pgHoverLabelSize     || '12';
    var padV     = root.dataset.pgHoverLabelPaddingV || '4';
    var padH     = root.dataset.pgHoverLabelPaddingH || '8';
    var radius   = root.dataset.pgHoverLabelRadius   || '0';
    var font     = root.dataset.pgHoverLabelFont     || 'body';
    var letter   = root.dataset.pgHoverLabelLetterSpacing || '0';
    transform    = root.dataset.pgHoverLabelTransform || 'none';
    tip.style.cssText = [
      'position:fixed',
      'pointer-events:none',
      'z-index:99999',
      'display:none',
      'white-space:nowrap',
      'background:' + bg,
      'color:' + color,
      'font-size:' + size + 'px',
      'padding:' + padV + 'px ' + padH + 'px',
      'border-radius:' + radius + 'px',
      'font-family:var(--' + font + '-font)',
      'letter-spacing:' + letter + 'em',
      'text-transform:' + transform
    ].join(';');
  }

  function setup() {
    var root = findEnabledRoot();
    if (!root) {
      if (tip) tip.style.display = 'none';
      return;
    }
    ensureTip();
    applyTipStyles(root);
  }

  document.addEventListener('mousemove', function(e) {
    if (!tip) return;
    tip.style.left = (e.clientX + 14) + 'px';
    tip.style.top  = (e.clientY - 8)  + 'px';
  });

  document.addEventListener('mouseover', function(e) {
    if (!tip) return;
    var swatch = e.target.closest('.product-card__swatch');
    if (swatch && swatch.closest('.product-grid-section[data-pg-hover-label="true"]')) {
      var color = swatch.dataset.color || swatch.getAttribute('title') || '';
      if (color) {
        if (transform === 'capitalize') {
          color = color.replace(/\b\w/g, function(c){ return c.toUpperCase(); });
        }
        tip.textContent = color;
        tip.style.display = 'block';
      }
    } else {
      tip.style.display = 'none';
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
(function() {

  // ── Pure event delegation — safe to run multiple times ────────────────
  // One click handler on document. Global flag ensures it's only registered once
  // even if this code runs from multiple section bundles simultaneously.

  function openFilterDrawer(drawer, overlay) {
    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeFilterDrawer(drawer, overlay) {
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  /* ── Shopify-filter mirror for non-collection pages ──────────────────
     On non-collection pages the section renders its own client-side
     filter facets (cs_*). On the first drawer open we fetch the actual
     collection page's HTML, extract its filter form (rendered by Shopify
     with the full collection.filters API — taxonomy, metafields, the
     works), and swap our facets out for it. Apply then redirects to the
     collection URL with the form's filter.* params, giving the user
     Shopify-native filtering and a single source of truth.

     Cached per page load. Falls back silently to the client-side facets
     if the fetch fails or finds no filter form. */
  function pgLoadShopifyFiltersIntoDrawer(form) {
    if (!form) return;
    if (form.dataset.pgClientsideFilter !== 'true') return;
    var loaded = form.dataset.pgShopifyFiltersLoaded;
    if (loaded === 'true' || loaded === 'pending') return;
    var collectionUrl = form.dataset.collectionUrl;
    if (!collectionUrl) return;

    form.dataset.pgShopifyFiltersLoaded = 'pending';
    fetch(collectionUrl, { credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sourceForm = doc.querySelector('[data-pg-filter-form]');
        if (!sourceForm) { form.dataset.pgShopifyFiltersLoaded = ''; return; }
        form.innerHTML = sourceForm.innerHTML;
        form.dataset.pgShopifyFiltersLoaded = 'true';
        form.dataset.pgRedirectOnApply = 'true';
        // Sync count badges and active state on the freshly-injected form.
        form.querySelectorAll('.pg-filter-section').forEach(function(sec) {
          var badge = sec.querySelector('.pg-filter-section__count');
          if (badge) {
            var n = sec.querySelectorAll('input:checked').length;
            badge.textContent = n > 0 ? n : '';
            badge.classList.toggle('is-active', n > 0);
          }
        });
        var sectionEl = form.closest('[id^="shopify-section-"]');
        if (sectionEl) {
          var sid = sectionEl.id.replace('shopify-section-', '');
          var total = form.querySelectorAll('input[name^="filter."]:checked').length;
          var totalBadge = document.getElementById('pg-filter-total-' + sid);
          if (totalBadge) {
            totalBadge.textContent = total > 0 ? total : '';
            totalBadge.classList.toggle('is-active', total > 0);
          }
        }
      })
      .catch(function() { form.dataset.pgShopifyFiltersLoaded = ''; });
  }

  /* ── Color filter active-state utilities ─────────────────────────────
     Shared by both filter paths (collection-page fetchFilteredGrid AND
     non-collection-page applyClientsideFilters). When a color filter
     applies, each visible card displays its matching color's image and
     shows the matching color swatch first. When the user selects 2+
     colors and a single product has multiple matching variants, the
     card is cloned in place — one card per matching color, each card
     pointing at its own color's image and swatch. */

  function pgBaseColor(name) {
    var v = (name || '').toLowerCase();
    if (v.indexOf('multi') !== -1 || v.indexOf('rainbow') !== -1) return 'multi';
    if (v.indexOf('off-white') !== -1 || v.indexOf('ivory') !== -1 || v.indexOf('cream') !== -1 || v.indexOf('eggshell') !== -1 || v.indexOf('pearl') !== -1) return 'white';
    if (v.indexOf('charcoal') !== -1 || v.indexOf('graphite') !== -1 || v.indexOf('gunmetal') !== -1) return 'gray';
    if (v.indexOf('gray') !== -1 || v.indexOf('grey') !== -1 || v.indexOf('silver') !== -1 || v.indexOf('slate') !== -1 || v.indexOf('ash') !== -1 || v.indexOf('pewter') !== -1) return 'gray';
    if (v.indexOf('black') !== -1 || v.indexOf('jet') !== -1 || v.indexOf('onyx') !== -1 || v.indexOf('ebony') !== -1) return 'black';
    if (v.indexOf('white') !== -1 || v.indexOf('chalk') !== -1) return 'white';
    if (v.indexOf('pink') !== -1 || v.indexOf('rose') !== -1 || v.indexOf('blush') !== -1 || v.indexOf('fuchsia') !== -1 || v.indexOf('salmon') !== -1 || v.indexOf('magenta') !== -1) return 'pink';
    if (v.indexOf('burgundy') !== -1 || v.indexOf('maroon') !== -1 || v.indexOf('wine') !== -1 || v.indexOf('crimson') !== -1 || v.indexOf('scarlet') !== -1 || v.indexOf('ruby') !== -1 || v.indexOf('cherry') !== -1) return 'red';
    if (v.indexOf('red') !== -1) return 'red';
    if (v.indexOf('rust') !== -1 || v.indexOf('terracotta') !== -1 || v.indexOf('copper') !== -1) return 'orange';
    if (v.indexOf('orange') !== -1 || v.indexOf('peach') !== -1 || v.indexOf('coral') !== -1 || v.indexOf('apricot') !== -1) return 'orange';
    if (v.indexOf('mustard') !== -1 || v.indexOf('gold') !== -1 || v.indexOf('amber') !== -1) return 'yellow';
    if (v.indexOf('yellow') !== -1 || v.indexOf('lemon') !== -1) return 'yellow';
    if (v.indexOf('olive') !== -1 || v.indexOf('forest') !== -1 || v.indexOf('sage') !== -1 || v.indexOf('mint') !== -1 || v.indexOf('lime') !== -1 || v.indexOf('emerald') !== -1 || v.indexOf('jade') !== -1 || v.indexOf('teal') !== -1) return 'green';
    if (v.indexOf('green') !== -1) return 'green';
    if (v.indexOf('turquoise') !== -1 || v.indexOf('aqua') !== -1 || v.indexOf('cyan') !== -1) return 'blue';
    if (v.indexOf('navy') !== -1 || v.indexOf('royal') !== -1 || v.indexOf('azure') !== -1 || v.indexOf('cobalt') !== -1 || v.indexOf('denim') !== -1 || v.indexOf('indigo') !== -1 || v.indexOf('cerulean') !== -1 || v.indexOf('sapphire') !== -1 || v.indexOf('midnight') !== -1) return 'blue';
    if (v.indexOf('blue') !== -1) return 'blue';
    if (v.indexOf('lavender') !== -1 || v.indexOf('lilac') !== -1 || v.indexOf('plum') !== -1 || v.indexOf('aubergine') !== -1 || v.indexOf('eggplant') !== -1 || v.indexOf('mauve') !== -1) return 'purple';
    if (v.indexOf('purple') !== -1 || v.indexOf('violet') !== -1) return 'purple';
    if (v.indexOf('tan') !== -1 || v.indexOf('beige') !== -1 || v.indexOf('khaki') !== -1 || v.indexOf('taupe') !== -1 || v.indexOf('camel') !== -1 || v.indexOf('chocolate') !== -1 || v.indexOf('mocha') !== -1 || v.indexOf('caramel') !== -1 || v.indexOf('sand') !== -1 || v.indexOf('nude') !== -1 || v.indexOf('bronze') !== -1) return 'brown';
    if (v.indexOf('brown') !== -1) return 'brown';
    return v.replace(/\s+/g, '');
  }

  // Resolve checked color inputs in a filter form. Four detection
  // strategies, tried in order — covers swatch and text-list filters
  // across all Shopify filter shapes (variant option / metafield /
  // tag), any option name in any locale, and even setups where my
  // Liquid section-class hasn't been picked up yet.
  function pgIsKnownBaseColor(s) {
    return s === 'multi' || s === 'white' || s === 'gray' || s === 'black' ||
           s === 'pink' || s === 'red' || s === 'orange' || s === 'yellow' ||
           s === 'green' || s === 'blue' || s === 'purple' || s === 'brown';
  }
  function pgGetCheckedColorValues(form) {
    if (!form) return [];
    var values = [];
    var all = Array.prototype.slice.call(form.querySelectorAll('input:checked'));
    all.forEach(function(input) {
      if (!input.value) return;
      var isColor = false;
      if (input.closest('.pg-filter-section--color')) isColor = true;
      else if (input.closest('.pg-filter-color-item')) isColor = true;
      else {
        var n = (input.name || '').toLowerCase();
        if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 || n.indexOf('couleur') !== -1 || n.indexOf('farbe') !== -1 || n.indexOf('kleur') !== -1) {
          isColor = true;
        } else if (pgIsKnownBaseColor(pgBaseColor(input.value))) {
          // Last-resort heuristic: the value itself maps to a recognized
          // base color word (e.g. "Navy Blue" → blue, "Burgundy" → red).
          // Safe because no realistic size/material/type filter value
          // would coincidentally contain a color keyword.
          isColor = true;
        }
      }
      if (!isColor) return;
      // Prefer the human-readable label text over the input value. For
      // Shopify's Standard Product Taxonomy color filter the input value
      // is an opaque GID like "gid://shopify/TaxonomyValue/10" — useless
      // for alt-text matching. The .pg-filter-color-name span next to
      // the checkbox carries the real name ("BLACK", "LIGHT GREEN" …).
      var item = input.closest('.pg-filter-color-item') || input.closest('label');
      var nameSpan = item && item.querySelector('.pg-filter-color-name');
      var label = nameSpan && nameSpan.textContent ? nameSpan.textContent.trim() : '';
      values.push(label || input.value);
    });
    return values;
  }

  // Find the swatch on a card that matches a color. Exact lowercase match
  // wins (Shopify-filter mode, value is "Navy Blue"); base-color match is
  // the fallback (client-side mode, value is "blue" with several variant
  // swatches mapping to it — first one wins).
  function pgFindSwatchForColor(card, color) {
    var lower = (color || '').toLowerCase();
    var target = pgBaseColor(color);
    var swatches = card.querySelectorAll('.product-card__swatch[data-color]');
    var i;
    for (i = 0; i < swatches.length; i++) {
      if ((swatches[i].dataset.color || '').toLowerCase() === lower) return swatches[i];
    }
    for (i = 0; i < swatches.length; i++) {
      if (pgBaseColor(swatches[i].dataset.color) === target) return swatches[i];
    }
    return null;
  }

  function pgApplyActiveColorToCard(card, color) {
    card.dataset.pgActiveColor = color;
    card.querySelectorAll('.product-card__swatch').forEach(function(s) {
      s.style.order = '';
      s.classList.remove('is-preview-active');
    });
    var matchingSwatch = pgFindSwatchForColor(card, color);
    if (matchingSwatch) {
      matchingSwatch.style.order = '-1';
      matchingSwatch.classList.add('is-preview-active');
    }
    var w = card.querySelector('.product-card__image-wrapper');
    if (w && w._pgShowColor) w._pgShowColor(color);
  }

  function pgCloneCardForColor(originalCard, color, prodSec) {
    var clone = originalCard.cloneNode(true);
    clone.dataset.pgClone = '1';
    // Clear nav-init flag on the cloned wrapper so initCardNav can re-run
    // on it (and rebuild local listeners + the _pgShowColor hook).
    var cw = clone.querySelector('.product-card__image-wrapper');
    if (cw) cw.removeAttribute('data-nav-init');
    if (prodSec && prodSec._pgInitCardNav && cw) prodSec._pgInitCardNav(cw);
    pgApplyActiveColorToCard(clone, color);
    return clone;
  }

  function pgClearColorFilterState(sectionEl) {
    sectionEl.querySelectorAll('.product-card[data-pg-clone="1"]').forEach(function(c) { c.remove(); });
    sectionEl.querySelectorAll('.product-card').forEach(function(card) {
      delete card.dataset.pgActiveColor;
      card.querySelectorAll('.product-card__swatch').forEach(function(s) {
        s.style.order = '';
        s.classList.remove('is-preview-active');
      });
    });
  }

  /* Toggle .is-toolbar-active on the section root whenever the user
     has put the top bar into a non-default state (any filter checked,
     custom sort selected, or view changed). The product-grid-images
     section uses this class to hide its editorial image blocks while
     filtering / sorting / changing view, so the visible product set
     isn't broken up by curated images. */
  function pgRecomputeToolbarActive(sectionEl) {
    try {
      if (!sectionEl) return;
      var prodSec = sectionEl.querySelector && sectionEl.querySelector('.product-grid-section');
      if (!prodSec) return;

      var active = false;

      // Any checked filter input, or a populated price range
      var form = sectionEl.querySelector('[data-pg-filter-form]');
      if (form) {
        if (form.querySelectorAll('input[name^="filter."]:checked, input[name^="cs_"]:checked').length > 0) {
          active = true;
        }
        if (!active) {
          var pmin = form.querySelector('input[name="cs_price_min"], input[name="filter.v.price.gte"]');
          var pmax = form.querySelector('input[name="cs_price_max"], input[name="filter.v.price.lte"]');
          if ((pmin && pmin.value !== '') || (pmax && pmax.value !== '')) active = true;
        }
      }

      // URL sort param (?sort_by=)
      if (!active) {
        try {
          if (new URLSearchParams(window.location.search).get('sort_by')) active = true;
        } catch (e) {}
      }

      // User-triggered flags set by view / sort handlers below
      if (!active && prodSec.dataset.pgViewChanged === 'true') active = true;
      if (!active && prodSec.dataset.pgSortChanged === 'true') active = true;

      prodSec.classList.toggle('is-toolbar-active', active);
    } catch (e) {
      // Never let the editorial-image toggle break the delegated click
      // handler — it's a cosmetic-only feature.
      if (window.console && console.warn) console.warn('pgRecomputeToolbarActive:', e);
    }
  }

  function pgApplyColorFilterState(sectionEl, selectedColors) {
    var prodSec = sectionEl.querySelector('.product-grid-section') || sectionEl;
    pgClearColorFilterState(sectionEl);
    if (!selectedColors || selectedColors.length === 0) {
      sectionEl.querySelectorAll('.product-card').forEach(function(card) {
        var w = card.querySelector('.product-card__image-wrapper');
        if (w && w._pgResetColor) w._pgResetColor();
      });
      return;
    }
    var cards = Array.prototype.slice.call(sectionEl.querySelectorAll('.product-card'));
    cards.forEach(function(card) {
      if (card.style.display === 'none') return;
      if (card.dataset.pgClone === '1') return;
      // Primary: data-opt-color emitted by Liquid (base-color normalized).
      // Fallback: derive colors from the card's swatches (handles cases
      // where data-opt-color is empty — e.g., the option is named
      // something other than "Color", or the card markup hasn't been
      // refreshed with the latest Liquid).
      var cardOptColor = card.getAttribute('data-opt-color') || '';
      if (!cardOptColor) {
        var attrs = card.attributes;
        for (var a = 0; a < attrs.length; a++) {
          var attrName = attrs[a].name;
          if (attrName.indexOf('data-opt-') === 0) {
            var val = attrs[a].value || '';
            if (val.indexOf('|') !== -1) cardOptColor += val;
          }
        }
      }
      if (!cardOptColor) {
        var sw = card.querySelectorAll('.product-card__swatch[data-color]');
        var parts = ['|'];
        for (var s = 0; s < sw.length; s++) {
          parts.push(pgBaseColor(sw[s].dataset.color || ''));
          parts.push('|');
          var raw = (sw[s].dataset.color || '').toLowerCase().replace(/\s+/g, '');
          parts.push(raw);
          parts.push('|');
        }
        cardOptColor = parts.join('');
      }
      var matching = [];
      selectedColors.forEach(function(c) {
        var base = pgBaseColor(c);
        var rawLower = (c || '').toLowerCase().replace(/\s+/g, '');
        if (cardOptColor.indexOf('|' + rawLower + '|') !== -1 || cardOptColor.indexOf('|' + base + '|') !== -1) {
          matching.push(c);
        }
      });
      // Defensive fallback: if our matcher can't pin which of the selected
      // colors this card has (e.g., the card markup lacks data-opt-color
      // AND has no swatches we could read), but Shopify/visibility filter
      // already deemed this card a match, apply the first selected color
      // so the image-swap + swatch-reorder still fires. Without this the
      // function would silently no-op on misconfigured cards.
      if (matching.length === 0) matching = [selectedColors[0]];
      pgApplyActiveColorToCard(card, matching[0]);
      var insertAfter = card;
      for (var i = 1; i < matching.length; i++) {
        var clone = pgCloneCardForColor(card, matching[i], prodSec);
        insertAfter.parentNode.insertBefore(clone, insertAfter.nextSibling);
        insertAfter = clone;
      }
    });
  }

  /* Fetches the filtered/sorted grid from Shopify and AJAX-swaps the
     content + drawer in place. Builds the URL from the filter form so
     the URL is the single source of truth (no localStorage). Uses the
     Section Rendering API (?section_id=) so we get just this section's
     HTML, not a whole page. pushState keeps filters shareable and lets
     the browser back button work. */
  function fetchFilteredGrid(sectionEl, sectionId, overrideUrl) {
    var container = sectionEl.querySelector('.pg-ajax-container');
    var drawer    = document.getElementById('pg-filter-drawer-' + sectionId);
    var form      = document.getElementById('pg-filter-form-' + sectionId);
    if (!container) return;

    var url;
    if (overrideUrl) {
      url = overrideUrl;
    } else if (form) {
      var collectionUrl = form.dataset.collectionUrl || form.getAttribute('action');
      // Drop the page param when filters change — old "?page=3" of an
      // older filter set is meaningless against the new result count.
      var data = new FormData(form);
      var params = new URLSearchParams();
      data.forEach(function(v, k) {
        if (k === 'page') return;
        if (v === '' || v == null) return;
        params.append(k, v);
      });
      url = collectionUrl + (params.toString() ? '?' + params.toString() : '');
    } else {
      return;
    }

    container.style.transition = 'opacity 0.2s ease';
    container.style.opacity = '0.35';

    fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId)
      .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Replace the grid + pagination
        var newContainer = doc.querySelector('.pg-ajax-container');
        if (newContainer) container.innerHTML = newContainer.innerHTML;

        // Replace the filter form (active checkboxes, swatch counts,
        // disabled out-of-stock options) so it reflects the new result
        // set. Drawer chrome (header/footer) stays mounted.
        var newForm = doc.getElementById('pg-filter-form-' + sectionId);
        if (newForm && form) form.innerHTML = newForm.innerHTML;

        // Refresh the toolbar Filters total (re-read the freshly-replaced form).
        var totalBadge = document.getElementById('pg-filter-total-' + sectionId);
        if (totalBadge && form) {
          var total = form.querySelectorAll('input[name^="filter."]:checked').length;
          totalBadge.textContent = total > 0 ? total : '';
          totalBadge.classList.toggle('is-active', total > 0);
        }

        // Update the URL bar so the filter state is bookmarkable.
        history.pushState({}, '', url);

        // Re-initialize newly-injected card wrappers so swatch hover/click
        // preview and the filter's image swap have their _pgShowColor hooks
        // attached. initCardNav (exposed on the section root) is idempotent.
        var prodSec = sectionEl.querySelector('.product-grid-section');
        if (prodSec && prodSec._pgInitCardNav) {
          prodSec.querySelectorAll('.product-card__image-wrapper').forEach(prodSec._pgInitCardNav);
        }

        // Color filter active-state on collection-page filter — same
        // helper as applyClientsideFilters. Reads the newly-replaced
        // filter form for checked color inputs (via robust 3-strategy
        // detector), then applies image swap + swatch reorder + clones
        // cards with 2+ matching colors.
        if (form) {
          pgApplyColorFilterState(sectionEl, pgGetCheckedColorValues(form));
        }

        pgRecomputeToolbarActive(sectionEl);

        container.style.opacity = '1';
      })
      .catch(function() { window.location.href = url; });
  }

  /* Client-side filter — used when the section is rendered with no Shopify
     filters available (non-collection pages, or a collection page with no
     filters configured). Reads checked cs_* inputs from the drawer form
     and hides/shows .product-card elements in place. Operates only on
     the currently-rendered (paginated) products.

     Supported facets: availability (cs_avail), price range (cs_price_min/max),
     product type (cs_type), vendor (cs_vendor), and every variant option
     (cs_opt_{key} — color, size, material, …) detected from the products.
     Cards expose data-available, data-price (cents), data-type, data-vendor,
     and data-opt-{key} for matching. */
  function applyClientsideFilters(sectionEl, form) {
    var sectionId = sectionEl.id.replace('shopify-section-', '');
    var toArr = function(nl){ return Array.prototype.slice.call(nl); };

    var avail   = toArr(form.querySelectorAll('input[name="cs_avail"]:checked')).map(function(i){ return i.value; });
    var types   = toArr(form.querySelectorAll('input[name="cs_type"]:checked')).map(function(i){ return i.value; });
    var vendors = toArr(form.querySelectorAll('input[name="cs_vendor"]:checked')).map(function(i){ return i.value; });

    var priceMinInput = form.querySelector('input[name="cs_price_min"]');
    var priceMaxInput = form.querySelector('input[name="cs_price_max"]');
    var priceMin = priceMinInput && priceMinInput.value !== '' ? parseFloat(priceMinInput.value) : null;
    var priceMax = priceMaxInput && priceMaxInput.value !== '' ? parseFloat(priceMaxInput.value) : null;
    if (isNaN(priceMin)) priceMin = null;
    if (isNaN(priceMax)) priceMax = null;

    // Variant options — group every cs_opt_* input by its option key
    var optionFilters = {};
    toArr(form.querySelectorAll('input[name^="cs_opt_"]:checked')).forEach(function(input) {
      var key = input.name.replace('cs_opt_', '');
      if (!optionFilters[key]) optionFilters[key] = [];
      optionFilters[key].push(input.value);
    });

    var cards = sectionEl.querySelectorAll('.product-card');
    cards.forEach(function(card) {
      var show = true;

      if (avail.length) {
        var isAvail = card.dataset.available === 'true';
        var wantIn  = avail.indexOf('in-stock') !== -1;
        var wantOut = avail.indexOf('out-of-stock') !== -1;
        if (wantIn && !wantOut && !isAvail) show = false;
        else if (wantOut && !wantIn && isAvail) show = false;
      }

      if (show && (priceMin !== null || priceMax !== null)) {
        var price = parseInt(card.dataset.price || '0', 10) / 100;
        if (priceMin !== null && price < priceMin) show = false;
        if (show && priceMax !== null && price > priceMax) show = false;
      }

      if (show && types.length && types.indexOf(card.dataset.type || '') === -1) show = false;
      if (show && vendors.length && vendors.indexOf(card.dataset.vendor || '') === -1) show = false;

      if (show) {
        for (var key in optionFilters) {
          if (!optionFilters.hasOwnProperty(key)) continue;
          var selected = optionFilters[key];
          var cardValues = (card.getAttribute('data-opt-' + key) || '').split('|').filter(Boolean);
          if (!selected.some(function(v){ return cardValues.indexOf(v) !== -1; })) {
            show = false;
            break;
          }
        }
      }

      card.style.display = show ? '' : 'none';
    });

    // Color filter active-state — image swap + swatch reorder, plus
    // card duplication when a product matches multiple selected colors.
    // Uses the robust 3-strategy color-input detector so both filter
    // paths (collection page + non-collection) detect the same way.
    pgApplyColorFilterState(sectionEl, pgGetCheckedColorValues(form));

    // Per-section count badges inside the drawer
    form.querySelectorAll('[data-filter-count]').forEach(function(badge) {
      var name = badge.dataset.filterCount;
      var n;
      if (name === 'cs_price') {
        n = (priceMin !== null ? 1 : 0) + (priceMax !== null ? 1 : 0);
      } else {
        n = form.querySelectorAll('input[name="' + name + '"]:checked').length;
      }
      badge.textContent = n > 0 ? n : '';
      badge.classList.toggle('is-active', n > 0);
    });

    // Toolbar Filters total badge
    var total = avail.length + types.length + vendors.length;
    total += toArr(form.querySelectorAll('input[name^="cs_opt_"]:checked')).length;
    if (priceMin !== null) total++;
    if (priceMax !== null) total++;
    var totalBadge = document.getElementById('pg-filter-total-' + sectionId);
    if (totalBadge) {
      totalBadge.textContent = total > 0 ? total : '';
      totalBadge.classList.toggle('is-active', total > 0);
    }
  }

  if (!window._pgToolbarDelegated) {
    window._pgToolbarDelegated = true;

    document.addEventListener('click', function(e) {
      var sectionEl = e.target.closest('[id^="shopify-section-"]');
      var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;

      // ── Swatch click ─────────────────────────────────────────
      var swatch = e.target.closest('.product-card__swatch[data-color]');
      if (swatch) {
        var pgSection = swatch.closest('.product-grid-section');
        var swatchMode = pgSection ? pgSection.dataset.swatchMode : 'off';
        var card = swatch.closest('.product-card');
        if (swatchMode === 'click' && window.innerWidth >= 1200) {
          // Desktop: preview mode — toggle active state + update image + update link
          e.preventDefault();
          e.stopPropagation();
          var wrapper = card && card.querySelector('.product-card__image-wrapper');
          var isActive = swatch.classList.contains('is-preview-active');
          card.querySelectorAll('.product-card__swatch.is-preview-active').forEach(function(s) {
            s.classList.remove('is-preview-active');
          });
          var imgLink = card.querySelector('.product-card__image-link');
          if (!imgLink.dataset.baseUrl) imgLink.dataset.baseUrl = imgLink.href;
          if (isActive) {
            if (wrapper && wrapper._pgResetColor) wrapper._pgResetColor();
            if (wrapper && wrapper._pgSyncButtons) wrapper._pgSyncButtons(null);
            if (imgLink) imgLink.href = imgLink.dataset.baseUrl;
          } else {
            swatch.classList.add('is-preview-active');
            if (wrapper && wrapper._pgShowColor) wrapper._pgShowColor(swatch.dataset.color);
            if (wrapper && wrapper._pgSyncButtons) wrapper._pgSyncButtons(swatch.dataset.variantId);
            if (imgLink) imgLink.href = swatch.dataset.variantId ? imgLink.dataset.baseUrl + '?variant=' + swatch.dataset.variantId : imgLink.dataset.baseUrl;
          }
          return;
        } else if (swatchMode === 'click' && window.innerWidth < 1200) {
          // Mobile: no preview, just navigate like off mode
          e.preventDefault();
          e.stopPropagation();
          var url = swatch.dataset.productUrl || '';
          var variantId = swatch.dataset.variantId || '';
          if (url) window.location.href = variantId ? url + '?variant=' + variantId : url;
          return;
        }
        // swatchMode 'off' or 'hover': navigation handled by inline element listener
      }

      // ── View by ──────────────────────────────────────────────
      var viewBtn = e.target.closest('.pg-view-by__btn');
      if (viewBtn) {
        var sec = viewBtn.closest('[id^="shopify-section-"]');
        if (sec) {
          var grid = sec.querySelector('.product-grid');
          if (grid) grid.style.gridTemplateColumns = 'repeat(' + viewBtn.dataset.cols + ', 1fr)';
          viewBtn.closest('.pg-view-by').querySelectorAll('.pg-view-by__btn').forEach(function(b) {
            b.classList.toggle('pg-view-by__btn--active', b === viewBtn);
          });
          var prodSec = sec.querySelector('.product-grid-section');
          if (prodSec) prodSec.dataset.pgViewChanged = 'true';
          pgRecomputeToolbarActive(sec);
        }
        return;
      }

      // ── Sort button ──────────────────────────────────────────
      var sortBtn = e.target.closest('.pg-sort-btn');
      if (sortBtn) {
        e.stopPropagation();
        var panel = sortBtn.nextElementSibling;
        var isOpen = sortBtn.getAttribute('aria-expanded') === 'true';
        sortBtn.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
        return;
      }

      // ── Sort option ──────────────────────────────────────────
      var sortOpt = e.target.closest('.pg-sort-option');
      if (sortOpt) {
        var sec = sortOpt.closest('[id^="shopify-section-"]');
        if (!sec) return;
        var grid = sec.querySelector('.product-grid');
        if (!grid) return;
        var sortValue = sortOpt.dataset.sortValue;
        sortOpt.closest('.pg-sort-panel').hidden = true;
        var sb = sec.querySelector('.pg-sort-btn');
        if (sb) sb.setAttribute('aria-expanded', 'false');
        sec.querySelectorAll('.pg-sort-option').forEach(function(o) {
          o.classList.toggle('pg-sort-option--active', o === sortOpt);
        });
        var cards = Array.from(grid.querySelectorAll('.product-card'));
        cards.sort(function(a, b) {
          var pa = parseInt(a.dataset.price || '0', 10);
          var pb = parseInt(b.dataset.price || '0', 10);
          return sortValue === 'price-ascending' ? pa - pb : pb - pa;
        });
        grid.style.opacity = '0.4';
        grid.style.transition = 'opacity 0.2s';
        setTimeout(function() {
          cards.forEach(function(c, i) {
            c.style.order = i + 1;  // reassign order values instead of moving DOM nodes
          });
          grid.style.opacity = '1';
        }, 200);
        var prodSec = sec.querySelector('.product-grid-section');
        if (prodSec) prodSec.dataset.pgSortChanged = 'true';
        pgRecomputeToolbarActive(sec);
        return;
      }

      // ── Filter button (open drawer) ──────────────────────────
      var filterBtn = e.target.closest('.pg-filter-btn');
      if (filterBtn) {
        e.stopPropagation();
        var sec = filterBtn.closest('[id^="shopify-section-"]');
        if (!sec) return;
        var sid = sec.id.replace('shopify-section-', '');
        var drawer = document.getElementById('pg-filter-drawer-' + sid);
        var overlay = document.getElementById('pg-filter-overlay-' + sid);
        if (drawer) openFilterDrawer(drawer, overlay);
        // (Previously: pgLoadShopifyFiltersIntoDrawer(form) — swapped the
        // drawer's contents with the collection page's Shopify-rendered
        // filters and made Apply redirect to /collections/.../?filter…
        // Removed so non-collection pages keep the in-place client-side
        // filter behavior — Apply hides/shows cards on the current page
        // instead of navigating away.)
        return;
      }

      // ── Filter drawer close button ───────────────────────────
      var closeBtn = e.target.closest('.pg-filter-drawer__close');
      if (closeBtn) {
        var drawer = closeBtn.closest('.pg-filter-drawer');
        var sec = closeBtn.closest('[id^="shopify-section-"]');
        if (!sec) return;
        var sid = sec.id.replace('shopify-section-', '');
        var overlay = document.getElementById('pg-filter-overlay-' + sid);
        closeFilterDrawer(drawer, overlay);
        return;
      }

      // ── Filter overlay (close) ───────────────────────────────
      if (e.target.classList.contains('pg-filter-overlay')) {
        var sid = e.target.id.replace('pg-filter-overlay-', '');
        var drawer = document.getElementById('pg-filter-drawer-' + sid);
        closeFilterDrawer(drawer, e.target);
        return;
      }

      // ── Filter section accordion toggle ─────────────────────
      var filterToggle = e.target.closest('.pg-filter-section__header');
      if (filterToggle) {
        var body = filterToggle.nextElementSibling;
        var isOpen = filterToggle.classList.contains('pg-filter-section__header--open');
        var drawer = filterToggle.closest('.pg-filter-drawer');
        if (!drawer || !body) return;
        drawer.querySelectorAll('.pg-filter-section__header').forEach(function(h) {
          h.classList.remove('pg-filter-section__header--open');
          if (h.nextElementSibling) h.nextElementSibling.classList.remove('is-open');
        });
        if (!isOpen) {
          filterToggle.classList.add('pg-filter-section__header--open');
          body.classList.add('is-open');
        }
        return;
      }

      // ── Filter reset (clears filter inputs only — sort_by is preserved
      // because it's a hidden input outside the filter.* namespace). ──
      var resetBtn = e.target.closest('.pg-filter-reset');
      if (resetBtn) {
        var sec = resetBtn.closest('[id^="shopify-section-"]');
        if (!sec) return;
        e.preventDefault();
        var sid = sec.id.replace('shopify-section-', '');
        var form = document.getElementById('pg-filter-form-' + sid);
        if (form) form.querySelectorAll('input[name^="filter."], input[name^="cs_"]').forEach(function(cb) {
          if (cb.type === 'checkbox' || cb.type === 'radio') cb.checked = false;
          else cb.value = '';
        });
        if (form && form.dataset.pgRedirectOnApply === 'true') {
          // Non-collection page with Shopify filters loaded → take the user
          // to the unfiltered collection page.
          var target = form.dataset.collectionUrl || form.getAttribute('action') || '';
          if (target) { window.location.href = target; return; }
        }
        if (form && form.dataset.pgClientsideFilter === 'true') {
          applyClientsideFilters(sec, form);
        } else {
          fetchFilteredGrid(sec, sid);
        }
        pgRecomputeToolbarActive(sec);
        return;
      }

      // ── Filter apply ─────────────────────────────────────────
      // Three behaviors depending on form state:
      //  1. Shopify filters loaded on a non-collection page → redirect
      //     to the collection URL with form params so the user lands on
      //     the collection page with everything Shopify-native.
      //  2. Client-side mode (fetch hadn't completed, or no collection
      //     assigned) → run the in-place applyClientsideFilters.
      //  3. Collection page → AJAX fetch with section_id (existing
      //     fetchFilteredGrid path).
      var applyBtn = e.target.closest('.pg-filter-apply');
      if (applyBtn) {
        var sec = applyBtn.closest('[id^="shopify-section-"]');
        if (!sec) return;
        var sid = sec.id.replace('shopify-section-', '');
        var form = document.getElementById('pg-filter-form-' + sid);
        if (form && form.dataset.pgRedirectOnApply === 'true') {
          var data = new FormData(form);
          var params = new URLSearchParams();
          data.forEach(function(v, k) {
            if (k === 'page') return;
            if (v === '' || v == null) return;
            params.append(k, v);
          });
          var target = (form.dataset.collectionUrl || form.getAttribute('action') || '');
          if (target) {
            window.location.href = target + (params.toString() ? '?' + params.toString() : '');
            return;
          }
        }
        if (form && form.dataset.pgClientsideFilter === 'true') {
          applyClientsideFilters(sec, form);
        } else {
          fetchFilteredGrid(sec, sid);
        }
        pgRecomputeToolbarActive(sec);
        var drawer = document.getElementById('pg-filter-drawer-' + sid);
        var overlay = document.getElementById('pg-filter-overlay-' + sid);
        closeFilterDrawer(drawer, overlay);
        return;
      }

      // ── Close sort panel on outside click ────────────────────
      document.querySelectorAll('.pg-sort-panel').forEach(function(p) { p.hidden = true; });
      document.querySelectorAll('.pg-sort-btn').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
    });

    // ── Escape key closes filter drawer ──────────────────────
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.pg-filter-drawer[aria-hidden="false"]').forEach(function(drawer) {
        var sid = drawer.id.replace('pg-filter-drawer-', '');
        var overlay = document.getElementById('pg-filter-overlay-' + sid);
        closeFilterDrawer(drawer, overlay);
      });
    });
  }

  // Filter restoration is no longer needed — URL params are the source
  // of truth, and Liquid renders the form with checked state already
  // reflecting them via value.active on each filter value.

  // Back/forward navigation: refetch when the URL changes so filter
  // state stays in sync with the visible grid.
  window.addEventListener('popstate', function() {
    var sectionEl = document.getElementById('shopify-section-{{ section.id }}');
    if (!sectionEl) return;
    var form = document.getElementById('pg-filter-form-{{ section.id }}');
    if (!form) return;
    fetchFilteredGrid(sectionEl, '{{ section.id }}', window.location.href);
  });

  // ── Sticky toolbar (runs per section) ──────────────────────
  (function() {
    function initStickyToolbars() {
      document.querySelectorAll('.pg-toolbar[data-sticky="true"]').forEach(function(toolbar) {
        if (toolbar._pgStickyInit) return;
        toolbar._pgStickyInit = true;
        var sectionId = toolbar.dataset.sectionId;
        var spacer = document.getElementById('pg-toolbar-spacer-' + sectionId);
        if (!spacer) return;
        var toolbarHeight = toolbar.offsetHeight;
        var toolbarTop = toolbar.getBoundingClientRect().top + window.scrollY;
        var isFixed = false;
        var ticking = false;
        var sectionEl = toolbar.closest('[id^="shopify-section-"]');
        spacer.style.height = toolbarHeight + 'px';
        function getStickyHeaderBottom() {
          var offset = 0;
          var hw = document.querySelector('.header-wrapper');
          var bar = document.getElementById('announcement-bar');
          if (hw && (hw.style.position === 'fixed' || getComputedStyle(hw).position === 'fixed')) offset = Math.max(offset, hw.getBoundingClientRect().bottom);
          if (bar && (bar.style.position === 'fixed' || getComputedStyle(bar).position === 'fixed')) offset = Math.max(offset, bar.getBoundingClientRect().bottom);
          return Math.round(offset);
        }
        function onScroll() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function() {
            var scrollY = window.scrollY;
            var stickyOffset = getStickyHeaderBottom();
            var pastSection = sectionEl && sectionEl.getBoundingClientRect().bottom <= stickyOffset + toolbarHeight;
            if (!pastSection && scrollY + stickyOffset >= toolbarTop && !isFixed) {
              isFixed = true; toolbar.classList.add('pg-toolbar--sticky'); toolbar.style.top = stickyOffset + 'px'; spacer.style.display = 'block';
            } else if ((scrollY + stickyOffset < toolbarTop || pastSection) && isFixed) {
              isFixed = false; toolbar.classList.remove('pg-toolbar--sticky'); toolbar.style.top = ''; spacer.style.display = 'none';
            } else if (isFixed) {
              toolbar.style.top = stickyOffset + 'px';
            }
            ticking = false;
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        document.addEventListener('shopify:section:load', function() { window.removeEventListener('scroll', onScroll); toolbar._pgStickyInit = false; });
      });
    }
    document.addEventListener('DOMContentLoaded', initStickyToolbars);
    document.addEventListener('shopify:section:load', initStickyToolbars);
  })();

  /* Previously preloaded Shopify's collection-page filter form into the
     drawer on every non-collection page so the filter list matched the
     collection page exactly. Disabled because Apply on the injected
     form redirected to the collection page — losing the in-place
     filtering merchants expect on non-collection sections. The
     pgLoadShopifyFiltersIntoDrawer function above is kept in case we
     want to re-enable it behind a per-section setting later. */

})();

(function() {
  /* Per-section bootstrap: pagination AJAX, filter selection counts,
     quick-add drawer, product card image nav + swatch hover preview.
     All values that used to be Liquid-interpolated are now read from
     data-* attributes on the .product-grid-section root or on the
     specific elements (cards, quick-add buttons). Init is idempotent
     (data-csp-init guard) and re-runs on shopify:section:load. */

  function initSection(root) {
    if (!root || root.dataset.cspInit === 'true') return;
    root.dataset.cspInit = 'true';

    var sectionId      = root.dataset.sectionId;
    var swatchPreviewMode = root.dataset.swatchMode || 'off';
    var hoverSecondImg = root.dataset.pgHoverSecondImage === 'true';
    var infoPosition   = root.dataset.pgInfoPosition || '';
    var mobileSwipe    = root.dataset.pgMobileSwipe === 'true';
    var ATC_STYLE_CART     = root.dataset.pgQaAtcStyle      || 'primary';
    var ATC_STYLE_WISHLIST = root.dataset.pgQaWishlistStyle || 'secondary';
    var cartType   = root.dataset.pgCartType      || 'drawer';
    var addAction  = root.dataset.pgCartAddAction || 'drawer';
    var MSG_SOLDOUT = root.dataset.pgMsgSoldout || 'This product is sold out.';
    var MSG_STOCK   = root.dataset.pgMsgStock   || 'Sorry, only %available% available and you already have %in_cart% in your cart.';
    var MSG_ADDED   = root.dataset.pgMsgAdded   || 'Your selection has been reserved.';

    var pgT = {
      addToCart:              root.dataset.pgI18nAddToCart        || 'Add to cart',
      addToWishlist:          root.dataset.pgI18nAddToWishlist    || 'Add to wishlist',
      removeFromList:         root.dataset.pgI18nRemoveFromList   || 'Remove from list',
      adding:                 root.dataset.pgI18nAdding           || 'Adding...',
      soldOut:                root.dataset.pgI18nSoldOut          || 'Sold out',
      unavailable:            root.dataset.pgI18nUnavailable      || 'Unavailable',
      errorStock:             root.dataset.pgI18nErrorStock       || '',
      errorGeneric:           root.dataset.pgI18nErrorGeneric     || 'Something went wrong. Please try again.',
      addToWishlistAria:      root.dataset.pgI18nAddToWishlistAria      || 'Add to wishlist',
      removeFromWishlistAria: root.dataset.pgI18nRemoveFromWishlistAria || 'Remove from wishlist'
    };

    var containerId = 'pg-ajax-container-' + sectionId;
    var sectionEl   = document.getElementById('shopify-section-' + sectionId);

    // ── Pagination AJAX (delegated on document, but scoped to this section) ──
    function handlePaginationClick(e) {
      if (!root.contains(e.target)) return;
      var link = e.target.closest('a.pg-pagination__item');
      if (!link) return;
      var container = document.getElementById(containerId);
      if (!container) return;

      e.preventDefault();
      e.stopPropagation();

      var url = link.href;

      container.style.transition = 'opacity 0.2s ease';
      container.style.opacity = '0';

      fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newContainer = doc.getElementById(containerId);
          if (!newContainer) { window.location.href = url; return; }

          container.innerHTML = newContainer.innerHTML;
          history.pushState({}, '', url);

          var section = container.closest('.product-grid-section');
          if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });

          container.style.opacity = '0';
          requestAnimationFrame(function() {
            container.style.transition = 'opacity 0.3s ease';
            container.style.opacity = '1';
          });
        })
        .catch(function() { window.location.href = url; });
    }
    document.addEventListener('click', handlePaginationClick);

    // ── Filter selection counts ───────────────────────────────────────────
    // Live-updates the per-section count badges and the toolbar total
    // as the user toggles filter checkboxes BEFORE pressing Apply. The
    // initial counts on first paint come from Liquid (active_values.size).
    (function() {
      if (!sectionEl) return;
      function updateFilterCounts() {
        sectionEl.querySelectorAll('.pg-filter-section').forEach(function(sec) {
          var badge = sec.querySelector('.pg-filter-section__count');
          if (!badge) return;
          var checked = sec.querySelectorAll('input[name^="filter."]:checked').length;
          badge.textContent = checked > 0 ? checked : '';
          badge.classList.toggle('is-active', checked > 0);
        });
        var totalBadge = document.getElementById('pg-filter-total-' + sectionId);
        if (totalBadge) {
          var total = sectionEl.querySelectorAll('.pg-filter-drawer input[name^="filter."]:checked').length;
          totalBadge.textContent = total > 0 ? total : '';
          totalBadge.classList.toggle('is-active', total > 0);
        }
      }

      sectionEl.addEventListener('change', function(e) {
        if (e.target && e.target.name && e.target.name.indexOf('filter.') === 0) updateFilterCounts();
      });
    })();

    // ── Quick Add Drawer ─────────────────────────────────────────────────
    (function() {
      var drawer  = document.getElementById('pg-qa-drawer-' + sectionId);
      var overlay = document.getElementById('pg-qa-overlay-' + sectionId);
      if (!drawer) return;

      var titleEl   = drawer.querySelector('.pg-qa-drawer__product-title');
      var priceEl   = drawer.querySelector('.pg-qa-drawer__price');
      var imageEl   = drawer.querySelector('.pg-qa-drawer__image');
      var optionsEl = drawer.querySelector('.pg-qa-drawer__options');
      var atcBtn    = drawer.querySelector('.pg-qa-drawer__atc');
      var closeBtn  = drawer.querySelector('.pg-qa-drawer__close');

      /* Button style tokens read from section root dataset so the ATC
         button can swap its data-button-style attribute based on which
         flow opened the panel. "ATC" style applies when adding to cart;
         "wishlist" style applies when the panel was opened via the
         wishlist icon (add OR remove). Both values are 'primary' or
         'secondary' and plug into the global [data-button-style] CSS
         system. */
      function applyAtcStyle(mode) {
        atcBtn.dataset.buttonStyle = (mode === 'wishlist') ? ATC_STYLE_WISHLIST : ATC_STYLE_CART;
        atcBtn.dataset.qaMode = mode;
      }

      var currentVariants = [];
      var selectedOptions = {};
      var wishlistMode = false;        // true when panel opened from wishlist button (add)
      var wishlistRemoveMode = false;  // true when panel opened to remove from wishlist
      var wishlistSourceBtn = null;    // the wishlist button that triggered the panel
      var wishlistHandle = null;       // product handle for wishlist mode

      /* Cart toast wrapper — thin shim around window.cartToast. */
      function showToast(msg, isError, btn) {
        if (!window.cartToast) return;
        var productImage = btn && btn.dataset ? (btn.dataset.productImage || '') : '';
        var productTitle = btn && btn.dataset ? (btn.dataset.productTitle || '') : '';
        window.cartToast.show({
          type:         isError ? 'error' : 'success',
          message:      msg,
          productImage: productImage,
          productTitle: productTitle,
          quantity:     1
        });
      }

      // Cart quantity cache — keyed by variant id string
      var cartQty = {};
      function refreshCartQty(cb) {
        fetch('/cart.js')
          .then(function(r){ return r.json(); })
          .then(function(cart){
            cartQty = {};
            cart.items.forEach(function(item){ cartQty[String(item.variant_id)] = item.quantity; });
            if (cb) cb();
          })
          .catch(function(){ if (cb) cb(); });
      }
      refreshCartQty();

      function openDrawer()  {
        drawer.setAttribute('aria-hidden','false');
        overlay.setAttribute('aria-hidden','false');
        document.body.style.overflow = 'hidden';
        if (wishlistRemoveMode) {
          atcBtn.textContent = pgT.removeFromList;
          atcBtn.classList.add('pg-qa-drawer__atc--wishlist');
          atcBtn.classList.add('pg-qa-drawer__atc--remove');
        } else if (wishlistMode) {
          atcBtn.textContent = pgT.addToWishlist;
          atcBtn.classList.add('pg-qa-drawer__atc--wishlist');
          atcBtn.classList.remove('pg-qa-drawer__atc--remove');
        } else {
          atcBtn.textContent = pgT.addToCart;
          atcBtn.classList.remove('pg-qa-drawer__atc--wishlist');
          atcBtn.classList.remove('pg-qa-drawer__atc--remove');
        }
      }
      function closeDrawer() {
        drawer.setAttribute('aria-hidden','true');
        overlay.setAttribute('aria-hidden','true');
        document.body.style.overflow = '';
        wishlistMode = false;
        wishlistRemoveMode = false;
        wishlistSourceBtn = null;
        wishlistHandle = null;
        atcBtn.textContent = pgT.addToCart;
        atcBtn.classList.remove('pg-qa-drawer__atc--wishlist');
        atcBtn.classList.remove('pg-qa-drawer__atc--remove');
        applyAtcStyle('cart');
      }

      function money(cents) {
        var n = (cents / 100).toFixed(2);
        var parts = n.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return '$ ' + parts.join('.');
      }

      function findVariant() {
        return currentVariants.find(function(v) {
          return v.options.every(function(opt, i) { return selectedOptions['o'+(i+1)] === opt; });
        }) || null;
      }

      function updateAtcBtn() {
        var v = findVariant();

        if (v && (wishlistMode || wishlistRemoveMode)) {
          var inWl = window.wishlistDrawer
            ? window.wishlistDrawer.isInWishlist(v.id)
            : (function() {
                try { return (JSON.parse(localStorage.getItem('wishlist_items')) || []).some(function(i) { return String(i.variantId) === String(v.id); }); }
                catch(e) { return false; }
              })();
          wishlistRemoveMode = inWl;
          wishlistMode = !inWl;
          atcBtn.classList.toggle('pg-qa-drawer__atc--remove', inWl);
        }

        if (!v) {
          atcBtn.textContent = wishlistRemoveMode ? pgT.removeFromList : (wishlistMode ? pgT.addToWishlist : pgT.unavailable);
          atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
          delete atcBtn.dataset.variantId;
        } else if (!v.available) {
          atcBtn.textContent = wishlistRemoveMode ? pgT.removeFromList : (wishlistMode ? pgT.addToWishlist : pgT.soldOut);
          atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
          atcBtn.dataset.variantId = v.id;
        } else {
          atcBtn.textContent = wishlistRemoveMode ? pgT.removeFromList : (wishlistMode ? pgT.addToWishlist : pgT.addToCart);
          atcBtn.disabled = false;
          atcBtn.dataset.variantId = v.id;
        }
        if (v) {
          priceEl.textContent = money(v.price);
          if (v.featured_image) imageEl.src = v.featured_image.src;
        }
        optionsEl.querySelectorAll('.pg-qa-option-btn, .pg-qa-color-btn').forEach(function(b) {
          var testKey = 'o' + b.dataset.pos;
          var test = Object.assign({}, selectedOptions);
          test[testKey] = b.dataset.value;
          var ok = currentVariants.some(function(v) {
            return v.options.every(function(o,i){ return test['o'+(i+1)]===o; });
          });
          b.classList.toggle('is-unavailable', !ok);

          var otherSelections = Object.assign({}, selectedOptions);
          delete otherSelections[testKey];
          var soldOut = !currentVariants.some(function(v) {
            return v.available && v.options[parseInt(b.dataset.pos, 10) - 1] === b.dataset.value &&
              Object.keys(otherSelections).every(function(k) {
                return otherSelections[k] === v.options[parseInt(k.slice(1), 10) - 1];
              });
          });
          b.classList.toggle('is-sold-out', soldOut);
        });
      }

      var swatchMap = {};
      function parseSwatchMap(card) {
        swatchMap = {};
        if (!card) return;
        (card.dataset.swatches || '').split('||').forEach(function(entry) {
          if (!entry) return;
          var parts = entry.split(':');
          var key  = parts[0];
          var type = parts[1];
          var val  = parts.slice(2).join(':');
          swatchMap[key] = { type: type, val: val };
        });
      }

      function getSwatchStyle(val) {
        if (!val) return null;
        var key = String(val).toLowerCase().replace(/\s/g, '');
        var s = swatchMap[key];
        if (s && s.type === 'image' && s.val) return { backgroundImage: 'url(' + s.val + ')', backgroundSize: 'cover' };
        if (s && s.type === 'color' && s.val) return { backgroundColor: s.val };
        /* Fallback: when Shopify didn't auto-resolve a swatch for this
           option value (no swatch.color or swatch.image set, type is
           'none', or the value isn't in the map at all), try the value
           name itself as a CSS color. "Light Green" → "lightgreen" is
           a valid CSS named color, so the dot renders without the
           merchant having to set the swatch metafield. Strips spaces,
           hyphens, and underscores so values entered as "Light-Green"
           or "Light_Green" also resolve. Returns null for unknown
           names so the option renders as a plain text button. */
        var cssCandidate = String(val).toLowerCase().replace(/[\s\-_]/g, '');
        if (!cssCandidate) return null;
        var valid = false;
        if (typeof CSS !== 'undefined' && CSS.supports) {
          valid = CSS.supports('color', cssCandidate);
        } else {
          var tester = getSwatchStyle._tester || (getSwatchStyle._tester = document.createElement('div'));
          tester.style.backgroundColor = '';
          tester.style.backgroundColor = cssCandidate;
          valid = tester.style.backgroundColor !== '';
        }
        if (valid) return { backgroundColor: cssCandidate };
        return null;
      }

      function renderOptions(product, preselectId) {
        currentVariants = product.variants;
        selectedOptions = {};
        var hasRealVariants = product.variants.length > 1 ||
          (product.variants.length === 1 && product.variants[0].title !== 'Default Title');
        optionsEl.style.display = hasRealVariants ? '' : 'none';
        var first = product.variants[0];
        if (preselectId) {
          var preVariant = product.variants.find(function(v){ return String(v.id) === String(preselectId); });
          if (preVariant) first = preVariant;
        }
        if (!first) first = product.variants.find(function(v){ return v.available; }) || product.variants[0];
        product.options.forEach(function(name, i) { selectedOptions['o'+(i+1)] = first.options[i]; });

        optionsEl.innerHTML = '';
        product.options.forEach(function(optRaw, idx) {
          var optName = typeof optRaw === 'object' ? optRaw.name : optRaw;
          var pos = idx + 1;

          var vals = [];
          product.variants.forEach(function(v){ if (vals.indexOf(v.options[idx])===-1) vals.push(v.options[idx]); });

          var isColor = vals.some(function(v) { return !!getSwatchStyle(v); });

          var wrap  = document.createElement('div');  wrap.className = 'pg-qa-option';
          var label = document.createElement('p');    label.className = 'pg-qa-option__label';
          var selSpan = document.createElement('span'); selSpan.className = 'pg-qa-option__selected'; selSpan.textContent = selectedOptions['o'+pos];
          label.textContent = optName + ': '; label.appendChild(selSpan);
          var btns = document.createElement('div');
          btns.className = isColor ? 'pg-qa-option__btns pg-qa-option__btns--colors' : 'pg-qa-option__btns';

          vals.forEach(function(val) {
            var swatch = isColor ? getSwatchStyle(val) : null;
            var btn = document.createElement('button');
            btn.dataset.pos = pos; btn.dataset.value = val;

            var colorSoldOut = isColor && !currentVariants.some(function(v) {
              return v.options[idx] === val && v.available;
            });

            if (swatch) {
              btn.className = 'pg-qa-color-btn';
              if (colorSoldOut) btn.classList.add('is-sold-out');
              var dot = document.createElement('span');
              dot.className = 'pg-qa-color-dot';
              Object.assign(dot.style, swatch);
              var name = document.createElement('span');
              name.className = 'pg-qa-color-name';
              name.textContent = val.toUpperCase();
              btn.appendChild(dot); btn.appendChild(name);
            } else {
              btn.className = 'pg-qa-option-btn';
              btn.textContent = val;
              if (!currentVariants.some(function(v) { return v.options[idx] === val && v.available; })) {
                btn.classList.add('is-sold-out');
              }
            }

            if (selectedOptions['o'+pos] === val) btn.classList.add('is-selected');
            btn.addEventListener('click', function() {
              selectedOptions['o'+pos] = val;
              selSpan.textContent = val;
              btns.querySelectorAll('.pg-qa-option-btn, .pg-qa-color-btn').forEach(function(b){ b.classList.remove('is-selected'); });
              btn.classList.add('is-selected');
              updateAtcBtn();
            });
            btns.appendChild(btn);
          });
          wrap.appendChild(label); wrap.appendChild(btns);
          optionsEl.appendChild(wrap);
        });
        updateAtcBtn();
      }

      // Parse variant inventory from product card data attribute (set server-side by Liquid)
      var variantInvMap = {};
      function parseVariantInvMap(card) {
        variantInvMap = {};
        if (!card) return;
        (card.dataset.variantInv || '').split('|').forEach(function(entry) {
          if (!entry) return;
          var parts = entry.split(':');
          if (parts.length < 3) return;
          variantInvMap[parts[0]] = { qty: parseInt(parts[1], 10), policy: parts[2] };
        });
      }

      function loadAndOpen(handle, btn, preselectId) {
        var card = btn.closest('.product-card');
        parseVariantInvMap(card);
        parseSwatchMap(card);
        btn.classList.add('is-loading');
        fetch('/products/' + handle + '.js')
          .then(function(r){ return r.json(); })
          .then(function(p) {
            btn.classList.remove('is-loading');
            titleEl.textContent = p.title;
            priceEl.textContent = money(p.price_min);
            imageEl.src = p.featured_image || '';
            imageEl.alt = p.title;
            atcBtn.dataset.productTitle = p.title;
            renderOptions(p, preselectId);
            refreshCartQty(function() { openDrawer(); });
          })
          .catch(function(err){ btn.classList.remove('is-loading'); console.error('pg-qa fetch error:', err); });
      }

      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.product-card__quick-add');
        if (!btn) return;
        if (sectionEl && !sectionEl.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();
        if (btn.dataset.multiVariant !== 'true' && btn.dataset.variantId) {
          var vid       = String(btn.dataset.variantId);
          var invQty    = parseInt(btn.dataset.inventory, 10);
          var invPolicy = btn.dataset.inventoryPolicy || 'deny';
          var inCart    = cartQty[vid] || 0;

          if (btn.dataset.available === 'false') {
            showToast(MSG_SOLDOUT, true);
            return;
          }

          if (invPolicy === 'deny' && !isNaN(invQty) && invQty > 0 && inCart >= invQty) {
            showToast(MSG_STOCK.replace('%available%', invQty).replace('%in_cart%', inCart), true);
            return;
          }

          btn.classList.add('is-loading');
          fetch('/cart/add.js', {
            method: 'POST', headers: {'Content-Type':'application/json'},
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
          })
          .then(function(r){ return r.json().then(function(d){ return {ok: r.ok, data: d}; }); })
          .then(function(res){
            btn.classList.remove('is-loading');
            if (res.ok) {
              cartQty[vid] = (cartQty[vid] || 0) + 1;
              showToast(MSG_ADDED, false, btn);
              document.dispatchEvent(new CustomEvent('cart:updated'));
              handlePostAdd();
            } else {
              refreshCartQty();
              var errMsg = (res.data && (res.data.description || res.data.message)) || pgT.errorGeneric;
              showToast(errMsg, true);
            }
          })
          .catch(function(){ btn.classList.remove('is-loading'); showToast(pgT.errorGeneric, true); });
        } else {
          loadAndOpen(btn.dataset.productHandle, btn, btn.dataset.variantId);
        }
      });

      atcBtn.addEventListener('click', function() {
        var vid = atcBtn.dataset.variantId;
        if (!vid || vid === 'undefined') return;

        // ── Wishlist remove mode ───────────────────────────────────
        if (wishlistRemoveMode) {
          if (window.wishlistDrawer) window.wishlistDrawer.remove(vid);
          document.querySelectorAll('[data-wishlist-add="' + vid + '"]').forEach(function(b) {
            b.classList.remove('is-wishlisted');
            b.setAttribute('aria-label', pgT.addToWishlistAria);
          });
          closeDrawer();
          return;
        }
        // ── Wishlist add mode ──────────────────────────────────────
        if (wishlistMode) {
          var srcBtn = wishlistSourceBtn;
          var handle = wishlistHandle;
          if (window.wishlistDrawer) {
            window.wishlistDrawer.add(vid, handle);
          } else {
            try {
              var wlItems = JSON.parse(localStorage.getItem('wishlist_items')) || [];
              if (!wlItems.some(function(i) { return i.variantId == vid; })) {
                wlItems.push({ variantId: vid, productHandle: handle, addedAt: Date.now() });
                localStorage.setItem('wishlist_items', JSON.stringify(wlItems));
              }
            } catch(e) {}
          }

          if (srcBtn) {
            srcBtn.classList.add('is-wishlisted');
            srcBtn.setAttribute('aria-label', pgT.removeFromWishlistAria);
          }
          document.querySelectorAll('[data-wishlist-add="' + vid + '"]').forEach(function(b) {
            b.classList.add('is-wishlisted');
          });

          closeDrawer();
          if (window.wishlistDrawer) window.wishlistDrawer.open();
          return;
        }

        // ── Normal ATC mode ───────────────────────────────────────
        var nvid = String(atcBtn.dataset.variantId);
        var invData = variantInvMap[nvid] || {};
        var invQty = invData.qty != null ? invData.qty : NaN;
        var invPolicy = invData.policy || 'deny';
        var inCart = cartQty[nvid] || 0;
        if (invPolicy === 'deny' && !isNaN(invQty) && invQty > 0 && inCart >= invQty) {
          showToast(MSG_STOCK.replace('%available%', invQty).replace('%in_cart%', inCart), true);
          return;
        }
        atcBtn.textContent = pgT.adding; atcBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json'},
          body: JSON.stringify({ id: nvid, quantity: 1 })
        })
        .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, data: d }; }); })
        .then(function(res){
          if (res.ok) {
            cartQty[String(nvid)] = (cartQty[String(nvid)] || 0) + 1;
            closeDrawer();
            var qaCtx = { dataset: { productImage: (imageEl && imageEl.src) || '', productTitle: (titleEl && titleEl.textContent) || '' } };
            showToast(MSG_ADDED, false, qaCtx);
            document.dispatchEvent(new CustomEvent('cart:updated'));
            handlePostAdd();
          } else {
            atcBtn.textContent = pgT.addToCart; atcBtn.disabled = false;
            refreshCartQty();
            var errMsg = (res.data && (res.data.description || res.data.message)) || pgT.errorGeneric;
            showToast(errMsg, true);
          }
        })
        .catch(function(){ atcBtn.textContent = pgT.addToCart; atcBtn.disabled = false; showToast(pgT.errorGeneric, true); });
      });

      closeBtn.addEventListener('click', closeDrawer);
      overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function(e){ if (e.key==='Escape') closeDrawer(); });

      // Expose API for wishlist drawer to open in wishlist mode
      window.pgQuickAdd = window.pgQuickAdd || {};
      window.pgQuickAdd[sectionId] = {
        openForWishlistRemove: function(handle, sourceBtn, preselectId) {
          wishlistMode = false;
          wishlistRemoveMode = true;
          wishlistSourceBtn = sourceBtn;
          wishlistHandle = handle;
          /* Pull the source card's swatch data into the drawer's
             local swatchMap BEFORE rendering. Without this, the
             map is empty/stale and image-type swatches (which
             can't fall back to the CSS named-color test in
             getSwatchStyle) render as plain text buttons. The
             cart-mode loadAndOpen path does the same call below. */
          var srcCardR = sourceBtn ? sourceBtn.closest('.product-card') : null;
          if (srcCardR) { parseVariantInvMap(srcCardR); parseSwatchMap(srcCardR); }
          fetch('/products/' + handle + '.js')
            .then(function(r){ return r.json(); })
            .then(function(p) {
              titleEl.textContent = p.title;
              priceEl.textContent = money(p.price_min);
              imageEl.src = p.featured_image || '';
              imageEl.alt = p.title;
              atcBtn.dataset.productTitle = p.title;
              renderOptions(p, preselectId);
              applyAtcStyle('wishlist');
              openDrawer();
            })
            .catch(function() {
              wishlistRemoveMode = false;
              if (window.wishlistDrawer) window.wishlistDrawer.remove(sourceBtn ? sourceBtn.dataset.wishlistAdd : null);
            });
        },

        openForWishlist: function(handle, sourceBtn) {
          /* Same fix as openForWishlistRemove above — populate the
             drawer's swatchMap from the source card's data-swatches
             BEFORE renderOptions, so image-type swatches (Natural,
             Multi-Brown, etc.) actually render instead of falling
             through to a text-only button. */
          var srcCardW = sourceBtn ? sourceBtn.closest('.product-card') : null;
          if (srcCardW) { parseVariantInvMap(srcCardW); parseSwatchMap(srcCardW); }
          fetch('/products/' + handle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(p) {
              var hasRealVariants = p.variants.length > 1 ||
                (p.variants.length === 1 && p.variants[0].title !== 'Default Title');

              if (!hasRealVariants) {
                var vid = p.variants[0].id;
                if (window.wishlistDrawer) {
                  window.wishlistDrawer.add(vid, handle);
                } else {
                  try {
                    var wlItems = JSON.parse(localStorage.getItem('wishlist_items')) || [];
                    if (!wlItems.some(function(i) { return i.variantId == vid; })) {
                      wlItems.push({ variantId: vid, productHandle: handle, addedAt: Date.now() });
                      localStorage.setItem('wishlist_items', JSON.stringify(wlItems));
                    }
                  } catch(e) {}
                }
                if (sourceBtn) {
                  sourceBtn.classList.add('is-wishlisted');
                  sourceBtn.setAttribute('aria-label', pgT.removeFromWishlistAria);
                }
                if (window.wishlistDrawer) window.wishlistDrawer.open();
              } else {
                wishlistMode = true;
                wishlistSourceBtn = sourceBtn;
                wishlistHandle = handle;
                titleEl.textContent = p.title;
                priceEl.textContent = money(p.price_min);
                imageEl.src = p.featured_image || '';
                imageEl.alt = p.title;
                atcBtn.dataset.productTitle = p.title;
                var preselectId = sourceBtn ? sourceBtn.dataset.wishlistAdd : null;
                renderOptions(p, preselectId);
                applyAtcStyle('wishlist');
                openDrawer();
              }
            })
            .catch(function() {
              wishlistMode = true;
              wishlistSourceBtn = sourceBtn;
              wishlistHandle = handle;
              var preselectId = sourceBtn ? sourceBtn.dataset.wishlistAdd : null;
              applyAtcStyle('wishlist');
              loadAndOpen(handle, { classList: { add: function(){}, remove: function(){} } }, preselectId);
            });
        }
      };

      function handlePostAdd() {
        if (addAction === 'drawer' && cartType === 'drawer') {
          if (window.cartDrawer) window.cartDrawer.open();
        } else if (addAction === 'page') {
          window.location.href = '/cart';
        }
      }

      document.addEventListener('cart:updated', function(){ refreshCartQty(); });
    })();

    // ── Product card image nav arrows + swatch hover preview ─────
    (function() {
      function getIndexesForColor(imgs, colorName) {
        var lower = colorName.toLowerCase().trim();
        var matched = [];
        imgs.forEach(function(img, i) {
          var alt = (img.alt || img.getAttribute('alt') || '').toLowerCase().trim();
          var idx = alt.indexOf(lower);
          while (idx !== -1) {
            var before = idx === 0 || !/[a-z0-9]/.test(alt[idx - 1]);
            var after  = (idx + lower.length) >= alt.length || !/[a-z0-9]/.test(alt[idx + lower.length]);
            if (before && after) { matched.push(i); break; }
            idx = alt.indexOf(lower, idx + 1);
          }
        });
        return matched;
      }

      function syncCardButtons(card, variantId) {
        var qabtns = card.querySelectorAll('.product-card__quick-add');
        var wlbtns = card.querySelectorAll('.product-card__wishlist');
        if (variantId === null) {
          qabtns.forEach(function(b){ if (b.dataset.defaultVariantId) b.dataset.variantId   = b.dataset.defaultVariantId; });
          wlbtns.forEach(function(b){ if (b.dataset.defaultVariantId) b.dataset.wishlistAdd = b.dataset.defaultVariantId; });
        } else {
          qabtns.forEach(function(b){ if (!b.dataset.defaultVariantId) b.dataset.defaultVariantId = b.dataset.variantId;   b.dataset.variantId   = variantId; });
          wlbtns.forEach(function(b){ if (!b.dataset.defaultVariantId) b.dataset.defaultVariantId = b.dataset.wishlistAdd; b.dataset.wishlistAdd = variantId; });
        }
        if (window.wishlistDrawer && window.wishlistDrawer.sync) window.wishlistDrawer.sync();
        else {
          wlbtns.forEach(function(b) {
            try {
              var items = JSON.parse(localStorage.getItem('wishlist_items')) || [];
              var vid = b.dataset.wishlistAdd;
              var inList = items.some(function(i){ return String(i.variantId) === String(vid); });
              b.classList.toggle('is-wishlisted', inList);
              b.setAttribute('aria-label', inList ? pgT.removeFromWishlistAria : pgT.addToWishlistAria);
            } catch(e) {}
          });
        }
      }

      function initCardNav(wrapper) {
        if (wrapper.dataset.navInit) return;
        wrapper.dataset.navInit = '1';
        var track = wrapper.querySelector('[data-card-track]');
        if (!track) return;
        var allImgs = Array.from(track.querySelectorAll('.product-card__img'));
        var card = wrapper.closest('.product-card');
        var hasImageSliding = allImgs.length > 1;

        // ── Swatch active-state setup: always runs even for single-image products ──
        if (swatchPreviewMode === 'click' && card && window.innerWidth >= 1200) {
          // If the server pre-marked a swatch active (split-by-color cards
          // do this for the card's own color), respect that. Otherwise
          // fall back to the first swatch in DOM order, matching the
          // pre-split default.
          var firstSwatch = card.querySelector('.product-card__swatch.is-preview-active[data-color]') ||
                            card.querySelector('.product-card__swatch[data-color]');
          if (firstSwatch && firstSwatch.dataset.variantId) {
            firstSwatch.classList.add('is-preview-active');
            syncCardButtons(card, firstSwatch.dataset.variantId);
            var imgLink = card.querySelector('.product-card__image-link');
            if (imgLink) {
              if (!imgLink.dataset.baseUrl) imgLink.dataset.baseUrl = imgLink.href;
              imgLink.href = imgLink.dataset.baseUrl + '?variant=' + firstSwatch.dataset.variantId;
            }
          }
        }

        if (!hasImageSliding) {
          if (card && swatchPreviewMode !== 'click') {
            card.querySelectorAll('.product-card__swatch[data-color]').forEach(function(swatch) {
              swatch.addEventListener('click', function(e) {
                e.preventDefault(); e.stopPropagation();
                var url = swatch.dataset.productUrl || '';
                var variantId = swatch.dataset.variantId || '';
                if (url) window.location.href = variantId ? url + '?variant=' + variantId : url;
              });
            });
          }
          return;
        }

        // ── Multi-image sliding setup ─────────────────────────────────────────
        var prevBtn = wrapper.querySelector('.product-card__nav--prev');
        var nextBtn = wrapper.querySelector('.product-card__nav--next');
        var scrollbarThumb = wrapper.querySelector('[data-card-scrollbar] .product-card__scrollbar-thumb');

        var firstColor = wrapper.dataset.firstColor || '';
        var visibleIndexes = firstColor.length ? getIndexesForColor(allImgs, firstColor) : [];
        if (!visibleIndexes.length) visibleIndexes = allImgs.map(function(_, i){ return i; });

        var currentPos = 0;
        var slideTransition = hoverSecondImg;

        function updateScrollbar() {
          if (!scrollbarThumb) return;
          var n = visibleIndexes.length;
          if (n <= 0) return;
          scrollbarThumb.style.width = (100 / n) + '%';
          scrollbarThumb.style.transform = 'translateX(' + (currentPos * 100) + '%)';
        }

        function goTo(pos) {
          currentPos = Math.max(0, Math.min(visibleIndexes.length - 1, pos));
          if (slideTransition) {
            track.style.transition = 'transform 0.5s ease';
            void track.offsetWidth;
          }
          track.style.transform = 'translateX(-' + (visibleIndexes[currentPos] * 100) + '%)';
          if (prevBtn) prevBtn.classList.toggle('is-hidden', currentPos === 0);
          if (nextBtn) nextBtn.classList.toggle('is-hidden', currentPos === visibleIndexes.length - 1);
          updateScrollbar();
        }

        function snapTo(pos) {
          currentPos = Math.max(0, Math.min(visibleIndexes.length - 1, pos));
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + (visibleIndexes[currentPos] * 100) + '%)';
          if (prevBtn) prevBtn.classList.toggle('is-hidden', currentPos === 0);
          if (nextBtn) nextBtn.classList.toggle('is-hidden', currentPos === visibleIndexes.length - 1);
          if (scrollbarThumb) {
            wrapper.classList.add('is-snapping');
            updateScrollbar();
            void scrollbarThumb.offsetWidth;
            wrapper.classList.remove('is-snapping');
          }
        }

        var swatchFadeTransition = slideTransition
          ? 'opacity 0.15s ease, transform 0.5s ease'
          : 'opacity 0.15s ease, transform 0.35s ease';

        // Resolve a variant color value down to a recognized base color
        // (Navy/Royal/Sky → Blue, Burgundy/Maroon/Wine → Red, etc.) so we
        // can fall back when image alts are tagged with just the base color
        // even though the filter / swatch carries the full variant name.
        function pgBaseColor(name) {
          var v = (name || '').toLowerCase();
          if (v.indexOf('multi') !== -1 || v.indexOf('rainbow') !== -1) return 'multi';
          if (v.indexOf('off-white') !== -1 || v.indexOf('ivory') !== -1 || v.indexOf('cream') !== -1 || v.indexOf('eggshell') !== -1 || v.indexOf('pearl') !== -1) return 'white';
          if (v.indexOf('charcoal') !== -1 || v.indexOf('graphite') !== -1 || v.indexOf('gunmetal') !== -1) return 'gray';
          if (v.indexOf('gray') !== -1 || v.indexOf('grey') !== -1 || v.indexOf('silver') !== -1 || v.indexOf('slate') !== -1 || v.indexOf('ash') !== -1 || v.indexOf('pewter') !== -1) return 'gray';
          if (v.indexOf('black') !== -1 || v.indexOf('jet') !== -1 || v.indexOf('onyx') !== -1 || v.indexOf('ebony') !== -1) return 'black';
          if (v.indexOf('white') !== -1 || v.indexOf('chalk') !== -1) return 'white';
          if (v.indexOf('pink') !== -1 || v.indexOf('rose') !== -1 || v.indexOf('blush') !== -1 || v.indexOf('fuchsia') !== -1 || v.indexOf('salmon') !== -1 || v.indexOf('magenta') !== -1) return 'pink';
          if (v.indexOf('burgundy') !== -1 || v.indexOf('maroon') !== -1 || v.indexOf('wine') !== -1 || v.indexOf('crimson') !== -1 || v.indexOf('scarlet') !== -1 || v.indexOf('ruby') !== -1 || v.indexOf('cherry') !== -1) return 'red';
          if (v.indexOf('red') !== -1) return 'red';
          if (v.indexOf('rust') !== -1 || v.indexOf('terracotta') !== -1 || v.indexOf('copper') !== -1) return 'orange';
          if (v.indexOf('orange') !== -1 || v.indexOf('peach') !== -1 || v.indexOf('coral') !== -1 || v.indexOf('apricot') !== -1) return 'orange';
          if (v.indexOf('mustard') !== -1 || v.indexOf('gold') !== -1 || v.indexOf('amber') !== -1) return 'yellow';
          if (v.indexOf('yellow') !== -1 || v.indexOf('lemon') !== -1) return 'yellow';
          if (v.indexOf('olive') !== -1 || v.indexOf('forest') !== -1 || v.indexOf('sage') !== -1 || v.indexOf('mint') !== -1 || v.indexOf('lime') !== -1 || v.indexOf('emerald') !== -1 || v.indexOf('jade') !== -1 || v.indexOf('teal') !== -1) return 'green';
          if (v.indexOf('green') !== -1) return 'green';
          if (v.indexOf('turquoise') !== -1 || v.indexOf('aqua') !== -1 || v.indexOf('cyan') !== -1) return 'blue';
          if (v.indexOf('navy') !== -1 || v.indexOf('royal') !== -1 || v.indexOf('azure') !== -1 || v.indexOf('cobalt') !== -1 || v.indexOf('denim') !== -1 || v.indexOf('indigo') !== -1 || v.indexOf('cerulean') !== -1 || v.indexOf('sapphire') !== -1 || v.indexOf('midnight') !== -1) return 'blue';
          if (v.indexOf('blue') !== -1) return 'blue';
          if (v.indexOf('lavender') !== -1 || v.indexOf('lilac') !== -1 || v.indexOf('plum') !== -1 || v.indexOf('aubergine') !== -1 || v.indexOf('eggplant') !== -1 || v.indexOf('mauve') !== -1) return 'purple';
          if (v.indexOf('purple') !== -1 || v.indexOf('violet') !== -1) return 'purple';
          if (v.indexOf('tan') !== -1 || v.indexOf('beige') !== -1 || v.indexOf('khaki') !== -1 || v.indexOf('taupe') !== -1 || v.indexOf('camel') !== -1 || v.indexOf('chocolate') !== -1 || v.indexOf('mocha') !== -1 || v.indexOf('caramel') !== -1 || v.indexOf('sand') !== -1 || v.indexOf('nude') !== -1 || v.indexOf('bronze') !== -1) return 'brown';
          if (v.indexOf('brown') !== -1) return 'brown';
          return '';
        }

        function showColor(colorName) {
          var indexes = getIndexesForColor(allImgs, colorName);
          // If the exact variant name (e.g. "Navy Blue") doesn't appear in any
          // image alt, fall back to the base color ("Blue") so alt-tagged
          // images that use only the base color still match.
          if (!indexes.length) {
            var base = pgBaseColor(colorName);
            if (base && base.toLowerCase() !== (colorName || '').toLowerCase()) {
              indexes = getIndexesForColor(allImgs, base);
            }
          }
          if (!indexes.length) return;
          visibleIndexes = indexes;
          track.style.transition = swatchFadeTransition;
          track.style.opacity = '0';
          setTimeout(function() {
            snapTo(0);
            void track.offsetWidth;
            track.style.transition = swatchFadeTransition;
            track.style.opacity = '1';
          }, 150);
        }

        function resetColor() {
          var indexes = firstColor.length ? getIndexesForColor(allImgs, firstColor) : [];
          visibleIndexes = indexes.length ? indexes : allImgs.map(function(_, i){ return i; });
          track.style.transition = swatchFadeTransition;
          track.style.opacity = '0';
          setTimeout(function() {
            snapTo(0);
            void track.offsetWidth;
            track.style.transition = swatchFadeTransition;
            track.style.opacity = '1';
          }, 150);
        }

        // Initial positioning. Use snapTo (transition: none) so split-by-color
        // cards — whose first visible image sits at index > 0 — don't slide
        // through the earlier colors' images on first paint. snapTo leaves
        // `transition: none` inline; clear it after a reflow so subsequent
        // nav-arrow clicks animate via the CSS rule on .product-card__track.
        snapTo(0);
        void track.offsetWidth;
        track.style.transition = '';

        if (prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goTo(currentPos - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goTo(currentPos + 1); });

        // Desktop hover: slide to second image (gated at runtime on info-position + hover-second flags)
        if (infoPosition === 'below' && hoverSecondImg) {
          if (wrapper.hasAttribute('data-hover-second-img')) {
            wrapper.addEventListener('mouseenter', function() {
              if (window.innerWidth < 1200) return;
              if (currentPos === 0 && visibleIndexes.length > 1) {
                goTo(1);
              }
            });

            wrapper.addEventListener('mouseleave', function() {
              if (window.innerWidth < 1200) return;
              if (currentPos !== 0) {
                goTo(0);
              }
            });
          }
        }

        // Mobile swipe
        if (mobileSwipe) {
          var touchStartX = 0;
          var touchStartY = 0;
          var dragging = false;

          track.addEventListener('touchstart', function(e) {
            if (window.innerWidth >= 1200) return;
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            dragging = false;
          }, { passive: true });

          track.addEventListener('touchmove', function(e) {
            if (window.innerWidth >= 1200) return;
            var dx = e.touches[0].clientX - touchStartX;
            var dy = e.touches[0].clientY - touchStartY;
            if (!dragging && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
              dragging = true;
            }
          }, { passive: true });

          track.addEventListener('touchend', function(e) {
            if (window.innerWidth >= 1200 || !dragging) return;
            var dx = e.changedTouches[0].clientX - touchStartX;
            if (Math.abs(dx) > 40) {
              dx < 0 ? goTo(currentPos + 1) : goTo(currentPos - 1);
            }
            dragging = false;
          }, { passive: true });
        }

        // Swatch click → navigate to product. Not needed in click-preview mode (delegation handles it).
        if (card && swatchPreviewMode !== 'click') {
          card.querySelectorAll('.product-card__swatch[data-color]').forEach(function(swatch) {
            swatch.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              var url = swatch.dataset.productUrl || '';
              var variantId = swatch.dataset.variantId || '';
              if (url) window.location.href = variantId ? url + '?variant=' + variantId : url;
            });
          });
        }

        // Swatch hover preview — element listeners stay here since hover events can't delegate easily
        if (swatchPreviewMode === 'hover' && card) {
          card.querySelectorAll('.product-card__swatch[data-color]').forEach(function(swatch) {
            swatch.addEventListener('mouseenter', function() {
              if (window.innerWidth < 1200) return;
              showColor(swatch.dataset.color);
            });
            swatch.addEventListener('mouseleave', function() {
              if (window.innerWidth < 1200) return;
              resetColor();
            });
          });
        }

        // Expose image-swap helpers on every multi-image wrapper, regardless
        // of swatchPreviewMode. The 'click' swatch flow uses them directly
        // (delegated handler reads wrapper._pgShowColor). 'hover' mode calls
        // the local showColor() inline so isn't affected. 'off' mode never
        // triggers an image swap. The client-side color filter then has the
        // same hook available across all modes.
        wrapper._pgShowColor = showColor;
        wrapper._pgResetColor = resetColor;
        wrapper._pgSyncButtons = function(variantId) { syncCardButtons(card, variantId); };
      }

      var initScope = sectionEl || root;
      initScope.querySelectorAll('.product-card__image-wrapper').forEach(initCardNav);

      // Expose initCardNav on the section root so the AJAX filter path
      // (fetchFilteredGrid, which replaces .pg-ajax-container HTML) can
      // re-initialize the new card wrappers. initCardNav is idempotent —
      // already-initialized wrappers carry data-nav-init and skip.
      root._pgInitCardNav = initCardNav;

      if (swatchPreviewMode === 'click') {
        setTimeout(function() {
          if (window.wishlistDrawer && window.wishlistDrawer.sync) {
            window.wishlistDrawer.sync();
          }
        }, 0);
      }
    })();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.product-grid-section').forEach(initSection);
  }

  /* The Shopify javascript block is deferred-loaded and may run after
     DOMContentLoaded has already fired — guard with readyState so the
     first init happens immediately when we load late. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: when the merchant saves a setting change, Shopify
     replaces the section's DOM and fires this event. The new DOM has
     a fresh .product-grid-section without our data-csp-init flag, so
     initSection runs cleanly on it. */
  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
})();

(function() {
  /* Hover color label tooltip — follows the cursor and displays the
     swatch color name. Was previously gated by Liquid {% if %} around
     a <script>; now the script always loads and the runtime checks
     data-pg-hover-label on the section root. We pick up the first
     section that has it enabled (per-page; if multiple sections enable
     it, we use the first set of style values). Re-evaluates on
     shopify:section:load so theme editor changes take effect. */

  var tip = null;
  var transform = '';

  function findEnabledRoot() {
    var all = document.querySelectorAll('.product-grid-section[data-pg-hover-label="true"]');
    return all.length ? all[0] : null;
  }

  function ensureTip() {
    if (tip && tip.parentNode) return;
    tip = document.createElement('div');
    document.body.appendChild(tip);
  }

  function applyTipStyles(root) {
    if (!tip) return;
    var bg       = root.dataset.pgHoverLabelBg       || '';
    var color    = root.dataset.pgHoverLabelColor    || '';
    var size     = root.dataset.pgHoverLabelSize     || '12';
    var padV     = root.dataset.pgHoverLabelPaddingV || '4';
    var padH     = root.dataset.pgHoverLabelPaddingH || '8';
    var radius   = root.dataset.pgHoverLabelRadius   || '0';
    var font     = root.dataset.pgHoverLabelFont     || 'body';
    var letter   = root.dataset.pgHoverLabelLetterSpacing || '0';
    transform    = root.dataset.pgHoverLabelTransform || 'none';
    tip.style.cssText = [
      'position:fixed',
      'pointer-events:none',
      'z-index:99999',
      'display:none',
      'white-space:nowrap',
      'background:' + bg,
      'color:' + color,
      'font-size:' + size + 'px',
      'padding:' + padV + 'px ' + padH + 'px',
      'border-radius:' + radius + 'px',
      'font-family:var(--' + font + '-font)',
      'letter-spacing:' + letter + 'em',
      'text-transform:' + transform
    ].join(';');
  }

  function setup() {
    var root = findEnabledRoot();
    if (!root) {
      if (tip) tip.style.display = 'none';
      return;
    }
    ensureTip();
    applyTipStyles(root);
  }

  document.addEventListener('mousemove', function(e) {
    if (!tip) return;
    tip.style.left = (e.clientX + 14) + 'px';
    tip.style.top  = (e.clientY - 8)  + 'px';
  });

  document.addEventListener('mouseover', function(e) {
    if (!tip) return;
    var swatch = e.target.closest('.product-card__swatch');
    // Only show inside a section that has the label enabled
    if (swatch && swatch.closest('.product-grid-section[data-pg-hover-label="true"]')) {
      var color = swatch.dataset.color || swatch.getAttribute('title') || '';
      if (color) {
        if (transform === 'capitalize') {
          color = color.replace(/\b\w/g, function(c){ return c.toUpperCase(); });
        }
        tip.textContent = color;
        tip.style.display = 'block';
      }
    } else {
      tip.style.display = 'none';
    }
  });

  /* {% javascript %} is deferred-loaded; run setup immediately if the
     DOM is already parsed, otherwise wait for DOMContentLoaded. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  /* Cached bundled script for the Related Products section.
     - Iterates every .rp-section root so multiple instances on the same
       page work.
     - dataset.cspInit flag prevents double-init when shopify:section:load
       fires after a partial re-render.
     - All Liquid-rendered settings, translations, and message templates
       are read from data-* attributes on the .rp-section root, so this
       block contains no Liquid interpolation and Shopify can cache it.
     - Deferred-load safe: if document.readyState !== 'loading', init
       runs immediately rather than waiting for DOMContentLoaded (which
       may have already fired by the time this script runs). */
  (function() {
    function initSection(root) {
      if (!root || root.dataset.cspInit === 'true') return;
      root.dataset.cspInit = 'true';

      var sectionEl = root.closest('.shopify-section') || root.parentNode;
      var sectionId = root.dataset.sectionId;

      var rpT = {
        addToCart:              root.dataset.tAddToCart || '',
        addToWishlist:          root.dataset.tAddToWishlist || '',
        removeFromList:         root.dataset.tRemoveFromList || '',
        adding:                 root.dataset.tAdding || '',
        soldOut:                root.dataset.tSoldOut || '',
        unavailable:            root.dataset.tUnavailable || '',
        errorGeneric:           root.dataset.tErrorGeneric || '',
        addToWishlistAria:      root.dataset.tAddToWishlistAria || '',
        removeFromWishlistAria: root.dataset.tRemoveFromWishlistAria || ''
      };

      var MSG_SOLDOUT = root.dataset.msgSoldout || '';
      var MSG_STOCK   = root.dataset.msgStock   || '';
      var MSG_ADDED   = root.dataset.msgAdded   || '';

      var swatchPreviewMode = root.dataset.swatchMode || 'off';
      var slideTransitionEnabled = root.dataset.hoverSecondImg === 'true';
      var mobileSwipeEnabled = root.dataset.mobileSwipe === 'true';
      var infoPositionBelow = root.dataset.infoPositionBelow === 'true';

      // ── Shopify Recommendations (Section Rendering API) ──────────
      (function() {
        var productId = root.dataset.productId;
        var useRecs   = root.dataset.useRecs === 'true';
        if (!productId || !useRecs) return;

        var gridContainer = root.querySelector('.rp-grid-container');
        var fallbackLimit = root.dataset.productLimit || '';
        var limit = gridContainer ? (gridContainer.dataset.recsLimit || fallbackLimit) : fallbackLimit;

        var url = '/recommendations/products?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit + '&intent=related';

        fetch(url)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var doc     = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('.rp-grid-container');
            var curGrid = root.querySelector('.rp-grid-container');
            if (!newGrid || !curGrid) return;

            var hasProducts = newGrid.querySelector('.product-card');
            if (!hasProducts) return; // keep fallback

            curGrid.innerHTML = newGrid.innerHTML;

            // Update QA drawer swatch map if applicable
            var newDrawer = doc.querySelector('.rp-qa-drawer');
            var curDrawer = root.querySelector('.rp-qa-drawer');
            if (newDrawer && curDrawer) {
              curDrawer.dataset.swatches = newDrawer.dataset.swatches || '';
              if (window._rpRefreshSwatchMap && window._rpRefreshSwatchMap[sectionId]) {
                window._rpRefreshSwatchMap[sectionId]();
              }
            }

            // Re-init card nav + swatch preview for new cards
            initAllCards();

            // Sync wishlist icons
            if (window.wishlistDrawer && window.wishlistDrawer.sync) window.wishlistDrawer.sync();
          })
          .catch(function() {}); // silently keep fallback
      })();

      // ── QA Drawer ────────────────────────────────────────────────
      (function() {
        var drawer  = document.getElementById('rp-qa-drawer-' + sectionId);
        var overlay = document.getElementById('rp-qa-overlay-' + sectionId);
        if (!drawer) return;

        var titleEl   = drawer.querySelector('.rp-qa-drawer__product-title');
        var priceEl   = drawer.querySelector('.rp-qa-drawer__price');
        var imageEl   = drawer.querySelector('.rp-qa-drawer__image');
        var optionsEl = drawer.querySelector('.pg-qa-drawer__options');
        var atcBtn    = drawer.querySelector('.rp-qa-drawer__atc');
        var closeBtn  = drawer.querySelector('.rp-qa-drawer__close');

        var ATC_STYLE_CART     = root.dataset.atcStyleCart || 'primary';
        var ATC_STYLE_WISHLIST = root.dataset.atcStyleWishlist || 'secondary';
        function applyAtcStyle(mode) {
          atcBtn.dataset.buttonStyle = (mode === 'wishlist') ? ATC_STYLE_WISHLIST : ATC_STYLE_CART;
          atcBtn.dataset.qaMode = mode;
        }

        var currentVariants = [];
        var selectedOptions = {};
        var wishlistMode = false;
        var wishlistRemoveMode = false;
        var wishlistSourceBtn = null;
        var wishlistHandle = null;

        function showToast(msg, isError, btn) {
          if (!window.cartToast) return;
          var productImage = btn && btn.dataset ? (btn.dataset.productImage || '') : '';
          var productTitle = btn && btn.dataset ? (btn.dataset.productTitle || '') : '';
          window.cartToast.show({
            type:         isError ? 'error' : 'success',
            message:      msg,
            productImage: productImage,
            productTitle: productTitle,
            quantity:     1
          });
        }

        var cartQty = {};
        function refreshCartQty(cb) {
          fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            cartQty = {};
            cart.items.forEach(function(item){ cartQty[String(item.variant_id)] = item.quantity; });
            if (cb) cb();
          }).catch(function(){ if (cb) cb(); });
        }
        refreshCartQty();

        // ── Swatch map (refreshable after recommendations load) ────
        var swatchMap = {};
        function buildSwatchMap() {
          swatchMap = {};
          (drawer.dataset.swatches || '').split('||').forEach(function(entry) {
            if (!entry) return;
            var parts = entry.split(':');
            swatchMap[parts[0]] = { type: parts[1], val: parts.slice(2).join(':') };
          });
        }
        buildSwatchMap();

        // Expose refresh so recommendations swap can update swatch map
        window._rpRefreshSwatchMap = window._rpRefreshSwatchMap || {};
        window._rpRefreshSwatchMap[sectionId] = buildSwatchMap;

        function getSwatchStyle(val) {
          if (!val) return null;
          var key = String(val).toLowerCase().replace(/\s/g, '');
          var s = swatchMap[key];
          if (s && s.type === 'image' && s.val) return { backgroundImage: 'url(' + s.val + ')', backgroundSize: 'cover' };
          if (s && s.type === 'color' && s.val) return { backgroundColor: s.val };
          /* Fallback: when Shopify didn't auto-resolve a swatch for this
             option value (no swatch.color or swatch.image set, type is
             'none', or the value isn't in the map at all), try the value
             name itself as a CSS color. "Light Green" → "lightgreen" is
             a valid CSS named color, so the dot renders without the
             merchant having to set the swatch metafield. Strips spaces,
             hyphens, and underscores so values entered as "Light-Green"
             or "Light_Green" also resolve. Returns null for unknown
             names so the option renders as a plain text button. */
          var cssCandidate = String(val).toLowerCase().replace(/[\s\-_]/g, '');
          if (!cssCandidate) return null;
          var valid = false;
          if (typeof CSS !== 'undefined' && CSS.supports) {
            valid = CSS.supports('color', cssCandidate);
          } else {
            var tester = getSwatchStyle._tester || (getSwatchStyle._tester = document.createElement('div'));
            tester.style.backgroundColor = '';
            tester.style.backgroundColor = cssCandidate;
            valid = tester.style.backgroundColor !== '';
          }
          if (valid) return { backgroundColor: cssCandidate };
          return null;
        }

        function openDrawer() {
          drawer.setAttribute('aria-hidden','false');
          overlay.setAttribute('aria-hidden','false');
          document.body.style.overflow = 'hidden';
          if (wishlistRemoveMode) {
            atcBtn.textContent = rpT.removeFromList;
            atcBtn.classList.add('rp-qa-drawer__atc--wishlist','rp-qa-drawer__atc--remove');
          } else if (wishlistMode) {
            atcBtn.textContent = rpT.addToWishlist;
            atcBtn.classList.add('rp-qa-drawer__atc--wishlist');
            atcBtn.classList.remove('rp-qa-drawer__atc--remove');
          } else {
            atcBtn.textContent = rpT.addToCart;
            atcBtn.classList.remove('rp-qa-drawer__atc--wishlist','rp-qa-drawer__atc--remove');
          }
        }
        function closeDrawer() {
          drawer.setAttribute('aria-hidden','true');
          overlay.setAttribute('aria-hidden','true');
          document.body.style.overflow = '';
          wishlistMode = false; wishlistRemoveMode = false;
          wishlistSourceBtn = null; wishlistHandle = null;
          atcBtn.textContent = rpT.addToCart;
          atcBtn.classList.remove('rp-qa-drawer__atc--wishlist','rp-qa-drawer__atc--remove');
          applyAtcStyle('cart');
        }
        function money(cents) {
          var n = (cents/100).toFixed(2);
          var p = n.split('.');
          p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
          return '$ ' + p.join('.');
        }
        function findVariant() {
          return currentVariants.find(function(v) {
            return v.options.every(function(opt,i){ return selectedOptions['o'+(i+1)]===opt; });
          })||null;
        }
        function updateAtcBtn() {
          var v = findVariant();
          if (v && (wishlistMode||wishlistRemoveMode)) {
            var inWl = window.wishlistDrawer ? window.wishlistDrawer.isInWishlist(v.id) :
              (function(){ try{ return (JSON.parse(localStorage.getItem('wishlist_items'))||[]).some(function(i){ return String(i.variantId)===String(v.id); }); }catch(e){ return false; } })();
            wishlistRemoveMode = inWl; wishlistMode = !inWl;
            atcBtn.classList.toggle('rp-qa-drawer__atc--remove',inWl);
          }
          if (!v) {
            atcBtn.textContent = wishlistRemoveMode ? rpT.removeFromList : (wishlistMode ? rpT.addToWishlist : rpT.unavailable);
            atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
            delete atcBtn.dataset.variantId;
          } else if (!v.available) {
            atcBtn.textContent = wishlistRemoveMode ? rpT.removeFromList : (wishlistMode ? rpT.addToWishlist : rpT.soldOut);
            atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
            atcBtn.dataset.variantId = v.id;
          } else {
            atcBtn.textContent = wishlistRemoveMode ? rpT.removeFromList : (wishlistMode ? rpT.addToWishlist : rpT.addToCart);
            atcBtn.disabled = false;
            atcBtn.dataset.variantId = v.id;
          }
          if (v) { priceEl.textContent = money(v.price); if (v.featured_image) imageEl.src = v.featured_image.src; }
          optionsEl.querySelectorAll('.pg-qa-option-btn,.pg-qa-color-btn').forEach(function(b) {
            var testKey = 'o'+b.dataset.pos;
            var test = Object.assign({},selectedOptions); test[testKey] = b.dataset.value;
            b.classList.toggle('is-unavailable', !currentVariants.some(function(v){ return v.options.every(function(o,i){ return test['o'+(i+1)]===o; }); }));
            var other = Object.assign({},selectedOptions); delete other[testKey];
            b.classList.toggle('is-sold-out', !currentVariants.some(function(v){ return v.available && v.options[parseInt(b.dataset.pos,10)-1]===b.dataset.value && Object.keys(other).every(function(k){ return other[k]===v.options[parseInt(k.slice(1),10)-1]; }); }));
          });
        }
        function renderOptions(product, preselectId) {
          currentVariants = product.variants; selectedOptions = {};
          var hasReal = product.variants.length > 1 || (product.variants.length===1 && product.variants[0].title!=='Default Title');
          optionsEl.style.display = hasReal ? '' : 'none';
          var first = product.variants[0];
          if (preselectId) { var pv = product.variants.find(function(v){ return String(v.id)===String(preselectId); }); if (pv) first = pv; }
          if (!first) first = product.variants.find(function(v){ return v.available; }) || product.variants[0];
          product.options.forEach(function(name,i){ selectedOptions['o'+(i+1)] = first.options[i]; });
          optionsEl.innerHTML = '';
          product.options.forEach(function(optRaw,idx) {
            var optName = typeof optRaw==='object'?optRaw.name:optRaw;
            var pos = idx+1;
            var vals = [];
            product.variants.forEach(function(v){ if(vals.indexOf(v.options[idx])===-1) vals.push(v.options[idx]); });
            var isColor = vals.some(function(v){ return !!getSwatchStyle(v); });
            var wrap = document.createElement('div'); wrap.className = 'pg-qa-option';
            var label = document.createElement('p'); label.className = 'pg-qa-option__label';
            var selSpan = document.createElement('span'); selSpan.className = 'pg-qa-option__selected'; selSpan.textContent = selectedOptions['o'+pos];
            label.textContent = optName+': '; label.appendChild(selSpan);
            var btns = document.createElement('div'); btns.className = isColor ? 'pg-qa-option__btns pg-qa-option__btns--colors' : 'pg-qa-option__btns';
            vals.forEach(function(val) {
              var swatch = isColor ? getSwatchStyle(val) : null;
              var btn = document.createElement('button');
              btn.dataset.pos = pos; btn.dataset.value = val;
              var colorSoldOut = isColor && !currentVariants.some(function(v){ return v.options[idx]===val && v.available; });
              if (swatch) {
                btn.className = 'pg-qa-color-btn'; if(colorSoldOut) btn.classList.add('is-sold-out');
                var dot = document.createElement('span'); dot.className = 'pg-qa-color-dot'; Object.assign(dot.style, swatch);
                var nm = document.createElement('span'); nm.className = 'pg-qa-color-name'; nm.textContent = val.toUpperCase();
                btn.appendChild(dot); btn.appendChild(nm);
              } else {
                btn.className = 'pg-qa-option-btn'; btn.textContent = val;
                if (!currentVariants.some(function(v){ return v.options[idx]===val && v.available; })) btn.classList.add('is-sold-out');
              }
              if (selectedOptions['o'+pos]===val) btn.classList.add('is-selected');
              btn.addEventListener('click', function() {
                selectedOptions['o'+pos] = val; selSpan.textContent = val;
                btns.querySelectorAll('.pg-qa-option-btn,.pg-qa-color-btn').forEach(function(b){ b.classList.remove('is-selected'); });
                btn.classList.add('is-selected'); updateAtcBtn();
              });
              btns.appendChild(btn);
            });
            wrap.appendChild(label); wrap.appendChild(btns); optionsEl.appendChild(wrap);
          });
          updateAtcBtn();
        }
        var variantInvMap = {};
        function parseVariantInvMap(card) {
          variantInvMap = {};
          if (!card) return;
          (card.dataset.variantInv||'').split('|').forEach(function(e){ if(!e) return; var p=e.split(':'); if(p.length<3) return; variantInvMap[p[0]]={qty:parseInt(p[1],10),policy:p[2]}; });
        }
        function loadAndOpen(handle, btn, preselectId) {
          var card = btn.closest ? btn.closest('.product-card') : null;
          parseVariantInvMap(card);
          if (btn.classList) btn.classList.add('is-loading');
          fetch('/products/'+handle+'.js').then(function(r){ return r.json(); }).then(function(p) {
            if (btn.classList) btn.classList.remove('is-loading');
            titleEl.textContent = p.title; priceEl.textContent = money(p.price_min);
            imageEl.src = p.featured_image||''; imageEl.alt = p.title;
            atcBtn.dataset.productTitle = p.title;
            renderOptions(p, preselectId);
            refreshCartQty(function(){ openDrawer(); });
          }).catch(function(){ if(btn.classList) btn.classList.remove('is-loading'); });
        }

        // Click delegation for quick-add buttons within this section.
        // Scoped to sectionEl (the shopify-section wrapper) to match the
        // original behavior of only handling clicks inside this section.
        document.addEventListener('click', function(e) {
          if (!sectionEl || !sectionEl.contains(e.target)) return;

          var qaBtn = e.target.closest('.product-card__quick-add');
          if (qaBtn) {
            e.preventDefault(); e.stopPropagation();
            if (qaBtn.dataset.multiVariant !== 'true' && qaBtn.dataset.variantId) {
              var vid = String(qaBtn.dataset.variantId);
              var invQty = parseInt(qaBtn.dataset.inventory,10);
              var invPolicy = qaBtn.dataset.inventoryPolicy||'deny';
              var inCart = cartQty[vid]||0;
              if (qaBtn.dataset.available==='false') { showToast(MSG_SOLDOUT, true); return; }
              if (invPolicy==='deny' && !isNaN(invQty) && invQty>0 && inCart>=invQty) { showToast(MSG_STOCK.replace('%available%',invQty).replace('%in_cart%',inCart),true); return; }
              qaBtn.classList.add('is-loading');
              fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:parseInt(vid,10), quantity:1}) })
              .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,data:d}; }); })
              .then(function(res){
                qaBtn.classList.remove('is-loading');
                if (res.ok) { cartQty[vid]=(cartQty[vid]||0)+1; showToast(MSG_ADDED, false, qaBtn); document.dispatchEvent(new CustomEvent('cart:updated')); handlePostAdd(); }
                else { refreshCartQty(); showToast((res.data&&(res.data.description||res.data.message))||rpT.errorGeneric,true); }
              }).catch(function(){ qaBtn.classList.remove('is-loading'); showToast(rpT.errorGeneric,true); });
            } else {
              loadAndOpen(qaBtn.dataset.productHandle, qaBtn, qaBtn.dataset.variantId);
            }
            return;
          }
        });

        atcBtn.addEventListener('click', function() {
          var vid = atcBtn.dataset.variantId;
          if (!vid||vid==='undefined') return;
          if (wishlistRemoveMode) {
            if (window.wishlistDrawer) window.wishlistDrawer.remove(vid);
            document.querySelectorAll('[data-wishlist-add="'+vid+'"]').forEach(function(b){ b.classList.remove('is-wishlisted'); b.setAttribute('aria-label',rpT.addToWishlistAria); });
            closeDrawer(); return;
          }
          if (wishlistMode) {
            var handle = wishlistHandle;
            if (window.wishlistDrawer) { window.wishlistDrawer.add(vid,handle); }
            else { try{ var wl=JSON.parse(localStorage.getItem('wishlist_items'))||[]; if(!wl.some(function(i){ return i.variantId==vid; })){ wl.push({variantId:vid,productHandle:handle,addedAt:Date.now()}); localStorage.setItem('wishlist_items',JSON.stringify(wl)); } }catch(e){} }
            if (wishlistSourceBtn) { wishlistSourceBtn.classList.add('is-wishlisted'); wishlistSourceBtn.setAttribute('aria-label',rpT.removeFromWishlistAria); }
            document.querySelectorAll('[data-wishlist-add="'+vid+'"]').forEach(function(b){ b.classList.add('is-wishlisted'); });
            closeDrawer();
            if (window.wishlistDrawer) window.wishlistDrawer.open();
            return;
          }
          var invData = variantInvMap[vid]||{}; var invQty = invData.qty!=null?invData.qty:NaN; var invPolicy = invData.policy||'deny'; var inCart = cartQty[vid]||0;
          if (invPolicy==='deny' && !isNaN(invQty) && invQty>0 && inCart>=invQty) { showToast(MSG_STOCK.replace('%available%',invQty).replace('%in_cart%',inCart),true); return; }
          atcBtn.textContent = rpT.adding; atcBtn.disabled = true;
          fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:vid, quantity:1}) })
          .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,data:d}; }); })
          .then(function(res){
            if (res.ok) { cartQty[String(vid)]=(cartQty[String(vid)]||0)+1; closeDrawer(); var qaCtx = { dataset: { productImage: (imageEl && imageEl.src) || '', productTitle: (titleEl && titleEl.textContent) || '' } }; showToast(MSG_ADDED, false, qaCtx); document.dispatchEvent(new CustomEvent('cart:updated')); handlePostAdd(); }
            else { atcBtn.textContent = rpT.addToCart; atcBtn.disabled = false; refreshCartQty(); showToast((res.data&&(res.data.description||res.data.message))||rpT.errorGeneric,true); }
          }).catch(function(){ atcBtn.textContent=rpT.addToCart; atcBtn.disabled=false; showToast(rpT.errorGeneric,true); });
        });

        closeBtn.addEventListener('click', closeDrawer);
        overlay.addEventListener('click', closeDrawer);
        document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

        // Expose API for wishlist-drawer global click handler
        window.pgQuickAdd = window.pgQuickAdd || {};
        window.pgQuickAdd[sectionId] = {
          openForWishlistRemove: function(handle, sourceBtn, preselectId) {
            wishlistMode = false; wishlistRemoveMode = true;
            wishlistSourceBtn = sourceBtn; wishlistHandle = handle;
            fetch('/products/'+handle+'.js').then(function(r){ return r.json(); }).then(function(p) {
              titleEl.textContent=p.title; priceEl.textContent=money(p.price_min);
              imageEl.src=p.featured_image||''; imageEl.alt=p.title;
              atcBtn.dataset.productTitle=p.title;
              renderOptions(p, preselectId);
              applyAtcStyle('wishlist');
              openDrawer();
            }).catch(function(){ wishlistRemoveMode=false; if(window.wishlistDrawer) window.wishlistDrawer.remove(sourceBtn?sourceBtn.dataset.wishlistAdd:null); });
          },
          openForWishlist: function(handle, sourceBtn) {
            fetch('/products/'+handle+'.js').then(function(r){ return r.json(); }).then(function(p) {
              var hasReal = p.variants.length>1||(p.variants.length===1&&p.variants[0].title!=='Default Title');
              if (!hasReal) {
                var vid = p.variants[0].id;
                if (window.wishlistDrawer) { window.wishlistDrawer.add(vid,handle); }
                else { try{ var wl=JSON.parse(localStorage.getItem('wishlist_items'))||[]; if(!wl.some(function(i){ return i.variantId==vid; })){ wl.push({variantId:vid,productHandle:handle,addedAt:Date.now()}); localStorage.setItem('wishlist_items',JSON.stringify(wl)); } }catch(e){} }
                if (sourceBtn) { sourceBtn.classList.add('is-wishlisted'); sourceBtn.setAttribute('aria-label',rpT.removeFromWishlistAria); }
                if (window.wishlistDrawer) window.wishlistDrawer.open();
              } else {
                wishlistMode=true; wishlistSourceBtn=sourceBtn; wishlistHandle=handle;
                titleEl.textContent=p.title; priceEl.textContent=money(p.price_min);
                imageEl.src=p.featured_image||''; imageEl.alt=p.title;
                atcBtn.dataset.productTitle=p.title;
                var preselectId = sourceBtn?sourceBtn.dataset.wishlistAdd:null;
                renderOptions(p,preselectId);
                applyAtcStyle('wishlist');
                openDrawer();
              }
            }).catch(function(){ wishlistMode=true; wishlistSourceBtn=sourceBtn; wishlistHandle=handle; var preselectId=sourceBtn?sourceBtn.dataset.wishlistAdd:null; applyAtcStyle('wishlist'); loadAndOpen(handle,{classList:{add:function(){},remove:function(){}}},preselectId); });
          }
        };

        function handlePostAdd() {
          var cartType  = root.dataset.cartType || 'drawer';
          var addAction = root.dataset.cartAddAction || 'drawer';
          if (addAction==='drawer' && cartType==='drawer') { if (window.cartDrawer) window.cartDrawer.open(); }
          else if (addAction==='page') { window.location.href='/cart'; }
        }
        document.addEventListener('cart:updated', function(){ refreshCartQty(); });
      })();

      // ── Card image nav + swatch preview ──────────────────────────
      function getIndexesForColor(imgs, colorName) {
        var lower = colorName.toLowerCase().trim();
        var matched = [];
        imgs.forEach(function(img,i) {
          var alt = (img.alt||img.getAttribute('alt')||'').toLowerCase().trim();
          var idx = alt.indexOf(lower);
          while (idx !== -1) {
            var before = idx===0||!/[a-z0-9]/.test(alt[idx-1]);
            var after  = (idx+lower.length)>=alt.length||!/[a-z0-9]/.test(alt[idx+lower.length]);
            if (before&&after){ matched.push(i); break; }
            idx = alt.indexOf(lower,idx+1);
          }
        });
        return matched;
      }

      function syncCardButtons(card, variantId) {
        var qabtns = card.querySelectorAll('.product-card__quick-add');
        var wlbtns = card.querySelectorAll('.product-card__wishlist');
        if (variantId===null) {
          qabtns.forEach(function(b){ if(b.dataset.defaultVariantId) b.dataset.variantId=b.dataset.defaultVariantId; });
          wlbtns.forEach(function(b){ if(b.dataset.defaultVariantId) b.dataset.wishlistAdd=b.dataset.defaultVariantId; });
        } else {
          qabtns.forEach(function(b){ if(!b.dataset.defaultVariantId) b.dataset.defaultVariantId=b.dataset.variantId; b.dataset.variantId=variantId; });
          wlbtns.forEach(function(b){ if(!b.dataset.defaultVariantId) b.dataset.defaultVariantId=b.dataset.wishlistAdd; b.dataset.wishlistAdd=variantId; });
        }
        if (window.wishlistDrawer && window.wishlistDrawer.sync) window.wishlistDrawer.sync();
      }

      function initCardNav(wrapper) {
        if (wrapper.dataset.navInit) return;
        wrapper.dataset.navInit = '1';
        var track   = wrapper.querySelector('[data-card-track]');
        if (!track) return;
        var allImgs = Array.from(track.querySelectorAll('.product-card__img'));
        var card    = wrapper.closest('.product-card');
        var hasImageSliding = allImgs.length > 1;

        if (swatchPreviewMode === 'click' && card && window.innerWidth >= 1200) {
          var firstSwatch = card.querySelector('.product-card__swatch[data-color]');
          if (firstSwatch && firstSwatch.dataset.variantId) {
            firstSwatch.classList.add('is-preview-active');
            syncCardButtons(card, firstSwatch.dataset.variantId);
            var imgLink = card.querySelector('.product-card__image-link');
            if (imgLink) { if (!imgLink.dataset.baseUrl) imgLink.dataset.baseUrl = imgLink.href; imgLink.href = imgLink.dataset.baseUrl+'?variant='+firstSwatch.dataset.variantId; }
          }
        }

        if (!hasImageSliding) {
          if (card && swatchPreviewMode !== 'click') {
            card.querySelectorAll('.product-card__swatch[data-color]').forEach(function(swatch) {
              swatch.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); var url=swatch.dataset.productUrl||''; var variantId=swatch.dataset.variantId||''; if(url) window.location.href=variantId?url+'?variant='+variantId:url; });
            });
          }
          return;
        }

        var prevBtn = wrapper.querySelector('.product-card__nav--prev');
        var nextBtn = wrapper.querySelector('.product-card__nav--next');
        var firstColor = wrapper.dataset.firstColor || '';
        var visibleIndexes = firstColor.length ? getIndexesForColor(allImgs, firstColor) : [];
        if (!visibleIndexes.length) visibleIndexes = allImgs.map(function(_,i){ return i; });
        var currentPos = 0;
        var slideTransition = slideTransitionEnabled;

        function goTo(pos) {
          currentPos = Math.max(0, Math.min(visibleIndexes.length-1, pos));
          if (slideTransition) {
            track.style.transition = 'transform 0.5s ease';
            // Commit the transition change before changing transform, so the
            // browser reliably animates the transform (matters when the previous
            // transition list was different — e.g. after a swatch fade).
            void track.offsetWidth;
          }
          track.style.transform = 'translateX(-'+(visibleIndexes[currentPos]*100)+'%)';
          if (prevBtn) prevBtn.classList.toggle('is-hidden', currentPos===0);
          if (nextBtn) nextBtn.classList.toggle('is-hidden', currentPos===visibleIndexes.length-1);
        }
        // Snap to a target position WITHOUT sliding (used by swatch preview).
        function snapTo(pos) {
          currentPos = Math.max(0, Math.min(visibleIndexes.length-1, pos));
          track.style.transition = 'none';
          track.style.transform = 'translateX(-'+(visibleIndexes[currentPos]*100)+'%)';
          if (prevBtn) prevBtn.classList.toggle('is-hidden', currentPos===0);
          if (nextBtn) nextBtn.classList.toggle('is-hidden', currentPos===visibleIndexes.length-1);
        }
        // Always include transform in the inline transition so it doesn't
        // override the CSS-defined transform transition on .product-card__track.
        var swatchFadeTransition = slideTransition
          ? 'opacity 0.15s ease, transform 0.5s ease'
          : 'opacity 0.15s ease, transform 0.35s ease';
        function showColor(colorName) {
          var indexes = getIndexesForColor(allImgs, colorName);
          if (!indexes.length) return;
          visibleIndexes = indexes;
          track.style.transition = swatchFadeTransition;
          track.style.opacity = '0';
          setTimeout(function(){
            snapTo(0);
            void track.offsetWidth;
            track.style.transition = swatchFadeTransition;
            track.style.opacity = '1';
          }, 150);
        }
        function resetColor() {
          var indexes = firstColor.length ? getIndexesForColor(allImgs,firstColor) : [];
          visibleIndexes = indexes.length ? indexes : allImgs.map(function(_,i){ return i; });
          track.style.transition = swatchFadeTransition;
          track.style.opacity = '0';
          setTimeout(function(){
            snapTo(0);
            void track.offsetWidth;
            track.style.transition = swatchFadeTransition;
            track.style.opacity = '1';
          }, 150);
        }
        goTo(0);

        if (prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goTo(currentPos-1); });
        if (nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goTo(currentPos+1); });

        // Hover-to-show-second-image: only when info position is "below"
        // AND the desktop_hover_second_image setting is on. Both gates were
        // Liquid-time in the original; here we evaluate at runtime from the
        // data-* attributes on the section root.
        if (infoPositionBelow && slideTransitionEnabled) {
          if (wrapper.hasAttribute('data-hover-second-img')) {
            wrapper.addEventListener('mouseenter', function(){ if(window.innerWidth<1200) return; if(currentPos===0&&visibleIndexes.length>1) goTo(1); });
            wrapper.addEventListener('mouseleave', function(){ if(window.innerWidth<1200) return; if(currentPos!==0) goTo(0); });
          }
        }

        if (mobileSwipeEnabled) {
          var touchStartX=0, touchStartY=0, dragging=false;
          track.addEventListener('touchstart',function(e){ if(window.innerWidth>=1200)return; touchStartX=e.touches[0].clientX; touchStartY=e.touches[0].clientY; dragging=false; },{passive:true});
          track.addEventListener('touchmove',function(e){ if(window.innerWidth>=1200)return; var dx=e.touches[0].clientX-touchStartX,dy=e.touches[0].clientY-touchStartY; if(!dragging&&Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>8) dragging=true; },{passive:true});
          track.addEventListener('touchend',function(e){ if(window.innerWidth>=1200||!dragging)return; var dx=e.changedTouches[0].clientX-touchStartX; if(Math.abs(dx)>40){ dx<0?goTo(currentPos+1):goTo(currentPos-1); } dragging=false; },{passive:true});
        }

        if (card && swatchPreviewMode !== 'click') {
          card.querySelectorAll('.product-card__swatch[data-color]').forEach(function(swatch) {
            swatch.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); var url=swatch.dataset.productUrl||''; var variantId=swatch.dataset.variantId||''; if(url) window.location.href=variantId?url+'?variant='+variantId:url; });
          });
        }
        if (swatchPreviewMode === 'hover' && card) {
          card.querySelectorAll('.product-card__swatch[data-color]').forEach(function(swatch) {
            swatch.addEventListener('mouseenter', function(){ if(window.innerWidth<1200) return; showColor(swatch.dataset.color); });
            swatch.addEventListener('mouseleave', function(){ if(window.innerWidth<1200) return; resetColor(); });
          });
        }
        if (swatchPreviewMode === 'click') {
          wrapper._rpShowColor   = showColor;
          wrapper._rpResetColor  = resetColor;
          wrapper._rpSyncButtons = function(variantId){ syncCardButtons(card, variantId); };
        }
      }

      function initAllCards() {
        root.querySelectorAll('.product-card__image-wrapper').forEach(initCardNav);
        if (swatchPreviewMode === 'click') {
          setTimeout(function(){ if(window.wishlistDrawer&&window.wishlistDrawer.sync) window.wishlistDrawer.sync(); },0);
        }
      }

      initAllCards();
      if (window.wishlistDrawer && window.wishlistDrawer.sync) window.wishlistDrawer.sync();

      // ── Carousel arrow nav ────────────────────────────────────────
      // NOTE: grid is looked up fresh on every click — the recommendations
      // fetch may have replaced the DOM after init ran, so a captured
      // reference would be stale and scrollBy would silently fail.
      (function() {
        var prevBtn = document.getElementById('rp-prev-' + sectionId);
        var nextBtn = document.getElementById('rp-next-' + sectionId);
        if (!prevBtn || !nextBtn) return;

        function getGrid() {
          return root.querySelector('.rp-grid');
        }
        function getCardWidth(grid) {
          var card = grid.querySelector('.product-card');
          if (!card) return 0;
          var gapStr = window.getComputedStyle(grid).columnGap || window.getComputedStyle(grid).gap;
          var gap = parseFloat(gapStr) || 0;
          return card.offsetWidth + gap;
        }
        prevBtn.addEventListener('click', function() {
          var grid = getGrid();
          if (grid) grid.scrollBy({ left: -getCardWidth(grid), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function() {
          var grid = getGrid();
          if (grid) grid.scrollBy({ left: getCardWidth(grid), behavior: 'smooth' });
        });
      })();
    }

    // ── Swatch click delegation (click-preview mode) ─────────────
    // Global once-only delegation — guarded so multiple .rp-section
    // instances don't each bind the same global handler.
    if (!window._rpSwatchDelegated) {
      window._rpSwatchDelegated = true;
      document.addEventListener('click', function(e) {
        var swatch = e.target.closest('.product-card__swatch[data-color]');
        if (!swatch) return;
        var rpSec = swatch.closest('.rp-section');
        if (!rpSec) return;
        var mode = rpSec.dataset.swatchMode;
        var card = swatch.closest('.product-card');
        if (mode === 'click' && window.innerWidth >= 1200) {
          e.preventDefault(); e.stopPropagation();
          var wrapper = card && card.querySelector('.product-card__image-wrapper');
          var isActive = swatch.classList.contains('is-preview-active');
          card.querySelectorAll('.product-card__swatch.is-preview-active').forEach(function(s){ s.classList.remove('is-preview-active'); });
          var imgLink = card.querySelector('.product-card__image-link');
          if (!imgLink.dataset.baseUrl) imgLink.dataset.baseUrl = imgLink.href;
          if (isActive) {
            if (wrapper&&wrapper._rpResetColor) wrapper._rpResetColor();
            if (wrapper&&wrapper._rpSyncButtons) wrapper._rpSyncButtons(null);
            if (imgLink) imgLink.href = imgLink.dataset.baseUrl;
          } else {
            swatch.classList.add('is-preview-active');
            if (wrapper&&wrapper._rpShowColor) wrapper._rpShowColor(swatch.dataset.color);
            if (wrapper&&wrapper._rpSyncButtons) wrapper._rpSyncButtons(swatch.dataset.variantId);
            if (imgLink) imgLink.href = swatch.dataset.variantId ? imgLink.dataset.baseUrl+'?variant='+swatch.dataset.variantId : imgLink.dataset.baseUrl;
          }
          return;
        } else if (mode === 'click' && window.innerWidth < 1200) {
          e.preventDefault(); e.stopPropagation();
          var url = swatch.dataset.productUrl||''; var variantId = swatch.dataset.variantId||'';
          if (url) window.location.href = variantId ? url+'?variant='+variantId : url;
          return;
        }
      });
    }

    function init(root) {
      (root || document).querySelectorAll('.rp-section').forEach(initSection);
    }

    // Deferred-load safe bootstrap. {% javascript %} is loaded with a
    // defer-like timing, so DOMContentLoaded may have already fired by
    // the time this runs. Check readyState and call init() immediately
    // in that case rather than waiting for an event that won't come.
    if (document.readyState !== 'loading') {
      init(document);
    } else {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    }

    // Re-init on Theme Editor section reload.
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function() {
  /* ────── Search page — interactive controls ──────
     Wires up: clear-button visibility, popular chips, sort
     submission, view-columns toggle (synced with drawer's
     localStorage key), and query highlighting in tiles. */

  /* Shared with the search drawer so changing in either UI
     carries over. Keep this in sync if the drawer's key ever
     changes. */
  var VIEW_STORAGE_KEY = 'sd_view_columns';

  var page = document.getElementById('search-page');
  if (!page || page.dataset.spCspInit === 'true') return;
  page.dataset.spCspInit = 'true';

  var sectionId       = page.dataset.sectionId;
  var DEFAULT_VIEW    = page.dataset.defaultView || '4';
  var QUERY           = page.dataset.query || '';
  var QA_ENABLED      = page.dataset.quickAddEnable === 'true';

  var input = document.getElementById('search-page-input');
  var clearBtn = document.getElementById('search-page-clear');
  var form = document.getElementById('search-page-form');
  var sortSelect = document.getElementById('search-page-sort');
  var grids = page.querySelectorAll('.search-page__grid');
  var viewBtns = page.querySelectorAll('.search-page__view-btn');

  /* ── Clear button visibility ─────────────────────────────── */
  function updateClear() {
    if (!input || !clearBtn) return;
    clearBtn.hidden = input.value.length === 0;
  }
  if (input) {
    input.addEventListener('input', updateClear);
    updateClear();
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      if (!input) return;
      input.value = '';
      updateClear();
      input.focus();
    });
  }

  /* ── Popular chips → fill input + submit ────────────────── */
  page.addEventListener('click', function(e) {
    var chip = e.target.closest('[data-search-fill]');
    if (!chip) return;
    e.preventDefault();
    var term = chip.getAttribute('data-search-fill') || chip.textContent.trim();
    if (input) {
      input.value = term;
      updateClear();
    }
    if (form) form.submit();
  });

  /* ── Sort dropdown — auto-submit on change ──────────────── */
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      /* Append/replace sort_by in current URL preserving q + type. */
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      /* Drop pagination param so the user lands on page 1 of the
         new sort order. Otherwise switching sort with ?page=3 still
         shows page 3 — almost never what you want. */
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ── View-columns toggle (3/4/6) ─────────────────────────
     Updates data-view on every grid on the page (results grid +
     featured-products grid in discovery), persists choice to
     the same localStorage key the drawer uses. */
  function applyView(cols) {
    if (cols !== '3' && cols !== '4' && cols !== '6') cols = '4';
    grids.forEach(function(g) { g.setAttribute('data-view', cols); });
    viewBtns.forEach(function(btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-view') === cols ? 'true' : 'false');
    });
    try { localStorage.setItem(VIEW_STORAGE_KEY, cols); } catch (e) {}
  }
  viewBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      applyView(btn.getAttribute('data-view'));
    });
  });
  /* Restore preference on load — falls back to merchant's default
     if no localStorage entry exists. */
  try {
    var saved = localStorage.getItem(VIEW_STORAGE_KEY);
    if (saved) applyView(saved);
    else applyView(DEFAULT_VIEW);
  } catch (e) {
    applyView(DEFAULT_VIEW);
  }

  /* ── Query highlight — wrap matching substrings in <mark> ──
     Runs after page load on tile titles so the user sees why each
     result matched. Doesn't touch the original product.title text
     (still available for sort/filter operations server-side). */
  if (QUERY && QUERY.length >= 2) {
    var titles = page.querySelectorAll('[data-search-title]');
    /* Escape regex special characters in the query so e.g. "($)"
       doesn't blow up the RegExp constructor. */
    var safe = QUERY.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    try {
      var re = new RegExp('(' + safe + ')', 'ig');
      titles.forEach(function(t) {
        var html = t.textContent;
        t.innerHTML = html.replace(re, '<mark>$1</mark>');
      });
    } catch (e) {}
  }

  /* ── Swatch click → deep-link to ?variant= ────────────────
     Mirrors product-grid + drawer behavior. The whole tile is a
     link to product.url, so without intercepting the swatch click
     the user just lands on the default variant. We stop propagation
     and navigate to product.url?variant=ID for the right color. */
  page.addEventListener('click', function(e) {
    var sw = e.target.closest('.search-page__result-tile-swatch');
    if (!sw) return;
    var vid = sw.getAttribute('data-variant-id');
    var url = sw.getAttribute('data-product-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = vid ? url + '?variant=' + vid : url;
  });

  /* ── Wishlist sync — once wishlist drawer is ready, refresh
     all wishlist hearts on this page so any items already in the
     wishlist show as filled. The drawer fires 'wishlist:ready'
     after it initialises window.wishlistDrawer. Per-section-instance
     listener (sectionId scoped from page.dataset). */
  function syncWishlist() {
    if (window.wishlistDrawer && window.wishlistDrawer.sync) {
      window.wishlistDrawer.sync();
    }
  }
  if (window.wishlistDrawer) syncWishlist();
  document.addEventListener('wishlist:ready', syncWishlist);

  /* ── Theme editor reload ───────────────────────────────── */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      if (e.detail.sectionId !== sectionId) return;
      /* Re-init by reloading the page so all server-rendered
         tiles + Liquid swatches refresh. The editor preview reload
         handles this gracefully. */
      var newGrids = document.querySelectorAll('#search-page .search-page__grid');
      var newBtns = document.querySelectorAll('#search-page .search-page__view-btn');
      try {
        var saved = localStorage.getItem(VIEW_STORAGE_KEY) || DEFAULT_VIEW;
        newGrids.forEach(function(g) { g.setAttribute('data-view', saved); });
        newBtns.forEach(function(b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-view') === saved ? 'true' : 'false');
        });
      } catch (err) {}
    });
  }
})();

/* ════════════════════════════════════════════════════════════
   Quick Add — bottom-sheet panel
   ════════════════════════════════════════════════════════════
   Mirrors product-grid.liquid's quick-add system, ported to
   the search page namespace (sp-qa-*). Cart notifications use
   the global window.cartToast API (see snippets/cart-toast.liquid).
   Self-gated: when quick_add_enable is off the drawer DOM isn't
   rendered, so the IIFE returns early at the `if (!drawer) return`
   line below. Config comes from data-* attrs on #search-page.

   Three modes:
     'cart'             — default flow on tile QA click
     'wishlistAdd'      — entered via window.pgQuickAdd[id]
                           .openForWishlist(handle, sourceBtn)
                           (called by wishlist-drawer's click delegate
                           when a wishlist heart is tapped without an
                           exact-variant flag)
     'wishlistRemove'   — entered via openForWishlistRemove(...)
                           (same delegate, when the variant is already
                           wishlisted and the user clicks again)

   Singleton panel — registered into window.pgQuickAdd[sectionId]
   so the wishlist drawer can find it via Object.values(...)[0].
   The /search section renders before the drawer in theme.liquid,
   so this section's panel is the FIRST entry, meaning the global
   wishlist click delegate routes through here for any wishlist add
   originating on the page.
*/
(function() {
  var page = document.getElementById('search-page');
  if (!page) return;
  if (page.dataset.quickAddEnable !== 'true') return;
  var sectionId = page.dataset.sectionId;
  var drawer  = document.getElementById('sp-qa-drawer-' + sectionId);
  var overlay = document.getElementById('sp-qa-overlay-' + sectionId);
  if (!drawer) return;

  var spT = {
    addToCart:              page.dataset.qaAtcText            || 'Add to cart',
    addToWishlist:          page.dataset.qaWishlistText       || 'Add to wishlist',
    removeFromList:         page.dataset.qaWishlistRemoveText || 'Remove from wishlist',
    adding:                 page.dataset.qaAddingText         || 'Adding…',
    soldOut:                page.dataset.qaSoldoutText        || 'Sold out',
    unavailable:            page.dataset.qaUnavailableText    || 'Unavailable',
    errorGeneric:           page.dataset.cartNotifError       || "Sorry, we couldn't add that to cart.",
    cartNotifSoldout:       page.dataset.cartNotifSoldout     || 'This product is sold out.',
    cartNotifStock:         page.dataset.cartNotifStock       || 'Sorry, only %available% available and you already have %in_cart% in your cart.',
    cartNotifAdded:         page.dataset.cartNotifAdded       || 'Your selection has been reserved.',
    addToWishlistAria:      'Add to wishlist',
    removeFromWishlistAria: 'Remove from wishlist'
  };

  var titleEl   = drawer.querySelector('.sp-qa-drawer__product-title');
  var priceEl   = drawer.querySelector('.sp-qa-drawer__price');
  var imageEl   = drawer.querySelector('.sp-qa-drawer__image');
  var optionsEl = drawer.querySelector('.sp-qa-drawer__options');
  var atcBtn    = drawer.querySelector('.sp-qa-drawer__atc');
  var closeBtn  = drawer.querySelector('.sp-qa-drawer__close');

  /* The ATC button swaps its data-button-style attr based on mode so
     the global [data-button-style] CSS picks up the right look in
     wishlist vs cart contexts. */
  var ATC_STYLE_CART     = page.dataset.qaAtcStyle      || 'primary';
  var ATC_STYLE_WISHLIST = page.dataset.qaWishlistStyle || 'secondary';
  function applyAtcStyle(mode) {
    atcBtn.dataset.buttonStyle = (mode === 'wishlist') ? ATC_STYLE_WISHLIST : ATC_STYLE_CART;
    atcBtn.dataset.qaMode = mode;
  }

  var currentVariants     = [];
  var selectedOptions     = {};
  var wishlistMode        = false;
  var wishlistRemoveMode  = false;
  var wishlistSourceBtn   = null;
  var wishlistHandle      = null;

  /* ── Cart toast wrapper ──────────────────────────────────
     Thin shim around the global window.cartToast API (rendered
     once via cart-toast snippet in theme.liquid). Configure the
     notification's appearance in Theme Settings → Cart Notification. */
  function showToast(msg, isError, btn) {
    if (!window.cartToast) return;
    var productImage = btn && btn.dataset ? (btn.dataset.productImage || '') : '';
    var productTitle = btn && btn.dataset ? (btn.dataset.productTitle || '') : '';
    window.cartToast.show({
      type:         isError ? 'error' : 'success',
      message:      msg,
      productImage: productImage,
      productTitle: productTitle,
      quantity:     1
    });
  }

  /* ── Cart quantity cache ─────────────────────────────────── */
  /* Keyed by variant id string. Used for inventory checks against
     `data-inventory` to prevent over-adding when the merchant has
     inventory tracking + 'deny' policy. Refreshed on init and after
     every successful add. */
  var cartQty = {};
  function refreshCartQty(cb) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartQty = {};
        cart.items.forEach(function(item) { cartQty[String(item.variant_id)] = item.quantity; });
        if (cb) cb();
      })
      .catch(function() { if (cb) cb(); });
  }
  refreshCartQty();

  /* ── Open / close ────────────────────────────────────────── */
  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (wishlistRemoveMode) {
      atcBtn.textContent = spT.removeFromList;
    } else if (wishlistMode) {
      atcBtn.textContent = spT.addToWishlist;
    } else {
      atcBtn.textContent = spT.addToCart;
    }
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    wishlistMode = false;
    wishlistRemoveMode = false;
    wishlistSourceBtn = null;
    wishlistHandle = null;
    atcBtn.textContent = spT.addToCart;
    applyAtcStyle('cart');
  }

  /* ── Money formatter ─────────────────────────────────────── */
  /* /products/{handle}.js returns prices in CENTS (unlike
     predictive-search which returns them in dollars). Keep this
     simple — the toast/title flow is short-lived and Shopify's
     I18n locale formatter isn't exposed here. */
  function money(cents) {
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  /* ── Variant matching ────────────────────────────────────── */
  function findVariant() {
    return currentVariants.find(function(v) {
      return v.options.every(function(opt, i) {
        return selectedOptions['o' + (i + 1)] === opt;
      });
    }) || null;
  }

  /* ── ATC button label/state sync ─────────────────────────── */
  function updateAtcBtn() {
    var v = findVariant();

    /* In wishlist mode, re-evaluate every selection change — the user
       might pick a variant that's already wishlisted, in which case we
       flip from add → remove (or vice-versa). */
    if (v && (wishlistMode || wishlistRemoveMode)) {
      var inWl = window.wishlistDrawer
        ? window.wishlistDrawer.isInWishlist(v.id)
        : false;
      wishlistRemoveMode = inWl;
      wishlistMode = !inWl;
    }

    if (!v) {
      atcBtn.textContent = wishlistRemoveMode ? spT.removeFromList
                          : (wishlistMode ? spT.addToWishlist : spT.unavailable);
      atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
      delete atcBtn.dataset.variantId;
    } else if (!v.available) {
      atcBtn.textContent = wishlistRemoveMode ? spT.removeFromList
                          : (wishlistMode ? spT.addToWishlist : spT.soldOut);
      atcBtn.disabled = !wishlistRemoveMode && !wishlistMode;
      atcBtn.dataset.variantId = v.id;
    } else {
      atcBtn.textContent = wishlistRemoveMode ? spT.removeFromList
                          : (wishlistMode ? spT.addToWishlist : spT.addToCart);
      atcBtn.disabled = false;
      atcBtn.dataset.variantId = v.id;
    }
    if (v) {
      priceEl.textContent = money(v.price);
      if (v.featured_image) imageEl.src = v.featured_image.src;
    }

    /* Sold-out + unavailable styling for option pills */
    optionsEl.querySelectorAll('.sp-qa-option-btn, .sp-qa-color-btn').forEach(function(b) {
      var testKey = 'o' + b.dataset.pos;
      var test = Object.assign({}, selectedOptions);
      test[testKey] = b.dataset.value;
      var ok = currentVariants.some(function(v) {
        return v.options.every(function(o, i) { return test['o' + (i + 1)] === o; });
      });
      b.classList.toggle('is-unavailable', !ok);

      var otherSelections = Object.assign({}, selectedOptions);
      delete otherSelections[testKey];
      var soldOut = !currentVariants.some(function(v) {
        return v.available && v.options[parseInt(b.dataset.pos, 10) - 1] === b.dataset.value &&
          Object.keys(otherSelections).every(function(k) {
            return otherSelections[k] === v.options[parseInt(k.slice(1), 10) - 1];
          });
      });
      b.classList.toggle('is-sold-out', soldOut);
    });
  }

  /* ── Swatch map (parsed once from drawer's data-swatches) ── */
  var swatchMap = {};
  (drawer.dataset.swatches || '').split('||').forEach(function(entry) {
    if (!entry) return;
    var parts = entry.split(':');
    var key  = parts[0];
    var type = parts[1];
    var val  = parts.slice(2).join(':');
    swatchMap[key] = { type: type, val: val };
  });
  function getSwatchStyle(val) {
    if (!val) return null;
    var key = String(val).toLowerCase().replace(/\s/g, '');
    var s = swatchMap[key];
    if (s && s.type === 'image' && s.val) return { backgroundImage: 'url(' + s.val + ')', backgroundSize: 'cover' };
    if (s && s.type === 'color' && s.val) return { backgroundColor: s.val };
    /* Fallback: when Shopify didn't auto-resolve a swatch for this
       option value (no swatch.color or swatch.image set, type is
       'none', or the value isn't in the map at all), try the value
       name itself as a CSS color. "Light Green" → "lightgreen" is
       a valid CSS named color, so the dot renders without the
       merchant having to set the swatch metafield. Strips spaces,
       hyphens, and underscores so values entered as "Light-Green"
       or "Light_Green" also resolve. Returns null for unknown
       names. */
    var cssCandidate = String(val).toLowerCase().replace(/[\s\-_]/g, '');
    if (!cssCandidate) return null;
    var valid = false;
    if (typeof CSS !== 'undefined' && CSS.supports) {
      valid = CSS.supports('color', cssCandidate);
    } else {
      var tester = getSwatchStyle._tester || (getSwatchStyle._tester = document.createElement('div'));
      tester.style.backgroundColor = '';
      tester.style.backgroundColor = cssCandidate;
      valid = tester.style.backgroundColor !== '';
    }
    if (valid) return { backgroundColor: cssCandidate };
    return null;
  }

  /* ── Render options (variant picker) ─────────────────────── */
  function renderOptions(product, preselectId) {
    currentVariants = product.variants;
    selectedOptions = {};
    var hasRealVariants = product.variants.length > 1 ||
      (product.variants.length === 1 && product.variants[0].title !== 'Default Title');
    optionsEl.style.display = hasRealVariants ? '' : 'none';

    var first = product.variants[0];
    if (preselectId) {
      var preVariant = product.variants.find(function(v) { return String(v.id) === String(preselectId); });
      if (preVariant) first = preVariant;
    }
    if (!first) first = product.variants.find(function(v) { return v.available; }) || product.variants[0];
    product.options.forEach(function(name, i) { selectedOptions['o' + (i + 1)] = first.options[i]; });

    optionsEl.innerHTML = '';
    product.options.forEach(function(optRaw, idx) {
      var optName = typeof optRaw === 'object' ? optRaw.name : optRaw;
      var pos = idx + 1;

      var vals = [];
      product.variants.forEach(function(v) {
        if (vals.indexOf(v.options[idx]) === -1) vals.push(v.options[idx]);
      });

      var isColor = vals.some(function(v) { return !!getSwatchStyle(v); });

      var wrap = document.createElement('div');
      wrap.className = 'sp-qa-option';
      var label = document.createElement('p');
      label.className = 'sp-qa-option__label';
      var selSpan = document.createElement('span');
      selSpan.className = 'sp-qa-option__selected';
      selSpan.textContent = selectedOptions['o' + pos];
      label.textContent = optName + ': ';
      label.appendChild(selSpan);

      var btns = document.createElement('div');
      btns.className = isColor ? 'sp-qa-option__btns sp-qa-option__btns--colors' : 'sp-qa-option__btns';

      vals.forEach(function(val) {
        var swatch = isColor ? getSwatchStyle(val) : null;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.pos = pos;
        btn.dataset.value = val;

        var colorSoldOut = isColor && !currentVariants.some(function(v) {
          return v.options[idx] === val && v.available;
        });

        if (swatch) {
          btn.className = 'sp-qa-color-btn';
          if (colorSoldOut) btn.classList.add('is-sold-out');
          var dot = document.createElement('span');
          dot.className = 'sp-qa-color-dot';
          Object.assign(dot.style, swatch);
          var name = document.createElement('span');
          name.className = 'sp-qa-color-name';
          name.textContent = val;
          btn.appendChild(dot);
          btn.appendChild(name);
        } else {
          btn.className = 'sp-qa-option-btn';
          btn.textContent = val;
        }
        if (selectedOptions['o' + pos] === val) btn.classList.add('is-selected');

        btn.addEventListener('click', function() {
          /* Step 1: clear selected from all siblings, mark this one. */
          btns.querySelectorAll('.sp-qa-option-btn, .sp-qa-color-btn').forEach(function(b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          /* Step 2: update model + label. */
          selectedOptions['o' + pos] = val;
          selSpan.textContent = val;
          /* Step 3: re-evaluate ATC button + sold-out states. */
          updateAtcBtn();
        });

        btns.appendChild(btn);
      });

      wrap.appendChild(label);
      wrap.appendChild(btns);
      optionsEl.appendChild(wrap);
    });

    updateAtcBtn();
  }

  /* ── Per-tile inventory map (parsed lazily on open) ──────── */
  var variantInvMap = {};
  function parseVariantInvMap(tileEl) {
    variantInvMap = {};
    if (!tileEl) return;
    (tileEl.dataset.variantInv || '').split('|').forEach(function(entry) {
      if (!entry) return;
      var parts = entry.split(':');
      if (parts.length < 3) return;
      variantInvMap[parts[0]] = { qty: parseInt(parts[1], 10), policy: parts[2] };
    });
  }

  /* ── Load product + open panel ───────────────────────────── */
  function loadAndOpen(handle, btn, preselectId) {
    var tile = btn.closest('.search-page__result-tile');
    parseVariantInvMap(tile);
    btn.classList.add('is-loading');
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        btn.classList.remove('is-loading');
        titleEl.textContent = p.title;
        priceEl.textContent = money(p.price_min);
        imageEl.src = p.featured_image || '';
        imageEl.alt = p.title;
        atcBtn.dataset.productTitle = p.title;
        renderOptions(p, preselectId);
        refreshCartQty(function() { openDrawer(); });
      })
      .catch(function(err) {
        btn.classList.remove('is-loading');
        showToast(spT.errorGeneric, true);
      });
  }

  /* ── Tile QA-click delegate ──────────────────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.search-page__result-tile-quick-add');
    if (!btn) return;
    /* Scope to this section only — defensive, since search.liquid is
       singleton on /search but Shopify section editor reloads can
       briefly render two instances. */
    var sectionEl = document.getElementById('shopify-section-' + sectionId);
    if (sectionEl && !sectionEl.contains(btn)) return;
    /* The button lives INSIDE the tile <a> — stop propagation so the
       tile's link doesn't fire. */
    e.preventDefault();
    e.stopPropagation();

    /* Single-variant path: ATC directly without opening the panel. */
    if (btn.dataset.multiVariant !== 'true' && btn.dataset.variantId) {
      var vid       = String(btn.dataset.variantId);
      var invQty    = parseInt(btn.dataset.inventory, 10);
      var invPolicy = btn.dataset.inventoryPolicy || 'deny';
      var inCart    = cartQty[vid] || 0;

      if (btn.dataset.available === 'false') {
        showToast(spT.cartNotifSoldout, true);
        return;
      }

      if (invPolicy === 'deny' && !isNaN(invQty) && invQty > 0 && inCart >= invQty) {
        showToast(spT.cartNotifStock.replace('%available%', invQty).replace('%in_cart%', inCart), true);
        return;
      }

      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      })
      .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
      .then(function(res) {
        btn.classList.remove('is-loading');
        if (res.ok) {
          cartQty[vid] = (cartQty[vid] || 0) + 1;
          showToast(spT.cartNotifAdded, false, btn);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          handlePostAdd();
        } else {
          refreshCartQty();
          var errMsg = (res.data && (res.data.description || res.data.message)) || spT.errorGeneric;
          showToast(errMsg, true);
        }
      })
      .catch(function() {
        btn.classList.remove('is-loading');
        showToast(spT.errorGeneric, true);
      });
    } else {
      /* Multi-variant path: load + open picker. */
      loadAndOpen(btn.dataset.productHandle, btn, btn.dataset.variantId);
    }
  });

  /* ── Panel ATC click — handles all three modes ──────────── */
  atcBtn.addEventListener('click', function() {
    var vid = atcBtn.dataset.variantId;
    if (!vid || vid === 'undefined') return;

    /* Wishlist remove mode. */
    if (wishlistRemoveMode) {
      if (window.wishlistDrawer) window.wishlistDrawer.remove(vid);
      document.querySelectorAll('[data-wishlist-add="' + vid + '"]').forEach(function(b) {
        b.classList.remove('is-wishlisted');
        b.setAttribute('aria-label', spT.addToWishlistAria);
      });
      closeDrawer();
      return;
    }

    /* Wishlist add mode — picker chose a size; commit to wishlist. */
    if (wishlistMode) {
      var srcBtn = wishlistSourceBtn;
      var handle = wishlistHandle;
      if (window.wishlistDrawer) {
        window.wishlistDrawer.add(vid, handle);
      } else {
        try {
          var wlItems = JSON.parse(localStorage.getItem('wishlist_items')) || [];
          if (!wlItems.some(function(i) { return i.variantId == vid; })) {
            wlItems.push({ variantId: vid, productHandle: handle, addedAt: Date.now() });
            localStorage.setItem('wishlist_items', JSON.stringify(wlItems));
          }
        } catch(e) {}
      }
      if (srcBtn) {
        srcBtn.classList.add('is-wishlisted');
        srcBtn.setAttribute('aria-label', spT.removeFromWishlistAria);
      }
      document.querySelectorAll('[data-wishlist-add="' + vid + '"]').forEach(function(b) {
        b.classList.add('is-wishlisted');
      });
      closeDrawer();
      if (window.wishlistDrawer) window.wishlistDrawer.open();
      return;
    }

    /* Normal cart ATC — re-check inventory (selected variant might
       differ from initial), then post to cart. */
    var invData = variantInvMap[vid] || {};
    var invQty = invData.qty != null ? invData.qty : NaN;
    var invPolicy = invData.policy || 'deny';
    var inCart = cartQty[vid] || 0;
    if (invPolicy === 'deny' && !isNaN(invQty) && invQty > 0 && inCart >= invQty) {
      showToast(spT.cartNotifStock.replace('%available%', invQty).replace('%in_cart%', inCart), true);
      return;
    }
    atcBtn.textContent = spT.adding;
    atcBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
    .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
    .then(function(res) {
      if (res.ok) {
        cartQty[String(vid)] = (cartQty[String(vid)] || 0) + 1;
        closeDrawer();
        /* Build a synthetic 'btn' for the toast so it gets product image + title */
        var qaCtx = { dataset: { productImage: (imageEl && imageEl.src) || '', productTitle: (titleEl && titleEl.textContent) || '' } };
        showToast(spT.cartNotifAdded, false, qaCtx);
        document.dispatchEvent(new CustomEvent('cart:updated'));
        handlePostAdd();
      } else {
        atcBtn.textContent = spT.addToCart;
        atcBtn.disabled = false;
        refreshCartQty();
        var errMsg = (res.data && (res.data.description || res.data.message)) || spT.errorGeneric;
        showToast(errMsg, true);
      }
    })
    .catch(function() {
      atcBtn.textContent = spT.addToCart;
      atcBtn.disabled = false;
      showToast(spT.errorGeneric, true);
    });
  });

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  /* ── Public API for wishlist drawer ──────────────────────── */
  /* Registers under window.pgQuickAdd[id] — same global namespace as
     product-grid + search-drawer. The wishlist drawer's click delegate
     looks up Object.values(window.pgQuickAdd)[0] and calls
     openForWishlist / openForWishlistRemove. Since this section
     renders before the drawer in theme.liquid, this is the FIRST
     entry → handles all wishlist clicks on /search. */
  window.pgQuickAdd = window.pgQuickAdd || {};
  window.pgQuickAdd[sectionId] = {
    openForWishlistRemove: function(handle, sourceBtn, preselectId) {
      wishlistMode = false;
      wishlistRemoveMode = true;
      wishlistSourceBtn = sourceBtn;
      wishlistHandle = handle;
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          titleEl.textContent = p.title;
          priceEl.textContent = money(p.price_min);
          imageEl.src = p.featured_image || '';
          imageEl.alt = p.title;
          atcBtn.dataset.productTitle = p.title;
          renderOptions(p, preselectId);
          applyAtcStyle('wishlist');
          openDrawer();
        })
        .catch(function() {
          wishlistRemoveMode = false;
          if (window.wishlistDrawer) window.wishlistDrawer.remove(sourceBtn ? sourceBtn.dataset.wishlistAdd : null);
        });
    },

    openForWishlist: function(handle, sourceBtn) {
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          var hasRealVariants = p.variants.length > 1 ||
            (p.variants.length === 1 && p.variants[0].title !== 'Default Title');

          if (!hasRealVariants) {
            /* Single-variant — skip picker, add directly. */
            var vid = p.variants[0].id;
            if (window.wishlistDrawer) {
              window.wishlistDrawer.add(vid, handle);
            } else {
              try {
                var wlItems = JSON.parse(localStorage.getItem('wishlist_items')) || [];
                if (!wlItems.some(function(i) { return i.variantId == vid; })) {
                  wlItems.push({ variantId: vid, productHandle: handle, addedAt: Date.now() });
                  localStorage.setItem('wishlist_items', JSON.stringify(wlItems));
                }
              } catch(e) {}
            }
            if (sourceBtn) {
              sourceBtn.classList.add('is-wishlisted');
              sourceBtn.setAttribute('aria-label', spT.removeFromWishlistAria);
            }
            if (window.wishlistDrawer) window.wishlistDrawer.open();
          } else {
            wishlistMode = true;
            wishlistSourceBtn = sourceBtn;
            wishlistHandle = handle;
            titleEl.textContent = p.title;
            priceEl.textContent = money(p.price_min);
            imageEl.src = p.featured_image || '';
            imageEl.alt = p.title;
            atcBtn.dataset.productTitle = p.title;
            var preselectId = sourceBtn ? sourceBtn.dataset.wishlistAdd : null;
            renderOptions(p, preselectId);
            applyAtcStyle('wishlist');
            openDrawer();
          }
        })
        .catch(function() {
          wishlistMode = true;
          wishlistSourceBtn = sourceBtn;
          wishlistHandle = handle;
          var preselectId = sourceBtn ? sourceBtn.dataset.wishlistAdd : null;
          applyAtcStyle('wishlist');
          loadAndOpen(handle, { classList: { add: function() {}, remove: function() {} } }, preselectId);
        });
    }
  };

  /* ── Post-add behavior ──────────────────────────────────── */
  /* Mirrors product-grid: respects the global cart_type +
     cart_add_action settings so behavior matches the rest of the
     theme (open cart drawer, redirect to cart page, etc.). */
  var cartType  = page.dataset.cartType      || 'drawer';
  var addAction = page.dataset.cartAddAction || 'drawer';
  function handlePostAdd() {
    if (addAction === 'drawer' && cartType === 'drawer') {
      if (window.cartDrawer) window.cartDrawer.open();
      else document.dispatchEvent(new CustomEvent('cart:open'));
    } else if (addAction === 'page') {
      window.location.href = '/cart';
    }
  }

  /* Keep cartQty fresh whenever cart changes elsewhere on the page. */
  document.addEventListener('cart:updated', function() { refreshCartQty(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  /* Slideshow runtime — single bundled script handles every slideshow
     instance on the page. Reads section ID + autoplay settings from
     data-* attributes so no Liquid interpolation lives here.
     Re-initializes on shopify:section:load (theme editor) so merchant
     edits take effect without a manual reload. */
  (function() {
    function initSlideshow(el) {
      if (el.dataset.cspInit === 'true') return;
      el.dataset.cspInit = 'true';

      var sectionId = el.dataset.sectionId;
      var slides    = Array.prototype.slice.call(el.querySelectorAll('.slideshow__slide'));
      var dots      = Array.prototype.slice.call(el.querySelectorAll('.slideshow__dot'));
      var prevBtn   = el.querySelector('.slideshow__arrow--prev');
      var nextBtn   = el.querySelector('.slideshow__arrow--next');
      var mode      = el.classList.contains('slideshow--slide') ? 'slide' : 'fade';
      var autoplay  = el.dataset.autoplay === 'true';
      var speed     = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
      var total     = slides.length;
      var current   = 0;
      var animating = false;
      var timer     = null;

      if (total <= 1) {
        if (el.dataset.scrollReveal === 'true') initScrollReveal(el);
        return;
      }

      function goTo(index, dir) {
        if (animating || index === current) return;
        animating = true;

        var prev = current;
        current = ((index % total) + total) % total;

        if (mode === 'slide') {
          var inFrom = dir === 'next' ? '100%' : '-100%';
          var outTo  = dir === 'next' ? '-100%' : '100%';

          slides[current].style.transition = 'none';
          slides[current].style.transform  = 'translateX(' + inFrom + ')';
          slides[current].style.visibility = 'visible';
          slides[current].style.zIndex     = '2';

          slides[current].offsetHeight;

          slides[current].style.transition = '';
          slides[current].classList.add('is-active');
          slides[current].style.transform  = 'translateX(0)';
          slides[prev].style.transform     = 'translateX(' + outTo + ')';

          setTimeout(function() {
            slides[prev].classList.remove('is-active');
            slides[prev].style.transform  = '';
            slides[prev].style.visibility = '';
            slides[prev].style.zIndex     = '';
            slides[current].style.zIndex  = '';
            slides[current].style.transform = '';
            animating = false;
          }, 650);

        } else {
          slides[prev].style.zIndex    = '1';
          slides[current].style.zIndex = '2';
          slides[current].classList.add('is-active');
          setTimeout(function() {
            slides[prev].classList.remove('is-active');
            slides[prev].style.zIndex    = '';
            slides[current].style.zIndex = '';
            animating = false;
          }, 700);
        }

        dots.forEach(function(d, i) {
          d.classList.toggle('is-active', i === current);
          d.setAttribute('aria-selected', i === current ? 'true' : 'false');
          if (i === current) {
            d.classList.add('no-anim');
            d.offsetHeight;
            d.classList.remove('no-anim');
          }
        });
      }

      function next() { goTo(current + 1, 'next'); }
      function prev() { goTo(current - 1, 'prev'); }

      function startTimer() {
        if (!autoplay) return;
        timer = (window.cspManagedInterval || setInterval)(next, speed, sectionId);
      }
      function resetTimer() { clearInterval(timer); startTimer(); }

      if (nextBtn) nextBtn.addEventListener('click', function() { resetTimer(); next(); });
      if (prevBtn) prevBtn.addEventListener('click', function() { resetTimer(); prev(); });
      dots.forEach(function(d, i) {
        d.addEventListener('click', function() { resetTimer(); goTo(i, i > current ? 'next' : 'prev'); });
      });

      el.addEventListener('mouseenter', function() { clearInterval(timer); });
      el.addEventListener('mouseleave', startTimer);

      var touchX = 0;
      el.addEventListener('touchstart', function(e) { touchX = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function(e) {
        var diff = touchX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { resetTimer(); diff > 0 ? next() : prev(); }
      }, { passive: true });

      var firstDot = dots[0];
      setTimeout(function() {
        startTimer();
        if (firstDot) {
          firstDot.classList.add('no-anim');
          firstDot.offsetHeight;
          firstDot.classList.remove('no-anim');
        }
      }, 50);

      if (el.dataset.scrollReveal === 'true') initScrollReveal(el);
    }

    /* Updates --ss-header-offset whenever the fixed header's height
       could have changed (scroll / resize). The static CSS uses that
       variable inside top: calc(...) on .slideshow__inner. */
    function initScrollReveal(ss) {
      function updateHeaderOffset() {
        var header = document.querySelector('#site-header, .site-header, header[data-sticky]');
        var h = 0;
        if (header) {
          var node = header.closest('[style*="position: fixed"], [style*="position:fixed"]') || header;
          if (node && (node.style.position === 'fixed' || window.getComputedStyle(node).position === 'fixed')) {
            h = node.offsetHeight;
          }
        }
        ss.style.setProperty('--ss-header-offset', h + 'px');
      }
      updateHeaderOffset();
      window.addEventListener('scroll', updateHeaderOffset, { passive: true });
      window.addEventListener('resize', updateHeaderOffset, { passive: true });
    }

    function initAll(root) {
      (root || document).querySelectorAll('.slideshow').forEach(initSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function(e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hero"] && !Shopify.designMode) return;
  try {
    
  /* Per-media independent video controls — each .split-hero__media gets
     its own play/pause + mute + progress. Pausing one panel's video
     doesn't affect another's.

     Multi-instance: iterates every .split-hero element on init, observes
     each one independently. Cached/bundled with no Liquid interpolation —
     section-specific config reads from class names and DOM structure.
     Re-runs on shopify:section:load so theme-editor reloads pick up
     newly-rendered sections. */
  (function() {
    function initMedia(media) {
      var video = media.querySelector('.split-hero__video');
      if (!video) return;
      var playBtn   = media.querySelector('.split-hero__vc-playpause');
      var muteBtn   = media.querySelector('.split-hero__vc-mute');
      var fill      = media.querySelector('.split-hero__vc-progress-fill');
      var pauseIcon = media.querySelector('.split-hero__vc-icon--pause');
      var playIcon  = media.querySelector('.split-hero__vc-icon--play');
      var soundIcon = media.querySelector('.split-hero__vc-icon--sound');
      var mutedIcon = media.querySelector('.split-hero__vc-icon--muted');
      if (playBtn) {
        playBtn.addEventListener('click', function() {
          if (video.paused) {
            video.play();
            if (pauseIcon) pauseIcon.style.display = '';
            if (playIcon)  playIcon.style.display  = 'none';
          } else {
            video.pause();
            if (pauseIcon) pauseIcon.style.display = 'none';
            if (playIcon)  playIcon.style.display  = '';
          }
        });
      }
      if (muteBtn) {
        muteBtn.addEventListener('click', function() {
          video.muted = !video.muted;
          if (video.muted) {
            if (soundIcon) soundIcon.style.display = 'none';
            if (mutedIcon) mutedIcon.style.display = '';
            muteBtn.setAttribute('aria-label', 'Unmute video');
          } else {
            if (soundIcon) soundIcon.style.display = '';
            if (mutedIcon) mutedIcon.style.display = 'none';
            muteBtn.setAttribute('aria-label', 'Mute video');
          }
        });
      }
      if (fill) {
        video.addEventListener('timeupdate', function() {
          if (!video.duration) return;
          fill.style.width = (video.currentTime / video.duration * 100) + '%';
        });
      }
    }

    /* Scroll reveal: when enabled, each panel's .split-hero__inner is
       position: sticky inside its panel (CSS rule above). We track any
       fixed site header's height and write it to --sh-header-offset so
       the sticky top sits below the header instead of being hidden
       behind it. Mirrors hero.liquid's initScrollReveal. */
    function initScrollReveal(section) {
      if (section.dataset.scrollReveal !== 'true') return;

      function updateHeaderOffset() {
        var header = document.querySelector('#site-header, .site-header, header[data-sticky]');
        var h = 0;
        if (header) {
          /* Climb to a positioned ancestor in case the visible fixed
             element is the wrapper rather than the header tag itself
             (header.liquid's sticky JS sets position:fixed on the
             wrapper). */
          var el = header.closest('[style*="position: fixed"], [style*="position:fixed"]') || header;
          if (el && (el.style.position === 'fixed' || window.getComputedStyle(el).position === 'fixed')) {
            h = el.offsetHeight;
          }
        }
        section.style.setProperty('--sh-header-offset', h + 'px');
      }

      updateHeaderOffset();
      window.addEventListener('scroll', updateHeaderOffset, { passive: true });
      window.addEventListener('resize', updateHeaderOffset, { passive: true });
    }

    function initSection(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';
      var medias = section.querySelectorAll('.split-hero__media');
      medias.forEach(initMedia);
      initScrollReveal(section);
    }

    function init(root) {
      (root || document).querySelectorAll('.split-hero').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-init: merchant saves a setting, Shopify replaces
       the section's DOM. The fresh node has no data-csp-init flag so
       initSection runs cleanly. */
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-section"] && !Shopify.designMode) return;
  try {
    
  /* Animation driver for the text-block-section.

     Multi-instance: scans every .text-block-section, guards each
     with data-csp-init so it initializes exactly once. Per-section
     configuration (animation type, duration, delay, stagger toggle)
     comes from data-* attributes so this block has no Liquid
     interpolation and can be cached/bundled.

     Trigger: IntersectionObserver fires the first time the section
     enters the viewport (threshold 0.1) — animations start, observer
     disconnects, no further work happens. There's also a fallback
     for sections already in view at init time, which kicks the
     animations off immediately and disconnects the observer to
     prevent a double-fire. */
  (function() {
    function initSection(section) {
      if (!section || section.dataset.cspInit === 'true') return;
      section.dataset.cspInit = 'true';

      var animationType = section.dataset.animation || 'none';
      if (animationType === 'none') return;

      var animationDuration = parseInt(section.dataset.animationDuration, 10) || 600;
      var animationDelay = parseInt(section.dataset.animationDelay, 10) || 0;
      var staggerEnabled = section.dataset.stagger === 'true';

      var elements = section.querySelectorAll('.animate-element');

      function typeWriter(element, callback) {
        var typewriterSpan = element.querySelector('.typewriter-text');
        var cursor = element.querySelector('.typewriter-cursor');

        if (!typewriterSpan) {
          element.classList.add('animated');
          if (callback) callback();
          return;
        }

        var text = typewriterSpan.getAttribute('data-text') || '';
        var speed = Math.max(20, Math.floor(animationDuration / Math.max(text.length, 1)));
        var i = 0;
        typewriterSpan.textContent = '';

        function type() {
          if (i < text.length) {
            typewriterSpan.textContent += text.charAt(i);
            i++;
            setTimeout(type, speed);
          } else {
            // Typing complete — hide cursor after a delay
            setTimeout(function() {
              if (cursor) cursor.classList.add('hidden');
              if (callback) callback();
            }, 1500);
          }
        }

        type();
      }

      function startAnimations() {
        if (animationType === 'typewriter') {
          // Start all typewriter elements at once (stagger handled
          // here in JS instead of CSS so each typer kicks off with
          // its own offset rather than the section's CSS delay).
          elements.forEach(function(el, index) {
            var typewriterSpan = el.querySelector('.typewriter-text');
            if (typewriterSpan) {
              var delay = staggerEnabled ? (index * 100) : 0;
              setTimeout(function() {
                typeWriter(el, null);
              }, animationDelay + delay);
            } else {
              // Non-typewriter elements (e.g. the buttons wrapper)
              // just reveal — no typing.
              el.classList.add('animated');
            }
          });
        } else {
          // CSS-driven animations: adding .animated triggers the
          // keyframe; CSS handles the stagger via :nth-child.
          elements.forEach(function(el) {
            el.classList.add('animated');
          });
        }
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            startAnimations();
            observer.disconnect();
          }
        });
      }, { threshold: 0.1 });

      observer.observe(section);

      // Fallback: if already in view at init time, start
      // immediately and disconnect the observer to avoid a
      // double-fire.
      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        setTimeout(startAnimations, 100);
        observer.disconnect();
      }
    }

    function init(root) {
      (root || document).querySelectorAll('.text-block-section').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }

    // Theme editor re-init: merchant saves a setting, Shopify
    // replaces the section's DOM. The fresh node has no
    // data-csp-init flag so initSection runs cleanly.
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-drawer"]) return;
  try {
    
  (function () {
    /* ── Init guard (singleton drawer, but use multi-instance pattern) ──
       The drawer element is the singleton root. Guard against double-bind
       in case shopify:section:load re-runs init() on theme editor reload. */
    function init(root) {
      var scope = root || document;
      var drawers = scope.querySelectorAll('#wishlist-drawer');
      if (!drawers.length) return;
      drawers.forEach(function (drawer) {
        if (drawer.dataset.cspInit === 'true') return;
        drawer.dataset.cspInit = 'true';
        initDrawer(drawer);
      });
    }

    function initDrawer(drawer) {
      /* ── Configuration from data-* attributes ─────────────── */
      var SECTION_ID  = drawer.dataset.wdSectionId || '';
      var CUSTOMER_ID = drawer.dataset.wdCustomerId || '';
      var ATC_STYLE   = drawer.dataset.wdAtcStyle || 'primary';
      var ATC_TEXT    = drawer.dataset.wdAtcText || 'Add to cart';
      var SOLD_OUT    = drawer.dataset.wdSoldOutText || 'Sold out';
      var I18N_ADD    = drawer.dataset.wdI18nAdd || 'Add to wishlist';
      var I18N_REMOVE = drawer.dataset.wdI18nRemove || 'Remove from wishlist';

      /* ── Customer scoping ─────────────────────────────────────────
         Wishlists are saved per device (localStorage). When a customer is
         logged in, items are stored under a per-customer key so multiple
         customers on a shared browser don't see each other's lists.
         Guests use a single shared key. On every page load, if a customer
         is present and a guest list exists, we merge the guest list into
         the customer list and clear the guest bucket (one-shot, idempotent). */
      var GUEST_KEY = 'wishlist_items';
      var STORAGE_KEY = CUSTOMER_ID ? 'wishlist_items_' + CUSTOMER_ID : GUEST_KEY;
      var DISMISS_KEY = 'wishlist_login_prompt_dismissed';

      function migrateGuestToCustomer() {
        if (!CUSTOMER_ID) return;
        var guest;
        try { guest = JSON.parse(localStorage.getItem(GUEST_KEY)) || []; } catch (e) { guest = []; }
        if (!Array.isArray(guest) || guest.length === 0) {
          try { if (localStorage.getItem(GUEST_KEY) !== null) localStorage.removeItem(GUEST_KEY); } catch (e) {}
          return;
        }
        var customer;
        try { customer = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { customer = []; }
        if (!Array.isArray(customer)) customer = [];
        var seen = {};
        customer.forEach(function (i) { if (i && i.variantId != null) seen[String(i.variantId)] = true; });
        guest.forEach(function (g) {
          if (g && g.variantId != null && !seen[String(g.variantId)]) {
            customer.push(g);
            seen[String(g.variantId)] = true;
          }
        });
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(customer));
          localStorage.removeItem(GUEST_KEY);
        } catch (e) {}
      }
      migrateGuestToCustomer();

      var overlay   = document.getElementById('wishlist-drawer-overlay');
      var closeBtn  = document.getElementById('wishlist-drawer-close');
      var bodyEl    = document.getElementById('wishlist-drawer-body');
      var itemsEl   = document.getElementById('wishlist-drawer-items');
      var emptyEl   = document.getElementById('wishlist-drawer-empty');
      var loadingEl = document.getElementById('wishlist-drawer-loading');
      var footerEl  = document.getElementById('wishlist-drawer-footer');
      var countEl   = document.getElementById('wishlist-drawer-title-count');

      /* Sync empty-state icon with the header's wishlist icon style.
         The header section owns the "Icon style" setting (heart / star /
         bookmark / diamond); rather than duplicating that setting here
         we clone the header's already-rendered SVG path into our empty
         icon at init. Changing the icon in the header section then
         propagates here automatically — single source of truth. */
      var headerWlSvg = document.querySelector('.header__wishlist-icon svg');
      var emptyIconEl = drawer.querySelector('.wishlist-drawer__empty-icon');
      if (headerWlSvg && emptyIconEl) {
        emptyIconEl.innerHTML = headerWlSvg.innerHTML;
      }

      /* ── Storage helpers ────────────────────────────────────── */
      function getWishlist() {
        try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
        catch (e) { return []; }
      }
      function saveWishlist(items) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
        catch (e) {}
        updateHeaderCount();
      }
      function addToWishlist(variantId, productHandle) {
        var items = getWishlist();
        var exists = items.some(function (i) { return i.variantId == variantId; });
        if (!exists) { items.push({ variantId: variantId, productHandle: productHandle, addedAt: Date.now() }); }
        saveWishlist(items);
      }
      function removeFromWishlist(variantId) {
        var items = getWishlist().filter(function (i) { return i.variantId != variantId; });
        saveWishlist(items);
        renderItems();
        syncWishlistButtons();
      }
      function isInWishlist(variantId) {
        return getWishlist().some(function (i) { return i.variantId == variantId; });
      }

      /* ── Header count badge ─────────────────────────────────── */
      function updateHeaderCount() {
        var items = getWishlist();
        var headerCountEl = document.querySelector('.header__wishlist-count');
        if (!headerCountEl) return;
        if (items.length > 0) {
          headerCountEl.textContent = items.length;
          headerCountEl.style.display = '';
        } else {
          headerCountEl.style.display = 'none';
        }
      }

      /* ── Open / Close ───────────────────────────────────────── */
      function openDrawer() {
        /* Close any other drawer that's currently open. Wishlisting from
           inside the cart-drawer (or quick-add from the search-drawer)
           would otherwise open this drawer on top of the previous one,
           causing overlapping focus traps and a non-interactive UI.
           The cart/search drawers each expose .close() on their window
           registration — they close themselves cleanly (deactivating their
           own focus trap), then this drawer's trap activates fresh. */
        if (window.cartDrawer && window.cartDrawer.close) {
          var cd = document.getElementById('cart-drawer');
          if (cd && cd.classList.contains('is-open')) window.cartDrawer.close();
        }
        if (window.searchDrawer && window.searchDrawer.close) {
          var sd = document.getElementById('search-drawer');
          if (sd && sd.classList.contains('is-open')) window.searchDrawer.close();
        }

        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) {
          overlay.classList.add('is-active');
          overlay.setAttribute('aria-hidden', 'false');
        }
        document.body.style.overflow = 'hidden';
        if (window.cspFocusTrap) window.cspFocusTrap.activate(drawer);
        renderItems();
      }
      function closeDrawer() {
        if (window.cspFocusTrap) window.cspFocusTrap.deactivate(drawer);
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (overlay) {
          overlay.classList.remove('is-active');
          overlay.setAttribute('aria-hidden', 'true');
        }
        document.body.style.overflow = '';
      }

      /* ── Render ─────────────────────────────────────────────── */
      function showLoading(show) {
        if (loadingEl) loadingEl.classList.toggle('is-visible', show);
      }

      function formatMoney(cents) {
        return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      function escapeHtml(str) {
        return String(str == null ? '' : str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function renderItems() {
        var items = getWishlist();
        if (!itemsEl) return;
        itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.classList.remove('is-visible');
        if (footerEl) footerEl.classList.remove('is-visible');

        if (countEl) {
          countEl.textContent = items.length > 0 ? items.length : '';
          countEl.classList.toggle('is-active', items.length > 0);
        }

        if (items.length === 0) {
          if (emptyEl) emptyEl.classList.add('is-visible');
          return;
        }

        showLoading(true);

        var fetches = items.map(function (item) {
          return fetch('/products/' + item.productHandle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (product) { return { item: item, product: product }; })
            .catch(function () { return null; });
        });

        Promise.all(fetches).then(function (results) {
          showLoading(false);
          var validResults = results.filter(Boolean);

          if (validResults.length === 0) {
            if (emptyEl) emptyEl.classList.add('is-visible');
            return;
          }

          validResults.forEach(function (r) {
            var item = r.item;
            var product = r.product;
            var variant = product.variants.find(function (v) { return v.id == item.variantId; }) || product.variants[0];
            /* Use variant featured_image if available, otherwise fall back to first product image */
            var imgSrc = (variant && variant.featured_image && variant.featured_image.src)
              ? variant.featured_image.src
              : (product.images && product.images.length > 0 ? product.images[0] : null);
            var imgHtml = imgSrc
              ? '<img class="wishlist-drawer__item-img" src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
              : '<div class="wishlist-drawer__item-img-placeholder"></div>';

            var variantLabel = variant && variant.title !== 'Default Title' ? variant.title : '';
            var available = variant ? variant.available : false;
            var price = variant ? formatMoney(variant.price) : '';

            var el = document.createElement('div');
            el.className = 'wishlist-drawer__item';
            el.dataset.variantId = variant.id;
            el.innerHTML =
              '<a href="/products/' + escapeHtml(product.handle) + '?variant=' + escapeHtml(variant.id) + '" class="wishlist-drawer__item-img-wrap">' + imgHtml + '</a>'
              + '<div class="wishlist-drawer__item-info">'
              +   '<a href="/products/' + escapeHtml(product.handle) + '?variant=' + escapeHtml(variant.id) + '" class="wishlist-drawer__item-title">' + escapeHtml(product.title) + '</a>'
              +   (variantLabel ? '<span class="wishlist-drawer__item-variant">' + escapeHtml(variantLabel) + '</span>' : '')
              +   '<span class="wishlist-drawer__item-price">' + escapeHtml(price) + '</span>'
              +   '<div class="wishlist-drawer__item-actions">'
              +     '<button class="wishlist-drawer__item-atc" data-button-style="' + escapeHtml(ATC_STYLE) + '" data-button-text-effect="false"' + (!available ? ' disabled' : '') + '>'
              +       (available ? escapeHtml(ATC_TEXT) : escapeHtml(SOLD_OUT))
              +     '</button>'
              +     '<button class="wishlist-drawer__item-remove" aria-label="' + escapeHtml(I18N_REMOVE) + '">'
              +       '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
              +     '</button>'
              +   '</div>'
              + '</div>';

            /* ATC button */
            if (available) {
              el.querySelector('.wishlist-drawer__item-atc').addEventListener('click', function () {
                var btn = this;
                btn.disabled = true;
                btn.textContent = '…';
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: variant.id, quantity: 1 })
                })
                .then(function (r) { return r.json(); })
                .then(function () {
                  btn.textContent = '✓';
                  removeFromWishlist(variant.id);
                  /* Update cart count + optionally open cart */
                  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                    var cartCount = document.querySelector('.header__cart-count');
                    if (cartCount) {
                      cartCount.textContent = cart.item_count;
                      cartCount.style.display = cart.item_count > 0 ? '' : 'none';
                    }
                    closeDrawer();
                    document.dispatchEvent(new CustomEvent('cart:open'));
                  });
                })
                .catch(function () {
                  btn.textContent = ATC_TEXT;
                  btn.disabled = false;
                });
              });
            }

            /* Remove button */
            el.querySelector('.wishlist-drawer__item-remove').addEventListener('click', function () {
              removeFromWishlist(variant.id);
            });

            itemsEl.appendChild(el);
          });

          if (footerEl) footerEl.classList.add('is-visible');
        });
      }

      /* ── Toggle wishlist icon state on product pages ───────────── */
      function syncWishlistButtons() {
        var items = getWishlist();
        document.querySelectorAll('[data-wishlist-add]').forEach(function (btn) {
          var vid = btn.dataset.wishlistAdd;
          var handle = btn.dataset.wishlistHandle;
          /* First try exact variant match */
          var inList = isInWishlist(vid);
          /* If not matched, check if any wishlisted item belongs to the same product handle
             (handles sold-out variants whose ID differs from first_available_variant).
             Skip this fallback for buttons with data-wishlist-exact (e.g. product page),
             where the heart must reflect only the currently selected variant/color. */
          if (!inList && handle && !btn.dataset.wishlistExact) {
            var matchedItem = items.find(function (i) { return i.productHandle === handle; });
            if (matchedItem) {
              inList = true;
              btn.dataset.wishlistAdd = String(matchedItem.variantId);
            }
          }
          btn.classList.toggle('is-wishlisted', inList);
          btn.setAttribute('aria-label', inList ? I18N_REMOVE : I18N_ADD);
        });
      }

      /* ── Global add/remove API ──────────────────────────────── */
      window.wishlistDrawer = {
        open: openDrawer,
        close: closeDrawer,
        sync: syncWishlistButtons,
        add: function (variantId, productHandle) {
          addToWishlist(variantId, productHandle);
          syncWishlistButtons();
        },
        remove: function (variantId) {
          removeFromWishlist(variantId);
          syncWishlistButtons();
        },
        toggle: function (variantId, productHandle) {
          if (isInWishlist(variantId)) {
            removeFromWishlist(variantId);
          } else {
            addToWishlist(variantId, productHandle);
          }
          syncWishlistButtons();
        },
        isInWishlist: isInWishlist,
        getItems: getWishlist,
        getStorageKey: function () { return STORAGE_KEY; },
        getCustomerId: function () { return CUSTOMER_ID || null; }
      };

      /* ── Event listeners ─────────────────────────────────────── */
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-wishlist-drawer-toggle]')) {
          e.preventDefault();
          openDrawer();
        }
        /* Handle [data-wishlist-add] buttons anywhere on page */
        var addBtn = e.target.closest('[data-wishlist-add]');
        if (addBtn) {
          e.preventDefault();
          var vid = addBtn.dataset.wishlistAdd;
          var handle = addBtn.dataset.wishlistHandle;

          /* data-wishlist-exact: variant already selected (product page bar) — skip QA panel */
          if (addBtn.dataset.wishlistExact) {
            window.wishlistDrawer.toggle(vid, handle);
            var nowIn = isInWishlist(vid);
            addBtn.classList.toggle('is-wishlisted', nowIn);
            addBtn.setAttribute('aria-label', nowIn ? I18N_REMOVE : I18N_ADD);
            if (nowIn) openDrawer();
            return;
          }

          /* Pick the QA API belonging to the SECTION that contains
             the clicked wishlist button. The previous
             `Object.values(window.pgQuickAdd)[0]` returned the
             first-inserted entry, which on most pages was
             `sd-fallback` (search-drawer's last-resort handler) —
             so the wishlist panel always rendered through
             search-drawer's code path even when the click happened
             on a product-grid / related-products / complete-the-look
             card. That handler can't read the source card's
             `data-swatches`, so image-type swatches (Natural,
             Multi-Brown, etc.) never rendered in wishlist mode.

             Strategy:
               1. Walk up from the clicked button to its
                  Shopify section wrapper; if that section
                  registered a pgQuickAdd entry, use it.
               2. Otherwise prefer any non-"fallback" entry
                  (real section APIs over the search-drawer
                  catch-all).
               3. Last resort, take whatever's there. */
          var qaApi = (function findQaApi() {
            var apis = window.pgQuickAdd || {};
            var keys = Object.keys(apis);
            if (!keys.length) return null;
            var sectionWrap = addBtn.closest('[id^="shopify-section-"]');
            if (sectionWrap) {
              var sectionId = sectionWrap.id.replace(/^shopify-section-/, '');
              if (apis[sectionId]) return apis[sectionId];
            }
            for (var i = 0; i < keys.length; i++) {
              if (!/fallback$/i.test(keys[i])) return apis[keys[i]];
            }
            return apis[keys[0]];
          })();

          /* If already wishlisted — open panel in remove mode */
          if (isInWishlist(vid)) {
            if (qaApi && handle) {
              qaApi.openForWishlistRemove(handle, addBtn, vid);
            } else {
              window.wishlistDrawer.toggle(vid, handle);
              addBtn.classList.remove('is-wishlisted');
              addBtn.setAttribute('aria-label', I18N_ADD);
            }
            return;
          }

          /* Open quick-add panel in wishlist mode so user can pick size first */
          if (qaApi && handle) {
            qaApi.openForWishlist(handle, addBtn);
          } else {
            window.wishlistDrawer.toggle(vid, handle);
            openDrawer();
          }
        }
      });

      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay)  overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });

      /* ── Login banner (only present in DOM when guest) ──────── */
      var loginBannerEl = document.getElementById('wishlist-drawer-login-banner');
      var loginDismissBtn = document.getElementById('wishlist-drawer-login-dismiss');
      if (loginBannerEl) {
        var dismissed = false;
        try { dismissed = localStorage.getItem(DISMISS_KEY) === '1'; } catch (e) {}
        if (dismissed) loginBannerEl.hidden = true;
        if (loginDismissBtn) {
          loginDismissBtn.addEventListener('click', function () {
            try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
            loginBannerEl.hidden = true;
          });
        }
      }

      /* ── Init ────────────────────────────────────────────────── */
      updateHeaderCount();
      syncWishlistButtons();
      document.dispatchEvent(new CustomEvent('wishlist:ready'));

      /* Theme editor */
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', function (e) {
          if (String(e.detail.sectionId) === String(SECTION_ID)) openDrawer();
        });
        document.addEventListener('shopify:section:deselect', function (e) {
          if (String(e.detail.sectionId) === String(SECTION_ID)) closeDrawer();
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Multi-instance safe init — the wishlist page is normally a singleton
       on the /pages/wishlist route, but in the theme editor a section may
       be re-rendered on edit. We iterate roots, guard against double-bind,
       and re-init on shopify:section:load (the dispatched root is e.target). */
    function init(root) {
      var scope = root || document;
      var pages = scope.querySelectorAll('.wishlist-page');
      if (!pages.length) return;
      pages.forEach(function (page) {
        if (page.dataset.cspInit === 'true') return;
        page.dataset.cspInit = 'true';
        initPage(page);
      });
    }

    function initPage(page) {
      /* ── Configuration from data-* attributes ─────────────── */
      var SECTION_ID    = page.dataset.wpSectionId || '';
      var CUSTOMER_ID   = page.dataset.wpCustomerId || '';
      var ATC_STYLE     = page.dataset.wpAtcStyle || 'primary';
      var MOVE_ALL_STYLE = page.dataset.wpMoveAllStyle || 'primary';

      var L = {
        addedOne:    page.dataset.wpAddedOneText  || 'Added to cart',
        addedMany:   page.dataset.wpAddedManyText || 'Added to cart',
        addError:    page.dataset.wpAddErrorText  || 'Could not add to cart',
        confirmClear: page.dataset.wpConfirmClearText || 'Click again to confirm',
        atcText:     page.dataset.wpAtcText      || 'Add to cart',
        soldOutText: page.dataset.wpSoldOutText  || 'Sold out',
        soldOutBadge: page.dataset.wpSoldoutBadgeText || 'Sold out',
        moveAllText: page.dataset.wpMoveAllText  || 'Move all to cart',
        clearAllText: page.dataset.wpClearAllText || 'Clear wishlist',
        removeLabel: page.dataset.wpI18nRemove   || 'Remove from wishlist'
      };

      /* ── Customer scoping ─────────────────────────────────────────
         Mirrors wishlist-drawer.liquid's storage scoping. The drawer owns
         the guest -> customer migration (runs at parse time on every load),
         so by the time this section's render() fires, STORAGE_KEY already
         points at the merged customer bucket. */
      var STORAGE_KEY = CUSTOMER_ID ? 'wishlist_items_' + CUSTOMER_ID : 'wishlist_items';
      var DISMISS_KEY = 'wishlist_login_prompt_dismissed';

      /* Element refs are recaptured on every render so editor reloads
         (which replace the section DOM) get fresh handles. */
      var loadingEl   = document.getElementById('wishlist-page-loading');
      var emptyEl     = document.getElementById('wishlist-page-empty');
      var gridEl      = document.getElementById('wishlist-page-grid');
      var bulkEl      = document.getElementById('wishlist-page-bulk');
      var moveAllBtn  = document.getElementById('wishlist-page-move-all');
      var clearAllBtn = document.getElementById('wishlist-page-clear-all');

      if (!gridEl || !emptyEl || !loadingEl) return;

      /* Sync empty-state icon with the header's wishlist icon style.
         The header section owns the "Icon style" setting (heart / star /
         bookmark / diamond); rather than duplicating that setting here
         we clone the header's already-rendered SVG path into our empty
         icon at init. Changing the icon in the header section then
         propagates here automatically — single source of truth. */
      var headerWlSvg = document.querySelector('.header__wishlist-icon svg');
      var emptyIconEl = page.querySelector('.wishlist-page__empty-icon');
      if (headerWlSvg && emptyIconEl) {
        emptyIconEl.innerHTML = headerWlSvg.innerHTML;
      }

      /* ── Storage helpers ──────────────────────────────────────────
         Direct read for initial render — wishlist-drawer's IIFE runs after
         ours since it's lower in the DOM, so window.wishlistDrawer may not
         exist at script parse time. localStorage is always available. */
      function getItems() {
        try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
        catch(e) { return []; }
      }

      /* For writes prefer the global API so header count, hearts, etc. stay
         synced. Falls back to direct write if the API isn't ready yet. */
      function removeItem(variantId) {
        if (window.wishlistDrawer && window.wishlistDrawer.remove) {
          window.wishlistDrawer.remove(variantId);
        } else {
          var items = getItems().filter(function(i) { return i.variantId != variantId; });
          try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch(e) {}
          var headerCount = document.querySelector('.header__wishlist-count');
          if (headerCount) {
            if (items.length > 0) { headerCount.textContent = items.length; headerCount.style.display = ''; }
            else { headerCount.style.display = 'none'; }
          }
        }
      }

      /* ── Money formatter ────────────────────────────────────────── */
      function formatMoney(cents) {
        if (window.Shopify && Shopify.formatMoney) {
          try { return Shopify.formatMoney(cents); } catch(e) {}
        }
        return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      /* ── Cart toast wrapper ────────────────────────────────────
         Thin shim around the global window.cartToast API (rendered
         once via cart-toast snippet in theme.liquid). Configure the
         notification's appearance in Theme Settings - Cart Notification.

         Optional `ctx` argument: { image, title, quantity }
         For bulk adds (e.g. 3 items at once), pass quantity > 1 — the
         toast shows xN badge on the (first) thumbnail. */
      function showToast(msg, isError, ctx) {
        if (!window.cartToast) return;
        ctx = ctx || {};
        window.cartToast.show({
          type:         isError ? 'error' : 'success',
          message:      msg,
          productImage: ctx.image || '',
          productTitle: ctx.title || '',
          quantity:     ctx.quantity || 1
        });
      }

      /* ── HTML escape (mirrors drawer's escapeHtml) ──────────────── */
      function esc(str) {
        if (str == null) return '';
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      /* ── Build a card ─────────────────────────────────────────────
         product = result of /products/{handle}.js
         variant = the specific variant we have wishlisted (may be null if
                   the variant ID is no longer valid on the live product —
                   we fall back to first variant in that case so the user can
                   still see/manage the entry). */
      function buildCard(product, variant, savedVariantId) {
        var available = !!(variant && variant.available);
        var imgSrc = (variant && variant.featured_image && variant.featured_image.src)
          ? variant.featured_image.src
          : (product.images && product.images.length > 0 ? product.images[0] : null);

        var variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
        var url = '/products/' + product.handle + (variant ? '?variant=' + variant.id : '');

        var price = variant ? variant.price : product.price;
        var compareAt = variant ? variant.compare_at_price : product.compare_at_price;
        var onSale = compareAt && compareAt > price;

        var card = document.createElement('div');
        card.className = 'wishlist-card' + (available ? '' : ' is-soldout');
        card.setAttribute('role', 'listitem');
        card.dataset.variantId = String(savedVariantId);
        card.dataset.liveVariantId = variant ? String(variant.id) : '';
        card.dataset.productHandle = product.handle;

        var imgHtml = imgSrc
          ? '<img class="wishlist-card__img" src="' + esc(imgSrc) + '" alt="' + esc(product.title) + '" loading="lazy">'
          : '<div class="wishlist-card__img-placeholder"></div>';

        var soldOutBadge = !available
          ? '<span class="wishlist-card__soldout-badge">' + esc(L.soldOutBadge) + '</span>'
          : '';

        var priceHtml = onSale
          ? '<span class="wishlist-card__price">' + esc(formatMoney(price)) + '</span>'
            + '<span class="wishlist-card__price wishlist-card__price--compare">' + esc(formatMoney(compareAt)) + '</span>'
          : '<span class="wishlist-card__price">' + esc(formatMoney(price)) + '</span>';

        card.innerHTML =
          '<a href="' + esc(url) + '" class="wishlist-card__image-wrap" aria-label="' + esc(product.title) + '">'
          +   imgHtml
          +   soldOutBadge
          +   '<button type="button" class="wishlist-card__remove" aria-label="' + esc(L.removeLabel) + '" data-wp-remove>'
          +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true">'
          +       '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>'
          +     '</svg>'
          +   '</button>'
          + '</a>'
          + '<div class="wishlist-card__info">'
          +   '<div class="wishlist-card__title-row">'
          +     '<a href="' + esc(url) + '" class="wishlist-card__title">' + esc(product.title) + '</a>'
          +   '</div>'
          +   (variantTitle ? '<span class="wishlist-card__variant">' + esc(variantTitle) + '</span>' : '')
          +   '<div class="wishlist-card__price-row">' + priceHtml + '</div>'
          + '</div>'
          + '<button type="button" class="wishlist-card__atc"'
          +   ' data-button-style="' + esc(ATC_STYLE) + '"'
          +   ' data-button-text-effect="false"'
          +   ' data-wp-atc'
          +   (available ? '' : ' disabled') + '>'
          +   (available ? esc(L.atcText) : esc(L.soldOutText))
          + '</button>';

        /* Remove handler */
        card.querySelector('[data-wp-remove]').addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          removeCard(card, savedVariantId);
        });

        /* ATC handler */
        if (available && variant) {
          card.querySelector('[data-wp-atc]').addEventListener('click', function() {
            var btn = this;
            if (btn.disabled) return;
            var originalText = btn.textContent;
            btn.disabled = true;
            btn.textContent = '…';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: variant.id, quantity: 1 })
            })
            .then(function(r) {
              if (!r.ok) return r.json().then(function(err) { throw err; });
              return r.json();
            })
            .then(function() {
              /* Update header cart count */
              return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
                var cartCount = document.querySelector('.header__cart-count');
                if (cartCount) {
                  cartCount.textContent = cart.item_count;
                  cartCount.style.display = cart.item_count > 0 ? '' : 'none';
                }
              });
            })
            .then(function() {
              showToast(L.addedOne, false, {
                image: imgSrc || '',
                title: variantTitle ? (product.title + ' — ' + variantTitle) : product.title
              });
              /* Match wishlist-drawer behaviour: ATC removes the item from
                 the wishlist and opens the cart drawer. */
              removeCard(card, savedVariantId);
              document.dispatchEvent(new CustomEvent('cart:open'));
              document.dispatchEvent(new CustomEvent('cart:updated'));
            })
            .catch(function() {
              btn.disabled = false;
              btn.textContent = originalText;
              showToast(L.addError, true);
            });
          });
        }

        return card;
      }

      /* ── Remove card with animation, then re-render bulk/empty state ─ */
      function removeCard(card, variantId) {
        card.classList.add('is-removing');
        setTimeout(function() {
          removeItem(variantId);
          if (card.parentNode) card.parentNode.removeChild(card);
          updateChromeFromDom();
        }, 250);
      }

      /* ── Update count badge / bulk visibility / empty state from
            whatever cards remain in the DOM. Called after a single
            remove so we don't have to refetch all products. */
      function updateChromeFromDom() {
        var n = gridEl.children.length;
        if (bulkEl) bulkEl.hidden = n === 0;
        if (n === 0) {
          gridEl.hidden = true;
          emptyEl.hidden = false;
        } else {
          gridEl.hidden = false;
          emptyEl.hidden = true;
        }
      }

      /* ── Initial render ─────────────────────────────────────────── */
      function render() {
        var items = getItems();

        /* Reset chrome */
        gridEl.innerHTML = '';
        emptyEl.hidden = true;
        if (bulkEl) bulkEl.hidden = true;

        if (items.length === 0) {
          loadingEl.hidden = true;
          gridEl.hidden = true;
          emptyEl.hidden = false;
          return;
        }

        loadingEl.hidden = false;
        gridEl.hidden = true;

        /* Fetch all products (parallel). Use Promise.all but keep order
           stable (most-recent first by addedAt, since localStorage push order
           is chronological — reverse so newest appears first). */
        var ordered = items.slice().sort(function(a, b) {
          return (b.addedAt || 0) - (a.addedAt || 0);
        });

        var fetches = ordered.map(function(item) {
          return fetch('/products/' + item.productHandle + '.js')
            .then(function(r) {
              if (!r.ok) throw new Error('not found');
              return r.json();
            })
            .then(function(product) { return { item: item, product: product }; })
            .catch(function() {
              /* Product was deleted from catalogue — drop silently from
                 the wishlist so it doesn't haunt the list. */
              removeItem(item.variantId);
              return null;
            });
        });

        Promise.all(fetches).then(function(results) {
          loadingEl.hidden = true;
          var valid = results.filter(Boolean);
          if (valid.length === 0) {
            gridEl.hidden = true;
            emptyEl.hidden = false;
            return;
          }
          gridEl.hidden = false;
          var frag = document.createDocumentFragment();
          valid.forEach(function(r) {
            var product = r.product;
            var variant = product.variants.find(function(v) { return v.id == r.item.variantId; }) || product.variants[0];
            frag.appendChild(buildCard(product, variant, r.item.variantId));
          });
          gridEl.appendChild(frag);
          updateChromeFromDom();
        });
      }

      /* ── Bulk: Move all to cart ─────────────────────────────────── */
      function moveAllToCart() {
        var cards = Array.prototype.slice.call(gridEl.querySelectorAll('.wishlist-card:not(.is-soldout):not(.is-removing)'));
        if (cards.length === 0) return;
        if (!moveAllBtn) return;

        var bulkItems = cards.map(function(card) {
          /* liveVariantId is what we add to cart (matches the variant that
             actually exists on the product right now); variantId is the
             localStorage key we'll use to remove the entry afterward. */
          return {
            liveId: parseInt(card.dataset.liveVariantId, 10),
            savedId: card.dataset.variantId,
            _card: card
          };
        }).filter(function(x) { return !!x.liveId; });

        if (bulkItems.length === 0) return;

        moveAllBtn.disabled = true;
        var originalLabel = moveAllBtn.querySelector('.wishlist-page__bulk-label').textContent;
        moveAllBtn.querySelector('.wishlist-page__bulk-label').textContent = '…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: bulkItems.map(function(i) { return { id: i.liveId, quantity: 1 }; }) })
        })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(err) { throw err; });
          return r.json();
        })
        .then(function() {
          return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            var cartCount = document.querySelector('.header__cart-count');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
              cartCount.style.display = cart.item_count > 0 ? '' : 'none';
            }
          });
        })
        .then(function() {
          /* For bulk adds, show the first item's image with a quantity badge
             indicating total count. Single-item bulk add behaves like normal ATC. */
          var firstCard = bulkItems[0] && bulkItems[0]._card;
          var firstImg  = firstCard ? firstCard.querySelector('.wishlist-card__img') : null;
          showToast(
            bulkItems.length === 1 ? L.addedOne : L.addedMany,
            false,
            {
              image:    firstImg ? firstImg.src : '',
              quantity: bulkItems.length
            }
          );
          /* Animate out and remove each successfully-added card */
          bulkItems.forEach(function(i) {
            i._card.classList.add('is-removing');
          });
          setTimeout(function() {
            bulkItems.forEach(function(i) {
              removeItem(i.savedId);
              if (i._card.parentNode) i._card.parentNode.removeChild(i._card);
            });
            updateChromeFromDom();
            moveAllBtn.disabled = false;
            moveAllBtn.querySelector('.wishlist-page__bulk-label').textContent = originalLabel;
            document.dispatchEvent(new CustomEvent('cart:open'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }, 250);
        })
        .catch(function() {
          moveAllBtn.disabled = false;
          moveAllBtn.querySelector('.wishlist-page__bulk-label').textContent = originalLabel;
          showToast(L.addError, true);
        });
      }

      /* ── Bulk: Clear wishlist (two-tap inline confirm) ──────────── */
      var clearConfirmTimer = null;
      function clearAllInit() {
        if (!clearAllBtn) return;
        clearAllBtn.classList.add('is-confirming');
        clearAllBtn.querySelector('.wishlist-page__bulk-label').textContent = L.confirmClear;
        clearConfirmTimer = setTimeout(function() {
          clearAllBtn.classList.remove('is-confirming');
          clearAllBtn.querySelector('.wishlist-page__bulk-label').textContent = L.clearAllText;
          clearConfirmTimer = null;
        }, 4000);
      }
      function clearAllExecute() {
        clearTimeout(clearConfirmTimer);
        clearConfirmTimer = null;
        var cards = Array.prototype.slice.call(gridEl.querySelectorAll('.wishlist-card'));
        cards.forEach(function(c) { c.classList.add('is-removing'); });
        setTimeout(function() {
          /* Remove every entry one by one through the API so header count
             and other UIs sync. (Direct localStorage clear would skip those.) */
          var items = getItems();
          items.forEach(function(it) { removeItem(it.variantId); });
          gridEl.innerHTML = '';
          updateChromeFromDom();
          if (clearAllBtn) {
            clearAllBtn.classList.remove('is-confirming');
            clearAllBtn.querySelector('.wishlist-page__bulk-label').textContent = L.clearAllText;
          }
        }, 250);
      }

      if (moveAllBtn) {
        moveAllBtn.addEventListener('click', moveAllToCart);
      }
      if (clearAllBtn) {
        clearAllBtn.addEventListener('click', function() {
          if (clearConfirmTimer) {
            clearAllExecute();
          } else {
            clearAllInit();
          }
        });
      }

      /* ── Login banner (only present in DOM when guest) ──────────── */
      var loginBannerEl = document.getElementById('wishlist-page-login-banner');
      var loginDismissBtn = document.getElementById('wishlist-page-login-dismiss');
      if (loginBannerEl) {
        var loginDismissed = false;
        try { loginDismissed = localStorage.getItem(DISMISS_KEY) === '1'; } catch(e) {}
        if (loginDismissed) loginBannerEl.hidden = true;
        if (loginDismissBtn) {
          loginDismissBtn.addEventListener('click', function() {
            try { localStorage.setItem(DISMISS_KEY, '1'); } catch(e) {}
            loginBannerEl.hidden = true;
          });
        }
      }

      /* ── Cross-tab sync ─────────────────────────────────────────── */
      /* Fires when another tab/window mutates wishlist_items. Re-render
         from scratch since we don't know what changed. */
      window.addEventListener('storage', function(e) {
        if (e.key === STORAGE_KEY) render();
        /* Sync dismiss state across tabs too — if banner was dismissed
           elsewhere, hide it here. */
        if (e.key === DISMISS_KEY && e.newValue === '1' && loginBannerEl) {
          loginBannerEl.hidden = true;
        }
      });

      /* ── Init render ────────────────────────────────────────────── */
      render();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    /* Theme editor: re-init on section reload. The dispatched event's
       target is the replaced section root, so initPage will pick up the
       fresh DOM. Resetting cspInit lets initPage rebind on the new node. */
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      if (!root) return;
      /* Clear init guard on any wishlist-page within the replaced root
         so we re-bind cleanly. */
      var pages = root.querySelectorAll ? root.querySelectorAll('.wishlist-page') : [];
      pages.forEach(function(p) { delete p.dataset.cspInit; });
      if (root.classList && root.classList.contains('wishlist-page')) {
        delete root.dataset.cspInit;
      }
      init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
